import { useEffect, useState, useCallback, useRef, useMemo, useSyncExternalStore } from 'react'
import { createPortal } from 'react-dom'
// Other Actions: the same step (2026-10-27): the Manual Panel's window shows
// its steps with this panel's step component, through a slot per step.
import { stepSlotFor, subscribeStepSlots, stepSlotsVersion, stepOwnProcessShown } from './stepSlots.js'
import ManualStepReply from './ManualStepReply.jsx'
import { EbayCaseLink, LinkedCaseText } from './EbayCaseText.jsx'
import { EbayRefundRouteNote } from './EbayRefundRouteNote.jsx'
import { OverdueRefundInfo, OverdueSupportEmail } from './OverdueRefundParts.jsx'
import { OVERDUE_EMAIL_STEP, OVERDUE_TOKENS_HINT, overdueReplyTag, isOverdueRefundStep, isOverdueNoteStep, waitsOnOverdueRefund, overdueRefundStepIndex, overdueLiveValues } from './overdueRefund.js'
import { ebayRerouteButtonLabel, ebayRerouteStepStates } from './ebayLinks.js'
import {
  Box, Stack, Typography, Chip, Button, TextField, Paper,
  CircularProgress, Alert, Tooltip, InputAdornment, IconButton, Link,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Select, MenuItem, FormControl, InputLabel, Checkbox, FormControlLabel, Radio, RadioGroup,
  Table, TableHead, TableBody, TableRow, TableCell, TableContainer,
  ClickAwayListener, ToggleButton, ToggleButtonGroup, useMediaQuery,
} from '@mui/material'
import { alpha } from '@mui/material/styles'
import { useSignedInIdentity } from './useSignedInIdentity.js'
import { refreshCaseHistory, chooseTaskPath, fetchRmaReference, fetchPartLink, saveStepChecks, fetchSuggestions, generateSuggestion, decideSuggestion, closeConversation, retrySuggestionSend, markAsSpam, setReviewedByMgmt as setReviewedByMgmtApi, executeStepAction, processSteps, runDispositionCheck, submitFeedback, releaseAssignment, sendManualReply, fetchInvoiceAttachments, takeoverAutomation, fetchCancelReasonCodes, fillTemplateTokens, fetchM365OwnAddresses } from './api.js'
import { startFeedbackCapture, finishFeedbackCapture, feedbackScreenshotPayload, PANEL_SELECTOR } from './feedbackScreenshot.js'
import { buildFeedbackUiState, attemptFromError, attemptBlocked, attemptOk } from './feedbackUiState.js'
import { buildFeedbackScreenState } from './feedbackScreenState.js'
import SpamRuleDialog from './SpamRuleDialog.jsx'
// Replacement or refund on the step (2026-10-27).
import ResolutionBar from './ResolutionBar.jsx'
import { isResolutionHiddenStep, resolutionView, resolutionSwitchPlan, resolutionNoteIndex, stockWarningLines } from './resolutionSwitch.js'
import { CopyButton } from './CopyButton.jsx'
import { insertHtmlTemplate, insertPlainTemplate, emailTemplateInsertHtml, placedCursor } from './templateInsert.js'
import { partlyDoneStepStates, ebayReturnStateLine, rmaNoteSiblingIndex, withRmaNoteLine } from './returnStepProgress.js'
import { isActionInputSatisfied, alreadyReturnedSelection, ALREADY_RETURNED_HINT, getEditableMessageDefault, getEditableNoteDefault, getEditableAddressDefault, noteFromPlannedSteps, withShippingNoteLine, withTotalRefundSuffix, shouldSkipDraftRefresh, reseedActionInputs, resendLabelCreateSiblingIndex, replacementLabelSiblingIndex, automatedReturnNoticeLabelSiblingIndex, issueEbayReturnRefundNoteSiblingIndex, takesEbayRefundDefaultNote, withEbayRefundNote, taskEbayStepIndexes, isTaskPathHidden, isEmptyPathReply, addressCandidateLabel, applyAddressCandidatePick, taskReplyTextFor, returnStageText, taskReplyTitleFor, taskPathHasEdits, resetTaskPathInputs, resolveReplySendErrorSeed, hasBespokeRequiresInputUi, isSingleValidEmail, signatureSeedFor, shouldSeedSignatureFor, restoredStepStates, stepProcessGate, replacementLabelSiblingReady, toggleKitAwareSelection, groupItemsForTable, isComponentBlockedByKit, labelSendToDefault, defaultLabelPackages, showsLabelPackagesEditor, labelStepHandoff, labelLinkNotInReply, LABEL_LINK_NOT_IN_REPLY } from './suggestionActionInputs.js'
import { replyDestinationLine, replyCarrierStepIndex, postsToCase, caseName, ebayCancelRejectTrackingLine } from '@cxhub/shared'
import { uncheckedStepsFrom, hasNoDraftBoxOfItsOwn, hasUnresolvedPlaceholder, isSignatureOnlyReply, templateHtmlToPlainText, taskResponseSubject, taskPathChoiceFrom, taskPathChoiceStep, taskPathDateMissing, effectiveTaskPathChoice, isIsoDate, estimatedRefundBreakdown, claimsAttachedInvoice, invoiceUnavailableText, stepBlockState, STEP_NOT_NEEDED_NOTE, STEP_MARK_NOT_NEEDED_LABEL, SKIP_CSR_MARKED_NOT_NEEDED, taskChoiceBlockMessage, TASK_PATH_NOT_CHOSEN_ERROR, isProcessableStep, returnStagePathKey, SEND_WARNINGS_ERROR, SEND_FIX, mentionsSignifyd, SIGNIFYD_SEND_WARNING } from '@cxhub/shared'
import { loadEbayBoxText } from './ebayBox.js'
import { clientAgentFooter, resolvePlaceholderSignature, m365ServiceAddressForCompany, companySignatureInfo } from './constants/companies.js'
import ExpandableTextField from './ExpandableTextField.jsx'
import RichReplyEditor from './RichReplyEditor.jsx'
import { FULL_REFUND_COMMENT, PARTIAL_REFUND_COMMENT } from './RefundModal.jsx'
import DraggableModal from './DraggableModal.jsx'
import { processAllPlan, processAllInputs, stepStatesAfterProcessAll, processAllFailureMessage, processAllStepList, processAllManualNote, offersProcessAll, checkedIndexes, toggleStepCheck, stepDependencyNote, replyForProcessChecks, replyAfterProcessAll, labelSlotFilledByProcessAll, LABEL_LINK_SLOT_WARNING, processAllSkippedList } from './processAll.js'
import { hasPendingLabelLinkSlot, labelLinkSlotUrls, fillLabelLinkSlot, labelLinkBlocks, withoutEbayPrintLine } from '@cxhub/shared'
import { rmaReferenceStepIndex, PART_LINK_STEP_TYPE, PART_LINK_LABEL, replaceCarryValue, setRefundAmountLines, hasRefundBreakdownLines, skuFromPartLink } from '@cxhub/shared'
import { customerReturnTrackingLine, withRefundAmountsNoteLine } from '@cxhub/shared'
import { rmaReferenceSendWarning, rmaReferenceProcessAllWarning, rmaReferenceFromResult, replyWithRmaReference, withoutRmaReferenceToken, hasRmaReferenceToken } from './rmaReference.js'
import { applySubstitutions, htmlToPlainText, estimateBase64Bytes } from './richTextConversion.js'
import { restrictedInfoWarning } from './restrictedInfoCheck.js'
import { unfilledPlaceholderWarning, placeholderOnlyWarning } from './placeholderCheck.js'
import TaskPathChoiceControls from './TaskPathChoiceControls.jsx'
import { walmartLinkWarning } from './walmartReply.js'
import { generationFailureView } from './generationError.js'
import { withBlankLineAboveSignature } from './templateInsert.js'
import { isOrderOnlyToNotice, isSiteAutomationInbound, noticeSeedTo, fillLateTo, noticeToBlockReason } from './noticeReply.js'
import { trqRetryNotice } from './trqRetryNotice.js'
import { sanitizeHtmlBody } from './htmlSanitize.js'
import { computeLineTax } from './itemTax.js'
import { roundMoney, shippingRateDefaultDeduction, combineRateQuotes, fillMissingUnitCost } from './shippingDeduction.js'
import PackagesEditor, { compactFieldSx } from './PackagesEditor.jsx'
// The return step's label section and disposition check (2026-10-27),
// shared with the agent's return step (ShadowDraftPanel.jsx).
import ReturnLabelFields, { LabelEmailInputs } from './ReturnLabelFields.jsx'
import { DISPOSITION_LABEL, DISPOSITION_HELPER, CHECK_STALE_TEXT, DISPOSITION_OPTIONS, dispositionWord, overriddenText, checkIsStale, overrideForChoice, keepCheckWhenStale } from './returnStepCheck.js'
import ReplacementShippingRequestBanners from './ReplacementShippingRequestBanners.jsx'
import { newOutboundOption, followsOrderAddresses, followsOrderDefaultReplyMode } from './newOutbound.js'
import { inboundWarnings } from './replacementShippingRequest.js'
import { hasRefreshableCaseHistory, caseHistorySentLabel, withRefreshedCaseHistory, alignedHistoryTranslation } from './caseHistory.js'
import { addressReplyMismatchWarning } from './addressReplyMismatch.js'
import TemplatePickerDialog from './TemplatePickerDialog.jsx'
import { resolveTemplateCarrierChoice } from './templateCarrierChoice.js'
import { ShadowCompareColumn, ShadowCompareRail, ShadowCompareStacked, ConfidenceLabel } from './ShadowDraftPanel.jsx'
// The agent draft panel's A2 layout (2026-10-23), shared with the admin
// agent draft column: AgentDraftLayout.jsx and its helpers.
import { A2, SummaryBlock, NextStepsSection, StepsSection, SystemChip, ReplySection as A2ReplySection, PlaceholderLine, PrimaryActionArea, DetailsFooter, GeneratedAtLine, StepCheck, StepFields, UncheckedGate } from './AgentDraftLayout.jsx'
import { ViewCalls } from './ViewCalls.jsx'
import { placeholderFieldNames, placeholderLine, withoutPlaceholderReasons, primaryActionState, runDetailsLine, agentDraftChipTooltip, showLiveChip, LIVE_CHIP_LABEL, LIVE_CHIP_TOOLTIP } from './agentDraftLayout.js'
import { useShadowDraft } from './useShadowDraft.js'
import { useShadowTranslation } from './useShadowTranslation.js'
import { ResizeHandle } from './ResizablePane.jsx'
import { PhotoLabelLine } from './PhotoLabelLine.jsx'
import { SHADOW_COMPARE_COLUMN_WIDTH, SHADOW_COMPARE_MIN_VIEWPORT, readShadowCompareCollapsed, writeShadowCompareCollapsed, shadowCompareMode, noAiDraftLabel, comparisonDraft, comparisonTitle, pipelineCompareOnDemand, pipelineDifferenceHint, COMPARE_PIPELINE_LINK, HIDE_COMPARISON_LABEL, agentNextStepsFor, agentAutomationHold, confidenceView, toolCallLines, shadowSourcesLine } from './shadowDraft.js'
import { contactNoteBlocks, contactNoteHeading } from './contactNotes.js'
import { supportTransferNote, whatsNextSteps, customerTrackingNextSteps, supportRefundNextSteps } from './returnTrackingSteps.js'
import { NextStepText } from './NextStepTracking.jsx'
import { replyAllCcDefault, parseCcText, ccFieldState, ccAddressesForSend } from './emailCc.js'
import EmailAttachmentList from './EmailAttachmentList.jsx'
import { readEmailAttachmentFile } from './emailAttachments.js'
import { callTimeDisplay } from './callTimeStatus.js'
import DecisionButtonRow from './DecisionButtonRow.jsx'
import { newDraftNoticeText, shouldHoldNewerSuggestion, isSupersededError } from './newDraftNotice.js'
import { quietCheckOutcome, QUIET_UPDATED_TEXT } from './quietStaleCheck.js'
import QuietCheckGate from './QuietCheckGate.jsx'
// Every "are you sure?" here is the styled dialog (2026-10-27), never the browser's confirm box.
import { useConfirmDialog } from './ConfirmDialog.jsx'
// The Send warnings dialog (2026-10-30, sendWarnings.js).
import SendWarningsDialog from './SendWarningsDialog.jsx'
import { sendStopReason, isBlankReply, panelPromiseWarnings, panelSendWarnings, mergeSendWarnings, warningCodes, withoutStepWarnings, EMPTY_REPLY_REASON, REGENERATED_SEND_STOP } from './sendWarnings.js'
import { newSuggestionPrompt, SWITCH_TASK_PATH_PROMPT, FILL_DATE_PROMPT, replaceReplyPrompt, stageTemplatePrompt, houseTemplateReplyPrompt, PASTE_MANUAL_REPLY_PROMPT } from './confirmPrompts.js'
import { findUnresolvedPlaceholders as findReplyPlaceholders } from '@cxhub/shared'
import { houseReplyFromResult, houseReplyFromRun, houseReplyAction, houseReplySwitchedNote, tokensFilledByPass, replyForProcessAllGate, heldLabelReply } from './houseTemplateReply.js'
import { isReplyEdited, replyReplacedNote, REPLY_REPLACED_NOTE_MS } from './replyEdited.js'
import { agentStepsShown, liveRefunds, replyRefundOf, replyKindFor, refilledReply, outcomeReplyFor, sendWarnings, sendWarningsRecord, USE_STEP_AMOUNT_LABEL, FROM_PIPELINE_CHIP } from './agentReplyFollowsSteps.js'
import { withStepAmount } from '@cxhub/shared'
import { untoldManualSteps, untoldReminderPrompt, manualReplyText, manualReplyAmounts } from './manualStepReply.js'
import ParkInfoStrip from './ParkInfoStrip.jsx'
import RelatedContactsBanners from './RelatedContactsBanners.jsx'
// Park saves the work (2026-10-27, docs/decisions/2026-10-27-park-saves-work.md).
import { fetchWorkDraft, saveWorkDraft, clearSavedWork, recordRestoredWork, settleParkCompare, markEbayStepSentInSellerHub, markEbayReplySentInSellerHub, rerouteEbayRefund, recordUntoldCustomerClose } from './api.js'
// eBay's daily message limit (2026-10-29): the banner over the reply box,
// and the copy + Sent response through eBay Portal notice on a refused send.
import EbayDailyLimitBanner from './EbayDailyLimitBanner.jsx'
import EbayDailyLimitNotice from './EbayDailyLimitNotice.jsx'
// A return step waiting on the OMS API (2026-10-29): its checklist, the
// spinner while Process waits for the RMA number, the "label on its way"
// banner, and the $0 RMA banner with its label box.
import { PendingStepChecklist, RmaNumberWaitCaption, ReturnLabelBanners, ZeroDollarRmaBanner, ReplacementLabelOptional } from './ReturnLabelPending.jsx'
import { useReturnLabels, useZeroDollarTiming } from './useReturnLabels.js'
import { pendingStepFor, pendingFromResult, waitsForRmaNumber, orderWaitingBanners, timedOutNextSteps, zeroDollarOption, zeroDollarLabelChecked, withZeroDollarLabelChoice, withoutZeroDollarChoice, draftWithZeroDollarChoice, replacementLabelHeldForZeroDollar, zeroDollarSeedKey, replacementLabelStepOptional, replacementLabelNotRequested, withReplacementLabelChoice } from './pendingLabels.js'
import { withLabelToFollow } from '@cxhub/shared'
import { isDailyLimitText, isDailyLimitStepState, dailyLimitStepStates } from './ebayDailyLimit.js'
import { compareParkedWork, restoredWorkLine, isOwnWork, START_FROM_AI_DRAFT_LABEL, tokenizeAgentName, retargetAgentName, signatureNameMismatch, fixSignatureName, signatureMismatchText, firstNameOf, parkResolutionFrom, stepFactWarning, savedStepIndexMap, PARK_NOTHING_NEW_TEXT, PARK_KEEP, PARK_NEW } from '@cxhub/shared'
import ParkComparePanel, { compareItems, REPLY_ITEM, stepItemId } from './ParkComparePanel.jsx'
import { buildWorkPayload, mapWorkText, workDiffersFromDraft, defaultUncheckedSteps, comparableText, isWorkEventTarget, isWorkChoiceClick, isEditingKey, workFingerprint, restoredWorkFor, shouldRestoreWork, chooseItems, chooseAll, compareNeedsChoice, parkFactLines, parkStripHidesOnWork, PARK_FACTS_ONLY_TEXT, WORK_AUTOSAVE_DELAY_MS } from './workDraft.js'
import { carryStepWork, choiceToRecord, choiceToSyncOnSend, isSameCustomerTurn, regeneratedCompareBlock, REGENERATED_COMPARE_TITLE, REGENERATED_KEPT_TEXT, REGENERATED_NOTICE_TEXT, REGENERATED_PROCESSED_NOTE, TASK_DATE_SAVE_ERROR, TASK_CHOICE_SAVE_ERROR } from './carryWork.js'
import { errorText, refusalMessage, decisionActionName } from './refusalMessage.js'
// The reply box's English view on every channel (2026-10-30).
import { translateDraft } from './api.js'
import { reestimateReplacementDelivery } from './api.js'
import { withEddNoteLine } from '@cxhub/shared'
import { initialEddStates, eddRequestFor, needsReestimate, eddStepView, stockLinesWithEdd, replyAfterReestimate, mainReplacementIndex, eddTone, eddToneColor, eddNoteKey, REPLACEMENT_EDD_DEBOUNCE_MS } from './replacementEdd.js'
import { mayBeForeign, sendingCaption, DRAFT_TRANSLATION_DEBOUNCE_MS } from './draftLanguage.js'
// "Found the right part?" (2026-10-30, correctPart.js).
import CorrectPartBox from './CorrectPartBox.jsx'
import { correctPartBoxApplies, stepsAfterCorrectPart, confidenceAfterCorrectPart } from './correctPart.js'
import { plainTextToHtmlParagraphs } from '@cxhub/shared'
import { recentRelatedReply, recentReplyMessage, withCorrectedAddress, emailTypoText } from './relatedContacts.js'

// Re-exported for ManualActionsSidebar.jsx and any other existing importer —
// these now live in shippingDeduction.js (a plain .js module, unit-testable
// under plain `node --test`, which can't import a .jsx file directly), not
// defined here.
export { roundMoney, shippingRateDefaultDeduction, combineRateQuotes, fillMissingUnitCost }

// The { folder, title } a CSR inserted, for the reply's sent template.
export function insertedTemplateOf(template) {
  return template?.title ? { folder: template.folder ?? null, title: template.title } : null
}

// Action types that are UI-only / informational — no server execution.
const UI_ONLY_TYPES = new Set(['select_reason_code'])


// groupItemsForTable() and isComponentBlockedByKit() live in
// suggestionActionInputs.js (2026-10-23, so ShadowDraftPanel.jsx can use them
// without a circular import); re-exported here for their importers.
export { groupItemsForTable, isComponentBlockedByKit }

// Kit-aware selection toggle — same shape as the plain filter/push logic both
// tables used inline before this, except checking a KIT also clears any of
// its own components already selected (their checkboxes un-check and qty
// fields grey out as a side effect of no longer being in `items` — no
// separate toast/notice needed, isComponentBlockedByKit above disables them
// from being re-checked afterward too).
// toggleKitAwareSelection() lives in suggestionActionInputs.js (2026-10-08,
// pure and unit-tested); re-exported here for ManualActionsSidebar.jsx.
export { toggleKitAwareSelection }

// Website RMA path's return-shipping rate-quote/label-deduction controls
// (feature/website-rma-rate-quote-and-label-send) — pure helpers, exported
// for direct unit testing. roundMoney/shippingRateDefaultDeduction/
// combineRateQuotes/fillMissingUnitCost now live in shippingDeduction.js
// (imported above, re-exported for backward compatibility) — everything
// below still uses them the same way.

// The auto-captured note line for the CURRENT option/deduction combination,
// or null when neither applies (the DEFAULT Customer-Cost choice, untouched,
// needs no note at all). A manual edit away from whichever default the
// current option implies always wins over the plain "Our Cost" line, since
// it's the more specific deviation.
export function shippingDeductionNoteLine(option, deduction, rateQuote) {
  if (option === 'customerShipsOwn' || deduction == null) return null
  const optionDefault = shippingRateDefaultDeduction(option, rateQuote)
  const deductionNum = Number(deduction)
  if (optionDefault == null || Math.abs(deductionNum - Number(optionDefault)) > 0.001) {
    return `Return label deduction manually adjusted to $${deductionNum.toFixed(2)}.`
  }
  if (option === 'ourCost') {
    return `Return label cost of $${deductionNum.toFixed(2)} charged to customer (Our Cost rate).`
  }
  return null
}

// withShippingNoteLine()/withTotalRefundSuffix() now live in
// suggestionActionInputs.js (moved 2026-09-24, feature/scrap-rma-note-box-
// visibility) — pure, framework-free, so node --test can cover them directly;
// this file just imports them (see the import block above).

// estimatedRefundBreakdown(): the items+tax refund for exactly the selected
// items. Lives in @cxhub/shared (shared/src/refund-amounts.js) since
// 2026-10-21, so the server computes the same Original Refund for the
// refund-amount template lines without Check; re-exported here for
// ManualActionsSidebar.jsx and the tests.
export { estimatedRefundBreakdown }

// What fraction of the pre-deduction items+tax total the Customer Cost rate
// would eat up — NOT the post-deduction refund, since that's circular (the
// deduction itself is derived from whichever option is picked). 0 when
// itemsTotal isn't positive (nothing selected yet) rather than dividing by
// zero/NaN.
export function shippingHighCostPct(rq, itemsTotal) {
  return itemsTotal > 0 ? (rq?.totalEstimated ?? 0) / itemsTotal : 0
}

// Shared between the red warning text and the note block below, so the two
// can never disagree on wording.
export function shippingHighCostMessage(pct) {
  return `Customer Cost is ${Math.round(pct * 100)}% of the total return, offer the label at Our Cost.`
}

// The full auto-managed note block: the always-present items/deduction/
// refund-total breakdown, matching the on-screen numbers exactly, plus (at
// most) one mutually-exclusive trailing line — the high-cost justification
// when Our Cost was picked BECAUSE Customer Cost is disproportionately
// expensive, or the existing single-line message shippingDeductionNoteLine()
// already produces for every other "Our Cost chosen, or manually adjusted"
// case, or nothing at all for the untouched Customer-Cost default.
// Replaces the whole PREVIOUS block via withShippingNoteLine() below, same
// find-and-replace-by-suffix mechanism as the old single-line version.
export function shippingNoteBlock({ paymentOption, itemsTotal, deductionAmount, estimatedRefund, pct, deduction, rateQuote }) {
  const lines = [`Refund for selected item(s) (items + tax): $${itemsTotal.toFixed(2)}`]
  if (paymentOption !== 'customerShipsOwn') {
    lines.push(`Less return label deduction: -$${deductionAmount.toFixed(2)}`)
  }
  lines.push(`Refund total: $${estimatedRefund.toFixed(2)}`)
  const extra = (pct >= 0.3 && paymentOption === 'ourCost')
    ? shippingHighCostMessage(pct)
    : shippingDeductionNoteLine(paymentOption, deduction, rateQuote)
  const block = lines.join('\n')
  return extra ? `${block}\n\n${extra}` : block
}

// Renders a rationale string with any http(s) URL substring as a clickable,
// new-tab Link — the rest stays plain text. Shared by this file's own
// proposed-steps rationale and ManualActionsSidebar.jsx's two equivalent
// render sites, all three of which previously interpolated rationale as
// inert text with no linkify treatment (the wear-and-tear step is the first
// rationale to actually carry a URL a CSR needs to click through).
//
// str.split(/(capture)/) interleaves [text, match, text, match, ...] — odd
// indices are always the captured match, regardless of how many URLs occur,
// so this is a plain index check rather than a second (stateful, with the
// `g` flag) regex test.
const URL_SPLIT_PATTERN = /(https?:\/\/\S+)/g
export function RationaleText({ rationale }) {
  if (!rationale) return null
  const parts = rationale.split(URL_SPLIT_PATTERN)
  return (
    <Typography variant="caption" color="text.secondary">
      {parts.map((part, i) => (
        i % 2 === 1
          ? <Link key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</Link>
          : <span key={i}>{part}</span>
      ))}
    </Typography>
  )
}


// The unresolved "[AGENT_FIRST_NAME] | <signature>" footer for a given
// account/company code — matches applyTemplate()'s own footer literal below.
// Company-aware (constants/companies.js's clientAgentFooter(), not a
// hardcoded 1A literal) so an AM conversation's bare starting signature is
// "[AGENT_FIRST_NAME] | AM-Autoparts", not 1A's.
const agentFooterFor = clientAgentFooter

const QA_COLOR = { pass: 'success', revise: 'warning', block: 'error' }

// Internal automation senders (an Automated Return Notice, a system-
// generated ops notice, etc.) — the reply-mode toggle's default: a message
// FROM one of our own domains is a system notice, not a real customer
// message to thread a reply into, so "Send New Outbound Email" is the
// sensible default rather than "Reply to Email". Domain-suffix match
// (case-insensitive), same normalization convention trq-role-override.js's
// resolveM365TrqCompanyOverride() uses for its own address lookups — no
// existing helper for this already exists in the codebase.
const INTERNAL_NOTICE_DOMAINS = ['@1aauto.com', '@am-autoparts.com']
function isInternalNoticeSender(address) {
  if (!address) return false
  const lower = String(address).toLowerCase()
  return INTERNAL_NOTICE_DOMAINS.some((domain) => lower.endsWith(domain))
}

const DIMENSIONS = [
  ['accuracyRelevance', 'Accuracy / Relevance'],
  ['toneSentiment', 'Tone / Sentiment'],
  ['compliance', 'Compliance'],
  ['consistency', 'Consistency'],
]

const INR_ACTOR_LABELS = { BUYER: 'Buyer', SELLER: 'Seller', SYSTEM: 'eBay System' }

function formatEST(iso) {
  if (!iso) return ''
  return new Date(iso).toLocaleString('en-US', {
    timeZone: 'America/New_York',
    month: 'short', day: 'numeric', year: 'numeric',
    hour: 'numeric', minute: '2-digit', hour12: true,
  })
}

// The "Send label to" email + "Also send a copy to" cc fields
// (feature/website-rma-label-email-step1) — shared by process_return_refund's
// Website RMA route (Step 1, folded in) and the legacy send_return_label_email
// step (kept for a suggestion that already had one appended before this
// feature shipped), so the two can never visually drift apart. i/a: the
// action's own index/object, same convention every other per-step render
// helper in this file uses. defaultEmail: the order's own on-file email
// (params.shipTo?.emailAddress for process_return_refund, params.defaultEmail
// for the legacy step). ccCompany: the bare '1A'/'AM' code the cc address
// defaults from.
function LabelEmailFields({ i, actionInputs, setActionInputs, defaultEmail, ccCompany, disabled }) {
  // The fields themselves are ReturnLabelFields.jsx's LabelEmailInputs
  // (2026-10-27), shared with the agent's return step.
  return (
    <LabelEmailInputs
      value={actionInputs[i] ?? {}}
      onChange={(patch) => setActionInputs((prev) => ({ ...prev, [i]: { ...(prev[i] ?? {}), ...patch } }))}
      defaultEmail={defaultEmail}
      ccCompany={ccCompany}
      disabled={disabled}
    />
  )
}

// spamContext: { channel, client, company, fromIdentifier, subject } — used to pre-fill the
// New Spam Rule dialog when the agent clicks Spam on a conversation.
// autoRegenerateStaleMinutes: from GET /api/me's config.ai.autoRegenerateStaleMinutes.
// onDraftDirtyChange(isDirty): reports whether the draft has unsaved edits
// relative to the currently-applied suggestion, so App.jsx can guard against
// discarding them when the CSR selects a different conversation.
// The admin line for a failed generation (2026-10-26, generationError.js):
// "Generation failed at <stage>", and the message and the file:line frames
// behind Details.
function GenerationFailureDetails({ modelMeta }) {
  const [open, setOpen] = useState(false)
  const view = generationFailureView(modelMeta)
  if (!view) return null
  return (
    <Box data-testid="generation-failure-details" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
      <Typography component="span" sx={{ fontSize: '0.75rem', fontWeight: 600 }} data-testid="generation-failure-title">{view.title}</Typography>
      {view.lines.length > 0 && (
        <>
          {' '}
          <Link component="button" type="button" underline="hover" aria-expanded={open} onClick={() => setOpen((v) => !v)}
            data-testid="generation-failure-toggle" sx={{ fontSize: '0.75rem' }}>
            Details {open ? '▾' : '▸'}
          </Link>
          {open && (
            <Box component="pre" data-testid="generation-failure-lines" sx={{ m: 0, mt: 0.5, fontSize: '0.7rem', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
              {view.lines.join('\n')}
            </Box>
          )}
        </>
      )}
    </Box>
  )
}

export default function SuggestionPanel({ conversationId, relatedContacts = null, onOpenRelatedConversation = null, onRelatedChanged = null, fromEbay = false, channel = null, client = null, spamContext, onDecided, onGenerated, onSpamMarked, orderSwitching = false, refreshKey = 0, refreshSkipDraft = false, forcedDraftText = null, showTranslation = false, draftTranslation = null, historyTranslation = null, shadowDraftTranslation = null, isAdmin = false, autoRegenerateStaleMinutes = 5, onDraftDirtyChange, onUntoldCustomerChange = null, automationFailures = [], conversationStatus, conversationWaitingReason = null, conversationAutomationDueAt = null, conversationRetryDueAt = null, conversationRetryAttempts = null, conversationRetryMaxAttempts = null, onCloseConversation, closingConversation = false, closeError = null, onDismissCloseError, onReopenConversation, reopeningConversation = false, reopenError = null, onDismissReopenError, reviewedByMgmt: reviewedByMgmtProp = false, reviewedByMgmtUser: reviewedByMgmtUserProp = null, canManageReviewedByMgmt = false, templateAccount = null, templateTrqClientCode = null, templateTeam = null, lastInboundMessage = null, orderSummaryCustomerEmail = null, orderSummaryOrderTax = null, orderSummaryShippingCost = null, orderSummaryOrderTotal = null, orderSummaryItemDetails = null, orderSummaryTrackingSummary = null, customerExternalUserId = null, mailbox = null, subject = null, outboundFrom = null, newOutbound = null, signatureTemplate = null, outboundMode = null, latestTransfer = null, latestEscalation = null, isInternalEmail = false, taskContact = null, showShadowCompare = false, onShadowCompareSideChange = null, shadowColumnWidth = SHADOW_COMPARE_COLUMN_WIDTH, onShadowColumnDrag = null, conversationMessages = null, regenerateRequest = 0, parkingEnabled = false, isOwner = false, viewerUsername = null, workCaptureRef = null, screenView = null }) {
  // "As the CSR saw it" (2026-10-29, FeedbackScreenView.jsx): this same
  // panel drawn read-only from a Send Feedback report's screen state
  // ({ state, suggestion, changedOnly, renderStepMarks }). Nothing is
  // fetched or generated, nothing autosaves, and the panel is inert: no
  // button in it calls anything.
  const screenMode = Boolean(screenView?.state && screenView?.suggestion)
  // The signed-in CSR's first name for every box (2026-10-30,
  // useSignedInIdentity.js): /api/me, else MSAL's active account; never the
  // MSAL cache's first account, which can be another person's.
  const { firstName: agentFirstName } = useSignedInIdentity()
  // Genuinely "is this conversation on the eBay channel", distinct from
  // fromEbay (only true for the FROM_EBAY case-type conversations, where the
  // whole draft box is hidden already — see the isEbayChannel gate below on
  // the OTHER eBay case, a normal FROM_MEMBERS buyer-message conversation,
  // where fromEbay is false but the box still renders). eBay's Message API
  // sends humanReply to the buyer verbatim, with no HTML stripping
  // (send-approved-reply.js) — real bold/link formatting would show up as
  // literal tags in the buyer's message, so the rich editor must never be
  // offered here, only the plain textarea every other eBay-adjacent editable
  // box in this file already uses.
  const isEbayChannel = channel === 'ebay'
  // A genuine eBay order arriving over m365_email (an automated_return_notice-
  // style conversation whose resolved client is eBay) — same signal server-
  // side flows already use (pipeline.js's own hoisted isEbayClientEmail,
  // resend-return-label.js, action-executor.js's requireEbayChannel()). This
  // conversation has no real "Email" field to send to at all — the eBay
  // message step maybeAddEbayMessageStep() (actions.js) proposes is the only
  // way to reply, so the generic bottom composer must not be offered here
  // either (see its render gate further below).
  const isEbayClientEmail = channel === 'm365_email' && client === 'eBay'

  // signatureTemplate (2026-09-28, feature/blank-draft-signatures): the
  // conversation's live-resolved "<Company> eBay/Signature" or "<Company>
  // Website/Signature" template (server's resolveSignatureTemplate) — used
  // to start a genuinely BLANK reply box instead of leaving it empty (Jenn's
  // rule, 2026-09-28: any box that opens blank starts with the signature).
  // Declared up here (not further down, near resolveAgentFirstNamePlaceholder)
  // because a useEffect below depends on resolvedSignatureTemplate directly —
  // a dependency array is evaluated at render time, so it must already be
  // initialized by the time that useEffect() call is reached, not just by
  // the time its callback runs.
  //
  // Its own [AGENT_FIRST_NAME] token is resolved with a plain global
  // replace here — deliberately NOT routed through
  // resolveAgentFirstNamePlaceholder/resolvePlaceholderSignature further
  // down, whose AM-specific "collapse to the bare signature" branch only
  // ever matches the OLD hardcoded "[AGENT_FIRST_NAME] | signature"
  // bare-footer shape (companies.js's agentFooter()) — a live, admin-authored
  // template's own wording (including whether/where it names the agent at
  // all) is the template author's call now, not a hardcoded company flag's,
  // so a token embedded anywhere else in the template (e.g. its own
  // paragraph) must still resolve instead of silently staying literal.
  function resolveSignatureFirstName(text) {
    const firstName = agentFirstName
    return firstName ? text.replaceAll('[AGENT_FIRST_NAME]', firstName) : text
  }
  const resolvedSignatureTemplate = signatureTemplate ? resolveSignatureFirstName(signatureTemplate) : null
  // Plain text for eBay's textarea, real HTML for RichReplyEditor — matching
  // how each editor already takes content elsewhere in this file. '' (not
  // null) when there's no live template for this scope — the box just stays
  // genuinely blank, same as before this feature existed (channels/m365/
  // signature.js logs its own warning server-side; never invented here). The
  // actual decision is a pure, unit-tested function (suggestionActionInputs.js)
  // — this is just the thin JSX-side wiring.
  function signatureSeed() {
    // eBay: the same load-time rule as every other text in the box, so the
    // seeded signature is resolved exactly as the send path would resolve it.
    if (isEbayChannel) return signatureTemplate ? draftBoxText(signatureTemplate) : ''
    return signatureSeedFor(isEbayChannel, resolvedSignatureTemplate, htmlToPlainText)
  }
  // What a BLANK box is seeded with (2026-10-12): one blank line above the
  // signature, an empty paragraph in an email box and a blank line in an eBay
  // box. signatureSeed() stays the bare signature, since it is also what the
  // signature-only and template-insert checks compare against. A draft the
  // AI wrote is never touched; only a box seeded blank gets the line.
  // The signature the reply box adds (2026-10-19), as plain text for the
  // agent draft's column: the same resolved template, through the same
  // draftBoxText(), and an email box's HTML as text.
  const shadowSignature = resolvedSignatureTemplate
    ? (isEbayChannel ? draftBoxText(resolvedSignatureTemplate) : htmlToPlainText(draftBoxText(resolvedSignatureTemplate)))
    : null
  function blankBoxSeed() {
    return withBlankLineAboveSignature(signatureSeed(), { plain: isEbayChannel })
  }

  const [suggestion, setSuggestion] = useState(null)
  // The agent's shadow draft beside the current suggestion (2026-10-16;
  // docs/agent-draft-shadow.md). showShadowCompare: an admin not in View as
  // Agent (App.jsx's effectiveIsAdmin); otherwise nothing is fetched or shown.
  // Side by side on a wide viewport, stacked below on a narrow one; one
  // collapse control, remembered per browser. onShadowCompareSideChange tells
  // App.jsx to widen the column while it is side by side and expanded.
  const shadowDraft = useShadowDraft(conversationId, suggestion?.id ?? null, showShadowCompare)
  // With the agent's draft as the suggestion's (2026-10-21, a primary
  // intent), the comparison shows the pipeline's draft and note instead,
  // "Pipeline draft (not used)" (shadowDraft.js's comparisonDraft()).
  const compareDraft = comparisonDraft(shadowDraft)
  // The pipeline's draft already ends with its signature.
  const compareSignature = compareDraft?.pipelineNotUsed ? null : shadowSignature
  // The agent draft's own Translate fetch (2026-10-20, useShadowTranslation.js):
  // when the draft lands after Translate was clicked, or the suggestion was
  // regenerated with Translate on.
  const shadowTr = useShadowTranslation({ conversationId, draft: shadowDraft, showTranslation, cached: shadowDraftTranslation, enabled: showShadowCompare })
  const [shadowCollapsed, setShadowCollapsed] = useState(() => readShadowCompareCollapsed(shadowCompareStorage()))
  const wideViewport = useMediaQuery(`(min-width:${SHADOW_COMPARE_MIN_VIEWPORT}px)`)
  // The pipeline comparison on demand (2026-11-02, Jenn): with the agent's
  // draft as the main one, "Pipeline draft (not used)" stays hidden until
  // an admin clicks "Compare with pipeline draft" in the main panel's
  // Details. Per contact view: another contact starts hidden again, and the
  // remembered collapse is not used for it.
  const pipelineOnDemand = showShadowCompare && pipelineCompareOnDemand(compareDraft)
  const [pipelineCompareOpen, setPipelineCompareOpen] = useState(false)
  const [pipelineCompareFor, setPipelineCompareFor] = useState(conversationId)
  if (pipelineCompareFor !== conversationId) {
    setPipelineCompareFor(conversationId)
    setPipelineCompareOpen(false)
  }
  const shadowMode = shadowCompareMode({ enabled: showShadowCompare, draft: shadowDraft, wide: wideViewport, collapsed: shadowCollapsed, onDemand: pipelineOnDemand, open: pipelineCompareOpen })
  useEffect(() => {
    onShadowCompareSideChange?.(shadowMode === 'side')
  }, [shadowMode, onShadowCompareSideChange])
  useEffect(() => () => { onShadowCompareSideChange?.(false) }, [onShadowCompareSideChange])
  function toggleShadowCompare() {
    if (pipelineOnDemand) {
      setPipelineCompareOpen((o) => !o)
      return
    }
    setShadowCollapsed((c) => {
      writeShadowCompareCollapsed(shadowCompareStorage(), !c)
      return !c
    })
  }
  // A task's moved / not-moved choice (2026-10-15), restored from the
  // suggestion's own record on load.
  const [taskChoice, setTaskChoice] = useState(null)
  // A Return Status stage's date (2026-10-21): the carrier's estimated
  // delivery or delivered date, YYYY-MM-DD, recorded with the choice.
  const [taskChoiceDate, setTaskChoiceDate] = useState('')
  // The choice step's own error line (2026-10-28): { index, kind, message }.
  // kind 'save': the choice or date could not be recorded (Send stays
  // blocked); 'refused': the server refused Send for the choice (shown on
  // the step, scrolled into view and highlighted, never as a banner).
  const [taskChoiceError, setTaskChoiceError] = useState(null)
  const taskChoiceBoxRef = useRef(null)
  // The newer suggestion held behind "Load new draft" because a Process,
  // Close or Spam reached a suggestion a Regenerate replaced (2026-10-28):
  // its notice reads "This contact was regenerated. ...".
  const [regeneratedNoticeId, setRegeneratedNoticeId] = useState(null)
  // The resolution switch (2026-10-27): each path's reply as the person
  // left it.
  const replyByPathRef = useRef({})
  const [draft, setDraft] = useState('')
  // The reply box in English (2026-10-30, docs/agent-draft-shadow.md
  // "Fitment before a purchase"): on every channel, eBay included, when the
  // reply in the box is not English, re-translated as the CSR edits it
  // (debounced), so what they approve is what is sent. Send always sends the
  // box's own text, never this view. { english, language } or null.
  const [liveEnglish, setLiveEnglish] = useState(null)
  // The CSR's correct part (2026-10-30): { suggestionId, sku, steps } once used.
  const [correctPart, setCorrectPart] = useState(null)
  const liveEnglishOffRef = useRef(false)
  useEffect(() => {
    if (screenMode || !conversationId || liveEnglishOffRef.current || !mayBeForeign(draft)) { setLiveEnglish(null); return undefined }
    const controller = new AbortController()
    const t = setTimeout(() => {
      translateDraft(conversationId, draft, { html: /<[a-z][^>]*>/i.test(draft), signal: controller.signal })
        .then((r) => setLiveEnglish(r?.english ? { english: r.english, language: r.language ?? null } : null))
        .catch((e) => {
          if (e?.name === 'AbortError') return
          // Translation off (403) or failing: stop asking for this panel.
          if (/403|translation_disabled/.test(String(e?.message ?? ''))) liveEnglishOffRef.current = true
          setLiveEnglish(null)
        })
    }, DRAFT_TRANSLATION_DEBOUNCE_MS)
    return () => { clearTimeout(t); controller.abort() }
  }, [draft, conversationId, screenMode])
  // The template a CSR last inserted in the main reply box ({ folder, title }),
  // sent with the decision as the reply's template (docs/decisions.md,
  // 2026-10-01). Cleared when the box is emptied or a different suggestion
  // loads.
  const [draftInsertedTemplate, setDraftInsertedTemplate] = useState(null)
  // The inserted template's id, for a Send Feedback report's screen state
  // (2026-10-29); insertedTemplateOf() keeps only folder and title.
  const draftInsertedTemplateIdRef = useRef(null)
  // Live pre-Send warning (eBay contact/payment-info policy) — cheap plain
  // regex, recomputed on every keystroke, no debounce needed. eBay-only:
  // restrictedInfoWarning() itself warns specifically about eBay's own
  // guidelines (see restrictedInfoCheck.js), so it must never fire for a
  // non-eBay (e.g. M365 email) reply, which has no such policy.
  const draftRestrictedWarning = useMemo(() => (isEbayChannel ? restrictedInfoWarning(draft) : null), [draft, isEbayChannel])
  // Live pre-Send warning for a leftover unfilled INSERT* placeholder token —
  // same "recompute live off the current value" approach, no stale state.
  // The RMA token of an RMARTN Cust Pays reply (2026-10-27, rmaReference.js)
  // has its own rule below (filled from the return step, or Send blocked
  // until the return is processed), so it is left out of this check.
  const draftPlaceholderWarning = useMemo(() => unfilledPlaceholderWarning(withoutRmaReferenceToken(draft)), [draft])
  // A Walmart reply with a link (2026-10-15; walmartReply.js): warned like an
  // unfilled placeholder, and Send stays disabled until it is removed.
  const walmartLinkReason = useMemo(() => walmartLinkWarning({ client, trqClientCode: templateTrqClientCode, text: draft }), [client, templateTrqClientCode, draft])
  // The signature names someone else (2026-10-30, @cxhub/shared's
  // signatureNameMismatch()): warned with a one-click fix; Send is never
  // blocked by it. The server logs the same check at send (ids only).
  const signatureInfo = companySignatureInfo(templateAccount)
  const draftSignatureMismatch = useMemo(() => signatureNameMismatch(draft, signatureInfo, agentFirstName), [draft, signatureInfo, agentFirstName])
  function fixDraftSignature() {
    touchedRef.current = true
    setDraft((d) => fixSignatureName(d, signatureInfo, agentFirstName))
  }
  function fixStepSignature(i) {
    touchedRef.current = true
    setActionInputs((prev) => ({ ...prev, [i]: { ...(prev[i] ?? {}), editedMessage: fixSignatureName(prev[i]?.editedMessage ?? '', signatureInfo, agentFirstName) } }))
  }
  const [loading, setLoading] = useState(true)
  const [busy, setBusy] = useState(false)
  // The quiet stale check on open (quietStaleCheck.js): it shows no
  // "Regenerating…" and leaves the draft editable, but Send, Process all
  // and the decision buttons wait for it (decideBusy): a decision taken
  // while it runs would let the new suggestion it persists land after the
  // reply was already sent.
  const [quietChecking, setQuietChecking] = useState(false)
  const decideBusy = busy || quietChecking
  // The suggestion the quiet check applied with no work to lose: shows
  // "Updated with new information" while it is the one on screen.
  const [quietUpdatedId, setQuietUpdatedId] = useState(null)
  const [error, setError] = useState(null)
  // The reply after Process all switched to the house template (2026-10-29,
  // houseTemplateReply.js): the line under the button, until the next
  // Process, Send or contact.
  const [houseReplyNote, setHouseReplyNote] = useState(null)
  // Distinct from `error`: a 404/no_inbound_turn from generateSuggestion means
  // the server closed this conversation (its latest message is already
  // outbound — nothing new to answer) rather than genuinely failing. Shown
  // as a plain informational note, not an error banner.
  const [closedNotice, setClosedNotice] = useState(null)
  // A contact with no messages at all (2026-10-16; prod contact 5670872):
  // nothing to answer, so the panel offers to close it.
  const [noMessages, setNoMessages] = useState(false)
  const [closingEmpty, setClosingEmpty] = useState(false)
  // A Regenerate or step refresh that came back deferred for a TRQ retry
  // (2026-10-14, ui/src/trqRetryNotice.js); cleared on every new attempt.
  const [retryDeferral, setRetryDeferral] = useState(null)
  // A newer suggestion held back because the agent has unsaved edits (a new
  // buyer message regenerated the contact, 2026-10-13). Shown as the
  // "New buyer message" notice; "Load new draft" applies it.
  const [newerSuggestion, setNewerSuggestion] = useState(null)
  // Admin takeover of a contact queued for Flows automation (migration 0087).
  // pendingAction, when set, is what Process/Close/Escalate/Spam WOULD have
  // done — run only after the confirm dialog's "Take over" succeeds.
  // takeoverBusy/takeoverError cover both the confirm dialog's own request
  // and a bare 409 automation_pending surfaced from Process itself (a stale
  // page — see handleProcessStep's own catch below), which reuses this same
  // dialog rather than a separate one.
  const [automationTakeoverConfirm, setAutomationTakeoverConfirm] = useState(null) // { pendingAction: () => void } | null
  // The double-reply guard (related contacts, 2026-10-20): { message,
  // proceed } while "We replied to this customer on #… Send anyway?" is open.
  const [recentReplyConfirm, setRecentReplyConfirm] = useState(null)
  // The Send warnings dialog (2026-10-30, sendWarnings.js): { warnings,
  // proceed(codes, markedNotNeeded), markedNotNeeded } while it is open.
  const [sendWarningsAsk, setSendWarningsAsk] = useState(null)
  // The refund documents a Templates fill read on this screen (2026-10-30):
  // the Send warning's "The order shows RTN…" before the suggestion reloads.
  // { suggestionId, docs }.
  const [templateRefundDocs, setTemplateRefundDocs] = useState({ suggestionId: null, docs: [] })
  // "Process all steps and send reply" (2026-10-23): the confirmation with
  // the steps that will run ({ indexes, status }), or null.
  const [processAllConfirm, setProcessAllConfirm] = useState(null)
  const [takeoverBusy, setTakeoverBusy] = useState(false)
  const [takeoverError, setTakeoverError] = useState(null)
  const isQueuedForAutomation = conversationStatus === 'waiting' && conversationWaitingReason === 'automation'

  // Runs `action` immediately unless this contact is queued for automation,
  // in which case it opens the takeover confirm dialog instead — action runs
  // only once takeover actually succeeds. Every entry point that could
  // otherwise race automation (Process, Close, Escalate, Spam) goes through
  // this, so none of them can ever reach the server while automation might
  // still be about to run the same suggestion.
  function withAutomationTakeoverGuard(action) {
    return (...args) => {
      if (isQueuedForAutomation) {
        setAutomationTakeoverConfirm({ pendingAction: () => action(...args) })
        return
      }
      action(...args)
    }
  }

  async function confirmAutomationTakeover() {
    setTakeoverBusy(true); setTakeoverError(null)
    try {
      await takeoverAutomation(conversationId)
      const pendingAction = automationTakeoverConfirm?.pendingAction
      setAutomationTakeoverConfirm(null)
      onDecided?.('open') // conversation is now open — refresh the status chip/banner right away
      pendingAction?.()
    } catch (e) {
      if (e.status === 409 && e.body?.error === 'automation_running') {
        setTakeoverError('Automation is running this contact right now; refresh in a moment.')
      } else if (e.status === 409) {
        setTakeoverError('This contact is no longer queued for automation — refreshing.')
        onDecided?.(e.body?.status ?? 'open')
        setAutomationTakeoverConfirm(null)
      } else {
        setTakeoverError(e.message)
      }
    } finally {
      setTakeoverBusy(false)
    }
  }
  const [spamDialogOpen, setSpamDialogOpen] = useState(false)
  // Escalate requires a reason note (see the modal below) — captured here
  // rather than in the modal itself so it survives the modal being closed
  // and reopened without losing an in-progress draft.
  const [escalateModalOpen, setEscalateModalOpen] = useState(false)
  const [escalateNoteDraft, setEscalateNoteDraft] = useState('')
  // Transfer to Support (2026-10-08): Escalate's modal pattern, a required
  // note; only for a contact whose effective team is Customer Service.
  const [transferModalOpen, setTransferModalOpen] = useState(false)
  const [transferNoteDraft, setTransferNoteDraft] = useState('')
  // Close - No Reply Needed on a task contact needs a note, its task's close
  // note (Tasks Phase 1, 2026-10-13).
  const [closeNoteOpen, setCloseNoteOpen] = useState(false)
  const [closeNoteDraft, setCloseNoteDraft] = useState('')
  // No reply box on a task contact whose response is not an email (an eBay
  // order's goes from its step; Amazon and unrouted have none).
  const noDraftBoxFn = (args) => hasNoDraftBoxOfItsOwn(args) || Boolean(taskContact?.noDraftBox)
  // A task contact (2026-10-13): no Escalate, no Spam, and its email response
  // is only ever a new email, so the reply-mode toggle is hidden (it shows
  // only when more than one mode is available). The server refuses escalate
  // and spam on a task too (routes/ai.js).
  const isTask = Boolean(taskContact?.isTask)
  const replyModes = isTask ? ['new'] : ['reply', 'new']
  const canTransferToSupport = templateTeam === 'customer_service'
  // For an admin who just marked as spam: onDecided (which deselects the
  // conversation in App.jsx) is deferred until the New Spam Rule dialog
  // below is dismissed, rather than fired immediately — deselecting right
  // away would null out Thread's `conversation` prop and unmount this whole
  // panel (dialog included) before the admin ever saw it. The conversation
  // LIST itself still refreshes immediately regardless (onSpamMarked, in
  // onSpam() below) — only the deselect/unmount is what's deferred.
  const [pendingSpamStatus, setPendingSpamStatus] = useState(null)
  const [actionInputs, setActionInputs] = useState({})
  // Re-render when a Manual Panel window opens or closes a step slot.
  useSyncExternalStore(subscribeStepSlots, stepSlotsVersion)
  // An edited address step the reply doesn't show (2026-10-19, prod contact
  // 7986822; addressReplyMismatch.js). A warning only, the reply is never
  // rewritten.
  const addressMismatchReason = useMemo(() => addressReplyMismatchWarning({ actions: suggestion?.proposedActions, actionInputs, reply: draft }), [suggestion?.proposedActions, actionInputs, draft])
  const [executionErrors, setExecutionErrors] = useState(null)
  const [replySendError, setReplySendError] = useState(null)
  // stepStates: { [index]: { status: 'idle'|'processing'|'success'|'failed', result: any, error: string|null } }
  const [stepStates, setStepStates] = useState({})
  // Other Actions' reply pasted into the draft reply (2026-10-30,
  // ManualStepReply.jsx): step index -> when (ISO). Reset per suggestion.
  const [manualPasted, setManualPasted] = useState({})
  // Return steps waiting on the OMS API (2026-10-29): read on open, after a
  // Process that left one waiting, and on Check now.
  const [returnLabelsKey, setReturnLabelsKey] = useState(0)
  const returnLabels = useReturnLabels(conversationId, returnLabelsKey + refreshKey)
  const zeroDollarTypical = useZeroDollarTiming()
  const labelChannelKind = (channel ?? 'ebay') === 'ebay' || ['1AE', 'AME'].includes(String(templateTrqClientCode ?? '').toUpperCase()) ? 'ebay' : 'email'
  // A $0 RMA reason code with its optional label step turned on (Jenn,
  // 2026-10-29; off by default since 2026-10-30): the draft gets the "label
  // will follow" sentence once per code; never twice (idempotent), and never
  // again after the person turns it off or deletes it. Off, nothing.
  const zeroSeededRef = useRef(new Set())
  const zeroSeedKey = zeroDollarSeedKey(suggestion?.proposedActions, actionInputs)
  const draftLoaded = Boolean(String(draft ?? '').trim())
  useEffect(() => {
    if (!suggestion?.id || !zeroSeedKey || !draftLoaded) return
    const key = `${suggestion.id}|${zeroSeedKey}`
    if (zeroSeededRef.current.has(key)) return
    zeroSeededRef.current.add(key)
    setDraft((prev) => draftWithZeroDollarChoice(prev, { zeroDollar: true, checked: true, channelKind: labelChannelKind }))
  }, [suggestion?.id, zeroSeedKey, draftLoaded, labelChannelKind])
  // An RMARTN Cust Pays reply's refund lines follow the return step
  // (2026-10-27): Original Refund, Return Label Deduction and Final Refund
  // update whenever the step's breakdown changes (Check, or the person
  // editing the deduction or the shipping option). Only a reply that has the
  // three lines; an amount not known yet leaves its line as it is.
  const rmaStepIdxForAmounts = rmaReferenceStepIndex(suggestion?.proposedActions ?? [])
  const rmaStepInputs = rmaStepIdxForAmounts >= 0 ? actionInputs[rmaStepIdxForAmounts] : null
  useEffect(() => {
    const original = Number(rmaStepInputs?.itemsTotal)
    // The read-only screen view keeps the box exactly as it was.
    if (screenMode) return
    if (rmaStepInputs?.itemsTotal == null || !Number.isFinite(original)) return
    const option = rmaStepInputs?.shippingPaymentOption ?? 'customerCost'
    const rawDeduction = option === 'customerShipsOwn' ? 0 : rmaStepInputs?.shippingDeduction
    const deduction = rawDeduction == null || rawDeduction === '' || !Number.isFinite(Number(rawDeduction)) ? null : Number(rawDeduction)
    const amounts = { original, deduction, final: deduction == null ? null : Math.round((original - deduction) * 100) / 100 }
    setDraft((prev) => (hasRefundBreakdownLines(prev) ? setRefundAmountLines(prev, amounts) : prev))
  }, [rmaStepInputs?.itemsTotal, rmaStepInputs?.shippingDeduction, rmaStepInputs?.shippingPaymentOption])
  // The link to the correct part (2026-10-27, rmartn_part_link): by step
  // index, { link, sku, warranty, needsSku, busy, filledLink, filledWarranty }.
  const [partLinks, setPartLinks] = useState({})
  // The agent draft panel's step checkboxes (2026-10-26): the unchecked step
  // indexes. Every step starts checked; the set is recorded on the
  // suggestion (POST .../step-checks) and restored from its call log, so a
  // reload or another person sees it.
  const [uncheckedSteps, setUncheckedSteps] = useState([])
  // The steps the person marked "My reply doesn't need this" (2026-10-27,
  // send blocks follow the reply): their block is lifted for this reply and
  // the decision records them (skippedSteps, csr_marked_not_needed).
  const [notNeededSteps, setNotNeededSteps] = useState([])
  // Park saves the work (2026-10-27, workDraft.js, ParkComparePanel.jsx;
  // docs/decisions/2026-10-27-park-saves-work.md). restoredLine: "Restored
  // your work from …"; parkCheckLine: "Checked for changes: nothing new …";
  // parkCompare: { compare, parked, fresh, work } while unpark's "Since you
  // parked this" panel asks; parkChoices: its per-item picks; parkStepWarnings
  // and parkStepNotes: per step index, shown on the step itself.
  const [restoredLine, setRestoredLine] = useState(null)
  const [parkCheckLine, setParkCheckLine] = useState(null)
  // What changed when only facts or a new message did (2026-10-28): listed
  // in the strip under parkCheckLine.
  const [parkChangeLines, setParkChangeLines] = useState([])
  const [parkChecking, setParkChecking] = useState(false)
  const [parkCompare, setParkCompare] = useState(null)
  const [parkChoices, setParkChoices] = useState({})
  const [parkBusy, setParkBusy] = useState(false)
  const [parkError, setParkError] = useState(null)
  const [parkStepWarnings, setParkStepWarnings] = useState({})
  const [parkStepNotes, setParkStepNotes] = useState({})
  // The restored / checked strip (ParkInfoStrip.jsx) stays until the CSR
  // edits something, ticks a step's checkbox, clicks Process, sends, or
  // closes it with its x.
  const [parkStripHidden, setParkStripHidden] = useState(false)
  // The conversation whose park restore (restoreSavedWork()) is running: its
  // regeneration goes only through the park compare, so nothing else applies
  // or asks about a new suggestion for it meanwhile.
  // { conversationId, token }.
  const parkRestoringRef = useRef(null)
  // The new suggestion an open "A new suggestion is ready" dialog asks about,
  // { conversationId, id }: a refresh meanwhile leaves it to the dialog.
  const askingNewSuggestionRef = useRef(null)
  // A function returning the CSR's work as of the latest render (carryWorkTo()).
  const latestWorkRef = useRef(null)
  const [askConfirm, confirmDialog, dismissConfirm] = useConfirmDialog()
  // What a restore puts back that an effect keyed on the suggestion would
  // otherwise reset (the CC, the template, the part links, an internal
  // email's box): { conversationId, suggestionId, cc, template, partLinks, draft }.
  const pendingRestoreRef = useRef(null)
  // The autosave's last saved fingerprint (workDraft.js's workFingerprint()).
  const workSavedFpRef = useRef(null)
  // Only real work is saved (2026-10-30, docs/decisions/2026-10-30-restored-
  // work-signature-owner.md): set by the person's own action on this contact
  // (typing in the reply or a step / note box, a template, a reason code,
  // items, a disposition or a path, a checkbox, an attachment, a step marked
  // not needed), never by a load, a regenerate, a restore, a reseed, step
  // defaults or name resolution. No touch, no save.
  const touchedRef = useRef(false)
  // Whether the restored work was someone else's (the strip's "Start from
  // the AI draft instead").
  const [restoredFromOther, setRestoredFromOther] = useState(false)
  // checkStates: { [index]: { status: 'idle'|'checking'|'checked'|'failed', result: any, error: string|null } }
  // Only used by process_return_refund — a non-destructive disposition
  // preview shown before the Process button appears for that step.
  const [checkStates, setCheckStates] = useState({})
  // The reply follows the agent's own steps (2026-10-30,
  // agentReplyFollowsSteps.js): with modelMeta.stepsSource 'agent', the
  // reply's refund amount is the step's, filled again whenever the person
  // changes the step (keeping every other edit), and a change of the step's
  // outcome (Return / Scrap, who pays) offers that outcome's reply through
  // the house template switch. The items' total for the current selection
  // counts only once the person changed the items (the stored check's
  // amounts until then, so nothing moves on load).
  const ownStepsShown = agentStepsShown(suggestion)
  const liveOriginalFor = (i) => {
    const a = suggestion?.proposedActions?.[i]
    const items = actionInputs?.[i]?.items
    const all = a?.itemSelection?.allItems ?? []
    if (!all.length || !Array.isArray(items) || !items.length || orderSummaryOrderTax == null || orderSummaryOrderTotal == null) return null
    const key = (list) => (list ?? []).map((x) => `${x.sku}x${Number(x.quantity) || 1}`).sort().join(',')
    if (key(items) === key(a.itemSelection.defaultSelected)) return null
    const allItems = fillMissingUnitCost(all, orderSummaryItemDetails)
    const lineTaxes = computeLineTax(allItems, { orderTax: orderSummaryOrderTax, shippingCost: orderSummaryShippingCost, orderTotal: orderSummaryOrderTotal })
    const { itemsTotal, unresolvedSkus } = estimatedRefundBreakdown({ allItems, selectedItems: items, lineTaxes, deduction: 0 })
    return (unresolvedSkus ?? []).length || !Number.isFinite(itemsTotal) ? null : itemsTotal
  }
  const liveRefundList = ownStepsShown ? liveRefunds(suggestion?.proposedActions ?? [], { inputs: actionInputs, checkStates, unchecked: uncheckedSteps, originalFor: liveOriginalFor }) : []
  const replyRefund = replyRefundOf(liveRefundList)
  const replyKindNow = replyRefund ? replyKindFor(replyRefund) : null
  const refundFilledRef = useRef({ id: null, amount: null, kind: null })
  useEffect(() => {
    if (screenMode || !ownStepsShown || !suggestion?.id) return
    const step = replyRefund ? suggestion.proposedActions?.[replyRefund.index] : null
    if (refundFilledRef.current.id !== suggestion.id) {
      refundFilledRef.current = { id: suggestion.id, amount: step?.params?.replyRefundFilled ?? null, kind: step?.params?.replyKind ?? null }
    }
    if (!replyRefund || replyRefund.final == null || refundFilledRef.current.amount === replyRefund.final) return
    const previous = refundFilledRef.current.amount
    refundFilledRef.current = { ...refundFilledRef.current, amount: replyRefund.final }
    setDraft((prev) => {
      const next = refilledReply(prev, { previous, refund: replyRefund })
      // CXHub's own refill (2026-11-02): an untouched reply stays untouched,
      // so a later template switch does not ask (replyEdited.js).
      if (!isReplyEdited({ box: prev, baseline: appliedDraftRef.current, signature: signatureSeed() })) appliedDraftRef.current = next
      liveDraftRef.current = next
      return next
    })
  }, [suggestion?.id, ownStepsShown, replyRefund?.final, replyRefund?.original, replyRefund?.deduction])
  useEffect(() => {
    if (screenMode || !ownStepsShown || !replyRefund || !replyKindNow || refundFilledRef.current.id !== suggestion?.id) return
    const action = suggestion?.proposedActions?.[replyRefund.index]
    const offer = outcomeReplyFor(action, replyRefund, { lastKind: refundFilledRef.current.kind })
    refundFilledRef.current = { ...refundFilledRef.current, kind: replyKindNow }
    if (!offer) return
    ;(async () => {
      if (await switchToHouseReply(offer.house, { action })) refundFilledRef.current = { ...refundFilledRef.current, amount: replyRefund.final }
    })()
  }, [replyKindNow])
  // Which QA dimension chip's explanatory-note Tooltip is currently open —
  // these are click-triggered, not hover-triggered, so only one at a time is
  // shown and it's tracked explicitly rather than via Tooltip's own hover state.
  const [openQaKey, setOpenQaKey] = useState(null)
  const [refreshingDraft, setRefreshingDraft] = useState(false)
  // Ad-hoc reply on an already-closed FROM_MEMBERS conversation — additive to
  // (not a replacement for) the decided-suggestion history above. See
  // onSendManualReply()/the "New reply" section below.
  const [closedReplyDraft, setClosedReplyDraft] = useState('')
  // Same, for the closed-conversation reply box.
  const [closedReplyInsertedTemplate, setClosedReplyInsertedTemplate] = useState(null)
  // eBay-only — see draftRestrictedWarning's own comment above.
  const closedReplyRestrictedWarning = useMemo(() => (isEbayChannel ? restrictedInfoWarning(closedReplyDraft) : null), [closedReplyDraft, isEbayChannel])
  const closedReplyPlaceholderWarning = useMemo(() => unfilledPlaceholderWarning(closedReplyDraft), [closedReplyDraft])
  const [closedReplyBusy, setClosedReplyBusy] = useState(false)
  const [closedReplyError, setClosedReplyError] = useState(null)
  const [feedbackOpen, setFeedbackOpen] = useState(false)
  const [feedbackText, setFeedbackText] = useState('')
  const [feedbackBusy, setFeedbackBusy] = useState(false)
  const [feedbackError, setFeedbackError] = useState(null)
  const [feedbackSuccess, setFeedbackSuccess] = useState(false)
  // Holds the captured screenshot Blob (or null) between capture and Submit —
  // a ref, not state: nothing about it is ever rendered (see
  // feedbackScreenshot.js's own comment on why this stays invisible to the
  // agent), so there's no reason to re-render when it changes.
  // The background screenshot capture started by Send Feedback
  // (feedbackScreenshot.js's startFeedbackCapture(): { promise }).
  const feedbackScreenshotRef = useRef(null)
  // Submit is waiting for that capture ("Attaching screenshot…").
  const [feedbackAttaching, setFeedbackAttaching] = useState(false)
  // What Send Feedback sends besides the text (2026-10-26, feedbackUiState.js):
  // when this contact was opened in this session and the last Send/Process
  // attempt with the message shown. Refs: nothing here is rendered.
  const feedbackOpenedAtRef = useRef(null)
  const lastAttemptRef = useRef(null)
  useEffect(() => {
    feedbackOpenedAtRef.current = new Date().toISOString()
    lastAttemptRef.current = null
  }, [conversationId])
  // eBay INR case history — expanded by default (full history shown), with a
  // toggle to collapse it away.
  const [historyExpanded, setHistoryExpanded] = useState(true)
  // Re-read the inquiry's History from eBay when a suggestion with one is
  // shown, open or closed (2026-10-23; the server caches it a few minutes per
  // inquiry). New entries replace the shown History; a failure leaves the
  // stored History on screen.
  const caseHistoryRefreshable = hasRefreshableCaseHistory(suggestion)
  useEffect(() => {
    const id = suggestion?.id
    if (screenMode || !id || !caseHistoryRefreshable) return undefined
    let active = true
    refreshCaseHistory(id)
      .then((res) => {
        if (!active || !Array.isArray(res?.history)) return
        setSuggestion((prev) => withRefreshedCaseHistory(prev, id, res.history))
      })
      .catch(() => {})
    return () => { active = false }
  }, [suggestion?.id, caseHistoryRefreshable])

  // "Reviewed by Mgmt" checkbox (spam intent only) — local state seeded from
  // the conversation prop, updated optimistically on toggle (flips
  // immediately, then reconciled with — or reverted from — the PATCH
  // response) rather than waiting on a full conversation refetch.
  const [reviewedByMgmt, setReviewedByMgmtState] = useState(reviewedByMgmtProp)
  const [reviewedByMgmtUser, setReviewedByMgmtUserState] = useState(reviewedByMgmtUserProp)
  const [reviewedByMgmtBusy, setReviewedByMgmtBusy] = useState(false)
  useEffect(() => {
    setReviewedByMgmtState(reviewedByMgmtProp)
    setReviewedByMgmtUserState(reviewedByMgmtUserProp)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId, reviewedByMgmtProp, reviewedByMgmtUserProp])

  // Starts empty except for the resolved signature on every conversation
  // switch — onSendManualReply() resets it back to this same bare state on a
  // successful send, so the box is never left with stale, already-sent text.
  useEffect(() => {
    setClosedReplyDraft(blankBoxSeed())
    setClosedReplyError(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId, resolvedSignatureTemplate])

  // From/To/Subject for an email reply. To/Subject are editable, UI-capture
  // only (no backend send path exists for M365 outbound today). From is
  // display-only — it shows the server's resolved `outboundFrom` (the
  // mailbox's own address, or the brand send identity for a no-reply internal
  // mailbox), falling back to the receiving address when the server hasn't
  // resolved one. Seeded once per conversation SELECTION, same pattern as
  // closedReplyDraft above, not on every Regenerate, so an agent's edits to
  // To/Subject survive re-drafting the body.
  const [draftFrom, setDraftFrom] = useState('')
  const [draftTo, setDraftTo] = useState('')
  // A Site Automation / system notice with no customer email on the order:
  // Send is disabled with the reason (noticeReply.js; the server refuses too).
  // A task contact's email response is blocked while its Customer Support
  // mailbox's outbound mode is off (Tasks Phase 1, 2026-10-13; taskContact.js).
  const noticeToReason = taskContact?.sendBlockedReason ?? noticeToBlockReason({ inbound: lastInboundMessage, draftTo, channel })
  const [draftSubject, setDraftSubject] = useState('')
  // A task's email response needs a Subject the agent types (2026-10-13), as
  // any new email does; the server refuses one without (send-approved-reply.js).
  const taskSubjectMissingReason = taskContact?.isTask && !taskContact?.noDraftBox && !draftSubject.trim() ? 'Enter a Subject before sending.' : null
  // Nothing is Sent before a task's moved / not-moved choice (2026-10-15).
  // A Return Status contact's in-transit / delivered choice needs its date
  // too (2026-10-21; @cxhub/shared's taskPathDateMissing()).
  // Since 2026-10-27 the block follows the reply (@cxhub/shared's
  // step-blocks.js): only while the reply is empty, still one of the
  // choice's templates or keeps its INSERTDATE, and not marked "My reply
  // doesn't need this". The server's decision route asks the same.
  const taskChoiceStep = taskPathChoiceStep(suggestion?.proposedActions)
  const taskChoiceStepIndex = taskChoiceStep ? (suggestion?.proposedActions ?? []).indexOf(taskChoiceStep) : -1
  // The path that is on (2026-10-29, @cxhub/shared's returnStagePathKey()):
  // the choice, or the overdue refund's path for a return delivered past its
  // refund window. Steps show by it; changing the stage or its date
  // re-decides it.
  const taskPathKey = returnStagePathKey(taskChoiceStep, { choice: taskChoice, date: taskChoiceDate })
  // The overdue refund's live values (2026-10-29, overdueRefund.js): what the
  // email and the refund card fill as the CSR enters them.
  const overdueLive = overdueLiveValues({ actions: suggestion?.proposedActions ?? [], choice: taskChoice, date: taskChoiceDate, inputs: actionInputs, stepStates })
  // A choice or date that could not be recorded keeps Send blocked
  // (2026-10-28): the server checks the recorded one, not the panel's. Only
  // "My reply doesn't need this" lifts it.
  const taskChoiceSaveFailed = taskChoiceError?.kind === 'save' && taskChoiceError.index === taskChoiceStepIndex
  const taskChoiceBlockState = (state) => (taskChoiceSaveFailed && state.reason !== SKIP_CSR_MARKED_NOT_NEEDED ? { applies: true, reason: null, why: 'unsaved' } : state)
  const taskChoiceBlock = taskChoiceStep && (taskChoiceSaveFailed || !taskChoice || taskPathDateMissing(taskChoiceStep, { choice: taskChoice, date: taskChoiceDate }))
    ? { index: taskChoiceStepIndex, ...taskChoiceBlockState(stepBlockState(taskChoiceStep, taskChoiceStepIndex, draft, { actions: suggestion?.proposedActions ?? [], signature: signatureSeed(), notNeeded: notNeededSteps })) }
    : null
  // While the regenerated compare asks (2026-10-28), Send and Process (a
  // step's, and Process all) wait for its Done: the CSR chooses before
  // anything is sent or processed. Close stays available.
  const regeneratedBlock = regeneratedCompareBlock(parkCompare)
  const taskChoiceMissingReason = regeneratedBlock
    ? regeneratedBlock
    : taskChoiceBlock?.applies
      ? (taskChoiceSaveFailed ? taskChoiceError.message : (taskChoiceStep.params?.missingReason ?? 'Choose whether the package has moved first.'))
      : null
  // "Reply to Email" ('reply', threaded — the current, only-ever behavior)
  // vs "Send New Outbound Email" ('new', unthreaded) — m365_email only.
  // Defaults per-conversation from the inbound sender's own domain (an
  // internal notice's own sender is never a real customer to reply into),
  // but stays a plain, agent-overridable toggle from there — never re-
  // derived once the CSR has touched it for this conversation (same
  // "seeded once per conversation SELECTION" scope as draftFrom/To/Subject
  // above).
  const [replyMode, setReplyMode] = useState('reply')
  // "Start a new contact" (2026-10-27): with Send New Outbound Email, the
  // email is recorded on THIS contact (its Messages, reopen on reply, the
  // customer's reply threads here) unless the person marks it a new topic.
  const [startNewContact, setStartNewContact] = useState(false)
  useEffect(() => {
    const contactForm = lastInboundMessage?.metadata?.contactForm
    // A Leave Us a Message form follows the same rule: its own parsed email
    // is the reply target, never the Reply-To/From headers (both our own
    // service@ address when it arrives self-addressed via Mandrill).
    const leaveUsAMessage = lastInboundMessage?.metadata?.leaveUsAMessage
    setDraftFrom(outboundFrom ?? lastInboundMessage?.metadata?.receivedAtAddress ?? mailbox ?? '')
    // A contact-form submission's own customerEmail is the FIRST-choice reply
    // target (see contact-form.js) — but it can legitimately be null (an
    // incomplete submission, or a reply-thread body the quote-stripping fix
    // now correctly declines to extract fields from) without the whole
    // conversation being unreplyable. Falls through the SAME chain
    // pipeline.js (~2337) and send-approved-reply.js (~222) already use at
    // send time: the header address, then the conversation's own resolved
    // customer identity — never silently landing on '' while any of those
    // are available. An automated-return-notice has no "Email" field or
    // usable header at all (the sender is an internal automation, not the
    // customer) — the TRQ order's own email (resolved by App.jsx's
    // order-summary fetch) is tried first there, with the same final
    // fallback.
    // Sales Hold Phone Call's own internal ops notice OR its Azure DevOps
    // 'OB Call' work-item-change sibling (same subject match server/src/ai/
    // sales-hold-phone-call.js's isSalesHoldPhoneCallEmail() uses) has the
    // same "no real Email field" shape as an automated-return-notice — the
    // sender is an internal automation, not the customer — so it gets the
    // same order-email-first seed.
    const trimmedSubject = subject?.trim() ?? ''
    const isSalesHoldPhoneCall = trimmedSubject === 'Call Customer to Resolve Sales Hold' || /^OB Call\b/i.test(trimmedSubject)
    // A genuine Sales Hold Applied notice (subject "Sales Hold Applied to
    // <order>") has the same "sender is an internal automation, not the
    // customer" shape as automatedReturnNotice/isSalesHoldPhoneCall above —
    // Company 1A/AM + client Website only (an eBay-client Sales Hold never
    // reaches this draft box at all today — pipeline.js's own sales_hold
    // branches skip drafting a reply for it, the eBay-side message is its
    // own proposed step instead — but scoped explicitly anyway, matching the
    // actual product decision rather than relying on that side effect).
    const isSalesHoldApplied = trimmedSubject.startsWith('Sales Hold Applied to') && ['1AW', 'AMW', 'WMT'].includes(templateTrqClientCode)
    // Data Deletion Request (2026-09-25): same "internal notice, not a real
    // customer reply target" shape as the three above — but the draftTo
    // fallback for these is a compliance@ address, not a customer email at
    // all, so isDataDeletionRequest is folded into the SAME branch (the
    // server-resolved suggestion.customerEmail carries the compliance
    // address for this flow — see pipeline.js's own comment on that field).
    const isDataDeletionRequest = suggestion?.intent === 'data_deletion_request'
    // A Site Automation failure notice, or any system notice (2026-10-12,
    // prod 6355963; noticeReply.js): the To comes from the order only, never
    // the notice's own headers (our own mailbox), the participant id or any
    // internal address. Empty when the order has no customer email.
    const orderOnlyTo = isOrderOnlyToNotice(lastInboundMessage)
    setDraftTo(
      orderOnlyTo
        ? noticeSeedTo({ orderSummaryCustomerEmail, suggestionCustomerEmail: suggestion?.customerEmail })
        : lastInboundMessage?.metadata?.automatedReturnNotice || isSalesHoldPhoneCall || isSalesHoldApplied || isDataDeletionRequest
        // customerExternalUserId is NOT a safe fallback here — for these
        // same internal-automation-sender conversations it resolves to the
        // notice's own sending address (e.g. service@1aauto.com), the exact
        // failure mode this branch exists to avoid. suggestion?.customerEmail
        // is server-resolved (pipeline.js, now falling back to the Sales
        // Hold groundings' own order email — see that file's own comment)
        // and correct independent of whether the order-summary fetch
        // succeeded, so it's the safe second choice; customerExternalUserId
        // is kept only as a last resort that should basically never be
        // reached for these three cases.
        ? (orderSummaryCustomerEmail ?? suggestion?.customerEmail ?? customerExternalUserId ?? '')
        : (contactForm?.customerEmail
            ?? leaveUsAMessage?.customerEmail
            ?? lastInboundMessage?.metadata?.replyToHeader
            ?? lastInboundMessage?.metadata?.fromHeader
            ?? customerExternalUserId
            ?? '')
    )
    // Reply-mode default: an internal-domain sender (an Automated Return
    // Notice, an ops notice, etc.) is never a real customer to thread a
    // reply into — "Send New Outbound Email" is the sensible default there;
    // every other case defaults to "Reply to Email", today's only behavior.
    // messageKind === 'contact_form' is checked FIRST, ahead of the
    // internal-domain check: a contact-form submission's fromHeader is a
    // genuinely internal address by design (see mapper.js's own "THE
    // REPLY-ADDRESS TRAP" comment on parseContactForm/messageKind), so
    // without this it would default to 'new' even though it's a real
    // customer contact. This is safe: replyMode never affects who the email
    // is sent to (send-approved-reply.js always uses the independently-
    // resolved customerEmail, and client.js's sendReply() explicitly sets
    // toRecipients to that same address even on the threaded Graph /reply
    // call) — it only controls threading/subject/quoted-history — so
    // defaulting a contact-form's internal-address sender to "reply" doesn't
    // resurrect the reply-address trap the mapper.js comment warns about.
    // isDataDeletionRequest checked FIRST, ahead of the contact_form check
    // below — a data_deletion_request suggestion always originates from a
    // contact_form message (that's what parseContactForm() parsed), which
    // would otherwise default to 'reply'; this flow is a NEW, unthreaded
    // internal notice (never a reply to the customer at all), so 'new' must
    // win outright regardless of messageKind.
    // A Site Automation notice is answered with a new outbound email to the
    // order's customer, never a reply into the notice (2026-10-12).
    // An internal email (2026-10-12) is answered as a threaded reply, so the
    // other mailbox's thread continues, even though its sender is ours.
    // A task contact's email response is always a new email (2026-10-13).
    const defaultReplyMode = isInternalEmail
      ? 'reply'
      : isDataDeletionRequest || isSiteAutomationInbound(lastInboundMessage) || lastInboundMessage?.metadata?.messageKind === 'task'
      ? 'new'
      : ['contact_form', 'leave_us_a_message'].includes(lastInboundMessage?.metadata?.messageKind)
        ? 'reply'
        : isInternalNoticeSender(lastInboundMessage?.metadata?.fromHeader) ? 'new' : 'reply'
    // An account that picks a new outbound email's From by the order
    // (1A_SUPPORT_EMAIL, 2026-10-06; ui/src/newOutbound.js): a reply goes back
    // to the agent who wrote in, from the mailbox; a new outbound email goes to
    // the customer named in the body, from the brand's service@. Its sender is
    // always an internal agent, so the internal-sender default above does not
    // apply.
    const orderMode = followsOrderDefaultReplyMode(newOutbound, suggestion?.intent)
    const effectiveMode = orderMode ?? defaultReplyMode
    const orderAddresses = followsOrderAddresses(newOutbound, effectiveMode, followsOrderContext())
    if (orderAddresses) {
      setDraftFrom(orderAddresses.from)
      setDraftTo(orderAddresses.to)
    }
    setReplyMode(effectiveMode)
    setStartNewContact(false)
    // "Re: " prefix, same fallback text send-approved-reply.js's own
    // send-time default already applies (~line 256) when the Subject box is
    // sent empty — applied here too so the CSR sees the correctly-prefixed
    // subject up front, not just as a last-resort default at send time.
    // Stripped instead for the 'new' default — a brand-new outbound message
    // has nothing to reply to, so it should never start life looking like a
    // reply. A Sales Hold Applied notice's own subject ("Sales Hold Applied
    // to <order>") is never customer-facing wording — a fixed, real
    // customer-facing subject line replaces it entirely rather than
    // prefixing/deriving from the notice's own subject.
    setDraftSubject(
      isTask
        ? taskResponseSubject()
        : isDataDeletionRequest
        ? 'Customer Request to Delete Data'
        : isSalesHoldApplied
          ? 'Help! We need some information to ship your order.'
          : (subject ? applyReplyModeToSubject(subject, effectiveMode) : '')
    )
    // suggestion?.customerEmail: this effect otherwise only depends on
    // conversationId (seeded once per conversation SELECTION, deliberately
    // never re-derived once the CSR edits it — see this effect's own
    // comments above) — but on first mount for a freshly-opened conversation
    // the suggestion itself often hasn't loaded yet, so without this the
    // automatedReturnNotice/isSalesHoldPhoneCall/isSalesHoldApplied branch
    // above can seed draftTo from a still-null suggestion?.customerEmail and
    // never get another chance to pick up the real value once the
    // suggestion fetch resolves (the same class of gap orderSummaryCustomerEmail's
    // own async resolution still has, left as-is here — see the comment on
    // that variable above).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId, suggestion?.customerEmail, newOutbound?.available, newOutbound?.fromAddress])

  // An internal email (2026-10-12): no AI draft to load, so the box starts
  // blank (the blank line above the signature) on each open and after each
  // suggestion change; the seed is also the dirty baseline, so leaving
  // without typing never warns.
  useEffect(() => {
    if (!isInternalEmail) return
    if (pendingRestoreFor(suggestion?.id)?.draft != null) return
    const seed = blankBoxSeed()
    setDraft(seed)
    appliedDraftRef.current = seed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId, isInternalEmail, suggestion?.id, signatureTemplate])

  // The order summary (App.jsx's own fetch) often resolves after the box is
  // seeded. On a notice whose To comes from the order (2026-10-12), a late
  // customer email fills an empty To, never one the agent typed.
  useEffect(() => {
    if (!isOrderOnlyToNotice(lastInboundMessage)) return
    const candidate = noticeSeedTo({ orderSummaryCustomerEmail, suggestionCustomerEmail: suggestion?.customerEmail })
    if (candidate) setDraftTo((prev) => fillLateTo(prev, candidate))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId, orderSummaryCustomerEmail, suggestion?.customerEmail])

  // The addresses followsOrderAddresses() picks between for an account that
  // chooses a new outbound email's From by the order.
  function followsOrderContext() {
    return {
      mailboxFrom: outboundFrom ?? mailbox ?? '',
      senderAddress: lastInboundMessage?.metadata?.replyToHeader ?? lastInboundMessage?.metadata?.fromHeader ?? customerExternalUserId ?? '',
      customerEmail: suggestion?.customerEmail ?? '',
    }
  }
  const newOutboundState = newOutboundOption(newOutbound)

  // Reply-All CC (2026-10-08, ui/src/emailCc.js): a Reply to Email copies
  // everyone else the inbound message went to, minus CXHub's own addresses
  // and the To. ccEdited is null until the agent touches the box, so the
  // default follows the To; it resets when a different conversation or
  // suggestion loads, never while editing. A cleared box replies to the
  // sender only. Shown disabled in test mode, and nothing is sent then.
  const [ownAddresses, setOwnAddresses] = useState([])
  useEffect(() => {
    if (screenMode || channel !== 'm365_email') return undefined
    let alive = true
    fetchM365OwnAddresses().then((list) => { if (alive) setOwnAddresses(list) })
    return () => { alive = false }
  }, [channel])
  const [ccEdited, setCcEdited] = useState(null)
  // A restore (Park saves the work) puts the saved CC back for its suggestion.
  useEffect(() => { setCcEdited(pendingRestoreFor(suggestion?.id)?.cc ?? null) }, [conversationId, suggestion?.id])
  const ccDefault = useMemo(
    () => replyAllCcDefault({ inbound: lastInboundMessage, ownAddresses, toAddress: draftTo }).join(', '),
    [lastInboundMessage, ownAddresses, draftTo],
  )
  const ccText = ccEdited ?? ccDefault
  const ccField = ccFieldState({ channel, replyMode, isEbayClientEmail, outboundMode })
  const ccInvalid = ccField.visible && !ccField.disabled ? parseCcText(ccText).invalid : []
  const ccToSend = () => ccAddressesForSend(ccField, ccText)
  // The agent column's Reply headers (2026-10-23): the From / To / CC /
  // Subject this reply box would use, shown read only beside the agent's
  // reply; none for an eBay message (no email fields).
  const shadowReplyHeaders = channel === 'm365_email' && !isEbayClientEmail
    ? { from: draftFrom, to: draftTo, cc: ccField.visible ? (ccField.disabled ? '' : ccText) : null, subject: draftSubject }
    : null

  // Shared by the initial per-conversation seed above and the toggle's own
  // onChange below, so switching modes mid-edit updates the subject the
  // same way the initial default would have.
  function applyReplyModeToSubject(text, mode) {
    return mode === 'new' ? text.replace(/^re:\s*/i, '') : (/^re:/i.test(text) ? text : `Re: ${text}`)
  }

  function handleReplyModeChange(newMode) {
    if (!newMode || newMode === replyMode || !replyModes.includes(newMode)) return
    if (newMode === 'new' && newOutboundState.disabled) return
    markTouched()
    setReplyMode(newMode)
    setDraftSubject((prev) => applyReplyModeToSubject(prev, newMode))
    const orderAddresses = followsOrderAddresses(newOutbound, newMode, followsOrderContext())
    if (orderAddresses) {
      setDraftFrom(orderAddresses.from)
      setDraftTo(orderAddresses.to)
    }
  }

  // File attachments (separate from inline images embedded in the draft
  // itself — see RichReplyEditor.jsx) for an m365_email reply. Stay in
  // browser memory only: nothing is uploaded/persisted server-side ahead of
  // Send/Retry Send, so a page reload loses them, same as an unsent draft
  // edit. Reset on conversation switch, same as draftFrom/draftTo/draftSubject.
  const [attachments, setAttachments] = useState([])
  const [attachmentError, setAttachmentError] = useState(null)
  const attachmentInputRef = useRef(null)
  // Preview before Send (2026-10-07): an image attachment opens in the image
  // lightbox, in EmailAttachmentList.jsx (shared with the New view).
  useEffect(() => {
    setAttachments([])
    setAttachmentError(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId])

  // Invoice Request (2026-09-25): preload the on-demand-rendered invoice
  // PNGs into this SAME attachments list — the CSR sees them exactly like
  // their own uploads (can remove/add), and they go out through the same
  // emailAttachments path on Send. Fires once per (conversation, intent)
  // pair, after the reset effect above already cleared the list for this
  // conversationId. Never blocks the rest of the panel: a failure or an
  // empty result just shows attachmentError, same surface a size-cap
  // failure already uses.
  // Also when the agent draft checked the order's invoices and says to attach
  // them (2026-10-16): an Order Status contact whose customer also asked for
  // an invoice. Same render, same list, nothing to click; the server only
  // renders for a 1A or AM Website order on email.
  // An invoice the agent attached unasked (2026-10-23) only with its draft
  // shown: the pipeline's draft never says it is attached.
  // The agent's draft shown with invoices attached (2026-10-23): read from
  // the suggestion itself (modelMeta.agentInvoices), so a CSR gets them too;
  // the shadow row is admin-only. The route renders the orders stored there.
  const agentDraftInvoices = suggestion?.modelMeta?.draftSource === 'agent' && Boolean(suggestion?.modelMeta?.agentInvoices)
  const wantInvoices = suggestion?.intent === 'invoice_request' || agentDraftInvoices || (shadowDraft?.attachInvoices === true && !(shadowDraft?.invoiceUnasked === true && shadowDraft?.draftSource !== 'agent'))
  const [invoicesLoading, setInvoicesLoading] = useState(false)
  useEffect(() => {
    if (screenMode || !wantInvoices || channel !== 'm365_email') return
    let cancelled = false
    setInvoicesLoading(true)
    fetchInvoiceAttachments(conversationId)
      .then((result) => {
        if (cancelled || conversationIdRef.current !== conversationId) return
        const fetched = (result?.attachments ?? []).map((a) => ({
          id: `invoice-${a.invoiceId}-${Date.now()}-${Math.random()}`,
          name: a.name,
          size: estimateBase64Bytes((a.dataUrl ?? '').split(',')[1] ?? ''),
          dataUrl: a.dataUrl,
        }))
        if (fetched.length === 0) {
          // Why (2026-10-29): the server's reason, never one generic line.
          setAttachmentError(`${invoiceUnavailableText(result?.reason)} Attach a copy manually before sending.`)
          return
        }
        setAttachments((prev) => [...prev, ...fetched])
      })
      .catch((err) => {
        if (cancelled || conversationIdRef.current !== conversationId) return
        setAttachmentError(`Could not render the invoice attachment(s) — ${err.message}. Attach a copy manually before sending.`)
      })
      // After the list is filled, so the claim warning never flashes.
      .finally(() => { if (!cancelled) setInvoicesLoading(false) })
    return () => { cancelled = true; setInvoicesLoading(false) }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId, wantInvoices, channel])
  // The reply says an invoice is attached but none is (2026-10-23): warned,
  // and Send stays disabled until an invoice is attached or the sentence is
  // changed. The server refuses the same (send-approved-reply.js). Not for
  // an Invoice Request or the agent's draft with its invoices stored on the
  // suggestion: there the server renders the invoices at send when the box
  // has none (and refuses when it cannot), as before.
  const serverRendersInvoices = suggestion?.intent === 'invoice_request' || agentDraftInvoices
  const invoiceClaimReason = channel === 'm365_email' && !serverRendersInvoices && attachments.length === 0 && claimsAttachedInvoice(draft)
    ? (invoicesLoading ? 'Loading the invoice attachment…' : 'The reply says an invoice is attached, but no invoice is attached. Attach the invoice or change the reply before sending.')
    : null
  // Since 2026-10-30 a Send warning, not a stop: Send anyway sends the reply
  // as written, with no invoice (the server lets an acknowledged one go).
  function invoiceClaimWarningFor(text) {
    if (!(channel === 'm365_email' && !serverRendersInvoices && attachments.length === 0 && claimsAttachedInvoice(text))) return null
    return 'The reply says an invoice is attached, but no invoice is attached. Add the attachment or change the reply, or Send anyway to send it with none.'
  }

  // select_reason_code fallback catalog (2026-09-28): a suggestion persisted
  // before this deploy has no inputOptions baked in (some may even predate
  // inputType itself) — fetched once per conversation, on demand, and reused
  // by every select_reason_code step in this suggestion that needs it. Never
  // used when the step already carries its own live-fetched inputOptions.
  const [fallbackCancelReasonOptions, setFallbackCancelReasonOptions] = useState(null)
  useEffect(() => {
    setFallbackCancelReasonOptions(null)
  }, [conversationId])
  const needsCancelReasonFallback = (suggestion?.proposedActions ?? []).some((a) => a.type === 'select_reason_code' && !(a.inputOptions?.length))
  useEffect(() => {
    if (screenMode || !needsCancelReasonFallback || fallbackCancelReasonOptions !== null) return
    let cancelled = false
    fetchCancelReasonCodes(conversationId)
      .then((result) => {
        if (cancelled || conversationIdRef.current !== conversationId) return
        setFallbackCancelReasonOptions(result?.inputOptions ?? [])
      })
      .catch(() => {
        if (cancelled || conversationIdRef.current !== conversationId) return
        setFallbackCancelReasonOptions([])
      })
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId, needsCancelReasonFallback])

  // Reading the file and the size cap are emailAttachments.js's (shared with
  // the New view).
  async function handleAttachmentFileSelected(e) {
    const file = e.target.files?.[0]
    e.target.value = ''
    if (!file) return
    setAttachmentError(null)
    const { attachment, error } = await readEmailAttachmentFile(file, { attachments, bodyHtml: draft })
    if (error) { setAttachmentError(error); return }
    markTouched()
    setAttachments((prev) => [...prev, attachment])
  }

  function removeAttachment(id) {
    markTouched()
    setAttachments((prev) => prev.filter((a) => a.id !== id))
  }


  // Always reflects the CURRENT conversationId prop — this panel is NOT
  // remounted on a conversation switch (no `key` prop; see
  // prevConversationIdRef's own comment below), so onGenerate()/
  // handleProcessStep() captures the conversationId they
  // were called for and compare it against this ref once their awaited call
  // resolves. If the CSR has since navigated to a different conversation,
  // the result is dropped silently — no apply()/setSuggestion/setDraft, no
  // onGenerated?.() callback, and critically no applyIfConfirmed() confirm()
  // dialog, none of which may fire for a conversation that isn't even on
  // screen anymore. The generation/action itself still ran and persisted
  // server-side regardless — only this CLIENT-side reaction is suppressed.
  const conversationIdRef = useRef(conversationId)
  useEffect(() => { conversationIdRef.current = conversationId }, [conversationId])

  // The draft text as of the last apply() — compared against the live `draft`
  // state to detect unsaved CSR edits before a regeneration (auto or manual)
  // or a conversation switch would otherwise silently discard them.
  const appliedDraftRef = useRef('')
  // Mirrors `draft` state, kept current via the effect below. isDraftDirty()
  // reads this instead of `draft` directly: the auto-regenerate-on-select
  // path calls apply() then (after an awaited generateSuggestion() call)
  // applyIfConfirmed() within the SAME effect closure, so the `draft` variable
  // that closure captured is whatever it was when the effect started — stale
  // by the time the await resolves, since setDraft() doesn't update it
  // in-place. A ref always reads the current value regardless of which
  // render's closure is doing the reading.
  const liveDraftRef = useRef('')
  // The line under the reply after a replace that did not ask (2026-11-02,
  // replyEdited.js), for a few seconds; null otherwise.
  const [replyReplaced, setReplyReplaced] = useState(null)
  const replyNoteTimerRef = useRef(null)
  useEffect(() => () => { if (replyNoteTimerRef.current) clearTimeout(replyNoteTimerRef.current) }, [])
  // The stage at which the CSR chose "Keep my reply" for an edited reply
  // (2026-10-29, Jenn): entering that stage's date then saves the date
  // without asking again. null otherwise.
  const keptAgentReplyStageRef = useRef(null)
  // The replacement step's delivery date (2026-11-02, replacementEdd.js):
  // { [index]: { estimate, pendingKey } }, from the step's staged record
  // (and its re-estimates in the Activity Log); a change to the step's
  // items, quantities, ZIP or method estimates again, debounced.
  const [eddStates, setEddStates] = useState({})
  const eddStatesRef = useRef({})
  useEffect(() => { eddStatesRef.current = eddStates }, [eddStates])
  const eddTimersRef = useRef({})
  // The note line added per step for its current estimate (eddNoteKey()).
  const eddNoteDoneRef = useRef({})
  useEffect(() => { eddNoteDoneRef.current = {} }, [suggestion?.id])
  // On open (2026-11-03): a step whose estimate exists but whose note box
  // has no "Estimated delivery:" line (estimated by an earlier build) gets
  // the line, with no call; once per estimate.
  useEffect(() => {
    const actions = suggestion?.proposedActions ?? []
    let changed = null
    actions.forEach((a, i) => {
      if (a?.type !== 'process_replacement') return
      const rec = eddStates[i]?.estimate ?? a.deliveryEstimate
      const key = eddNoteKey(rec)
      if (!key || eddNoteDoneRef.current[i] === key) return
      const cur = actionInputs[i]
      if (!cur || typeof cur !== 'object' || typeof cur.editedNote !== 'string') return
      eddNoteDoneRef.current[i] = key
      const editedNote = withEddNoteLine(cur.editedNote, rec)
      if (editedNote !== cur.editedNote) (changed ??= {})[i] = editedNote
    })
    if (!changed) return
    setActionInputs((prev) => {
      const out = { ...prev }
      for (const [i, note] of Object.entries(changed)) if (out[i] && typeof out[i] === 'object') out[i] = { ...out[i], editedNote: note }
      return out
    })
    for (const [i, note] of Object.entries(changed)) {
      if (appliedActionInputsRef.current?.[i]) appliedActionInputsRef.current = { ...appliedActionInputsRef.current, [i]: { ...appliedActionInputsRef.current[i], editedNote: note } }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suggestion?.id, suggestion?.proposedActions, eddStates, actionInputs])
  useEffect(() => {
    setEddStates(initialEddStates(suggestion?.proposedActions ?? [], suggestion?.modelMeta?.apiCalls ?? []))
    return () => {
      for (const t of Object.values(eddTimersRef.current)) clearTimeout(t?.timer)
      eddTimersRef.current = {}
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suggestion?.id])
  useEffect(() => {
    const target = suggestion
    if (!target?.id) return
    // Never on a decided suggestion or a closed contact (2026-11-03): a step
    // with no staged estimate is looked up only while it can still change.
    if (conversationStatus === 'closed' || !['pending', 'escalated', 'transferred'].includes(target.status)) return
    ;(target.proposedActions ?? []).forEach((a, i) => {
      if (a?.type !== 'process_replacement') return
      const pending = eddTimersRef.current[i]
      const busy = ['success', 'processing'].includes(stepStates[i]?.status)
      if (busy || !needsReestimate(a, actionInputs[i], eddStates[i])) {
        if (pending) { clearTimeout(pending.timer); delete eddTimersRef.current[i] }
        return
      }
      const req = eddRequestFor(a, actionInputs[i])
      if (pending?.key === req.key) return
      if (pending) clearTimeout(pending.timer)
      const timer = setTimeout(() => { runReplacementReestimate(target.id, i, req) }, REPLACEMENT_EDD_DEBOUNCE_MS)
      eddTimersRef.current[i] = { key: req.key, timer }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suggestion?.id, suggestion?.status, suggestion?.proposedActions, actionInputs, eddStates, stepStates, conversationStatus])
  // The actionInputs as of the last apply() — mirrors appliedDraftRef's
  // purpose but for per-step editedNote/editedMessage fields, since
  // isDraftDirty() only ever covered the main draft box. Compared against
  // the live `actionInputs` state by isAnyStepInputDirty() below.
  const appliedActionInputsRef = useRef({})
  // Tracks the conversationId the fetch effect last ran for, so a refreshKey-only
  // bump (e.g. from a bulk "Generate all" elsewhere) doesn't re-trigger
  // auto-regenerate — that should fire at most once per conversation selection.
  const prevConversationIdRef = useRef(undefined)
  // The suggestion id as of the last apply() — used to reset stepStates only
  // when a genuinely NEW suggestion is swapped in (not a re-apply of the
  // same one). A ref rather than reading `suggestion` state directly, same
  // stale-closure reasoning as liveDraftRef above: apply() can run inside an
  // awaited callback whose closure captured an earlier render's `suggestion`.
  const appliedSuggestionIdRef = useRef(undefined)

  // Template selector state
  // The dialog's own folders / search / suggestions state lives in
  // TemplatePickerDialog.jsx (2026-10-08, shared with the New view).
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false)
  // null = the main drafted-reply box (today's only target); a number = the
  // proposed-actions index whose editable message field ("Message to buyer
  // (editable)" / "Reply to eBay case") should receive the applied template
  // instead — set by which "Templates" button was clicked.
  const [templateTargetStep, setTemplateTargetStep] = useState(null)
  // Where a template lands (docs/decisions.md, 2026-10-06): at the agent's
  // cursor when they placed one in that box since its content was last set
  // programmatically, otherwise above the signature. The email box tracks
  // its own cursor (RichReplyEditor's ref); each plain box records its last
  // cursor here, keyed like templateTargetStep ('main', 'closed-reply', a
  // step index), with the value it held at the time: a programmatic set
  // changes the value and so forgets the cursor (templateInsert.js's
  // placedCursor()).
  const draftEditorRef = useRef(null)
  const cursorRecordsRef = useRef({})
  const textBoxRefs = useRef({})
  const pendingTemplateFocusRef = useRef(null)
  function cursorTrackingProps(key) {
    const record = (e) => {
      const el = e.target
      if (el && typeof el.selectionStart === 'number') cursorRecordsRef.current[key] = { value: el.value, start: el.selectionStart, end: el.selectionEnd }
    }
    return {
      inputRef: (el) => { textBoxRefs.current[key] = el },
      inputProps: { onSelect: record, onKeyUp: record, onMouseUp: record, onFocus: record },
    }
  }
  // After an insert, once the dialog has closed: focus goes back to the box,
  // with the cursor after the inserted text.
  useEffect(() => {
    if (templateDialogOpen || !pendingTemplateFocusRef.current) return
    const { key, cursor } = pendingTemplateFocusRef.current
    pendingTemplateFocusRef.current = null
    if (key === 'rich') { draftEditorRef.current?.focus(); return }
    const el = textBoxRefs.current[key]
    if (!el) return
    el.focus()
    el.setSelectionRange(cursor, cursor)
    cursorRecordsRef.current[key] = { value: el.value, start: cursor, end: cursor }
  }, [templateDialogOpen])

  // Opens the template dialog for a target box: null = the main drafted-reply
  // box, a step index, or 'closed-reply'. The dialog loads its own data.
  const openTemplateDialog = useCallback((stepIndex = null) => {
    if (stepIndex === null) draftEditorRef.current?.captureSelection()
    setTemplateTargetStep(stepIndex)
    setTemplateDialogOpen(true)
  }, [])

  async function applyTemplate(template) {
    markTouched()
    // Auto-fill the return-refund flow's own Process-time tokens
    // (INSERTRMANUMBER/INSERTAMOUNT/INSERTTYPE/INSERTDAYS) BEFORE the usual
    // substitution/merge logic below, using facts this panel already has in
    // memory (stepStates' persisted execution result, actionInputs' own
    // Check-time itemsTotal/shippingDeduction/shippingPaymentOption) — no
    // persisted, structured record of a step's own execution result exists
    // server-side to read these back from otherwise (routes/ai.js's own
    // comment on the fill endpoint). The server also fills what it can read
    // for itself: Refund Confirmation from the order's most recent refund
    // document, and INSERTTYPE in any template (docs/decisions.md,
    // 2026-10-01) — so any template carrying an INSERT token is sent, with or
    // without a process_return_refund step. On any failure —
    // network error, template not found, whatever — falls back to the
    // template's own unfilled content, exactly as before this feature;
    // never blocks the insert.
    let effectiveTemplate = template
    const returnRefundIndex = (suggestion?.proposedActions ?? []).findIndex((a) => a.type === 'process_return_refund')
    if (suggestion?.id && template?.id && hasUnresolvedPlaceholder(template?.content)) {
      try {
        const facts = returnRefundIndex >= 0 ? {
          erpRmaId: stepStates[returnRefundIndex]?.result?.erpRmaId ?? null,
          itemsTotal: actionInputs[returnRefundIndex]?.itemsTotal ?? null,
          shippingDeduction: actionInputs[returnRefundIndex]?.shippingDeduction ?? null,
          shippingPaymentOption: actionInputs[returnRefundIndex]?.shippingPaymentOption ?? null,
          // The refund-amount lines (2026-10-21): the server works out the
          // amounts for the items and reason the agent has on the step.
          items: actionInputs[returnRefundIndex]?.items ?? null,
          reasonCode: actionInputs[returnRefundIndex]?.reasonCode ?? null,
        } : {}
        const { content: filledContent, refundDocument } = await fillTemplateTokens(suggestion.id, template.id, facts)
        effectiveTemplate = { ...template, content: filledContent }
        if (refundDocument) {
          const forId = suggestion.id
          setTemplateRefundDocs((prev) => ({ suggestionId: forId, docs: [...(prev.suggestionId === forId ? prev.docs : []), refundDocument] }))
        }
      } catch {
        // Fall through with the unfilled template — never block the insert.
      }
    }
    // The carrier choice line (2026-10-26, templateCarrierChoice.js): the
    // order's one carrier from the tracking the order header already loaded,
    // by the same shared rule as a drafted reply; mixed or unknown carriers
    // leave the line, highlighted, for the agent.
    effectiveTemplate = { ...effectiveTemplate, content: resolveTemplateCarrierChoice(effectiveTemplate.content, orderSummaryTrackingSummary) }

    // Every box flattens the template with the shared DB-template rule
    // (templateHtmlToPlainText(), 2026-10-28): exactly the layout the
    // Templates editor shows, a paragraph a blank line, a line break a single
    // one, the same as the server for a drafted reply. The email box's HTML
    // path (emailTemplateInsertHtml()) reads the same rule.
    const plain = templateHtmlToPlainText(effectiveTemplate.content)
    const firstName = agentFirstName
    const erpOrderId = suggestion?.modelMeta?.erpOrderId ?? null
    const trackingUrl = suggestion?.modelMeta?.trqOrder?.tracking?.[0]?.trackingUrl
      ?? suggestion?.modelMeta?.trackingUrl
      ?? null
    const substituted = applySubstitutions(plain, { firstName, erpOrderId, trackingUrl })

    // The template's own text, agent name resolved, before it is placed, so
    // the cursor offset after the insert is its offset in the final text.
    const templateText = resolveAgentFirstNamePlaceholder(substituted, templateAccount)
    const footer = resolveAgentFirstNamePlaceholder(agentFooterFor(templateAccount), templateAccount)
    // The live, resolved signature (what seeds a blank box), as a loaded
    // draft's text resolves it (draftBoxText), and the stored template as-is,
    // so a box still holding the token form is recognized too.
    const signatures = [signatureSeed(), resolvedSignatureTemplate, signatureTemplate && draftBoxText(signatureTemplate), signatureTemplate]
    const placeInPlainBox = (key, current, { withFooter }) => {
      const { text, cursor } = insertPlainTemplate(current, templateText, {
        account: templateAccount, signatures,
        cursor: placedCursor(cursorRecordsRef.current[key], current),
        footer: withFooter ? footer : null,
      })
      cursorRecordsRef.current[key] = { value: text, start: cursor, end: cursor }
      pendingTemplateFocusRef.current = { key, cursor }
      return text
    }

    if (templateTargetStep === 'closed-reply') {
      // The ad-hoc reply box for an already-closed conversation (see the
      // "New reply" section below), leaving draft and every proposed-action
      // step untouched. It never added a signature of its own.
      setClosedReplyDraft(placeInPlainBox('closed-reply', closedReplyDraft, { withFooter: false }))
      setClosedReplyInsertedTemplate(insertedTemplateOf(template))
    } else if (templateTargetStep !== null) {
      // A per-step editable message (send_ebay_member_message,
      // resend_return_label's Flow B, any inr_request_id_process
      // disposition), written back only to that step's actionInputs entry,
      // leaving draft and every other step untouched.
      const i = templateTargetStep
      const merged = placeInPlainBox(i, actionInputs[i]?.editedMessage ?? '', { withFooter: true })
      setActionInputs((prev) => ({ ...prev, [i]: { ...(prev[i] ?? {}), editedMessage: merged } }))
    } else if (!isEbayChannel) {
      // The main email box (RichReplyEditor). Every template takes the HTML
      // path: a "1A Website" template keeps its real bold/links, a plain one
      // becomes editable paragraphs, and none gets the one-line
      // "[AGENT_FIRST_NAME] | 1A Auto" footer: an email ends with the live
      // signature only (docs/decisions.md, 2026-09-28/29, 2026-10-06).
      const insertedHtml = emailTemplateInsertHtml(effectiveTemplate.content, { account: templateAccount, firstName, erpOrderId, trackingUrl })
      if (draftEditorRef.current?.insertTemplate(insertedHtml, signatures)) {
        pendingTemplateFocusRef.current = { key: 'rich' }
      } else {
        setDraft(insertHtmlTemplate(draft, insertedHtml, signatures))
      }
      setDraftInsertedTemplate(insertedTemplateOf(template))
      draftInsertedTemplateIdRef.current = template?.id ?? null
    } else {
      // The main eBay box: the template's own signature line is stripped and
      // exactly one signature stays at the end.
      setDraft(placeInPlainBox('main', draft, { withFooter: true }))
      setDraftInsertedTemplate(insertedTemplateOf(template))
      draftInsertedTemplateIdRef.current = template?.id ?? null
    }

    setTemplateDialogOpen(false)
    setTemplateTargetStep(null)
  }

  // An inserted template stops describing the reply once the box is emptied
  // (or holds only the signature), and never carries over to a different
  // suggestion or conversation.
  useEffect(() => {
    if (!draft || isSignatureOnlyReply(draft, signatureSeed())) setDraftInsertedTemplate(null)
  }, [draft])
  useEffect(() => {
    if (!closedReplyDraft || isSignatureOnlyReply(closedReplyDraft, signatureSeed())) setClosedReplyInsertedTemplate(null)
  }, [closedReplyDraft])
  useEffect(() => {
    // A restore (Park saves the work) puts the saved template and part links
    // back for its suggestion.
    const pending = pendingRestoreFor(suggestion?.id)
    setDraftInsertedTemplate(pending?.template ?? null)
    setClosedReplyInsertedTemplate(null)
    setPartLinks(pending?.partLinks ?? {})
  }, [suggestion?.id, conversationId])

  // [AGENT_FIRST_NAME] is left unresolved in draftReply/humanReply/step
  // replyText until approve/send time server-side (see routes/ai.js's
  // firstNameFromAuth) — resolve it here too so the CSR sees (and edits/
  // submits) their real name instead of the raw placeholder. Used by every
  // call site that sets draft text from a suggestion or step result.
  //
  // account: the conversation's account/company code (SuggestionPanel's own
  // templateAccount prop) — the actual resolution mirrors companies.js's
  // resolveSignature() exactly (constants/companies.js's
  // resolvePlaceholderSignature(): signatureIncludesAgentName: false (AM)
  // always wins, collapsing the whole footer to the bare company signature
  // regardless of agentFirstName), rather than the previous unconditional
  // "insert the name" behavior that hardcoded 1A Auto's footer and, for AM,
  // could show a real agent's name next to AM's signature (or leave the raw
  // placeholder unresolved when no name was available, since the old
  // bare-fallback literal only ever matched 1A's footer text).
  function resolveAgentFirstNamePlaceholder(text, account) {
    const firstName = agentFirstName
    return resolvePlaceholderSignature(text, account, firstName)
  }

  // eBay is plain text, and an eBay box holds exactly what will be sent
  // (docs/decisions.md, 2026-09-29). Every text LOADED into one goes through
  // the shared ebayPlainText() first, which converts only text that actually
  // carries HTML (plain text is left byte-for-byte), then the agent-name
  // placeholders resolve by the send path's own rule. Runs once per load,
  // never on a keystroke, so an agent's own blank lines and spacing are never
  // rewritten. INSERT* tokens and [AGENT_FIRST_NAME] survive the conversion.
  // The main box only on the eBay channel (email uses the rich editor);
  // every step message box, whatever the channel, since each one is an eBay
  // send (getEditableMessageDefault()'s types).
  function draftBoxText(text) {
    if (!isEbayChannel) return resolveAgentFirstNamePlaceholder(text, templateAccount)
    return loadEbayBoxText(text, templateAccount, agentFirstName)
  }
  // The CSR's correct part's reply (2026-10-30, correctPart.js) in the box:
  // the reply, then the box's signature, as the pipeline's draft is laid out
  // (eBay plain text; email paragraphs).
  function correctPartBoxText(reply) {
    if (isEbayChannel) return draftBoxText([reply, signatureTemplate ?? ''].filter((t) => String(t).trim()).join('\n\n'))
    const sig = resolvedSignatureTemplate ? (/<[a-z][^>]*>/i.test(resolvedSignatureTemplate) ? resolvedSignatureTemplate : plainTextToHtmlParagraphs(resolvedSignatureTemplate)) : ''
    return `${plainTextToHtmlParagraphs(resolveAgentFirstNamePlaceholder(reply, templateAccount))}${sig}`
  }
  function ebayStepBoxText(text) {
    return loadEbayBoxText(text, templateAccount, agentFirstName)
  }

  // skipDraft: true for the post-Process refresh of a note-only step
  // (add_order_note/address_confirmation_add_note — see handleProcessStep),
  // and unconditionally for the manual-actions sidebar's refresh (see
  // App.jsx's handleManualActionCompleted) — in both cases the CSR's live
  // draft (and whatever they'd already typed) must be left alone rather than
  // overwritten with the refreshed suggestion's own draftReply/humanReply.
  // Also threaded into reseedActionInputs() below (not just the main draft
  // box here) — skipDraft protects editedMessage/editedNote on EVERY
  // proposed step the same way, since those are where the FROM_EBAY case-
  // response box and note boxes actually live, and a manual-panel Process on
  // step A must not clobber a manually-templated box on a different step B.
  function apply(s, { skipDraft = false } = {}) {
    // A genuinely new suggestion (different id, including the very first
    // load) must not inherit a stale 'success' checkmark from whatever step
    // index the PREVIOUS suggestion left behind — otherwise a fresh, fully
    // undecided step can render right next to a leftover green check from a
    // step at the same array index on the old suggestion (e.g. the
    // post-Process regenerate swapping in a brand-new pending suggestion).
    // The replacement steps are the exception: their state is rebuilt from
    // the suggestion's own call log, so a created replacement never offers
    // Process again after a reload (suggestionActionInputs.js's
    // restoredStepStates()).
    // The recorded choice, else the step's preselection (2026-10-21).
    const restoredEffective = effectiveTaskPathChoice(s)
    const restoredChoice = restoredEffective?.choice ?? null
    const sameSuggestion = s?.id === appliedSuggestionIdRef.current
    if (s?.id !== appliedSuggestionIdRef.current) {
      setStepStates({ ...restoredStepStates(s), ...dailyLimitStepStates(s), ...ebayRerouteStepStates(s), ...partlyDoneStepStates(s) })
      setManualPasted({})
      setUncheckedSteps(uncheckedStepsFrom(s?.modelMeta?.apiCalls))
      setNotNeededSteps([])
      setTaskChoice(restoredChoice)
      setTaskChoiceDate(restoredEffective?.date ?? '')
      setTaskChoiceError(null)
      showReplyReplacedNote(null)
      keptAgentReplyStageRef.current = null
    }
    appliedSuggestionIdRef.current = s?.id ?? null
    setSuggestion(s)
    if (!skipDraft) {
      // A task waiting on the moved / not-moved choice has no stored draft:
      // the chosen path's template is the reply (2026-10-15).
      const chosenText = restoredChoice ? returnStageText(s?.proposedActions, restoredChoice, restoredEffective?.date) : null
      const rawText = s ? (s.humanReply || s.draftReply || chosenText || '') : ''
      // A blank draft starts with the resolved signature instead of nothing
      // (Jenn's rule, 2026-09-28) — but only where a draft box is actually
      // shown; hasNoDraftBoxOfItsOwn's three cases (FROM_EBAY,
      // automated_return_notice_default, isEbayClientEmail) have no box to
      // seed, and onDecide() already omits humanReply for them regardless.
      // The decision itself is the pure, unit-tested shouldSeedSignatureFor()
      // (suggestionActionInputs.js).
      const seedSignature = shouldSeedSignatureFor({ suggestion: s, fromEbay, isEbayClientEmail, hasNoDraftBoxOfItsOwnFn: noDraftBoxFn, rawText })
      const text = seedSignature ? blankBoxSeed() : draftBoxText(rawText)
      setDraft(text)
      appliedDraftRef.current = text
    }
    // Pre-seed any requiresInput fields that have an AI-suggested default so the
    // Approve button isn't blocked and the CSR sees the suggestion right away.
    // Preserves whatever the CSR already confirmed for an action (see
    // reseedActionInputs()'s own comment) rather than blindly reseeding fresh
    // defaults on every apply() — including the automatic post-Process
    // suggestion refresh, which would otherwise wipe out items/address the
    // CSR already checked/typed for the step that just succeeded.
    setActionInputs((prevInputs) => {
      const next = reseedActionInputs(s?.proposedActions, prevInputs, ebayStepBoxText, { skipDraft })
      appliedActionInputsRef.current = next
      return next
    })
    setExecutionErrors(null)
    setReplySendError(resolveReplySendErrorSeed(s, conversationStatus))
    // A step started from Other Actions keeps its check across a refresh of
    // the same suggestion (2026-10-27): its reply template (the check's
    // custPays) is offered after Process, which refreshes the suggestion.
    setCheckStates((prev) => (sameSuggestion
      ? Object.fromEntries(Object.entries(prev).filter(([k]) => s?.proposedActions?.[Number(k)]?.source === 'manual_panel'))
      : {}))
    // A return step whose check the pipeline ran at generation (2026-10-27,
    // services/return-check.js) arrives checked: its disposition selected,
    // the steps after it built. Edits since make it stale (Check again).
    ;(s?.proposedActions ?? []).forEach((a, i) => {
      if (a?.type === 'process_return_refund' && a.params?.checkResult?.success) applyCheckResult(i, a.params.checkResult, a)
    })
    setOpenQaKey(null)
  }

  // "Refund on the return / inquiry" (2026-10-29): the stopped seller refund
  // step is rebuilt on the open eBay return or INR inquiry (POST
  // .../ebay-refund-reroute, reads only). The rebuilt step(s) take its place;
  // the steps from it on start fresh, for the person to Process.
  async function handleEbayRefundReroute(index) {
    if (!suggestion?.id) return
    setStepStates((prev) => ({ ...prev, [index]: { ...(prev[index] ?? {}), rerouting: true, rerouteError: null } }))
    let res
    try {
      res = await rerouteEbayRefund(suggestion.id, index)
    } catch (e) {
      setStepStates((prev) => ({ ...prev, [index]: { ...(prev[index] ?? {}), rerouting: false, rerouteError: e?.body?.message ?? e?.message ?? 'The refund could not be rebuilt.' } }))
      return
    }
    const next = Array.isArray(res?.proposedActions) ? res.proposedActions : null
    if (!next) return
    const before = (obj) => Object.fromEntries(Object.entries(obj ?? {}).filter(([k]) => Number(k) < index))
    setStepStates((prev) => before(prev))
    setActionInputs((prev) => {
      const seeded = reseedActionInputs(next, before(prev), ebayStepBoxText, { skipDraft: true })
      appliedActionInputsRef.current = seeded
      return seeded
    })
    setSuggestion((s) => (s ? { ...s, proposedActions: next } : s))
  }

  // The link to the correct part (2026-10-27, rmartn_part_link): the SKU is
  // read from the link (or the SKU field when the link has none) and Item
  // Info's warranty for it comes back; the reply's INSERTLINK and
  // INSERTWARRANTY (or the values filled before) take the new ones, keeping
  // the person's other edits. Reads only.
  async function applyPartLink(index, step, { link, sku = '' }) {
    if (!suggestion) return
    const prev = partLinks[index] ?? {}
    const clean = String(link ?? '').trim()
    if (!clean) return
    setPartLinks((p) => ({ ...p, [index]: { ...(p[index] ?? {}), link: clean, sku, busy: true } }))
    let out
    try {
      out = await fetchPartLink(suggestion.id, { link: clean, sku })
    } catch {
      const parsed = skuFromPartLink(clean)
      out = { link: clean, sku: parsed ?? (sku || null), warranty: null, needsSku: !parsed && !sku }
    }
    const lastLink = prev.filledLink ?? step?.params?.link ?? null
    const lastWarranty = prev.filledWarranty ?? step?.params?.warranty ?? null
    setDraft((d) => {
      let t = replaceCarryValue(d, 'link', lastLink, clean)
      if (out?.warranty) t = replaceCarryValue(t, 'warranty', lastWarranty, out.warranty)
      return t
    })
    setPartLinks((p) => ({ ...p, [index]: { link: clean, sku: out?.sku ?? sku ?? '', warranty: out?.warranty ?? null, needsSku: Boolean(out?.needsSku), busy: false, filledLink: clean, filledWarranty: out?.warranty ?? lastWarranty } }))
  }

  // The agent picks a task's path (2026-10-15). Switching confirms first when
  // it would drop edits on the path being hidden (its note and message boxes,
  // and the reply built from its template); those steps go back to their
  // defaults, every other step keeps its input, and the reply box takes the
  // chosen path's template (no model call). Recorded on the suggestion, by
  // whom, so a reload and the Activity Log show it.
  async function handleTaskPathChoice(index, value) {
    if (!suggestion || value === taskChoice) return
    markTouched()
    const actions = suggestion.proposedActions ?? []
    let switchConfirmed = false
    if (taskChoice) {
      const edited = taskPathHasEdits(actions, actionInputs, appliedActionInputsRef.current, taskChoice)
        || (taskReplyTextFor(actions, taskChoice) != null && isDraftDirty())
      if (edited) {
        const startedForId = conversationId
        if (!(await askConfirm(SWITCH_TASK_PATH_PROMPT)) || conversationIdRef.current !== startedForId) return
        switchConfirmed = true
      }
    }
    let recorded
    try {
      recorded = await chooseTaskPath(suggestion.id, index, value)
    } catch (err) {
      setError(err.message)
      return
    }
    const previous = taskChoice
    setTaskChoice(value)
    setTaskChoiceDate('')
    setTaskChoiceError(null)
    const entry = recorded?.choice ?? { choice: value }
    setSuggestion((s) => (s ? { ...s, modelMeta: { ...(s.modelMeta ?? {}), apiCalls: [...(s.modelMeta?.apiCalls ?? []), { service: 'CXHub', label: 'Task path chosen', phase: 'process', stepIndex: index, taskPathChoice: value, actedBy: entry.by ?? null, at: entry.at ?? null }] } } : s))
    if (previous) {
      setActionInputs((prev) => {
        const next = resetTaskPathInputs(actions, prev, previous, ebayStepBoxText)
        appliedActionInputsRef.current = { ...appliedActionInputsRef.current, ...next }
        return next
      })
    }
    const text = taskReplyTextFor(actions, value)
    if (text != null) {
      // The stage's template (or, with agentStageReplies, the agent's reply
      // for that stage) replaces the box. Since 2026-11-02 (Jenn) it asks
      // "Replace your reply?" only when the person edited the reply
      // (replyEdited.js); the AI or agent draft, or an earlier stage's
      // template, untouched, is replaced silently. The choice is already
      // recorded either way.
      keptAgentReplyStageRef.current = null
      const title = taskReplyTitleFor(actions, value)
      const edited = replyEditedSinceSet()
      if (edited && !switchConfirmed) {
        const startedForId = conversationId
        const use = await askConfirm(stageTemplatePrompt(title))
        if (conversationIdRef.current !== startedForId) return
        if (!use) {
          keptAgentReplyStageRef.current = value
          return
        }
      }
      setReplyBox(draftBoxText(text), { note: edited ? null : replyReplacedNote({ title }) })
    }
  }

  // Whether the person edited the reply since CXHub last put text in the box
  // (2026-11-02, replyEdited.js): the same baseline as isDraftDirty()
  // (appliedDraftRef), whitespace-only and signature-only differences
  // ignored. Every "Replace your reply?" asks only when this is true.
  function replyEditedSinceSet() {
    if (fromEbay) return false
    return isReplyEdited({ box: liveDraftRef.current, baseline: appliedDraftRef.current, signature: signatureSeed() })
  }

  // The replacement step estimated again for the person's change (2026-11-02,
  // replacementEdd.js): the step shows the new date; the reply's date lines
  // follow when the reply carries this step's date, silently when the
  // person has not edited the reply, else "Update the delivery date in your
  // reply to <date>?" (Update / Keep my reply). A new estimate with no date
  // never changes the reply; the step shows why.
  async function runReplacementReestimate(suggestionId, index, req) {
    delete eddTimersRef.current[index]
    const startedForId = conversationIdRef.current
    const previous = eddStatesRef.current[index]?.estimate ?? null
    setEddStates((prev) => ({ ...prev, [index]: { ...(prev[index] ?? {}), pendingKey: req.key } }))
    let next = null
    try {
      const res = await reestimateReplacementDelivery(suggestionId, index, req.selection)
      next = res?.estimate ?? null
    } catch (err) {
      next = {
        source: 'staged_replacement', estimatedAt: new Date().toISOString(), deliveryDate: null, shipDate: null,
        noDate: { kind: 'call_failed', text: `No delivery date: the estimate call failed (${err?.message ?? 'error'}).` },
        input: { items: req.selection.items, method: req.selection.shippingMethod, zipCode: req.selection.zipCode },
      }
    }
    if (conversationIdRef.current !== startedForId) return
    if (!next || next.awaitingItems) {
      // { estimate: null }: the flag is off; the step is left alone.
      setEddStates((prev) => ({ ...prev, [index]: { ...(prev[index] ?? {}), pendingKey: null, ...(next ? {} : { disabled: true }) } }))
      return
    }
    setEddStates((prev) => ({ ...prev, [index]: { estimate: next, pendingKey: null } }))
    // The step's order note follows too (2026-11-03): its "Estimated
    // delivery:" line changes in place, edited or not, and is added when the
    // note has none (2026-11-03), so it is always visible before Process.
    const noteWith = (v) => (v && typeof v === 'object' && typeof v.editedNote === 'string' ? { ...v, editedNote: withEddNoteLine(v.editedNote, next) } : v)
    eddNoteDoneRef.current[index] = eddNoteKey(next)
    setActionInputs((prev) => ({ ...prev, [index]: noteWith(prev[index]) }))
    if (appliedActionInputsRef.current?.[index]) appliedActionInputsRef.current = { ...appliedActionInputsRef.current, [index]: noteWith(appliedActionInputsRef.current[index]) }
    if (mainReplacementIndex(suggestion?.proposedActions ?? [], taskChoice) !== index) return
    // The reply follows (Jenn, 2026-11-03), edited or not: only its date
    // values change, in place; no date makes it INSERTEDD. No question.
    const update = replyAfterReestimate(liveDraftRef.current ?? '', previous, next)
    if (!update.changed) return
    if (replyEditedSinceSet()) {
      // The person's other edits stay edits: the box changes, its baseline
      // does not.
      setDraft(update.text)
      liveDraftRef.current = update.text
    } else {
      setReplyBox(update.text)
    }
    setEddStates((prev) => ({ ...prev, [index]: { ...(prev[index] ?? {}), replyNote: update.note } }))
  }

  // CXHub puts text in the reply box: the box and its baseline both take it,
  // so a later replacement is silent again until the person edits.
  // note: the line under the reply for a few seconds (a replace that did not
  // ask), else none.
  function setReplyBox(boxText, { note = null } = {}) {
    setDraft(boxText)
    liveDraftRef.current = boxText
    appliedDraftRef.current = boxText
    showReplyReplacedNote(note)
  }

  function showReplyReplacedNote(note) {
    if (replyNoteTimerRef.current) clearTimeout(replyNoteTimerRef.current)
    replyNoteTimerRef.current = null
    setReplyReplaced(note)
    if (note) replyNoteTimerRef.current = setTimeout(() => { replyNoteTimerRef.current = null; setReplyReplaced(null) }, REPLY_REPLACED_NOTE_MS)
  }

  // Replacement or refund on the step (2026-10-27, resolutionSwitch.js):
  // switching shows the other path's steps at once (built at generation) and
  // keeps every edit on the path left, so switching back restores it. The
  // note takes the new path's default unless the person edited it; the
  // reply takes the new path's template, asking first ("Replace your
  // reply?") when the person edited it. Recorded on the suggestion with why
  // (out of stock or the person's choice).
  async function handleResolutionChoice(value, why) {
    if (!suggestion || value === taskChoice) return
    const actions = suggestion.proposedActions ?? []
    const index = actions.findIndex((a) => a?.type === 'task_path_choice')
    if (index < 0) return
    let recorded
    try {
      recorded = await chooseTaskPath(suggestion.id, index, value, null, why)
    } catch (err) {
      setError(err.message)
      return
    }
    const previous = taskChoice
    const noteIdx = resolutionNoteIndex(actions)
    const plan = resolutionSwitchPlan({
      actions, from: previous, to: value, draftDirty: replyEditedSinceSet(), replyByPath: replyByPathRef.current,
      noteInput: noteIdx >= 0 ? (actionInputs[noteIdx]?.editedNote ?? null) : null,
      noteBaseline: noteIdx >= 0 ? (appliedActionInputsRef.current[noteIdx]?.editedNote ?? actions[noteIdx]?.params?.notes ?? null) : null,
    })
    if (previous) replyByPathRef.current = { ...replyByPathRef.current, [previous]: liveDraftRef.current ?? draft }
    setTaskChoice(value)
    const entry = recorded?.choice ?? { choice: value }
    setSuggestion((s) => (s ? { ...s, modelMeta: { ...(s.modelMeta ?? {}), apiCalls: [...(s.modelMeta?.apiCalls ?? []), { service: 'CXHub', label: 'Resolution chosen', phase: 'process', stepIndex: index, taskPathChoice: value, resolutionWhy: why ?? null, actedBy: entry.by ?? null, at: entry.at ?? null }] } } : s))
    if (plan.note != null && noteIdx >= 0) {
      setActionInputs((prev) => ({ ...prev, [noteIdx]: { ...(prev[noteIdx] ?? {}), editedNote: plan.note } }))
      appliedActionInputsRef.current = { ...appliedActionInputsRef.current, [noteIdx]: { ...(appliedActionInputsRef.current[noteIdx] ?? {}), editedNote: plan.note } }
    }
    if (!plan.reply) return
    const boxText = plan.reply.own ? plan.reply.text : draftBoxText(plan.reply.text)
    // "Replace your reply?" (the shared ConfirmDialog.jsx): Keep my reply /
    // Use the new template, only when the person edited the reply
    // (replyEditedSinceSet()); otherwise silently, with the line under it.
    if (plan.askReply) {
      if (!(await askConfirm(replaceReplyPrompt(plan.reply.title)))) return
      setReplyBox(boxText)
      return
    }
    setReplyBox(boxText, { note: replyReplacedNote({ title: plan.reply.title, own: plan.reply.own === true }) })
  }

  // Records a task choice (and a Return Status stage's date) on `target`,
  // and mirrors the entry on the panel's copy of it, so the panel's Send
  // check reads what the server reads. Throws when the call fails.
  async function recordTaskChoice(target, index, choice, date = null) {
    const recorded = await chooseTaskPath(target.id, index, choice, date ?? undefined)
    const entry = recorded?.choice ?? { choice, date }
    const recordedDate = entry.date ?? date ?? null
    setSuggestion((s) => (s && s.id === target.id ? { ...s, modelMeta: { ...(s.modelMeta ?? {}), apiCalls: [...(s.modelMeta?.apiCalls ?? []), { service: 'CXHub', label: recordedDate ? 'Return stage chosen' : 'Task path chosen', phase: 'process', stepIndex: index, taskPathChoice: choice, ...(recordedDate ? { taskPathDate: recordedDate } : {}), actedBy: entry.by ?? null, at: entry.at ?? null }] } } : s))
    return recorded
  }

  // The choice step's error line, scrolled into view and highlighted
  // (2026-10-28): a refused Send for the choice, never a banner at the top.
  function showTaskChoiceError(index, message, kind = 'refused') {
    setTaskChoiceError({ index, kind, message })
    const box = taskChoiceBoxRef.current
    if (box?.scrollIntoView) {
      try { box.scrollIntoView({ block: 'center', behavior: 'smooth' }) } catch { box.scrollIntoView() }
    }
  }

  // The stage's date (2026-10-21): recorded with the choice, and the chosen
  // template's INSERTDATE (and, delivered, its expected-by date) filled in
  // the reply box. Since 2026-10-28 the date is recorded as soon as it is a
  // valid date, before and whatever the "Replace your reply?" answer: the
  // dialog decides only whether the template, with the date, goes into the
  // reply box ("Fill the date") or the reply stays as it is ("Keep my
  // reply"). A failed recording shows on the step and keeps Send blocked.
  async function handleTaskChoiceDate(index, date) {
    if (!suggestion || !taskChoice) return
    setTaskChoiceDate(date)
    if (!isIsoDate(date)) return
    const startedForId = conversationId
    const target = suggestion
    const choice = taskChoice
    try {
      await recordTaskChoice(target, index, choice, date)
    } catch {
      if (conversationIdRef.current === startedForId) setTaskChoiceError({ index, kind: 'save', message: TASK_DATE_SAVE_ERROR })
      return
    }
    if (conversationIdRef.current !== startedForId) return
    setTaskChoiceError((prev) => (prev?.index === index ? null : prev))
    const text = returnStageText(target.proposedActions, choice, date)
    if (text == null) return
    // Asks only when the person edited the reply (2026-11-02,
    // replyEditedSinceSet()); the date is recorded above either way.
    const edited = replyEditedSinceSet()
    // "Keep my reply" already chosen for this stage (2026-10-29, Jenn): the
    // date is saved above; the reply stays, with no second question.
    if (edited && keptAgentReplyStageRef.current === choice) return
    if (edited && (!(await askConfirm(FILL_DATE_PROMPT)) || conversationIdRef.current !== startedForId)) return
    if (conversationIdRef.current !== startedForId) return
    setReplyBox(draftBoxText(text), { note: edited ? null : replyReplacedNote({ title: taskReplyTitleFor(target.proposedActions, choice, date) }) })
  }

  // "Load new draft" (2026-10-13): replaces the box with the held newer
  // suggestion, asking first (the "A new suggestion is ready" dialog,
  // 2026-10-27) when that discards unsaved edits.
  async function loadNewerDraft() {
    if (!newerSuggestion) return
    const held = newerSuggestion
    // A Regenerate replaced the suggestion under the CSR's work (2026-10-28):
    // they see what changed and choose, as on unpark.
    if (held.id === regeneratedNoticeId && isSameCustomerTurn(suggestion, held) && hasStartedWork()) {
      setError(null)
      compareWithRegenerated(held)
      return
    }
    if (isDraftDirty() || isAnyStepInputDirty()) {
      const startedForId = conversationId
      askingNewSuggestionRef.current = { conversationId: startedForId, id: held.id }
      let use = false
      try {
        use = await askConfirm(newSuggestionPrompt({ current: suggestion, fresh: held, messages: conversationMessages ?? [], savedWork: restoredLine != null }))
      } finally {
        if (askingNewSuggestionRef.current?.id === held.id) askingNewSuggestionRef.current = null
      }
      if (!use || conversationIdRef.current !== startedForId) return
    }
    apply(held)
    setNewerSuggestion(null)
    setError(null)
  }

  // The server refused an action because this suggestion was replaced by a
  // newer one. The work never moves by itself (2026-10-28, Jenn): for a
  // newer suggestion answering the same customer message (a Regenerate seen
  // from a stale tab), a Send opens the change comparison (compare: true)
  // so the CSR sees what changed and chooses; a Process, Close or Spam only
  // says "This contact was regenerated. ..." with "Load new draft". A newer
  // suggestion for a NEW customer message: the notice as before. The
  // agent's edits stay in the box either way.
  async function showNewerAfterSupersededRefusal({ compare = false } = {}) {
    setError(null)
    const startedForId = conversationId
    let latest = null
    try {
      latest = (await fetchSuggestions(conversationId))[0] ?? null
    } catch {
      // The notice still explains the refusal on the next refresh.
      return
    }
    if (conversationIdRef.current !== startedForId || !latest || latest.id === suggestion?.id) return
    const regenerated = latest.status === 'pending' && isSameCustomerTurn(suggestion, latest)
    if (regenerated && compare) {
      compareWithRegenerated(latest)
      return
    }
    setRegeneratedNoticeId(regenerated ? latest.id : null)
    setNewerSuggestion(latest)
  }

  // Whether the CSR has started work on the suggestion on screen: an edit to
  // the reply or a step, a "not needed" mark, or a task choice recorded.
  function hasStartedWork() {
    return isDraftDirty() || isAnyStepInputDirty() || notNeededSteps.length > 0
      || Boolean(taskPathChoiceFrom(suggestion?.modelMeta?.apiCalls))
  }

  // The change comparison for a regenerated contact (2026-10-28): the park
  // compare panel, comparing the CSR's work with the latest suggestion. The
  // work stays in place on the latest suggestion while the panel asks; its
  // Done applies the picks (applyParkChoices()): "Keep my saved work" keeps
  // it and records the task choice and its date there, "Use new suggestion"
  // loads the latest as generated. When the steps and the reply are the
  // same, nothing asks: the work stays and the strip says so. Never sends.
  function compareWithRegenerated(latest) {
    const work = latestWorkRef.current()
    const old = suggestion
    const compare = compareParkedWork({ parked: old, fresh: latest, work, messages: conversationMessages ?? [], signature: signatureSeed() })
    apply(latest)
    setNewerSuggestion(null)
    setRegeneratedNoticeId(null)
    const r = overlayWork(work, latest, { processedNote: REGENERATED_PROCESSED_NOTE, recordChoice: false })
    setParkStripHidden(false)
    if (!compareNeedsChoice(compare)) {
      setParkCheckLine(REGENERATED_KEPT_TEXT)
      setParkChangeLines(parkFactLines(compare))
      recordCarriedChoice(latest, r.taskChoice)
      return
    }
    setParkCompare({ compare, parked: old, fresh: latest, work, map: r.map, source: 'regenerated', carriedChoice: r.taskChoice })
    setParkChoices({})
    setParkStepWarnings(parkStepWarningsFor(compare, work, old, latest))
  }

  // Records a carried task choice (and its date) on `target` when it differs;
  // a failure shows on the step and keeps Send blocked.
  async function recordCarriedChoice(target, carried) {
    const rec = choiceToRecord(target, carried)
    if (!rec) return
    try {
      await recordTaskChoice(target, rec.index, rec.choice, rec.date)
    } catch {
      setTaskChoiceError({ index: rec.index, kind: 'save', message: rec.date ? TASK_DATE_SAVE_ERROR : TASK_CHOICE_SAVE_ERROR })
    }
  }

  // Moves the CSR's work onto `target` (2026-10-28): the reply, the step
  // inputs, "My reply doesn't need this" marks, the checkboxes, and the task
  // choice with its date (recorded on `target` again). Steps processed on
  // the earlier suggestion stay done where they match. The same carry-over
  // the park restore does (overlayWork(), carryWork.js).
  async function carryWorkTo(target) {
    const work = latestWorkRef.current()
    apply(target)
    setNewerSuggestion(null)
    const r = overlayWork(work, target, { processedNote: 'Processed on the earlier suggestion: not offered again.' })
    if (!r.choiceRecording) return
    try {
      await r.choiceRecording
    } catch {
      const step = taskPathChoiceStep(target.proposedActions)
      const idx = step ? (target.proposedActions ?? []).indexOf(step) : -1
      if (idx >= 0) setTaskChoiceError({ index: idx, kind: 'save', message: r.taskChoice?.date ? TASK_DATE_SAVE_ERROR : TASK_CHOICE_SAVE_ERROR })
    }
  }

  // True when the CSR has typed something into the draft field that differs
  // from the currently-applied suggestion's text. FROM_EBAY conversations never
  // show/edit a draft, so there's nothing to lose there.
  function isDraftDirty() {
    return !fromEbay && liveDraftRef.current !== appliedDraftRef.current
  }

  // True when the CSR has typed into a step's editable note/message box
  // (e.g. an order note, an eBay case reply) and that edit hasn't been
  // superseded by a subsequent apply() yet — same purpose as isDraftDirty()
  // above, but for per-step inputs rather than the main draft box. Without
  // this, a background suggestion regeneration triggered by processing a
  // DIFFERENT step could silently overwrite whatever the CSR is actively
  // typing into an unrelated step's box.
  function isAnyStepInputDirty() {
    const applied = appliedActionInputsRef.current
    return Object.keys(actionInputs).some((key) => {
      const live = actionInputs[key] ?? {}
      const baseline = applied[key] ?? {}
      return (live.editedNote != null && live.editedNote !== baseline.editedNote)
        || (live.editedMessage != null && live.editedMessage !== baseline.editedMessage)
    })
  }

  // Applies a freshly-generated suggestion, but first asks the CSR when doing
  // so would discard their edits to the reply or a step — shared by the
  // manual Regenerate button and the auto-regenerate-on-select path. The
  // styled "A new suggestion is ready" dialog (2026-10-27): "Keep my saved
  // work" keeps the reply and the step inputs as they are and holds the new
  // suggestion behind the "Load new draft" notice; "Use new suggestion"
  // applies it. Never asks:
  // - while a park restore runs for this contact: unpark's regeneration goes
  //   only through the park compare (restoreSavedWork());
  // - for the suggestion already on screen (an on-open refresh that changed
  //   nothing): the edits stay, nothing to choose.
  // Returns whether the suggestion was applied.
  async function applyIfConfirmed(newSuggestion) {
    if (!newSuggestion) return false
    if (parkRestoringRef.current?.conversationId === conversationId) return false
    const dirty = isDraftDirty() || isAnyStepInputDirty()
    if (dirty && newSuggestion.id === appliedSuggestionIdRef.current) {
      apply(newSuggestion, { skipDraft: true })
      return true
    }
    if (dirty) {
      const startedForId = conversationId
      const current = suggestion
      askingNewSuggestionRef.current = { conversationId: startedForId, id: newSuggestion.id }
      let use = false
      try {
        use = await askConfirm(newSuggestionPrompt({ current, fresh: newSuggestion, messages: conversationMessages ?? [], savedWork: restoredLine != null }))
      } finally {
        if (askingNewSuggestionRef.current?.id === newSuggestion.id) askingNewSuggestionRef.current = null
      }
      if (conversationIdRef.current !== startedForId) return false
      if (!use) {
        // The same customer message (a Regenerate, a step refresh,
        // 2026-10-28): the work moves onto the new suggestion, so the panel
        // is never left on one that can't be sent. A new customer message
        // keeps the work where it is, behind "Load new draft".
        if (newSuggestion.status === 'pending' && isSameCustomerTurn(current, newSuggestion)) {
          await carryWorkTo(newSuggestion)
          return true
        }
        setNewerSuggestion(newSuggestion)
        return false
      }
    }
    apply(newSuggestion)
    setNewerSuggestion(null)
    return true
  }

  // --- Park saves the work (2026-10-27) --------------------------------------
  // docs/decisions/2026-10-27-park-saves-work.md, docs/contact-view.md
  // "Parking". The CSR's work in progress is saved with Park and autosaved a
  // few seconds after the last edit (owner only); on the next open it is
  // restored, and a parked contact regenerates and compares first. Nothing
  // here sends, processes, or writes to TRQ or eBay: the only calls are the
  // saved-work record, the step checks and the task path choice (both
  // recordings on the suggestion), and the on-open regeneration.

  function pendingRestoreFor(suggestionId) {
    const p = pendingRestoreRef.current
    return p && p.conversationId === conversationId && p.suggestionId === suggestionId ? p : null
  }

  function resetParkState() {
    setRestoredLine(null)
    setParkCheckLine(null)
    setParkChangeLines([])
    setParkChecking(false)
    setParkCompare(null)
    setParkChoices({})
    setParkBusy(false)
    setParkError(null)
    setParkStepWarnings({})
    setParkStepNotes({})
    setParkStripHidden(false)
    setRestoredFromOther(false)
    workSavedFpRef.current = null
    touchedRef.current = false
  }

  function markTouched() {
    touchedRef.current = true
  }
  // The panel's own events (2026-10-30): typing, a change, a paste, a key
  // that edits a box, a pick from a list. Not inside a dialog (a template
  // search, Send Feedback), except a step card in the Manual Panel's window.
  function onPanelInput(e) {
    if (isWorkEventTarget(e?.target)) markTouched()
    hideParkStripOnEdit(e)
  }
  function onPanelKeyDown(e) {
    if (isEditingKey(e) && isWorkEventTarget(e.target)) markTouched()
  }
  function onPanelClick(e) {
    if (isWorkChoiceClick(e?.target)) markTouched()
  }

  // The strip goes once the CSR edits something on the panel itself (typing,
  // a checkbox, a choice). Events from a dialog portaled out of the panel
  // (a template search) don't count. The hide waits for the event to finish
  // (2026-10-28): set during the input event's capture, it re-rendered the
  // panel before the box's own onChange and the first keystrokes after a
  // restore were lost. A contact switch meanwhile cancels it.
  function hideParkStripOnEdit(e) {
    if (parkStripHidden || (!restoredLine && !parkCheckLine)) return
    if (!parkStripHidesOnWork(parkChangeLines)) return
    if (!e?.currentTarget?.contains?.(e.target)) return
    const forId = conversationId
    setTimeout(() => { if (conversationIdRef.current === forId) setParkStripHidden(true) }, 0)
  }
  // A step's checkbox and Process (a step's own, or "Process all") hide it
  // too (2026-10-28): the step cards are portaled into their slots, so their
  // events are not DOM descendants of the panel the capture handlers sit on.
  function hideParkStrip() {
    if (!parkStripHidesOnWork(parkChangeLines)) return
    if (!parkStripHidden && (restoredLine || parkCheckLine)) setParkStripHidden(true)
  }

  // Everything the CSR has done on the contact so far (workDraft.js).
  // The signature is saved as the token (2026-10-30): the box's resolved
  // "<first name> | <signature>" (and a lone first name where the draft had
  // the token) goes back to [AGENT_FIRST_NAME], so a restore signs as
  // whoever opens it.
  // tokenized false: the box text as it is (a carry-over onto a new
  // suggestion in this same panel, never saved).
  function currentWorkPayload({ tokenized = true } = {}) {
    return buildWorkPayload({
      suggestion, draft, from: draftFrom, to: draftTo, cc: ccEdited, subject: draftSubject, replyMode, startNewContact,
      insertedTemplate: draftInsertedTemplate, attachments, actionInputs, uncheckedSteps, notNeededSteps,
      taskChoice, taskChoiceDate, partLinks, stepStates,
      tokenize: tokenized ? (text) => tokenizeAgentName(text, companySignatureInfo(templateAccount), agentFirstName, { sources: signatureSources(suggestion) }) : null,
    })
  }

  // The texts that held [AGENT_FIRST_NAME] before it was resolved into a box:
  // the suggestion's draft, its steps' messages, the signature template.
  function signatureSources(s) {
    const out = [s?.humanReply, s?.draftReply, signatureTemplate]
    for (const a of s?.proposedActions ?? []) {
      for (const v of Object.values(a?.params ?? {})) if (typeof v === 'string' && v.includes('[AGENT_FIRST_NAME]')) out.push(v)
    }
    return out.filter((t) => typeof t === 'string')
  }

  // Saved work put back for the CSR opening it (2026-10-30): the signature
  // token resolved for them through the boxes' own load path, and a name an
  // older save resolved for its saver moved to them.
  function workForViewer(work, base) {
    if (!work?.payload) return work
    const info = companySignatureInfo(templateAccount)
    const saver = firstNameOf(work.savedByName ?? work.savedBy)
    const sources = signatureSources(base)
    const move = (load) => (text) => retargetAgentName(text, info, saver, agentFirstName, { sources, load })
    return { ...work, payload: mapWorkText(work.payload, { reply: move(draftBoxText), step: move(ebayStepBoxText) }) }
  }

  // Text as the restore's "differs from the draft" check compares it: the
  // signature as the token (the saver's or the viewer's name), then no tags
  // or spacing.
  function comparableWorkText(work, base) {
    const info = companySignatureInfo(templateAccount)
    const names = [firstNameOf(work?.savedByName ?? work?.savedBy), agentFirstName].filter(Boolean)
    const sources = signatureSources(base)
    return (text) => {
      let t = String(text ?? '')
      for (const n of names) t = tokenizeAgentName(t, info, n, { sources })
      // The token then resolved for nobody: a box loaded with no name and one
      // loaded with a name compare the same.
      return comparableText(resolvePlaceholderSignature(t, templateAccount, ''))
    }
  }

  // The box text a suggestion loads (apply()'s own rule), for the compare.
  function freshBoxTextFor(s) {
    const effective = effectiveTaskPathChoice(s)
    const chosenText = effective?.choice ? returnStageText(s?.proposedActions, effective.choice, effective?.date) : null
    const rawText = s ? (s.humanReply || s.draftReply || chosenText || '') : ''
    const seed = shouldSeedSignatureFor({ suggestion: s, fromEbay, isEbayClientEmail, hasNoDraftBoxOfItsOwnFn: noDraftBoxFn, rawText })
    return seed ? blankBoxSeed() : draftBoxText(rawText)
  }

  // Whether saved work holds real work against the suggestion it was saved
  // on (workDraft.js's workDiffersFromDraft()).
  function savedWorkIsReal(work, base) {
    return workDiffersFromDraft(work, {
      base,
      freshDraft: freshBoxTextFor(base),
      defaults: reseedActionInputs(base?.proposedActions ?? [], {}, ebayStepBoxText),
      baseUnchecked: uncheckedStepsFrom(base?.modelMeta?.apiCalls),
      baseTaskChoice: effectiveTaskPathChoice(base),
      normalize: comparableWorkText(work, base),
    })
  }

  // "Start from the AI draft instead" (2026-10-30): someone else's restored
  // reply and step inputs go; the current suggestion's draft, step defaults
  // and step checkboxes (every step checked) load, signed as the person now
  // working the contact. Steps already processed stay done (and unchecked).
  // The saved work is dropped (owner only).
  function startFromAiDraft() {
    if (!suggestion) return
    const box = freshBoxTextFor(suggestion)
    setDraft(box)
    appliedDraftRef.current = box
    const defaults = reseedActionInputs(suggestion.proposedActions ?? [], {}, ebayStepBoxText)
    setActionInputs(defaults)
    appliedActionInputsRef.current = defaults
    setNotNeededSteps([])
    const unchecked = defaultUncheckedSteps(stepStates)
    if (JSON.stringify(unchecked) !== JSON.stringify([...uncheckedSteps].sort((a, b) => a - b))) {
      setUncheckedSteps(unchecked)
      if (suggestion.id) saveStepChecks(suggestion.id, unchecked).catch(() => {})
    }
    const own = effectiveTaskPathChoice(suggestion)
    setTaskChoice(own?.choice ?? null)
    setTaskChoiceDate(own?.date ?? '')
    setDraftInsertedTemplate(null)
    pendingRestoreRef.current = null
    setRestoredLine(null)
    setRestoredFromOther(false)
    setParkCheckLine(null)
    setParkChangeLines([])
    setParkStepWarnings({})
    setParkStepNotes({})
    touchedRef.current = false
    workSavedFpRef.current = null
    dropSavedWorkWhenOwner()
  }

  // The saved work goes once this person owns the contact (the claim can
  // land after the open's restore): only the owner may drop it, as only the
  // owner saves it.
  const dropSavedWorkRef = useRef(null)
  // As of the latest render (a restore runs from an older render's closure).
  const isOwnerRef = useRef(isOwner)
  isOwnerRef.current = isOwner
  function dropSavedWorkWhenOwner() {
    dropSavedWorkRef.current = conversationId
    if (isOwnerRef.current) {
      dropSavedWorkRef.current = null
      clearSavedWork(conversationId).catch(() => {})
    }
  }
  useEffect(() => {
    if (!isOwner || dropSavedWorkRef.current !== conversationId) return
    dropSavedWorkRef.current = null
    clearSavedWork(conversationId).catch(() => {})
  }, [isOwner, conversationId])
  // The work as of the latest render, for carryWorkTo(), which can run from
  // an older render's closure (after a dialog or a request).
  latestWorkRef.current = () => ({ suggestionId: suggestion?.id ?? null, payload: currentWorkPayload({ tokenized: false }) })

  // Puts saved work back onto `target`, which apply() just loaded. keepSteps /
  // keepReply: whether the saved step inputs / reply replace the target's.
  // A step processed before the park is marked done and unchecked, so it is
  // never offered again (the server refuses an unchecked step too).
  // processedNote: the line on a step processed before (the park's, or a
  // carry-over's). Returns restoredWorkFor()'s result with choiceRecording:
  // the task choice's recording on `target` (a promise), or null.
  // recordChoice false: the carried task choice is shown but not recorded
  // yet (the regenerated compare records it on Done).
  function overlayWork(work, target, { keepSteps = true, keepReply = true, processedNote = 'Processed before you parked this: not offered again.', recordChoice = true } = {}) {
    const r = restoredWorkFor(work, target, { keepSteps, keepReply })
    const reply = r.reply
    pendingRestoreRef.current = {
      conversationId, suggestionId: target?.id ?? null,
      cc: reply?.cc ?? null, template: reply?.template ?? null, partLinks: keepSteps ? r.partLinks : {}, draft: r.draft,
    }
    if (r.draft != null) setDraft(r.draft)
    if (reply) {
      if (reply.to) setDraftTo(reply.to)
      if (reply.from) setDraftFrom(reply.from)
      if (reply.subject) setDraftSubject(reply.subject)
      if (reply.replyMode) setReplyMode(reply.replyMode)
      setStartNewContact(Boolean(reply.startNewContact))
      if (reply.cc != null) setCcEdited(reply.cc)
      if (reply.template) setDraftInsertedTemplate(reply.template)
      const saved = (reply.attachments ?? []).filter((a) => a?.dataUrl)
      if (saved.length) setAttachments((prev) => [...prev.filter((x) => !saved.some((a) => a.name === x.name && a.size === x.size)), ...saved])
      if (reply.attachmentsDropped) {
        setAttachmentError(`Attach again: ${(reply.attachments ?? []).map((a) => a.name).filter(Boolean).join(', ')}. They were too large to save with your work.`)
      }
    }
    // The step work, and the choice recorded on the suggestion again (Send
    // checks it there): the shared carry-over (carryWork.js).
    const choiceRecording = keepSteps
      ? carryStepWork(r, target, { setActionInputs, setNotNeededSteps, setPartLinks, setTaskChoice, setTaskChoiceDate, recordChoice: recordChoice ? (idx, choice, date) => recordTaskChoice(target, idx, choice, date) : () => null })
      : null
    choiceRecording?.catch(() => {})
    const processedIdx = Object.keys(r.processed).map(Number)
    if (processedIdx.length) {
      setStepStates((prev) => ({ ...prev, ...Object.fromEntries(processedIdx.map((j) => [j, { status: 'success', error: null, result: r.processed[j], fromPark: true }])) }))
    }
    const stored = uncheckedStepsFrom(target?.modelMeta?.apiCalls)
    const unchecked = [...new Set([...(keepSteps ? r.uncheckedSteps : stored), ...processedIdx])].sort((a, b) => a - b)
    setUncheckedSteps(unchecked)
    if (target?.id && JSON.stringify([...stored].sort((a, b) => a - b)) !== JSON.stringify(unchecked)) {
      saveStepChecks(target.id, unchecked).catch(() => {})
    }
    setParkStepNotes(Object.fromEntries(processedIdx.map((j) => [j, processedNote])))
    return { ...r, choiceRecording }
  }

  // The warning on a step whose inputs the CSR changed while the facts under
  // it changed (@cxhub/shared's stepFactWarning()), by the new step's index.
  function parkStepWarningsFor(compare, work, parked, fresh) {
    if (!compare.facts.length) return {}
    const toParked = savedStepIndexMap(work, parked)
    const parkedDefaults = reseedActionInputs(parked?.proposedActions ?? [], {}, ebayStepBoxText)
    const toFresh = compare.steps.map?.oldToNew ?? {}
    const out = {}
    for (const [savedIdx, input] of Object.entries(work?.payload?.actionInputs ?? {})) {
      const p = toParked[savedIdx]
      if (p == null || JSON.stringify(input) === JSON.stringify(parkedDefaults[p] ?? null)) continue
      const j = toFresh[p]
      if (j == null) continue
      const warning = stepFactWarning(fresh?.proposedActions?.[j], compare.facts)
      if (warning) out[j] = warning
    }
    return out
  }

  async function settleNothingNew(target) {
    setParkCheckLine(PARK_NOTHING_NEW_TEXT)
    try {
      await settleParkCompare(conversationId, { suggestionId: target.id, resolution: { choice: 'nothing_new', items: [] } })
    } catch {
      // The next open checks again.
    }
  }

  // The saved work for this contact, restored onto the pending suggestion.
  // A parked one first regenerates as the on-open refresh does (ifChanged),
  // then compares the new suggestion with the parked one and the saved work:
  // nothing substantial keeps the work and says so; otherwise the "Since you
  // parked this" panel asks, with the saved work in place meanwhile. Returns
  // whether it handled the open (false: no saved work to restore).
  async function restoreSavedWork(list, isActive) {
    let work = null
    try {
      work = await fetchWorkDraft(conversationId)
    } catch {
      return false
    }
    if (!isActive() || !work) return false
    const latest = list[0] ?? null
    const baseId = work.parkedSuggestionId ?? work.suggestionId
    const base = list.find((x) => x.id === baseId) ?? null
    if (!shouldRestoreWork(work, { latest, base })) return false
    // Only real work is restored (2026-10-30): saved work that equals what
    // the suggestion it was saved on loads by itself (the AI draft, the step
    // defaults, the signature as the token) is nobody's work. The draft loads
    // fresh with no line, and the row goes (the owner's open drops it).
    if (!savedWorkIsReal(work, base ?? latest)) {
      dropSavedWorkWhenOwner()
      return false
    }
    // Signed as the person opening it, whoever saved it.
    work = workForViewer(work, base ?? latest)
    let fresh = latest
    if (work.parkedAt) {
      setBusy(true)
      setParkChecking(true)
      try {
        const updated = await generateSuggestion(conversationId, { ifChanged: true })
        if (updated?.id && updated.status === 'pending') fresh = updated
      } catch {
        // The latest suggestion stays; the compare runs against it.
      } finally {
        if (isActive()) { setBusy(false); setParkChecking(false) }
      }
      if (!isActive()) return true
      onGenerated?.()
    }
    apply(fresh)
    setNewerSuggestion(null)
    const r = overlayWork(work, fresh)
    setRestoredLine(restoredWorkLine(work, viewerUsername))
    setRestoredFromOther(!isOwnWork(work, viewerUsername))
    // Someone else's work: recorded on the suggestion it lands on (the
    // saver's Roles page id and the time, never a name), for the signature
    // report.
    if (!isOwnWork(work, viewerUsername) && fresh?.id) recordRestoredWork(conversationId, fresh.id).catch(() => {})
    // Restored work the person does not touch is never re-saved under them:
    // it keeps its author and time (touchedRef stays false).
    workSavedFpRef.current = null
    // The same suggestion back (or the parked one gone): only a new customer
    // message can be news.
    const parked = base ?? fresh
    // Work restored from an autosave onto the suggestion it was saved on:
    // nothing to compare.
    if (!work.parkedAt && parked.id === fresh.id) return true
    const compare = compareParkedWork({ parked, fresh, work, messages: conversationMessages ?? [], signature: signatureSeed() })
    if (!compare.substantial) {
      if (work.parkedAt) await settleNothingNew(fresh)
      return true
    }
    // Only order facts or a new customer message changed (2026-10-28): the
    // steps and the reply are the same, so nothing asks. The work stays and
    // the strip says what changed.
    if (!compareNeedsChoice(compare)) {
      if (!isActive()) return true
      setParkCheckLine(PARK_FACTS_ONLY_TEXT)
      setParkChangeLines(parkFactLines(compare))
      setParkStepWarnings(parkStepWarningsFor(compare, work, parked, fresh))
      try {
        await settleParkCompare(conversationId, { suggestionId: fresh.id, resolution: parkResolutionFrom({}) })
      } catch {
        // The next open checks again.
      }
      return true
    }
    if (!isActive()) return true
    setParkCompare({ compare, parked, fresh, work, map: r.map })
    setParkChoices({})
    setParkStepWarnings(parkStepWarningsFor(compare, work, parked, fresh))
    return true
  }

  // Steps the CSR kept from the parked suggestion came back appended (the
  // settle route): their saved inputs follow them.
  function adoptRestoredSteps(updated, work, parked) {
    const before = suggestion?.proposedActions?.length ?? 0
    const actions = updated?.proposedActions ?? []
    setSuggestion((x) => (x && x.id === updated.id ? { ...x, proposedActions: actions, modelMeta: updated.modelMeta ?? x.modelMeta } : x))
    if (actions.length <= before) return
    const toParked = savedStepIndexMap(work, parked)
    const parkedToSaved = Object.fromEntries(Object.entries(toParked).map(([savedIdx, p]) => [p, savedIdx]))
    const defaults = reseedActionInputs(actions, {}, ebayStepBoxText)
    setActionInputs((prev) => {
      const next = { ...prev }
      for (let j = before; j < actions.length; j++) {
        const p = actions[j]?.restoredFromPark?.index
        const savedIdx = p != null ? parkedToSaved[p] : undefined
        const saved = savedIdx != null ? work?.payload?.actionInputs?.[savedIdx] : undefined
        if (saved !== undefined) next[j] = saved
        else if (defaults[j] !== undefined) next[j] = defaults[j]
      }
      return next
    })
  }

  // Applies the choice to the panel and records it (parkResolution). all:
  // PARK_KEEP / PARK_NEW for "Keep my saved work" / "Use new suggestion" on
  // everything; else the per-item picks (an item not picked keeps the work).
  // The panel's Done (2026-10-28) applies the picks; every item picked "Use
  // new suggestion" is the same as everything new.
  async function applyParkChoices(all = null, picks = parkChoices) {
    const pc = parkCompare
    if (!pc || !suggestion) return
    const { compare, parked, fresh, work } = pc
    const ids = compareItems(compare)
    const items = Object.fromEntries(ids.map((id) => [id, all ?? picks[id] ?? PARK_KEEP]))
    if (!all && ids.length && ids.every((id) => items[id] === PARK_NEW)) all = PARK_NEW
    const actions = suggestion.proposedActions ?? []
    const defaults = reseedActionInputs(actions, {}, ebayStepBoxText)
    setParkBusy(true)
    setParkError(null)
    if (all === PARK_NEW) {
      // The new suggestion as generated: its draft and every step's defaults.
      // Steps processed before the park stay done.
      const text = fresh.humanReply || fresh.draftReply || ''
      const box = text ? draftBoxText(text) : blankBoxSeed()
      setDraft(box)
      setActionInputs(defaults)
      setNotNeededSteps([])
      setParkStepWarnings({})
    } else {
      if (items[REPLY_ITEM] === PARK_NEW) {
        const text = fresh.humanReply || fresh.draftReply || ''
        setDraft(text ? draftBoxText(text) : blankBoxSeed())
      }
      const toDefaults = compare.steps.changed.filter((x) => items[stepItemId('changed', x.index)] === PARK_NEW).map((x) => x.index)
      if (toDefaults.length) {
        setActionInputs((prev) => {
          const next = { ...prev }
          for (const j of toDefaults) {
            if (defaults[j] === undefined) delete next[j]
            else next[j] = defaults[j]
          }
          return next
        })
        setParkStepWarnings((prev) => Object.fromEntries(Object.entries(prev).filter(([j]) => !toDefaults.includes(Number(j)))))
      }
    }
    // An added step the CSR keeps their work over is left out (unchecked).
    const leaveOut = compare.steps.added.filter((x) => items[stepItemId('added', x.index)] === PARK_KEEP).map((x) => x.index)
    if (leaveOut.length) {
      const next = [...new Set([...uncheckedSteps, ...leaveOut])].sort((a, b) => a - b)
      setUncheckedSteps(next)
      saveStepChecks(suggestion.id, next).catch(() => {})
      setParkStepNotes((prev) => ({ ...prev, ...Object.fromEntries(leaveOut.map((j) => [j, 'Not in your saved work: left out (Keep my saved work).'])) }))
    }
    // A removed step the CSR keeps comes back from the parked suggestion.
    const restoreSteps = compare.steps.removed.filter((x) => items[stepItemId('removed', x.index)] === PARK_KEEP).map((x) => x.index)
    const regenerated = pc.source === 'regenerated'
    try {
      const res = await settleParkCompare(conversationId, { suggestionId: suggestion.id, resolution: parkResolutionFrom(items), restoreSteps, ...(regenerated ? { fromSuggestionId: parked.id } : {}) })
      if (res?.suggestion?.id === suggestion.id) adoptRestoredSteps(res.suggestion, work, parked)
      setParkCompare(null)
      setParkChoices({})
      // A regenerated contact (2026-10-28): the task choice and its date
      // follow the work unless everything is new; then the new suggestion's
      // own choice shows.
      if (regenerated) {
        if (all === PARK_NEW) {
          const own = effectiveTaskPathChoice(fresh)
          setTaskChoice(own?.choice ?? null)
          setTaskChoiceDate(own?.date ?? '')
        } else {
          await recordCarriedChoice(fresh, pc.carriedChoice)
        }
      }
    } catch (e) {
      setParkError(`Your choice could not be recorded: ${e.message}`)
    } finally {
      setParkBusy(false)
    }
  }

  // The autosave: a few seconds after the last edit, while this person owns
  // the contact and the suggestion is undecided. Only once the person did
  // something on it (touchedRef, 2026-10-30: never because state differs
  // after a load, a reseed, defaults, name resolution or a restore), and
  // never the same work twice.
  const workPayloadNow = parkingEnabled && isOwner && suggestion?.status === 'pending' && !loading ? currentWorkPayload() : null
  const workFp = workPayloadNow ? workFingerprint(workPayloadNow) : ''
  useEffect(() => {
    if (screenMode || !workPayloadNow || workFp === workSavedFpRef.current) return undefined
    if (!touchedRef.current) return undefined
    const id = conversationId
    const body = { suggestionId: suggestion.id, payload: workPayloadNow }
    const fp = workFp
    const timer = setTimeout(() => {
      saveWorkDraft(id, body).then(() => { if (conversationIdRef.current === id) workSavedFpRef.current = fp }).catch(() => {})
    }, WORK_AUTOSAVE_DELAY_MS)
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workFp, conversationId])
  // Park (App.jsx's header button) reads the work through this, so it is
  // saved with the park in one request.
  // Nothing touched (2026-10-30): the park marks the saved work there is
  // (keeping its author and time) and saves none of its own.
  if (workCaptureRef) {
    workCaptureRef.current = () => {
      if (!parkingEnabled || suggestion?.status !== 'pending') return null
      if (!touchedRef.current) return { suggestionId: suggestion.id, untouched: true, payload: {} }
      return { suggestionId: suggestion.id, payload: currentWorkPayload() }
    }
  }

  useEffect(() => {
    liveDraftRef.current = draft
  }, [draft])

  // Reports draft-dirty state up to App.jsx so it can guard against discarding
  // unsaved edits when the CSR selects a different conversation.
  useEffect(() => {
    onDraftDirtyChange?.(isDraftDirty())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draft, suggestion, fromEbay])

  useEffect(() => {
    let active = true
    // A genuinely new conversation selection, as opposed to a refreshKey-only
    // bump for the conversation already open (e.g. a bulk "Generate all"
    // elsewhere) — auto-regenerate only fires once per selection event.
    // The ref is deliberately NOT updated here (only once this invocation's
    // fetch actually lands, below, guarded by `active`) — React 18
    // StrictMode double-invokes this effect once in dev (mount, cleanup,
    // mount again); updating the ref synchronously would let the phantom
    // first invocation claim conversationId as "already seen" before its
    // own fetch is even cancelled, making the real (second) invocation
    // compute isNewSelection as false and silently skip the on-open
    // regenerate below.
    // The read-only screen view: the report's suggestion, no fetch, no
    // on-open regenerate. Its screen state is put back by the effect below.
    if (screenMode) {
      apply(screenView.suggestion)
      setLoading(false)
      return () => { active = false }
    }
    const isNewSelection = prevConversationIdRef.current !== conversationId
    // A minimized (or full-size) New Spam Rule dialog is tied to the
    // conversation it was opened for — since this panel isn't remounted on
    // conversation switch (no `key` prop), it would otherwise stay floating
    // over whatever conversation is now open, showing stale spamContext and
    // deselecting the WRONG conversation if later closed/saved. Reset it on
    // every genuine switch, not on a refreshKey-only bump for the same conversation.
    if (isNewSelection) {
      setSpamDialogOpen(false)
      setPendingSpamStatus(null)
      resetParkState()
      setRegeneratedNoticeId(null)
      setQuietChecking(false)
      setQuietUpdatedId(null)
      // A question about the contact left behind is answered "keep".
      dismissConfirm()
      askingNewSuggestionRef.current = null
    }
    setLoading(true); setError(null); setClosedNotice(null); setHouseReplyNote(null); setNoMessages(false); setRetryDeferral(null)
    fetchSuggestions(conversationId)
      .then(async (list) => {
        if (!active) return
        prevConversationIdRef.current = conversationId
        const latest = list[0] ?? null
        // refreshSkipDraft is only ever meaningful for a same-conversation
        // refresh bump (a manual-panel Process completing) — a genuinely new
        // conversation selection must always populate the draft box normally,
        // regardless of what refreshSkipDraft happens to be set to. Also skip
        // whenever the CSR has unsaved draft/step-input edits right now,
        // regardless of which trigger caused this refresh (a bulk generate,
        // an intent override, or any other same-conversation bump) — same
        // protection handleProcessStep's own regenerate call applies.
        // A suggestion for a NEW buyer message, while the agent has unsaved
        // edits: keep their edits and offer it (newDraftNotice.js), rather
        // than swapping the suggestion underneath them (2026-10-13).
        // Left alone while this contact's park restore runs (it applies the
        // regenerated suggestion and compares, restoreSavedWork()) or while
        // the "A new suggestion is ready" dialog asks about one (2026-10-27);
        // a newer suggestion the agent kept their work over stays held.
        const dirtyNow = isDraftDirty() || isAnyStepInputDirty()
        if (!isNewSelection && (parkRestoringRef.current?.conversationId === conversationId || askingNewSuggestionRef.current?.conversationId === conversationId)) {
          // the restore or the dialog decides
        } else if (!isNewSelection && (shouldHoldNewerSuggestion({ current: suggestion, latest, dirty: dirtyNow }) || (dirtyNow && latest && newerSuggestion?.id === latest.id))) {
          setNewerSuggestion(latest)
        } else {
          apply(latest, { skipDraft: !isNewSelection && (refreshSkipDraft || isDraftDirty() || isAnyStepInputDirty()) })
          setNewerSuggestion(null)
        }
        // forcedDraftText: the deliberate exception to every other same-
        // conversation refresh — CreateReturnLabelModal.jsx's create-label
        // step passes its resolved reply text here (App.jsx's
        // handleManualActionCompleted), since the CSR explicitly asked to
        // create a label and the draft SHOULD reflect the real URL just
        // resolved, regardless of skipDraft above. Only meaningful for a
        // same-conversation bump, same guard as refreshSkipDraft itself.
        if (!isNewSelection && forcedDraftText != null) {
          setDraft(draftBoxText(forcedDraftText))
        }
        // Park saves the work (2026-10-27): saved work for this contact is
        // restored here, and a parked one regenerates (as the on-open refresh
        // below does) and compares before replacing anything
        // (restoreSavedWork()). Handled: the on-open refresh below is skipped.
        if (isNewSelection && parkingEnabled && latest) {
          const token = {}
          parkRestoringRef.current = { conversationId, token }
          // A refresh bump for this same contact (the list noticing the
          // regenerated suggestion) must not cut the restore short: it stays
          // live until another restore or another contact takes over.
          const restoreLive = () => active || (parkRestoringRef.current?.token === token && conversationIdRef.current === conversationId)
          let handled = false
          try {
            handled = await restoreSavedWork(list, restoreLive)
          } finally {
            if (parkRestoringRef.current?.token === token) parkRestoringRef.current = null
          }
          if (handled || !active) return
        }
        // sales_hold_phone_call: the Tier-3 ifChanged:true reuse path only
        // fingerprints generic order-enrichment facts (pipeline.js) — it
        // never re-runs groundSalesHoldPhoneCall(), so it can silently reuse
        // a stale suggestion even when safeToCall/hold-status would have
        // changed (e.g. the customer's local clock crossed into the safe
        // window, or the hold cleared). Force a full fresh regenerate on
        // every open instead, matching the manual Regenerate button's own
        // unconditional call below — never gated on isSuggestionStale(),
        // since staleness here isn't just about time-in-queue.
        const isSalesHoldPhoneCall = latest?.intent === 'sales_hold_phone_call'
        if (isNewSelection && latest && (isSalesHoldPhoneCall || isSuggestionStale(latest))) {
          // Quiet (2026-10-29, docs/contact-view.md "Stale check on open"):
          // no "Regenerating…" and the draft stays editable; only the
          // decision buttons wait for it (decideBusy). The draft shows
          // meanwhile: the panel's loading spinner ends here, not after it.
          setQuietChecking(true)
          setLoading(false)
          try {
            // ifChanged: this is the opportunistic on-open refresh, not an
            // explicit Regenerate — the server re-pulls order data fresh but
            // reuses this draft (no LLM) when nothing that grounds it changed,
            // so a stale-but-unchanged suggestion loads fast instead of eating
            // the full draft+grade cost. Skipped for sales_hold_phone_call —
            // see comment above.
            const updated = isSalesHoldPhoneCall
              ? await generateSuggestion(conversationId)
              : await generateSuggestion(conversationId, { ifChanged: true })
            if (active) {
              const outcome = quietCheckOutcome({ updated, appliedId: appliedSuggestionIdRef.current, dirty: isDraftDirty() || isAnyStepInputDirty(), forced: isSalesHoldPhoneCall })
              setQuietChecking(false)
              if (outcome !== 'unchanged') {
                const applied = await applyIfConfirmed(updated)
                if (applied && outcome === 'silent' && active) setQuietUpdatedId(updated.id)
              }
              onGenerated?.()
            }
          } catch (e) {
            // Best-effort background refresh — the existing (still valid, if
            // stale) suggestion stays displayed on failure rather than
            // surfacing an error banner for a call the CSR didn't initiate.
            // Exception: a 404/no_inbound_turn means the server just closed
            // this conversation as a side effect (not a genuine failure) —
            // still silent (no notice; the CSR didn't ask for this refresh),
            // but the status badge/list must catch up regardless of who
            // triggered the close.
            if (active && e.status === 404) onGenerated?.()
          } finally {
            if (active) setQuietChecking(false)
          }
        }
      })
      .catch((e) => active && setError(e.message))
      .finally(() => active && setLoading(false))
    return () => { active = false }
  }, [conversationId, refreshKey])

  // The read-only screen view (2026-10-29): once the report's suggestion is
  // applied, its screen state is put back exactly: every step's inputs as on
  // screen (the prefilled ones as the baseline), the step and check states,
  // the choices, the reply box's HTML and its template. Declared after every
  // other effect that seeds these, so it runs last and wins.
  useEffect(() => {
    if (!screenMode || !suggestion || suggestion.id !== screenView.suggestion.id) return
    const st = screenView.state
    const panel = st.panel ?? null
    const stepsBy = (key) => Object.fromEntries((st.steps ?? []).filter((x) => x?.inputs?.[key] != null).map((x) => [x.index, x.inputs[key]]))
    const onScreen = panel?.actionInputs ?? stepsBy('onScreen')
    appliedActionInputsRef.current = panel?.appliedInputs ?? stepsBy('prefilled')
    setActionInputs(onScreen)
    setStepStates(panel?.stepStates ?? Object.fromEntries((st.steps ?? []).filter((x) => x.state && x.state !== 'pending').map((x) => [x.index, { status: x.state, error: x.error ?? null }])))
    setCheckStates(panel?.checkStates ?? {})
    setPartLinks(panel?.partLinks ?? {})
    setTaskChoice(st.choices?.taskChoice?.choice ?? null)
    setTaskChoiceDate(st.choices?.taskChoice?.date ?? '')
    setNotNeededSteps(st.choices?.notNeededSteps ?? [])
    setUncheckedSteps(st.choices?.uncheckedSteps ?? [])
    const box = st.reply?.box ?? null
    if (box != null) { setDraft(box); appliedDraftRef.current = box }
    setDraftInsertedTemplate(st.template?.source === 'agent_inserted' ? insertedTemplateOf(st.template) : null)
    if (st.reply?.to != null) setDraftTo(st.reply.to)
    if (st.reply?.subject != null) setDraftSubject(st.reply.subject)
    if (st.reply?.replyMode) setReplyMode(st.reply.replyMode)
    if (st.reply?.cc != null) setCcEdited(st.reply.cc)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenMode, suggestion?.id])

  // The backend now defers QA grading to a non-blocking follow-up (see
  // pipeline.js's gradeAndUpdateSuggestion()) so the CSR can act on the
  // draft/proposed actions as soon as they're generated — a freshly applied
  // suggestion often starts with qaGrade: null. Poll briefly for the grade to
  // land and patch ONLY the grade-related fields into local state once it
  // does — never re-apply the whole suggestion here, that would discard any
  // draft edit the CSR has already started. Self-terminating: once qaGrade
  // is non-null this effect's own dependency changes and it does nothing.
  useEffect(() => {
    if (screenMode || !suggestion || suggestion.qaGrade != null || suggestion.status !== 'pending') return
    let active = true
    let timer = null
    const suggestionId = suggestion.id
    async function poll(attempt) {
      if (!active) return
      try {
        const list = await fetchSuggestions(conversationId)
        const match = list.find((s) => s.id === suggestionId)
        if (!active) return
        if (match && (match.qaGrade != null || match.modelMeta?.gradeError)) {
          setSuggestion((prev) => (prev && prev.id === suggestionId
            ? { ...prev, qaGrade: match.qaGrade, needsHumanReview: match.needsHumanReview, humanReviewReason: match.humanReviewReason }
            : prev))
          return
        }
      } catch {
        return // best-effort — the draft itself is unaffected either way
      }
      if (active && attempt < 8) timer = setTimeout(() => poll(attempt + 1), 2000)
    }
    timer = setTimeout(() => poll(1), 2000)
    return () => { active = false; clearTimeout(timer) }
  }, [suggestion?.id, suggestion?.qaGrade, suggestion?.status, conversationId])

  // A suggestion qualifies for silent auto-regeneration only when it's still
  // undecided (never touch an approved/edited/escalated/dismissed suggestion)
  // and old enough that the conversation likely sat in the queue a while.
  function isSuggestionStale(s) {
    if (s.status !== 'pending') return false
    const createdAt = s.createdAt ? new Date(s.createdAt).getTime() : null
    if (!createdAt) return false
    return Date.now() - createdAt >= autoRegenerateStaleMinutes * 60000
  }

  // Decided-suggestion staleness relative to a NEWER inbound message —
  // distinct from isSuggestionStale() above (time-in-queue, pending only).
  // This fires for a suggestion that's ALREADY been decided (approved/
  // edited/dismissed) but a genuinely new customer message has arrived
  // since — most commonly channels/m365/ingest.js's own reopen-on-reply
  // hook, whose regeneration attempt is best-effort and can silently fail
  // into summary.errors, leaving list[0] (the most recently CREATED
  // suggestion — repositories/ai-suggestions.js's own ORDER BY) stuck on
  // the pre-reply decision. Showing that as "decided" — read-only, no Send/
  // Escalate/Close/Spam — would silently hide a conversation that genuinely
  // needs a fresh answer.
  function isDecidedSuggestionStaleRelativeToLatestMessage(s) {
    if (!s || s.status === 'pending' || !lastInboundMessage) return false
    const createdAt = s.createdAt ? new Date(s.createdAt).getTime() : null
    const receivedAt = lastInboundMessage.receivedAt ? new Date(lastInboundMessage.receivedAt).getTime() : null
    if (!createdAt || !receivedAt || Number.isNaN(createdAt) || Number.isNaN(receivedAt)) return false
    return receivedAt > createdAt
  }

  // Closes a contact with no messages (the notice's button). The server
  // allows it only while the contact is open and still has no messages.
  async function handleCloseEmpty() {
    setClosingEmpty(true); setError(null)
    try {
      await closeConversation(conversationId)
      setNoMessages(false)
      setClosedNotice('Contact closed.')
      onGenerated?.()
    } catch (e) {
      setError(`Couldn't close this contact: ${e.status === 409 ? refusalMessage(e, 'Close') : e.message}`)
    } finally {
      setClosingEmpty(false)
    }
  }

  // The header's Regenerate (2026-10-21, App.jsx's "VIN updated" line): each
  // new request runs the same onGenerate() as this panel's own Regenerate
  // button, its unsaved-draft confirm included.
  const handledRegenerateRequestRef = useRef(regenerateRequest)
  useEffect(() => {
    if (screenMode || regenerateRequest === handledRegenerateRequestRef.current) return
    handledRegenerateRequestRef.current = regenerateRequest
    onGenerate()
  }, [regenerateRequest]) // eslint-disable-line react-hooks/exhaustive-deps

  async function onGenerate() {
    const startedForId = conversationId
    setBusy(true); setError(null); setClosedNotice(null); setNoMessages(false); setRetryDeferral(null)
    try {
      const updated = await generateSuggestion(conversationId)
      // The CSR may have navigated to a different conversation while this
      // generation was in flight — this component instance persists across
      // conversation switches (see conversationIdRef's own comment). Drop the
      // result silently: the generation already completed and persisted
      // server-side; the CSR sees it next time they open this conversation.
      if (conversationIdRef.current !== startedForId) return
      applyIfConfirmed(updated)
      onGenerated?.()
    }
    catch (e) {
      if (conversationIdRef.current !== startedForId) return
      if (e.deferral) {
        // Deferred for a TRQ retry: the order is not in TRQ yet. The
        // existing suggestion stays; the list refreshes to show 'waiting'.
        setRetryDeferral(e.deferral)
        onGenerated?.()
      } else if (e.status === 404 && e.body?.error === 'no_messages') {
        // No messages at all: nothing was answered and nothing was closed.
        setNoMessages(true)
      } else if (e.status === 404 && e.body?.error === 'no_inbound_turn') {
        // Not a failure — the server closed this conversation because its
        // latest message is already outbound (nothing new to answer).
        // Refresh so the status badge/list catch up, and say so plainly
        // instead of showing the raw request URL as an "error."
        setClosedNotice('This conversation has already been answered — nothing new to generate. It has been closed.')
        onGenerated?.()
      } else {
        setError(e.message)
      }
    }
    finally { setBusy(false) }
  }

  // Once-per-conversation auto-retry guard for the staleness above — a
  // plain ref (not state), so it survives this panel instance's whole
  // session without forcing a render of its own (this component persists
  // across conversation switches, no `key` prop — see conversationIdRef's
  // own comment). Prevents looping if the retry itself comes back
  // stale/errored again; switching away and back never re-fires it.
  const staleAutoRetriedRef = useRef(new Set())
  const [autoRetryingStale, setAutoRetryingStale] = useState(false)

  useEffect(() => {
    if (screenMode || loading || !suggestion) return
    if (!isDecidedSuggestionStaleRelativeToLatestMessage(suggestion)) return
    if (staleAutoRetriedRef.current.has(conversationId)) return
    staleAutoRetriedRef.current.add(conversationId)
    setAutoRetryingStale(true)
    onGenerate().finally(() => setAutoRetryingStale(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId, suggestion?.id, suggestion?.status, suggestion?.createdAt, lastInboundMessage?.receivedAt, loading])

  async function onSpam() {
    setBusy(true); setError(null)
    try {
      const { suggestion: updated, conversationStatus } = await markAsSpam(suggestion.id)
      apply(updated)
      releaseAssignment(conversationId)
      // Unconditional, independent of the admin dialog below: the decision
      // already succeeded server-side, so the sidebar list (status/intent for
      // this row) must reflect it right away — regardless of whether an
      // admin later minimizes, cancels, or saves the follow-up dialog.
      onSpamMarked?.()
      if (isAdmin) {
        setPendingSpamStatus(conversationStatus)
        setSpamDialogOpen(true)
      } else {
        onDecided?.(conversationStatus)
      }
    } catch (e) {
      if (isSupersededError(e)) { await showNewerAfterSupersededRefusal(); return }
      if (e.status === 409 && e.body?.suggestion) {
        apply(e.body.suggestion)
        setError('Already handled — this suggestion was decided by someone else before it could be marked as spam.')
      } else setError(errorText(e, 'Spam'))
    }
    finally { setBusy(false) }
  }

  // Toggle "Reviewed by Mgmt" (spam intent only) — flips the checkbox
  // immediately, then reconciles with the PATCH response; reverts on
  // failure. Unchecking always clears the reviewer name (see
  // setReviewedByMgmt() in ai-suggestions.js — there's no "current reviewer"
  // once it's unchecked).
  async function onReviewedByMgmtChange(checked) {
    const prevReviewed = reviewedByMgmt
    const prevUser = reviewedByMgmtUser
    setReviewedByMgmtState(checked)
    if (!checked) setReviewedByMgmtUserState(null)
    setReviewedByMgmtBusy(true)
    try {
      const { suggestion: updated } = await setReviewedByMgmtApi(suggestion.id, checked)
      setReviewedByMgmtState(updated.reviewedByMgmt)
      setReviewedByMgmtUserState(updated.reviewedByMgmtUser)
    } catch (e) {
      setReviewedByMgmtState(prevReviewed)
      setReviewedByMgmtUserState(prevUser)
      setError(e.message)
    } finally {
      setReviewedByMgmtBusy(false)
    }
  }

  // note: the escalation note for 'escalated', the transfer note for
  // 'transferred' (Transfer to Support, 2026-10-08).
  // confirmRecentReply: the person already answered the double-reply guard's
  // "Send anyway?" (related contacts, 2026-10-20).
  // confirmPromise (2026-10-23): the person answered "Send anyway?" for a
  // reply that promises an action no step on the contact does.
  // replyOverride (2026-10-26): the reply to send in place of the box's text
  // when Process all just filled its label link slot (the box's state is not
  // updated yet inside this call).
  // skippedSteps (2026-10-27): the steps whose Send block the reply lifted,
  // [{ index, reason }], recorded with the decision. Process all passes its
  // own list; otherwise the task choice's, and on the agent draft panel
  // (where the one button is Process all) every lifted step.
  // noReply (2026-10-27): the agent draft panel's steps-only run on an eBay
  // case waiting for the buyer: Approve with no reply text (the server sends
  // nothing and closes the contact).
  // acknowledged (2026-10-30, sendWarnings.js): the codes of the Send
  // warnings the person sent past (Send anyway); null before the dialog.
  // processedNow: the steps a Process all just ran (their state is not on
  // screen yet inside this call). markedNotNeeded: the steps the dialog's
  // "Mark this step not needed" marked.
  async function onDecide(status, note, { confirmRecentReply = false, closeAnsweredGroup = undefined, confirmPromise = false, replyOverride = undefined, skippedSteps = undefined, noReply = false, acknowledged = null, processedNow = [], markedNotNeeded = [] } = {}) {
    // Close - No Reply Needed after an Other Actions step whose customer
    // hasn't been told (2026-10-30): the reminder first.
    if (status === 'dismissed' && !(await remindUntoldCustomer('dismiss'))) return
    let replyToSend = replyOverride ?? draft
    const willSendReply = status === 'approved' && !noReply && !noDraftBoxFn({ fromEbay, intent: suggestion.intent, isEbayClientEmail })
    // The Send warnings (2026-10-30): every one that applies, in one dialog,
    // before anything is recorded or sent. Send anyway comes back here with
    // their codes acknowledged.
    if (willSendReply && acknowledged == null) {
      const warnings = sendWarningsFor(replyToSend, { processedNow, markedNotNeeded })
      if (warnings.length) {
        openSendWarnings(warnings, (codes, marked) => onDecide(status, note, { confirmRecentReply, closeAnsweredGroup, confirmPromise, replyOverride, skippedSteps, noReply, acknowledged: codes, processedNow, markedNotNeeded: [...markedNotNeeded, ...marked] }))
        return
      }
    }
    // Plain Send with the RMA token still in the reply (2026-10-27,
    // rmaReference.js): once the return step ran, its RMA number goes in
    // first (up to 5 s, else the order's number); before that Send is
    // disabled (rmaSendWarning).
    if (status === 'approved' && hasRmaReferenceToken(replyToSend)) {
      const rmaIdx = rmaReferenceStepIndex(suggestion?.proposedActions ?? [])
      const st = rmaIdx >= 0 ? stepStates[rmaIdx] : null
      if (st?.status === 'success') {
        setBusy(true)
        const ref = await rmaReferenceFromResult({ result: st.result, step: suggestion.proposedActions[rmaIdx], fetchRef: () => fetchRmaReference(suggestion.id, rmaIdx, { trqRmaId: st.result?.trqRmaId ?? null }) })
        if (ref.value) {
          replyToSend = replyWithRmaReference(replyToSend, ref.value)
          setDraft(replyToSend)
          replyOverride = replyToSend
        }
      }
    }
    const skippedBase = status === 'approved' ? (skippedSteps ?? (agentLayout ? liftedSteps : liftedSteps.filter((x) => x.index === taskChoiceStepIndex))) : []
    // A step marked not needed (the step's link, or the Send warnings'
    // "Mark this step not needed", 2026-10-30) goes with the decision too, so
    // the server's promise check reads it the same way.
    const skippedToSend = status === 'approved'
      ? [...skippedBase, ...[...new Set([...notNeededSteps, ...markedNotNeeded])].filter((i) => !skippedBase.some((x) => x.index === i)).map((index) => ({ index, reason: SKIP_CSR_MARKED_NOT_NEEDED }))]
      : []
    const escalationNote = status === 'escalated' ? note : undefined
    const transferNote = status === 'transferred' ? note : undefined
    const closeNote = status === 'dismissed' && taskContact?.isTask ? note : undefined
    setBusy(true); setError(null); setExecutionErrors(null); setReplySendError(null); setHouseReplyNote(null)
    setTaskChoiceError((prev) => (prev?.kind === 'refused' ? null : prev))
    try {
      // The server checks the RECORDED choice and date (2026-10-28): when the
      // panel's differ, Send records them first, then decides. A failed
      // recording stops here, on the step.
      if (status === 'approved') {
        const sync = choiceToSyncOnSend(suggestion, taskChoice, taskChoiceDate)
        if (sync) {
          try {
            await recordTaskChoice(suggestion, sync.index, sync.choice, sync.date)
          } catch (err) {
            if (isSupersededError(err)) { await showNewerAfterSupersededRefusal({ compare: true }); return }
            showTaskChoiceError(sync.index, sync.date ? TASK_DATE_SAVE_ERROR : TASK_CHOICE_SAVE_ERROR, 'save')
            return
          }
        }
      }
      // FROM_EBAY/automated_return_notice_default/isEbayClientEmail never
      // send a reply from this box — no humanReply, no edited status. Same
      // three-case check as the draft box's own visibility condition above
      // (hasNoDraftBoxOfItsOwn) — kept as one shared predicate so the two
      // can never drift apart again (see that function's own comment for the
      // real "stuck pending forever, no visible error" bug this fixes: an
      // explicit humanReply: '' here used to override the server's
      // `humanReply ?? (existing.draftReply || null)` fallback, since `??`
      // doesn't treat '' as nullish — only an omitted (undefined) humanReply
      // lets that fallback, and the server's own auto-close check, run).
      const hasDraftBox = !noReply && !noDraftBoxFn({ fromEbay, intent: suggestion.intent, isEbayClientEmail })
      const edited = hasDraftBox && status === 'approved' && replyToSend !== suggestion.draftReply
      // We replied on a related contact in the last hour: one of the Send
      // warnings above since 2026-10-30 (the server checks again).
      const { suggestion: updated, conversationStatus, executionErrors: errs, replySendError: sendErr, replySendWarning: sendWarn, deliveryEstimateNotice: eddNotice } = await decideSuggestion(suggestion.id, {
        confirmRecentReply: confirmRecentReply || undefined,
        confirmPromise: confirmPromise || undefined,
        acknowledgedWarnings: acknowledged?.length ? acknowledged : undefined,
        closeAnsweredGroup: status === 'dismissed' ? closeAnsweredGroup : undefined,
        status: edited ? 'edited' : status,
        humanReply: (hasDraftBox && status === 'approved') ? replyToSend : undefined,
        insertedTemplate: (hasDraftBox && status === 'approved') ? (draftInsertedTemplate ?? undefined) : undefined,
        actionInputs,
        skippedSteps: skippedToSend.length ? skippedToSend : undefined,
        // The Send guard's warnings sent past (2026-10-30): codes and step
        // indexes only, recorded with the decision.
        replyStepWarnings: status === 'approved' && hasDraftBox && replyStepWarns.length ? sendWarningsRecord(replyStepWarns) : undefined,
        noReply: (noReply && status === 'approved') || undefined,
        escalationNote,
        transferNote,
        closeNote,
        // Only ever persisted for an m365_email Approve — same condition
        // humanReply above already uses, plus the channel check since these
        // two fields are m365_email-only (the From/To/Subject TextFields
        // don't render at all for eBay). A CSR who never touched them still
        // sends these through — send-approved-reply.js falls back to its
        // own auto-derivation whenever either is falsy.
        emailTo: (hasDraftBox && status === 'approved' && channel === 'm365_email') ? draftTo : undefined,
        emailSubject: (hasDraftBox && status === 'approved' && channel === 'm365_email') ? draftSubject : undefined,
        emailAttachments: (hasDraftBox && status === 'approved' && channel === 'm365_email')
          ? attachments.map((a) => ({ name: a.name, dataUrl: a.dataUrl }))
          : undefined,
        // Same "m365_email Approve only" scoping as emailTo/emailSubject
        // above — never persisted onto the suggestion row (browser-memory
        // only, same as emailAttachments), so a later /retry-send must
        // resend this explicitly too (see onRetrySend below) rather than
        // silently falling back to 'reply'.
        replyMode: (hasDraftBox && status === 'approved' && channel === 'm365_email') ? replyMode : undefined,
        startNewContact: (hasDraftBox && status === 'approved' && channel === 'm365_email' && replyMode === 'new' && startNewContact) || undefined,
        // Reply-All CC: same Approve-only scoping, browser-memory only.
        ccAddresses: (hasDraftBox && status === 'approved') ? ccToSend() : undefined,
      })
      apply(updated)
      if (errs?.length) setExecutionErrors(errs)
      if (sendErr) setReplySendError(sendErr)
      // A Send warning only the send could see (2026-10-30, an Invoice Request
      // with no invoice): the decision is recorded, so Send anyway goes
      // through Retry Send with it acknowledged.
      // The contact stays open for it (onDecided would close the tab).
      if (sendErr && sendWarn?.code) {
        lastAttemptRef.current = attemptBlocked('send', { code: sendWarn.code, message: String(sendErr) })
        openSendWarnings([sendWarn], (codes) => onRetrySend({ acknowledged: [...new Set([...(acknowledged ?? []), ...codes])], markedNotNeeded }))
        return
      }
      if (status === 'approved') lastAttemptRef.current = sendErr ? attemptBlocked('send', { code: 'reply_send_error', message: String(sendErr) }) : attemptOk('send')
      // The storefront delivery estimate re-estimated at Send (2026-10-21):
      // the contact closes on a send, so the app shell shows the notice.
      onDecided?.(conversationStatus, eddNotice ? { deliveryEstimateNotice: eddNotice } : undefined)
      // Escalate/Close always release — the agent is done with it either way.
      // Approve/Edit only releases when the reply actually went out (or there
      // was nothing to send, e.g. FROM_EBAY's "Approve Actions" with no
      // humanReply) — if replySendError is set the agent still needs to fix
      // and retry, so the conversation must stay assigned to them.
      if (status === 'escalated' || status === 'transferred' || status === 'dismissed' || !sendErr) {
        releaseAssignment(conversationId)
      }
    } catch (e) {
      if (status === 'approved') lastAttemptRef.current = attemptFromError('send', e)
      // A stale tab Sending on a superseded suggestion (2026-10-28): the
      // change comparison, the CSR chooses; Escalate, Close, Transfer: the
      // notice only.
      if (isSupersededError(e)) { await showNewerAfterSupersededRefusal({ compare: status === 'approved' }); return }
      // The choice (or its date) is missing on the server (2026-10-28): said
      // on the step itself, the reply and inputs left as they are.
      if (e.status === 409 && e.body?.error === TASK_PATH_NOT_CHOSEN_ERROR) {
        const idx = Number.isInteger(e.body.index) ? e.body.index : taskChoiceStepIndex
        showTaskChoiceError(idx, e.body.message || taskChoiceBlockMessage(suggestion?.proposedActions?.[idx], idx))
        return
      }
      // The server's Send warnings (2026-10-30: the promise check, the task
      // choice, the double-reply guard) that were not acknowledged: the same
      // dialog, with every warning, the ones already sent past included.
      // Nothing was recorded.
      if (e.status === 409 && e.body?.error === SEND_WARNINGS_ERROR) {
        const shown = acknowledged?.length ? sendWarningsFor(replyToSend, { processedNow, markedNotNeeded }) : []
        const list = mergeSendWarnings(shown, e.body.warnings ?? [])
        openSendWarnings(list, (codes, marked) => onDecide(status, note, { confirmRecentReply, closeAnsweredGroup, confirmPromise, replyOverride, skippedSteps, noReply, acknowledged: [...new Set([...(acknowledged ?? []), ...codes])], processedNow, markedNotNeeded: [...markedNotNeeded, ...marked] }))
        return
      }
      if (e.status === 409 && e.body?.suggestion) {
        // Someone (another CSR, another tab, Flows automation, or a proposed
        // action's own direct send — e.g. resend a return label, reply to an
        // eBay case) decided this suggestion first — the server refused a
        // duplicate. Show their decision; no second reply was sent.
        apply(e.body.suggestion)
        const decidedBy = e.body.suggestion.decidedBy
        setError(
          decidedBy
            ? `Already resolved by ${decidedBy} — this conversation may have been handled via a proposed action (e.g. a message sent directly to the buyer) rather than this Approve/Escalate/Dismiss flow. No duplicate reply was sent.`
            : 'Already handled — this suggestion was decided by someone else (or automation) a moment ago. No duplicate reply was sent.'
        )
      } else setError(errorText(e, decisionActionName(status)))
    }
    finally { setBusy(false) }
  }

  // Retry sending an already-decided suggestion whose outbound send failed
  // (replySendError set) — reuses the existing decided row (server route
  // /retry-send) rather than re-deciding it, so the CSR's edits to `draft`
  // since the failed send are what actually goes out this time. Mirrors
  // onDecide's apply/releaseAssignment shape above.
  // acknowledged (2026-10-30): the Send warnings sent past, as on Send; the
  // same dialog first.
  async function onRetrySend({ confirmPromise = false, acknowledged = null, markedNotNeeded = [] } = {}) {
    if (acknowledged == null) {
      const warnings = sendWarningsFor(draft, { markedNotNeeded, retry: true })
      if (warnings.length) {
        openSendWarnings(warnings, (codes, marked) => onRetrySend({ confirmPromise, acknowledged: codes, markedNotNeeded: [...markedNotNeeded, ...marked] }))
        return
      }
    }
    const notNeededNow = [...new Set([...notNeededSteps, ...markedNotNeeded])]
    setBusy(true); setError(null); setReplySendError(null)
    try {
      const { suggestion: updated, conversationStatus: convStatus, replySendError: sendErr, replySendWarning: sendWarn, deliveryEstimateNotice: eddNotice } = await retrySuggestionSend(suggestion.id, {
        humanReply: draft,
        emailTo: channel === 'm365_email' ? draftTo : undefined,
        emailSubject: channel === 'm365_email' ? draftSubject : undefined,
        // Nothing server-persisted (per this pass's scope) — a retry after a
        // failed send only carries these forward if this component instance
        // is still alive, which is the realistic case immediately after a
        // failed-send banner appears.
        emailAttachments: channel === 'm365_email' ? attachments.map((a) => ({ name: a.name, dataUrl: a.dataUrl })) : undefined,
        replyMode: channel === 'm365_email' ? replyMode : undefined,
        startNewContact: (channel === 'm365_email' && replyMode === 'new' && startNewContact) || undefined,
        ccAddresses: ccToSend(),
        confirmPromise: confirmPromise || undefined,
        acknowledgedWarnings: acknowledged?.length ? acknowledged : undefined,
        skippedSteps: notNeededNow.length ? notNeededNow.map((index) => ({ index, reason: SKIP_CSR_MARKED_NOT_NEEDED })) : undefined,
      })
      apply(updated)
      if (sendErr) setReplySendError(sendErr)
      // A Send warning only the send could see (2026-10-30): Send anyway
      // resends with it acknowledged.
      if (sendErr && sendWarn?.code) openSendWarnings([sendWarn], (codes) => onRetrySend({ confirmPromise, acknowledged: [...new Set([...(acknowledged ?? []), ...codes])], markedNotNeeded }))
      lastAttemptRef.current = sendErr ? attemptBlocked('retry_send', { code: 'reply_send_error', message: String(sendErr) }) : attemptOk('retry_send')
      onDecided?.(convStatus, eddNotice ? { deliveryEstimateNotice: eddNotice } : undefined)
      // Same convention as onDecide: release only once the reply has actually
      // gone out — a second failed attempt must keep the conversation
      // assigned to this CSR so they can try again.
      if (!sendErr) releaseAssignment(conversationId)
    } catch (e) {
      lastAttemptRef.current = attemptFromError('retry_send', e)
      if (isSupersededError(e)) { await showNewerAfterSupersededRefusal(); return }
      // The server's Send warnings (2026-10-30), as on Send.
      if (e.status === 409 && e.body?.error === SEND_WARNINGS_ERROR) {
        const list = mergeSendWarnings(acknowledged?.length ? sendWarningsFor(draft, { markedNotNeeded, retry: true }) : [], e.body.warnings ?? [])
        openSendWarnings(list, (codes, marked) => onRetrySend({ confirmPromise, acknowledged: [...new Set([...(acknowledged ?? []), ...codes])], markedNotNeeded: [...markedNotNeeded, ...marked] }))
        return
      }
      if (e.status === 409 && e.body?.suggestion) {
        // No longer retryable — decided/closed/resent by someone else (or
        // this same CSR in another tab) in the meantime.
        apply(e.body.suggestion)
        setError('No longer retryable — this suggestion or conversation was already resolved elsewhere.')
      } else setError(errorText(e, 'Send'))
    }
    finally { setBusy(false) }
  }

  // A step's checkbox (2026-10-26, the agent draft panel): unchecking a step
  // also unchecks the steps that need it, checking one also checks the step
  // it needs (processAll.js's toggleStepCheck()). The set is shown at once
  // and recorded on the suggestion; a failed save puts the old set back.
  async function onToggleStep(index, value) {
    if (!suggestion?.id) return
    markTouched()
    hideParkStrip()
    const before = uncheckedSteps
    const { unchecked } = toggleStepCheck({ actions: suggestion.proposedActions ?? [], unchecked: before, index, checked: value })
    setUncheckedSteps(unchecked)
    try {
      await saveStepChecks(suggestion.id, unchecked)
    } catch (e) {
      setUncheckedSteps(before)
      setError(`The step checkbox could not be saved: ${e.body?.error ?? e.message}`)
    }
  }

  // "Process all steps and send reply" (2026-10-23, processAll.js): the
  // confirmed steps run first, in one server pass that stops at the first
  // failure (POST .../process-steps). A failed step leaves the reply unsent
  // and names the step; a run that added new steps (a return's label email)
  // stops too, so the person processes them before sending. Otherwise the
  // reply goes out through the normal Send (onDecide), which checks again
  // that every promised step was processed.
  async function onProcessAllAndSend(indexes) {
    // The regenerated compare asks first (2026-10-28).
    if (regeneratedBlock) return
    const startedForId = conversationId
    hideParkStrip()
    // The steps the reply lifted, as the button was clicked (2026-10-27).
    const skippedAtClick = liftedSteps
    const actions = suggestion.proposedActions ?? []
    // The step that carries the reply as its eBay comment (2026-10-27): it
    // gets the reply as its message, and the reply is not sent again.
    const carrierAtClick = indexes.includes(replyCarrierIndex) ? replyCarrierIndex : -1
    const noReplyAtClick = agentNoReply
    const inputs = processAllInputs({ actions, actionInputs, stepStates, indexes, replyCarrierIndex: carrierAtClick, reply: draft })
    setBusy(true); setError(null); setExecutionErrors(null); setReplySendError(null); setHouseReplyNote(null)
    setStepStates((prev) => {
      const next = { ...prev }
      for (const i of indexes) next[i] = { status: 'processing', result: null, error: null }
      return next
    })
    let res
    try {
      res = await processSteps(suggestion.id, indexes, inputs, { replyCarrierIndex: carrierAtClick >= 0 ? carrierAtClick : null })
    } catch (e) {
      lastAttemptRef.current = attemptFromError('process_all', e)
      setStepStates((prev) => stepStatesAfterProcessAll(prev, indexes, []))
      setBusy(false)
      if (isSupersededError(e)) { await showNewerAfterSupersededRefusal(); return }
      if (e.status === 409 && e.body?.error === 'automation_pending') {
        setAutomationTakeoverConfirm({ pendingAction: () => onProcessAllAndSend(indexes) })
        return
      }
      setError(e.status === 409 ? refusalMessage(e, 'Process') : (e.body?.detail ?? e.body?.error ?? e.message))
      return
    }
    if (conversationIdRef.current !== startedForId) return
    setStepStates((prev) => stepStatesAfterProcessAll(prev, indexes, res?.results ?? []))
    if (res?.failed) {
      setBusy(false)
      setError(processAllFailureMessage(res.failed))
      lastAttemptRef.current = attemptBlocked('process_all', { code: 'step_failed', message: processAllFailureMessage(res.failed) })
      return
    }
    // The reply went out as a step's eBay comment (2026-10-27): that was the
    // Send; the contact is closed and nothing more is sent.
    if (res?.replySentBy != null) {
      try {
        const fresh = (await fetchSuggestions(conversationId))[0] ?? null
        if (fresh && fresh.id === suggestion.id && conversationIdRef.current === startedForId) apply(fresh, { skipDraft: true })
      } catch { /* the decision is already recorded on the server */ }
      setBusy(false)
      lastAttemptRef.current = attemptOk('send')
      onDecided?.(res.conversationStatus ?? 'closed')
      releaseAssignment(conversationId)
      return
    }
    // A step may append a new one (process_return_refund's label email,
    // action-executor.js's appendProposedActions()): show it and stop.
    try {
      const fresh = (await fetchSuggestions(conversationId))[0] ?? null
      if (fresh && fresh.id === suggestion.id && (fresh.proposedActions?.length ?? 0) > actions.length && conversationIdRef.current === startedForId) {
        apply(fresh, { skipDraft: true })
        setBusy(false)
        setError('The steps ran and added a new step. Process it, then Send. The reply was not sent.')
        return
      }
    } catch { /* the Send below checks the steps again */ }
    // The label link slot (2026-10-26, @cxhub/shared's label-link-slot.js):
    // a "recover and send" step that ran in this pass fills the reply's
    // INSERTLABELLINK with the link it recovered, before the send. A slot
    // still unfilled is refused by Send's placeholder check.
    let filled = replyAfterProcessAll(draft, actions, res?.results ?? [], { indexes, stepStates })
    // A return label held for the RMA number (2026-10-29): the reply says
    // the label will follow; it is never switched to the label template.
    filled = heldLabelReply(filled, (res?.results ?? []).filter((x) => actions[x?.index]?.type === 'process_return_refund'), isEbayChannel ? 'ebay' : 'email', heldLabelSignatureOpts())
    // The RMA number (2026-10-27, rmaReference.js): the return step's RMA as
    // its Reference ID, waiting up to 5 s for it, else the order's number
    // with the note recorded.
    if (hasRmaReferenceToken(filled)) {
      const rmaIdx = rmaReferenceStepIndex(actions)
      const ran = (res?.results ?? []).find((x) => x?.index === rmaIdx && x?.success)
      const result = ran?.result ?? stepStates[rmaIdx]?.result ?? null
      if (result) {
        const ref = await rmaReferenceFromResult({ result, step: actions[rmaIdx], fetchRef: () => fetchRmaReference(suggestion.id, rmaIdx, { trqRmaId: result?.trqRmaId ?? null }) })
        filled = replyWithRmaReference(filled, ref.value)
      }
      if (conversationIdRef.current !== startedForId) return
    }
    // No reply (2026-10-27, the eBay case waits for the buyer): the steps
    // ran; the decision records no reply and closes the contact.
    if (noReplyAtClick) {
      setBusy(false)
      await onDecide('approved', undefined, { noReply: true, skippedSteps: skippedAtClick })
      return
    }
    // The reply after Process (2026-10-29, houseTemplateReply.js): one
    // switch, after the last step, from the last step in this pass that
    // returned its house template. The switched reply is not sent from
    // here: the box is what is sent, so the person sees it first and
    // presses Send. "Keep my reply" sends the reply as it was.
    const house = houseReplyFromRun(actions, res?.results ?? [], indexes)
    // Return Status's overdue refund in this pass (2026-10-29): the reply
    // stays its Refund Confirmation, tagged with it.
    {
      const r = (res?.results ?? []).find((x) => x?.success && overdueReplyTag(actions[Number(x.index)], x.result))
      if (r && !isDraftDirty()) setDraftInsertedTemplate(overdueReplyTag(actions[Number(r.index)], r.result))
    }
    if (house) {
      // Its own line (houseReplySwitchedNote()) says what happened; no second one.
      const switched = await switchToHouseReply(house, { action: actions[house.index], startedForId, quiet: true })
      if (conversationIdRef.current !== startedForId) return
      if (switched) {
        setBusy(false)
        setHouseReplyNote(houseReplySwitchedNote(house.template))
        return
      }
    }
    if (filled !== draft) setDraft(filled)
    // Never sends a placeholder (2026-10-29): a Website scrap refund's
    // amount, dates or RTN number the steps did not fill (the person kept
    // their reply, or a step ran another way) stops here; the reply stays
    // in the box and Send refuses it as before.
    const leftTokens = findReplyPlaceholders(withoutRmaReferenceToken(filled))
    if (leftTokens.length) {
      setBusy(false)
      setError(`The steps ran. Fill in ${leftTokens.join(', ')} in the reply, then Send. The reply was not sent.`)
      return
    }
    setBusy(false)
    await onDecide('approved', undefined, { ...(filled !== draft ? { replyOverride: filled } : {}), skippedSteps: skippedAtClick, processedNow: (res?.results ?? []).filter((x) => x?.success).map((x) => Number(x.index)) })
  }

  // Ad-hoc reply on an already-closed FROM_MEMBERS conversation — a fresh
  // suggestion is created and decided server-side (routes/ai.js's
  // /manual-reply route), reusing the same send pipeline the normal Approve
  // flow uses, so the safety mechanisms there (fail-closed company routing,
  // the redaction-token guard) apply here too.
  async function onSendManualReply({ confirmRecentReply = false } = {}) {
    if (!confirmRecentReply) {
      const recent = recentRelatedReply(relatedContacts)
      if (recent) { setRecentReplyConfirm({ message: recentReplyMessage(recent), proceed: () => onSendManualReply({ confirmRecentReply: true }) }); return }
    }
    setClosedReplyBusy(true)
    setClosedReplyError(null)
    try {
      const { conversationStatus, replySendError: sendErr } = await sendManualReply(conversationId, closedReplyDraft, { insertedTemplate: closedReplyInsertedTemplate ?? undefined, confirmRecentReply: confirmRecentReply || undefined })
      if (sendErr) {
        setClosedReplyError(sendErr)
      } else {
        setClosedReplyDraft(blankBoxSeed())
        onDecided?.(conversationStatus)
      }
    } catch (e) {
      if (e.status === 409 && e.body?.error === 'recent_group_reply') {
        setRecentReplyConfirm({ message: e.body.message, proceed: () => onSendManualReply({ confirmRecentReply: true }) })
        return
      }
      setClosedReplyError(e.message)
    } finally {
      setClosedReplyBusy(false)
    }
  }

  // m365_email's own version of onSendManualReply() above — same create-
  // suggestion-then-send flow (routes/ai.js's /manual-reply route), but
  // reusing the main pending-suggestion editor's own draft/draftTo/
  // draftSubject state (composingClosedReply) instead of the eBay-only
  // closedReplyDraft box, now threading to/subject through the send too.
  // Reuses the shared busy/error state the normal decision flow uses (this
  // button sits in that same button row), not the closedReply-specific
  // busy/error pair, which stays scoped to the eBay box.
  async function onSendClosedM365Reply({ confirmRecentReply = false } = {}) {
    if (!confirmRecentReply) {
      const recent = recentRelatedReply(relatedContacts)
      if (recent) { setRecentReplyConfirm({ message: recentReplyMessage(recent), proceed: () => onSendClosedM365Reply({ confirmRecentReply: true }) }); return }
    }
    setBusy(true); setError(null)
    try {
      const { conversationStatus, replySendError: sendErr } = await sendManualReply(conversationId, draft, { to: draftTo, subject: draftSubject, replyMode, startNewContact: (replyMode === 'new' && startNewContact) || undefined, insertedTemplate: draftInsertedTemplate ?? undefined, ccAddresses: ccToSend(), confirmRecentReply: confirmRecentReply || undefined })
      if (sendErr) {
        setReplySendError(sendErr)
      } else {
        setDraft(blankBoxSeed())
        onDecided?.(conversationStatus)
      }
    } catch (e) {
      if (e.status === 409 && e.body?.error === 'recent_group_reply') {
        setRecentReplyConfirm({ message: e.body.message, proceed: () => onSendClosedM365Reply({ confirmRecentReply: true }) })
        return
      }
      setError(e.message)
    } finally {
      setBusy(false)
    }
  }

  // The reply after Process (2026-10-29, houseTemplateReply.js): the
  // processed step's house template, filled, into the reply box, with its
  // template tag. The reply as the draft left it switches silently; an
  // edited one asks first. Returns true when the box switched.
  // The signature the "label will follow" sentence goes above (2026-10-29):
  // the same forms the Templates button recognizes.
  function heldLabelSignatureOpts() {
    return { account: templateAccount, signatures: [signatureSeed(), resolvedSignatureTemplate, signatureTemplate && draftBoxText(signatureTemplate), signatureTemplate] }
  }

  // The part the CSR found (2026-10-30, correctPart.js): the reply switches
  // to "Prefit No Do Carry" for it; an edited reply asks first ("Replace
  // your reply?"). What's next's "Double-check" line and its confidence
  // reason clear; the server's own lines (a link to fill in, an unconfirmed
  // fitment) are added. The server recorded it on the Activity Log.
  async function applyCorrectPart(result) {
    const startedForId = conversationId
    const edited = replyEditedSinceSet()
    if (edited && !(await askConfirm(replaceReplyPrompt(result.template ?? 'Prefit No Do Carry')))) return
    if (conversationIdRef.current !== startedForId) return
    setReplyBox(correctPartBoxText(result.reply), { note: edited ? null : replyReplacedNote({ title: result.template ?? 'Prefit No Do Carry' }) })
    if (result.english) setLiveEnglish({ english: result.english, language: result.languageName ?? null })
    setCorrectPart({ suggestionId: suggestion?.id ?? null, sku: result.sku, steps: result.steps ?? [] })
  }

  async function switchToHouseReply(house, { action = null, startedForId = conversationId, quiet = false } = {}) {
    const decision = houseReplyAction({ house, action, reply: liveDraftRef.current, dirty: replyEditedSinceSet() })
    if (decision === 'keep') return false
    if (decision === 'ask' && (!(await askConfirm(houseTemplateReplyPrompt(house.template?.title ?? null))) || conversationIdRef.current !== startedForId)) return false
    if (conversationIdRef.current !== startedForId) return false
    setReplyBox(draftBoxText(house.text), { note: decision === 'switch' && !quiet ? replyReplacedNote({ title: house.template?.title ?? null }) : null })
    setDraftInsertedTemplate(house.template ?? null)
    return true
  }

  // Other Actions' "Paste this into the draft reply" (2026-10-30,
  // ManualStepReply.jsx): the step's filled reply into the reply box, with
  // its template tag, as the reply after a main-panel step. Since 2026-11-02
  // it asks first only when the person edited the reply
  // (replyEditedSinceSet()); an empty or signature-only box, the untouched
  // AI or agent draft, or an earlier paste, pastes without asking. Never
  // sends. Returns true once pasted.
  async function pasteManualReply(index, text, template = null) {
    const startedForId = conversationId
    const edited = replyEditedSinceSet()
    if (edited && (!(await askConfirm(PASTE_MANUAL_REPLY_PROMPT)) || conversationIdRef.current !== startedForId)) return false
    if (conversationIdRef.current !== startedForId) return false
    setReplyBox(draftBoxText(text), { note: edited ? null : replyReplacedNote({ title: template?.title ?? null }) })
    setDraftInsertedTemplate(template ?? null)
    setManualPasted((prev) => ({ ...prev, [index]: new Date().toISOString() }))
    return true
  }

  // The steps from Other Actions whose customer hasn't been told yet
  // (2026-10-30, manualStepReply.js's untoldManualSteps()).
  const untoldSteps = untoldManualSteps({
    actions: suggestion?.proposedActions ?? [],
    stepStates,
    checks: Object.fromEntries(Object.entries(checkStates ?? {}).map(([k, v]) => [k, v?.result ?? null]).filter(([, v]) => v)),
    pasted: manualPasted,
    boxTemplateTitle: draftInsertedTemplate?.title ?? null,
    messages: conversationMessages ?? [],
  })

  // The reminder before Close / Dismiss / leaving the contact (2026-10-30):
  // not blocking. "Close anyway" goes ahead and is recorded in the Activity
  // Log (ids and a reason code only); "Paste the reply" pastes it (asking
  // first over a reply in the box) and stays; "Send it" (the reply pasted,
  // not sent) puts the focus on the reply box, near Send, and stays, sending
  // nothing; "Stay on this contact" and Escape stay. via: 'dismiss',
  // 'close', 'close_tab' or 'switch_contact'. Resolves true to go ahead.
  async function remindUntoldCustomer(via) {
    const steps = untoldSteps
    if (!steps.length || !suggestion?.id) return true
    const startedForId = conversationId
    const suggestionId = suggestion.id
    const prompt = untoldReminderPrompt(steps)
    const answer = await askConfirm(prompt)
    if (conversationIdRef.current !== startedForId) return false
    if (answer === true) {
      await recordUntoldCustomerClose(suggestionId, { steps: steps.map((s) => s.index), via }).catch(() => {})
      return true
    }
    if (answer === 'alt' && prompt.mode === 'pasted') {
      const box = document.querySelector('[data-reply-box="true"]')
      box?.scrollIntoView?.({ block: 'center' })
      if (draftEditorRef.current?.focus) draftEditorRef.current.focus()
      else box?.focus?.()
      return false
    }
    if (answer === 'alt') {
      const first = steps.find((s) => !s.pasted) ?? steps[0]
      const only = first.options.length === 1 && !first.options[0].needsLink ? first.options[0] : null
      if (only) {
        const st = stepStates[first.index]
        const text = manualReplyText(only.text, { erpRmaId: st?.result?.erpRmaId ?? null, amounts: manualReplyAmounts(actionInputs[first.index] ?? {}) })
        await pasteManualReply(first.index, text, only.template)
      } else {
        // A choice (Carry Yes / No) or a link to give: the step's reply, to
        // pick from.
        document.querySelector(`[data-testid="manual-step-reply"][data-step-index="${first.index}"]`)?.scrollIntoView?.({ block: 'center' })
      }
    }
    return false
  }
  const remindUntoldRef = useRef(remindUntoldCustomer)
  remindUntoldRef.current = remindUntoldCustomer
  // App.jsx asks before closing the tab or switching contacts.
  const hasUntold = untoldSteps.length > 0
  useEffect(() => {
    onUntoldCustomerChange?.(hasUntold ? (via) => remindUntoldRef.current(via) : null)
  }, [hasUntold]) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => () => { onUntoldCustomerChange?.(null) }, []) // eslint-disable-line react-hooks/exhaustive-deps

  async function handleProcessStep(index) {
    // The regenerated compare asks first (2026-10-28).
    if (regeneratedBlock) return
    const startedForId = conversationId
    hideParkStrip()
    setHouseReplyNote(null)
    setStepStates((prev) => ({ ...prev, [index]: { status: 'processing', result: null, error: null } }))
    try {
      // Flow B-create's eBay message step (resend_return_label_send_message)
      // has no trackingNumber/labelUrl of its own — the label doesn't exist
      // until the sibling create-label step succeeds. Pull those forward
      // from that sibling's own result rather than requiring a redundant
      // recovery call — see suggestionActionInputs.js's
      // resendLabelCreateSiblingIndex(). The Process button for this step
      // stays disabled until that sibling has actually succeeded (see the
      // render logic below), so createResult is always present by the time
      // this runs.
      const action = suggestion.proposedActions[index]
      const createSiblingIndex = resendLabelCreateSiblingIndex(action, suggestion.proposedActions)
      let stepInputs = actionInputs
      if (createSiblingIndex !== null) {
        const createResult = stepStates[createSiblingIndex]?.result
        stepInputs = { ...actionInputs, [index]: { ...(actionInputs[index] ?? {}), trackingNumber: createResult?.trackingNumber, labelUrl: createResult?.labelUrl } }
      }
      // Every box's link, whether the labels went onto the eBay return, and
      // the labels created (2026-10-27) for the label message and note steps.
      if (action?.type === 'resend_return_label_send_message' || action?.type === 'automated_return_notice_send_message' || action?.type === 'resend_return_label_add_note') {
        const handoff = labelStepHandoff(suggestion.proposedActions, stepStates)
        const pick = action.type === 'resend_return_label_add_note'
          ? (handoff.labels ? { labels: handoff.labels } : {})
          : { ...(handoff.labelUrls ? { labelUrls: handoff.labelUrls } : {}), ...(typeof handoff.attachedToEbayReturn === 'boolean' ? { attachedToEbayReturn: handoff.attachedToEbayReturn, attachFallbackReason: handoff.attachFallbackReason ?? null } : {}) }
        if (Object.keys(pick).length) stepInputs = { ...stepInputs, [index]: { ...(stepInputs[index] ?? {}), ...pick } }
      }
      // create_return_label_for_replacement has no replacementId/items of its
      // own — the replacement doesn't exist until the sibling
      // process_replacement step succeeds. Same threading pattern as the
      // resend-label sibling above — see suggestionActionInputs.js's
      // replacementLabelSiblingIndex(). The Process button for this step
      // stays disabled until that sibling has actually succeeded (see the
      // render logic above), so replacementResult is always present by the
      // time this runs.
      const replacementSiblingIndex = replacementLabelSiblingIndex(action, suggestion.proposedActions)
      if (replacementSiblingIndex !== null) {
        const replacementResult = stepStates[replacementSiblingIndex]?.result
        stepInputs = { ...actionInputs, [index]: { ...(actionInputs[index] ?? {}), replacementId: replacementResult?.id, items: actionInputs[replacementSiblingIndex]?.items } }
      }
      // automated_return_notice_send_message has no labelUrl of its own when
      // the sibling label step just CREATED a brand new label (no known
      // trackingNumber at proposal time) — same threading pattern as the
      // resend-label sibling above. See suggestionActionInputs.js's
      // automatedReturnNoticeLabelSiblingIndex(). The Process button for this
      // step stays disabled until that sibling has actually succeeded (see
      // the render logic below), so labelResult is always present by the
      // time this runs.
      const labelSiblingIndex = automatedReturnNoticeLabelSiblingIndex(action, suggestion.proposedActions)
      if (labelSiblingIndex !== null) {
        const labelResult = stepStates[labelSiblingIndex]?.result
        stepInputs = { ...actionInputs, [index]: { ...(actionInputs[index] ?? {}), labelUrl: labelResult?.labelUrl } }
      }
      // address_confirmation_update_address's executor reads rawInput.address
      // (flat, matching its own flat params shape) — every other address-
      // carrying action type reads rawInput.editedAddress directly (see
      // action-executor.js's sales_hold_*_update_address/apply/too_long
      // cases). actionInputs itself stays keyed editedAddress everywhere so
      // the UI/reseed convention is uniform; only the wire submission for
      // this one type differs.
      if (action?.type === 'address_confirmation_update_address' && stepInputs[index]?.editedAddress) {
        const { editedAddress, ...rest } = stepInputs[index]
        stepInputs = { ...stepInputs, [index]: { ...rest, address: editedAddress } }
      }
      // A notice's label step after its RMA step held the label (2026-10-29):
      // no RMA or label of its own.
      if (action?.type === 'automated_return_notice_resend_label') {
        const rmaIdx = suggestion.proposedActions.findIndex((x) => x?.type === 'automated_return_notice_create_rma')
        const held = rmaIdx >= 0 ? stepStates[rmaIdx]?.result : null
        if (held?.labelPending) stepInputs = { ...stepInputs, [index]: { ...(stepInputs[index] ?? {}), labelPending: true, trqRmaId: held.trqRmaId ?? null, pendingReturnLabelId: held.pendingReturnLabelId ?? null } }
      }
      // The label step held its label: the note and message steps say so.
      if (action?.type === 'resend_return_label_send_message' || action?.type === 'resend_return_label_add_note') {
        const labelIdx = suggestion.proposedActions.findIndex((x) => x?.type === 'resend_return_label' && x?.params?.flow === 'B-create')
        if (labelIdx >= 0 && stepStates[labelIdx]?.result?.labelPending) stepInputs = { ...stepInputs, [index]: { ...(stepInputs[index] ?? {}), labelPending: true } }
      }
      const res = await executeStepAction(suggestion.id, index, stepInputs)
      if (res.success) {
        setStepStates((prev) => ({ ...prev, [index]: { status: 'success', result: res.result ?? null, error: null, processedAt: res.processedAt ?? new Date().toISOString() } }))
        if (res.result?.labelPending || res.result?.zeroDollarPending || res.result?.checkedNow) setReturnLabelsKey((k) => k + 1)
        // The label waits on the RMA number: the eBay message step's link
        // slot says the label will follow.
        if (action?.type === 'resend_return_label' && res.result?.labelPending) {
          const messageSiblingIndex = suggestion.proposedActions.findIndex((x) => x?.type === 'resend_return_label_send_message')
          if (messageSiblingIndex >= 0) {
            setActionInputs((prev) => ({ ...prev, [messageSiblingIndex]: { ...(prev[messageSiblingIndex] ?? {}), editedMessage: withLabelToFollow(prev[messageSiblingIndex]?.editedMessage ?? suggestion.proposedActions[messageSiblingIndex]?.params?.body ?? '', 'ebay') } }))
          }
        }
        // send_return_label_email's own per-package result (feature/return-
        // label-multi-package) — a mix of succeeded/failed packages still
        // reports success: true overall (see action-executor.js's own
        // comment). Persist which packages already went out so a CSR who
        // retries this SAME step (after fixing whatever failed package 2)
        // never re-sends (and re-emails the customer) a package that
        // already succeeded — the executor skips anything listed here.
        if (Array.isArray(res.result?.packages) && res.result.packages.some((p) => 'success' in p)) {
          const succeededPackages = res.result.packages.filter((p) => p.success).map((p) => p.package)
          if (succeededPackages.length) {
            setActionInputs((prev) => ({ ...prev, [index]: { ...(prev[index] ?? {}), alreadySent: succeededPackages } }))
          }
        }
        // process_return_refund's own Website RMA path (route:
        // 'website_rma_path', feature/website-rma-label-email-step1) — the
        // "already created" half of this same retry-safety contract, which
        // the generic alreadySent block above doesn't cover (it only tracks
        // "already recorded"). createRma has no TRQ-side idempotency key of
        // its own (action-executor.js's own comment on why), so once it
        // succeeds a retry must reuse the SAME trqRmaId/erpRmaId rather than
        // opening a second RMA; same for any package whose label already
        // succeeded — a retry must never create a label twice.
        if (res.result?.route === 'website_rma_path' && res.result?.trqRmaId && res.result?.erpRmaId) {
          const succeededLabels = Array.isArray(res.result.labels) ? res.result.labels.filter((l) => !l.error) : []
          setActionInputs((prev) => ({
            ...prev,
            [index]: {
              ...(prev[index] ?? {}),
              existingRma: { trqRmaId: res.result.trqRmaId, erpRmaId: res.result.erpRmaId },
              ...(succeededLabels.length ? { existingLabels: succeededLabels } : {}),
            },
          }))
        }
        // resend_return_label's own Website B-create (feature/website-resend-
        // label-decision) — same "already created" retry-safety half as
        // above, minus existingRma (the RMA always already exists for this
        // flow — nothing to create there).
        if (action?.type === 'resend_return_label' && res.result?.flow === 'B-create') {
          const succeededLabels = Array.isArray(res.result.labels) ? res.result.labels.filter((l) => !l.error) : []
          if (succeededLabels.length) {
            setActionInputs((prev) => ({ ...prev, [index]: { ...(prev[index] ?? {}), existingLabels: succeededLabels } }))
          }
        }
        // Everything below reacts on the currently-displayed draft/suggestion
        // — drop it silently if the CSR has since navigated to a different
        // conversation. The step itself already ran and persisted
        // server-side regardless.
        if (conversationIdRef.current !== startedForId) return
        if (res.result?.conversationClosed) {
          // automated_return_notice_send_message (and inr_send_message)
          // close the conversation themselves once their send succeeds —
          // same "reflect closed + release assignment" behavior the panel's
          // main Send button gets from onDecide() once ITS send succeeds.
          // Nothing left to regenerate a draft/suggestion for.
          onDecided?.('closed')
          releaseAssignment(conversationId)
          return
        }
        if (action?.type === 'resend_return_label' && (action?.params?.recoverAndSend === true || (action?.params?.flow === 'B-create' && res.result?.flow === 'B-create')) && res.result?.labelUrl) {
          // "Recover and send" (2026-10-26): the reply's label link slot
          // (INSERTLABELLINK) gets the link this step recovered, keeping the
          // CSR's edits around it. The draft is not regenerated
          // (shouldSkipDraftRefresh()). A label created for an RMA with none
          // (2026-10-27) fills it the same way; its resolved reply, when
          // the executor has one, replaces the draft below as before.
          const urls = labelLinkSlotUrls(res.result)
          setDraft((prev) => fillLabelLinkSlot(prev, urls, { boxes: res.result?.boxes === true }))
        }
        if (res.result?.attachedToEbayReturn === false) {
          // The label did not go onto the buyer's eBay return (2026-10-27):
          // the eBay print line comes out of the reply and the message boxes.
          setDraft((prev) => withoutEbayPrintLine(prev))
          setActionInputs((prev) => Object.fromEntries(Object.entries(prev).map(([k, v]) => [k, typeof v?.editedMessage === 'string' ? { ...v, editedMessage: withoutEbayPrintLine(v.editedMessage) } : v])))
        }
        if (action?.type === 'resend_return_label' && (res.result?.flow === 'B-create' || action?.params?.recoverAndSend === true) && res.result?.labelUrl) {
          // eBay B-create: the sibling message step's box was pre-filled at
          // proposal time with INSERTLABELLINK where the link goes (the label
          // didn't exist yet). Fill in the real link now, keeping any edits
          // the CSR already made around it.
          const messageSiblingIndex = suggestion.proposedActions.findIndex((a) => resendLabelCreateSiblingIndex(a, suggestion.proposedActions) === index)
          if (messageSiblingIndex >= 0) {
            setActionInputs((prev) => {
              const current = prev[messageSiblingIndex]?.editedMessage ?? ''
              const boxUrls = (res.result.boxLabels ?? []).map((l) => l?.labelUrl).filter(Boolean)
              return { ...prev, [messageSiblingIndex]: { ...(prev[messageSiblingIndex] ?? {}), editedMessage: current.split('INSERTLABELLINK').join(boxUrls.length > 1 ? labelLinkBlocks(boxUrls) : res.result.labelUrl) } }
            })
          }
        }
        if (action?.type === 'automated_return_notice_resend_label' && res.result?.resendMessageBody) {
          // The sibling automated_return_notice_send_message step's editable
          // box was seeded (at proposal time, before this label existed)
          // with the "no link yet" version of the template — refresh it now
          // with the accurate, fully-resolved text (real URL substituted) so
          // the CSR reviews/sends the right thing rather than a stale
          // stripped-link draft. Same "just processed my sibling, pull its
          // result forward" shape as resendLabelCreateSiblingIndex's own
          // threading, just pushing forward into a LATER step instead of
          // pulling from an earlier one.
          const messageSiblingIndex = suggestion.proposedActions.findIndex((a) => a.type === 'automated_return_notice_send_message')
          if (messageSiblingIndex >= 0) {
            setActionInputs((prev) => ({ ...prev, [messageSiblingIndex]: { ...(prev[messageSiblingIndex] ?? {}), editedMessage: ebayStepBoxText(res.result.resendMessageBody) } }))
          }
        }
        if (action?.type === 'process_return_refund' && (res.result?.route === 'rma_path' || res.result?.route === 'scrap_refund_path') && res.result?.replyText) {
          // isEbayClientEmail (an m365_email automated-return-notice resolved
          // to a genuine eBay order): the top-level Drafted reply box is
          // hidden for this case (see its own render gate), so the generic
          // setDraft() below is invisible — the sibling send_ebay_member_message
          // step (actions.js's maybeAddEbayMessageStep()) is the only surface
          // that actually reaches the buyer. Its editable box starts out with
          // just a signature placeholder (this conversation has no real
          // draftReplyText at all now — pipeline.js sets needsDraft: false for
          // an automated-return-notice-originated return_refund) — refresh it
          // now with the accurate, fully-resolved template text, whichever
          // outcome Process just resolved: RMA path -> "Label Where is it"
          // (real label link substituted), scrap path -> "Refund Confirmation
          // (eBay)". Same "just processed my sibling, pull its result forward"
          // shape as automated_return_notice_resend_label's own push just
          // above. A no-op for a genuine eBay-channel (non-m365) conversation,
          // which has no such sibling step at all — the generic setDraft()
          // branch below is what reaches the buyer there instead.
          const messageSiblingIndex = suggestion.proposedActions.findIndex((a) => a.type === 'send_ebay_member_message')
          if (messageSiblingIndex >= 0) {
            setActionInputs((prev) => ({ ...prev, [messageSiblingIndex]: { ...(prev[messageSiblingIndex] ?? {}), editedMessage: ebayStepBoxText(res.result.replyText) } }))
          }
        }
        if (action?.type === 'process_return_refund' && res.result?.rmaNoteLine) {
          // eBay had approved the return itself (2026-10-29): the order note
          // names the RMA, which the skipped approve would have carried.
          const noteIdx = rmaNoteSiblingIndex(suggestion.proposedActions, index)
          if (noteIdx >= 0) {
            setActionInputs((prev) => ({ ...prev, [noteIdx]: { ...(prev[noteIdx] ?? {}), editedNote: withRmaNoteLine(prev[noteIdx]?.editedNote ?? suggestion.proposedActions[noteIdx]?.params?.notes ?? '', res.result.rmaNoteLine) } }))
          }
        }
        if (action?.type === 'issue_ebay_return_refund' && res.result) {
          // The sibling issue_ebay_return_refund_add_note step's note box
          // starts empty (see suggestionActionInputs.js's
          // getEditableNoteDefault()) — this refund's outcome (full/partial,
          // amount, comment) isn't known until this step actually succeeds.
          // Same wording RefundModal.jsx's own manual-button flow already
          // seeds its note with, so a CSR sees identical phrasing regardless
          // of which entry point produced this refund.
          const noteSiblingIndex = suggestion.proposedActions.findIndex((a) => a.type === 'issue_ebay_return_refund_add_note')
          if (noteSiblingIndex >= 0) {
            const { refundType, comment } = actionInputs[index] ?? {}
            const refundValue = res.result?.value
            const noteText = `Refund issued directly via eBay against existing return ${suggestion.proposedActions[index]?.params?.returnId} (no return required) — ${refundType === 'full' ? 'Full' : 'Partial'} refund of $${refundValue}. ${comment ?? ''}`
            setActionInputs((prev) => ({ ...prev, [noteSiblingIndex]: { ...(prev[noteSiblingIndex] ?? {}), editedNote: noteText } }))
          }
        }
        // A task contact on an eBay order (2026-10-14): the response is its
        // eBay step(s), not a reply box. The replacement's or the refund's
        // resolved template (with the new order or return number) goes into
        // the eBay message box(es) of the same path (taskEbayStepIndexes()).
        if (isTask && res.result?.replyText) {
          for (const idx of taskEbayStepIndexes(suggestion.proposedActions, index)) {
            setActionInputs((prev) => ({ ...prev, [idx]: { ...(prev[idx] ?? {}), editedMessage: ebayStepBoxText(res.result.replyText) } }))
          }
        }
        // An RMARTN Cust Pays reply (2026-10-27, rmaReference.js): the
        // return step's RMA number fills the reply's Reference ID as soon as
        // the result has it, keeping the person's edits; the executor's own
        // reply text never replaces this reply.
        // A step started from Other Actions (2026-10-27) never rewrites the
        // reply: its template is offered on the step ("Paste this into the draft reply",
        // ManualStepReply.jsx), and the draft is not regenerated.
        const fromManualPanel = action?.source === 'manual_panel'
        const fillsRmaToken = !fromManualPanel && action?.type === 'process_return_refund' && hasRmaReferenceToken(draft)
        if (fillsRmaToken) {
          const ref = await rmaReferenceFromResult({ result: res.result, step: action, fetchRef: () => fetchRmaReference(suggestion.id, index, { trqRmaId: res.result?.trqRmaId ?? null }) })
          if (ref.value && conversationIdRef.current === startedForId) setDraft((prev) => replyWithRmaReference(prev, ref.value))
        }
        const hasReplyText = Boolean(res.result?.replyText) || fillsRmaToken
        if (hasReplyText && !fillsRmaToken && !fromManualPanel) {
          // The executor already resolved the outbound reply (e.g. the Gen
          // instructions or Refund No Return template) using the CSR's
          // confirmed reason/items — use it directly rather than
          // regenerating, which could re-run the same reason/item ambiguity
          // from scratch and overwrite it. The reply after Process
          // (2026-10-29, houseTemplateReply.js): an edited reply asks
          // first ("Replace your reply?"), and the template tag follows.
          await switchToHouseReply(houseReplyFromResult(action, res.result), { action, startedForId })
        }
        // Return Status's overdue refund (2026-10-29, overdueRefund.js): the
        // reply stays the stage's Refund Confirmation, tagged with it; the
        // reply after Process never switches it.
        if (overdueReplyTag(action, res.result) && !isDraftDirty()) setDraftInsertedTemplate(overdueReplyTag(action, res.result))
        // A return label held for the RMA number (2026-10-29): a waiting
        // step never switches the reply; the reply says the label will follow.
        if (!fromManualPanel && action?.type === 'process_return_refund' && res.result?.labelPending) {
          setDraft((prev) => heldLabelReply(prev, [{ success: true, result: res.result }], isEbayChannel ? 'ebay' : 'email', heldLabelSignatureOpts()))
        }
        {
          // See suggestionActionInputs.js's shouldSkipDraftRefresh() for which
          // action types skip the post-Process draft regenerate, and why. A
          // replyText result always skips the AI regenerate too (the draft is
          // already set directly above) — but the proposedActions refresh
          // below must still run either way: a step can append a NEW
          // proposed step (e.g. process_return_refund's Website RMA path
          // appending send_return_label_email once a label is created,
          // action-executor.js's appendProposedActions()), which would
          // otherwise never reach the UI — this used to bypass the refresh
          // entirely whenever replyText was present, since every Website RMA
          // outcome returns one.
          const skipDraftRefresh = hasReplyText || fromManualPanel || shouldSkipDraftRefresh(suggestion.proposedActions[index])

          // Refresh suggestion so dependent steps (and any newly appended
          // one) pick up updated params. Same dirty-check protection as the
          // regenerate call below — the CSR may already have started typing
          // during the executeStepAction/fetchSuggestions awaits above,
          // before this apply() call ever runs.
          const list = await fetchSuggestions(conversationId)
          const fresh = list[0] ?? null
          if (fresh && conversationIdRef.current === startedForId) apply(fresh, { skipDraft: skipDraftRefresh || isDraftDirty() || isAnyStepInputDirty() })

          if (!skipDraftRefresh) {
            // Regenerate AI draft to reflect the completed step.
            setRefreshingDraft(true)
            try {
              const newSuggestion = await generateSuggestion(conversationId)
              // A background regeneration triggered by processing THIS step must
              // never clobber a draft or step input the CSR is actively editing
              // right now, possibly for a completely different step — see
              // isDraftDirty()/isAnyStepInputDirty()'s own comments.
              if (newSuggestion && conversationIdRef.current === startedForId) { apply(newSuggestion, { skipDraft: isDraftDirty() || isAnyStepInputDirty() }); onGenerated?.() }
            } catch (e) {
              // Same benign case as onGenerate()'s own catch below: the step
              // that just succeeded above may have been the conversation's
              // own last word, closing it — nothing new for the pipeline to
              // classify. Must not let this reach the outer catch, which
              // would otherwise overwrite the just-set 'success' step status
              // with 'failed' and skip onGenerated?.() for a step that
              // actually succeeded.
              if (e.deferral) {
                // Deferred for a TRQ retry (2026-10-14): never "already answered".
                if (conversationIdRef.current === startedForId) {
                  setRetryDeferral(e.deferral)
                  onGenerated?.()
                }
              } else if (e.status === 404 && e.body?.error === 'no_inbound_turn') {
                if (conversationIdRef.current === startedForId) {
                  setClosedNotice('This conversation has already been answered — nothing new to generate. It has been closed.')
                  onGenerated?.()
                }
              } else {
                throw e
              }
            } finally { setRefreshingDraft(false) }
          }
        }
      } else {
        setStepStates((prev) => ({ ...prev, [index]: { status: 'failed', result: null, error: res.error ?? 'Action failed', errorCode: res.errorCode ?? null, dailyLimit: res.dailyLimit ?? null, ebayRefundReroute: res.ebayRefundReroute ?? null, ...(res.partlyDone ? { partlyDone: true, stepState: res.stepState ?? null, checklist: res.checklist ?? [] } : {}) } }))
      }
    } catch (e) {
      // A stale page (opened before an admin's earlier takeover reset, or
      // before this suggestion was queued for automation in the first
      // place) can reach here even past withAutomationTakeoverGuard's own
      // up-front check, which only reads whatever conversationStatus/
      // conversationWaitingReason this render already has. Offer the same
      // takeover dialog rather than the raw "-> 409" error box — confirming
      // re-runs this exact step once takeover succeeds.
      if (e.status === 409 && e.body?.error === 'automation_pending') {
        setStepStates((prev) => ({ ...prev, [index]: { status: 'idle', result: null, error: null } }))
        setAutomationTakeoverConfirm({ pendingAction: () => handleProcessStep(index) })
        return
      }
      // Replaced by a newer suggestion (a new buyer message): nothing ran.
      if (isSupersededError(e)) {
        setStepStates((prev) => ({ ...prev, [index]: { status: 'idle', result: null, error: null } }))
        await showNewerAfterSupersededRefusal()
        return
      }
      setStepStates((prev) => ({ ...prev, [index]: { status: 'failed', result: null, error: errorText(e, 'Process') } }))
    }
  }

  // inputsOverride: an already-updated actionInputs object to send instead
  // of the `actionInputs` state — needed by the disposition-override toggle
  // below, which must re-run the check with its own just-set
  // dispositionOverride immediately, not after waiting for a re-render to
  // pick up the still-stale `actionInputs` closure.
  async function handleCheckStep(index, inputsOverride) {
    // result: keeps whatever the LAST check resolved (not nulled out) while
    // this one is in flight — a plain re-check or the disposition-override
    // toggle both route back through here, and the note box below (and
    // anything else keyed on checkStates[i]?.result rather than strictly on
    // status === 'checked') would otherwise flicker out and back in for the
    // whole "checking" window instead of staying put.
    setCheckStates((prev) => ({ ...prev, [index]: { status: 'checking', result: prev[index]?.result ?? null, error: null } }))
    try {
      // The disposition check (2026-10-27, Check and Check again): POST
      // /api/ai/conversations/:id/disposition-check, the same check the
      // pipeline ran at generation (server/src/services/return-check.js),
      // for exactly the step's items and reason code. Reads only.
      const inputs = inputsOverride ?? actionInputs
      const input = inputs[index] ?? {}
      const action = suggestion?.proposedActions?.[index]
      const packages = Array.isArray(input.packages) && input.packages.length ? input.packages.map((p) => ({ weight: p?.weight === '' ? null : (p?.weight ?? null) })) : null
      const res = await runDispositionCheck(suggestion.conversationId, {
        erpOrderId: action?.params?.erpOrderId ?? '',
        items: (input.items ?? []).map((it) => ({ sku: it.sku, quantity: Number(it.quantity) || 1 })),
        reasonCode: String(input.reasonCode ?? ''),
        suggestionId: suggestion.id,
        actionIndex: index,
        ...(input.shippingPaymentOption ? { shippingPaymentOption: input.shippingPaymentOption } : {}),
        ...(packages ? { packages } : {}),
        ...(typeof input.dispositionOverride === 'boolean' ? { dispositionOverride: input.dispositionOverride } : {}),
        ...(typeof input.email === 'string' ? { email: input.email } : {}),
        ...(typeof input.ccInternalCopy === 'boolean' ? { ccInternalCopy: input.ccInternalCopy } : {}),
        ...(typeof input.ccAddress === 'string' ? { ccAddress: input.ccAddress } : {}),
      })
      if (res.success) {
        applyCheckResult(index, res)
      } else {
        setCheckStates((prev) => ({ ...prev, [index]: { status: 'failed', result: null, error: res.error ?? 'Check failed' } }))
      }
    } catch (e) {
      setCheckStates((prev) => ({ ...prev, [index]: { status: 'failed', result: null, error: e.message } }))
    }
  }

  // A check's answer on the step (2026-10-27): the Check route's, or the
  // one the pipeline stored at generation (params.checkResult, seeded on
  // load). Selects its disposition, seeds the note, the who-pays default and
  // the packages, and keeps the check's own disposition for the decision's
  // override record (checkedDisposition).
  function applyCheckResult(index, res, actionArg = null) {
    setCheckStates((prev) => ({ ...prev, [index]: { status: 'checked', result: res, error: null } }))
    if (typeof res.naturalDisposition === 'boolean' || Array.isArray(res.labelPackages) || res.alreadyShippedBack) {
      setActionInputs((prev) => {
        const cur = prev[index] ?? {}
        return {
          ...prev,
          [index]: {
            ...cur,
            ...(typeof res.naturalDisposition === 'boolean' ? { checkedDisposition: dispositionWord(res.naturalDisposition) } : {}),
            ...(!cur.packages && Array.isArray(res.labelPackages) && res.labelPackages.length ? { packages: res.labelPackages } : {}),
            // Already shipped back (2026-10-28): the step's own override and
            // the customer's own shipping, as the check returned them, unless
            // the person already chose (Process and the decision record send
            // them).
            ...(res.alreadyShippedBack && typeof cur.dispositionOverride !== 'boolean' && res.disposition === true && res.naturalDisposition !== true ? { dispositionOverride: true } : {}),
            ...(res.alreadyShippedBack && !cur.shippingPaymentOption && res.shippingPaymentOption ? { shippingPaymentOption: res.shippingPaymentOption } : {}),
          },
        }
      })
    }
    // process_return_refund's note default isn't known until the check
    // resolves the live disposition (see suggestionActionInputs.js's
    // noteFromPlannedSteps()) — seed it here, same "preserve if already
    // there" treatment reseedActionInputs gives editedNote on initial
    // load, so re-running the check doesn't clobber an in-progress edit.
    const noteDefault = noteFromPlannedSteps(res.plannedSteps)
    if (noteDefault !== null) {
      setActionInputs((prev) => ({
        ...prev,
        [index]: { ...(prev[index] ?? {}), editedNote: prev[index]?.editedNote?.trim() ? prev[index].editedNote : noteDefault },
      }))
    }
    // Website RMA path's rate quote — seed the DEFAULT "who pays" option
    // (Our Cost when Customer Cost would eat up 30%+ of the return, same
    // threshold the render-time red warning uses; Customer Cost
    // otherwise) and its own deduction amount, the same "preserve if
    // already there" way as editedNote above (never override an agent's
    // own prior choice — including on a RE-check, e.g. after an item-
    // selection change) — action-executor.js only ever applies an
    // `adjustment` when shippingPaymentOption is actually present,
    // distinguishing "the CSR (or this default seed) resolved a real
    // rate" from "this ran with no rate-quote flow at all" (an older
    // suggestion, or the Flows automation engine's own zero-actionInputs
    // pass). Also (re)builds the auto-managed note block from whichever
    // option/deduction ends up in effect — recomputed every time this
    // runs, since a stale block against a NEW item selection or a fresh
    // rate quote would show wrong numbers; the CSR's own note text above
    // it is never touched (see withShippingNoteLine).
    const action = actionArg ?? suggestion?.proposedActions?.[index]
    // Auto-managed note fragments belong to exactly one path — a
    // disposition override (or a plain re-check that resolves
    // differently) can flip which path this is, and a fragment the
    // OTHER path attached on a prior run must not linger in the note it
    // no longer describes. Determined the same way the two branches
    // below gate themselves; a no-op when the fragment was never set.
    // Covers the company-pays case too (no rateQuotes at all), which
    // the two branches below wouldn't otherwise touch. The CSR's own
    // typed text is never touched, only path-owned auto-text.
    const isWebsiteRmaPath = res.disposition === true && !action?.params?.hasExistingReturn && !isEbayChannel && !isEbayClientEmail
    const isWebsiteScrapPath = res.disposition === false && !action?.params?.hasExistingReturn && !isEbayChannel && !isEbayClientEmail
    if (isWebsiteRmaPath || isWebsiteScrapPath) {
      setActionInputs((prev) => {
        const cur = prev[index] ?? {}
        if (isWebsiteRmaPath && cur.scrapRefundNoteSuffix) {
          return { ...prev, [index]: { ...cur, editedNote: withTotalRefundSuffix(cur.editedNote, cur.scrapRefundNoteSuffix, null), scrapRefundNoteSuffix: null } }
        }
        if (isWebsiteScrapPath && cur.shippingNoteLine) {
          return { ...prev, [index]: { ...cur, editedNote: withShippingNoteLine(cur.editedNote, cur.shippingNoteLine, null), shippingNoteLine: null } }
        }
        return prev
      })
    }
    if (res.rateQuotes) {
      setActionInputs((prev) => {
        const cur = prev[index] ?? {}
        const allItems = fillMissingUnitCost(action?.itemSelection?.allItems ?? [], orderSummaryItemDetails)
        const selectedItems = cur.items ?? []
        const lineTaxes = computeLineTax(allItems, { orderTax: orderSummaryOrderTax, shippingCost: orderSummaryShippingCost, orderTotal: orderSummaryOrderTotal })
        const { itemsTotal } = estimatedRefundBreakdown({ allItems, selectedItems, lineTaxes, deduction: 0 })
        // combined: the SAME shape a single rate quote always was, summed
        // across every package (feature/return-label-multi-package) — every
        // deduction-default/high-cost/note-block helper below keeps working
        // unchanged against this combined total.
        const combined = combineRateQuotes(res.rateQuotes)
        const pct = shippingHighCostPct(combined, itemsTotal)
        const option = cur.shippingPaymentOption ?? (res.alreadyShippedBack ? res.shippingPaymentOption : null) ?? (pct >= 0.3 ? 'ourCost' : 'customerCost')
        // Not manually edited (shippingDeductionEdited) → every re-check
        // (re-estimate, or the first check after a package add/remove —
        // see handlePackagesChange's own estimateStale flag) resets the
        // deduction to the fresh combined default for the selected
        // option, rather than keeping a stale prior default around.
        const deduction = cur.shippingDeductionEdited ? cur.shippingDeduction : shippingRateDefaultDeduction(option, combined)
        const { deductionAmount, estimatedRefund } = estimatedRefundBreakdown({
          allItems, selectedItems, lineTaxes,
          deduction: option === 'customerShipsOwn' ? 0 : deduction,
        })
        // Already shipped back (2026-10-28): the RMA note's own amounts line
        // ("Original Refund: ... Final Refund: ..."), not the block.
        const newBlock = res.alreadyShippedBack ? null : shippingNoteBlock({ paymentOption: option, itemsTotal, deductionAmount, estimatedRefund, pct, deduction, rateQuote: combined })
        const note = res.alreadyShippedBack
          ? withRefundAmountsNoteLine(cur.editedNote, { original: itemsTotal, deduction: deductionAmount, final: estimatedRefund })
          : withShippingNoteLine(cur.editedNote, cur.shippingNoteLine ?? null, newBlock)
        return {
          ...prev,
          // itemsTotal: sent through to action-executor.js's own
          // amount auto-fill for LABEL_DEDUCTION_TEMPLATE — the server
          // has no tax logic of its own, so it reuses the same
          // pre-deduction items+tax total this panel already displays
          // rather than recomputing it independently.
          //
          // packages: seeded from res.packages ONLY the first time (the
          // server's own resolvedPackages — package 1 defaults to
          // computeLabelWeight()'s total) — preserve-if-already-there,
          // same convention as editedNote above, so a re-check (e.g.
          // after an item-selection change) never clobbers weights the
          // CSR already edited. estimateStale: false — this check just
          // ran against whatever packages are in effect right now, so
          // the estimate is fresh again.
          [index]: {
            ...cur, shippingPaymentOption: option, shippingDeduction: deduction, editedNote: note, shippingNoteLine: newBlock, itemsTotal,
            packages: cur.packages ?? res.packages ?? [{ weight: 0 }],
            estimateStale: false,
          },
        }
      })
    } else if (res.disposition === false && !action?.params?.hasExistingReturn && !isEbayChannel && !isEbayClientEmail) {
      // Website scrap-refund path (no existing return, disposition
      // scrap): no rate-quote/who-pays UI at all — the item never ships
      // back, so there's no label cost to negotiate. Same
      // itemsTotal/note auto-capture pattern as the rate-quote branch
      // above, just without the deduction/who-pays pieces (deduction is
      // always 0 here).
      setActionInputs((prev) => {
        const cur = prev[index] ?? {}
        const allItems = fillMissingUnitCost(action?.itemSelection?.allItems ?? [], orderSummaryItemDetails)
        const selectedItems = cur.items ?? []
        const lineTaxes = computeLineTax(allItems, { orderTax: orderSummaryOrderTax, shippingCost: orderSummaryShippingCost, orderTotal: orderSummaryOrderTotal })
        const { itemsTotal } = estimatedRefundBreakdown({ allItems, selectedItems, lineTaxes, deduction: 0 })
        const suffix = ` Total refund: $${itemsTotal.toFixed(2)}.`
        const note = withTotalRefundSuffix(cur.editedNote, cur.scrapRefundNoteSuffix ?? null, suffix)
        return { ...prev, [index]: { ...cur, editedNote: note, scrapRefundNoteSuffix: suffix, itemsTotal } }
      })
    }
  }

  // The Disposition dropdown's override (2026-10-27: Return or Scrap, in the
  // checked-result box) — `overridden` is the boolean disposition to force, or undefined to
  // go back to the console's own live result. Recomputes actionInputs
  // synchronously and hands the SAME object to handleCheckStep so the
  // re-check's plannedSteps preview reflects the override on this same
  // click, not a render later.
  function handleDispositionOverrideChange(index, overridden) {
    const next = {
      ...actionInputs,
      [index]: { ...(actionInputs[index] ?? {}), dispositionOverride: overridden },
    }
    setActionInputs(next)
    handleCheckStep(index, next)
  }

  // The packages editor's onChange (feature/return-label-multi-package) —
  // any weight edit, or an add/remove, invalidates whatever estimate is
  // currently in effect (estimateStale: true disables Process — see the
  // per-step Process/Re-estimate button below — until a fresh Check
  // re-quotes the new package set).
  function handlePackagesChange(index, nextPackages) {
    markTouched()
    setActionInputs((prev) => ({ ...prev, [index]: { ...(prev[index] ?? {}), packages: nextPackages, estimateStale: true } }))
  }

  const qa = suggestion?.qaGrade
  // A closed conversation must never present as actionable, regardless of
  // whether the suggestion ITSELF was ever formally decided (e.g. its
  // resolution went out via a proposed-action Process step, or the
  // conversation was closed some other way while a pending suggestion was
  // left behind) — every `decided`-gated editable control below (the
  // FROM_EBAY case-reply box, note/item-selection/shipping fields, the
  // FROM_MEMBERS draft box, and the top-level Send/Escalate/Close/Spam row)
  // collapses to read-only the same way it already does for a genuinely
  // decided suggestion.
  // 'transferred' (Transfer to Support) is still actionable, like 'escalated'.
  const decided = conversationStatus === 'closed' || (suggestion && suggestion.status !== 'pending' && suggestion.status !== 'escalated' && suggestion.status !== 'transferred')
  // "Responded via Process" (migration 0083): a Proposed Step already sent
  // the customer response directly (server/src/services/action-executor.js's
  // attributeDirectSend()), deciding the suggestion 'approved' without
  // closing the contact. `decided` above is still true here (status isn't
  // pending/escalated) — every OTHER decided-gated control stays collapsed
  // as usual, but Escalate/Close/Spam must reappear (there is still real work
  // left: hand it off, close it out, or mark it spam) and only Send must stay
  // hidden (the reply already went out). Same state regardless of channel —
  // every direct-send Process step sets this one column.
  const directSendAttributionState = Boolean(suggestion) && suggestion.status === 'approved' && suggestion.directSendAttribution && conversationStatus !== 'closed'
  // See isDecidedSuggestionStaleRelativeToLatestMessage()'s own comment —
  // a decided suggestion that predates the conversation's latest message.
  // Gates the Decision alert/action-row swap below; not threaded into
  // `decided` itself (busy already disables every decided-gated field for
  // the duration of the auto-retry — see the effect above).
  const staleDecidedSuggestion = !loading && Boolean(suggestion) && isDecidedSuggestionStaleRelativeToLatestMessage(suggestion)
  // A decided suggestion whose outbound send failed can be fixed and resent
  // without re-deciding it (see onRetrySend/POST .../retry-send) — the
  // conversation staying 'pending' despite an approved/edited status is
  // exactly the "still needs to go out" signal (see onDecide's own comment on
  // why it doesn't release assignment in this case). FROM_EBAY is out of
  // scope: it never shows a draft box, and its replySendError is a benign
  // no-send-target case, not a real failed send to retry.
  const canRetrySend = !fromEbay && Boolean(replySendError) && conversationStatus === 'pending' && (suggestion?.status === 'approved' || suggestion?.status === 'edited')
  // m365_email's own version of the "closed, buyer wrote back, no pending
  // suggestion to Approve" case (see the closedReplyDraft box further down,
  // still used for eBay) — reuses the SAME draft/draftTo/draftSubject editor
  // + Templates button the normal pending-suggestion flow renders above,
  // rather than that stripped-down box, since m365_email actually needs a
  // real To/Subject/Templates surface (an eBay message has no such concept
  // at all, which is why that box never needed them). Never true for eBay —
  // scoped narrowly to the one channel this was missing real functionality
  // for.
  // !isEbayClientEmail: an eBay-client email has no real "Email" field at all
  // (see this file's own isEbayClientEmail comment above) — the closed-reply
  // compose surfaces this flag drives (the To/Subject/reply-mode/draft boxes
  // further below) are ALL gated on !isEbayClientEmail already; without the
  // same gate here, this would still resolve true for a closed eBay-client-
  // email conversation and render a Send button (below) with no composer
  // above it to type a reply into.
  // An internal email between CXHub mailboxes (2026-10-12) gets no AI, so its
  // reply is always this manual composer, open or closed.
  const composingClosedReply = (conversationStatus === 'closed' || isInternalEmail) && !fromEbay && channel === 'm365_email' && !isEbayClientEmail
  // FROM_EBAY suggestions never carry a reply draft by convention — Send is
  // only meaningful there if some proposed action is a real executable step
  // (same targetSystem/UI_ONLY_TYPES test used to show a step's own "Process"
  // button). With neither a draft nor a processable step, there's nothing
  // for Send to do — Close/Escalate are the only real options.
  const hasProcessableStep = Boolean(suggestion?.proposedActions?.some((a) => a.source !== 'manual_panel' && !UI_ONLY_TYPES.has(a.type) && Boolean(a.targetSystem)))
  const nothingToSendOrProcess = fromEbay && !draft?.trim() && !hasProcessableStep
  // "Process all steps and send reply" (2026-10-23, processAll.js): offered
  // beside Send when the reply promises a refund, replacement, return label
  // or cancellation and a step of that kind is still to run; disabled while
  // a step needs the person first. Never on a task contact (its steps close
  // the task).
  // The agent draft panel (2026-10-23, AgentDraftLayout.jsx; docs/contact-
  // view.md): when the agent's draft is this suggestion's (a primary intent,
  // modelMeta.draftSource 'agent'), the panel takes the A2 layout every CSR
  // sees: Summary, What's next, Steps, Reply, then one full-width "Process
  // all steps and send reply" (or "Send Reply" with no steps) in place of
  // Send, and the run's Details collapsed.
  const agentLayout = Boolean(suggestion) && suggestion.modelMeta?.draftSource === 'agent' && !isTask && !fromEbay
  // "Compare with pipeline draft" (2026-11-02, Jenn): admin only (not View
  // as Agent), only with a pipeline draft for this suggestion; it opens the
  // "Pipeline draft (not used)" column, and reads "Hide comparison" while
  // that is open. The hint is the differences' count, never their text.
  const pipelineHint = pipelineOnDemand ? pipelineDifferenceHint(compareDraft) : null
  const pipelineCompareLink = pipelineOnDemand ? (
    <Stack direction="row" spacing={1} alignItems="baseline" flexWrap="wrap" useFlexGap data-testid="pipeline-compare-row">
      <Link component="button" type="button" underline="hover" data-testid="pipeline-compare-link" aria-expanded={pipelineCompareOpen}
        onClick={() => setPipelineCompareOpen((o) => !o)}
        sx={{ fontSize: 12, fontWeight: 600, textAlign: 'left' }}>
        {pipelineCompareOpen ? HIDE_COMPARISON_LABEL : COMPARE_PIPELINE_LINK}
      </Link>
      {pipelineHint && <Typography component="span" data-testid="pipeline-compare-hint" sx={{ fontSize: 12, color: A2.label }}>{pipelineHint}</Typography>}
    </Stack>
  ) : null
  // "Found the right part?" (2026-10-30, correctPart.js): on this
  // suggestion, until a part is used.
  const correctPartUsed = Boolean(correctPart && correctPart.suggestionId === suggestion?.id)
  const correctPartSteps = (steps) => (correctPartUsed ? stepsAfterCorrectPart(steps, correctPart.steps) : steps)
  const showCorrectPartBox = Boolean(suggestion) && !screenMode && !fromEbay && !correctPartUsed && conversationStatus !== 'closed' && correctPartBoxApplies({ intent: suggestion.intent, nextSteps: suggestion.modelMeta?.agentNextSteps ?? [], templateTitle: suggestion.modelMeta?.draftTemplate?.title ?? null, reply: suggestion.draftReply ?? '' })
  // The checked steps (2026-10-26): only on the agent draft panel, where
  // each step has its checkbox; every other panel processes every step.
  // A step on a path not in effect (the sales-hold path, the resolution
  // switch, 2026-10-27) is never in Process all: the server refuses it.
  // A step left out by unpark's "Keep my saved work", or processed before
  // the park (2026-10-27), is unchecked on any layout, so Process all skips it.
  const pathActions = suggestion?.proposedActions ?? []
  const onPath = (i) => !isTaskPathHidden(pathActions[i], taskPathKey)
  const checkedSteps = (agentLayout || uncheckedSteps.length > 0)
    ? checkedIndexes(pathActions, uncheckedSteps).filter(onPath)
    : (pathActions.some((a) => a?.taskPath) ? pathActions.map((_, i) => i).filter(onPath) : null)
  // Replacement or refund on the step (2026-10-27): what the head step shows.
  const resView = agentLayout ? resolutionView(pathActions, taskChoice) : null
  const resolutionDisabled = busy || decided || conversationStatus === 'closed'
  const isStepUnchecked = (i) => agentLayout && uncheckedSteps.includes(i)
  // The reply's destination (2026-10-27, @cxhub/shared's
  // reply-destination.js): on the agent draft panel of an eBay contact, the
  // open eBay inquiry or return the reply is posted to, an escalated case
  // (sent as a member message), or a member message. agentHasReply: there
  // is a reply to send (not empty, not only the signature); without one the
  // button processes the steps only. replyCarrierIndex: the inquiry refund
  // or shipment proof that carries the reply as its comment.
  const replyDest = agentLayout && channel === 'ebay' ? (suggestion?.modelMeta?.replyDestination ?? null) : null
  const agentHasReply = Boolean(String(draft ?? '').trim()) && !isSignatureOnlyReply(draft ?? '', signatureSeed())
  const agentNoReply = agentLayout && !agentHasReply && Boolean(replyDest?.noReply)
  const replyDestLine = replyDest ? replyDestinationLine(replyDest, { hasReply: agentHasReply }) : null
  const replyCarrierIndex = agentLayout && agentHasReply
    ? replyCarrierStepIndex(suggestion?.proposedActions ?? [], replyDest, { checked: checkedSteps, done: Object.entries(stepStates ?? {}).filter(([, st]) => st?.status === 'success').map(([k]) => Number(k)) })
    : -1
  // The reply decides which blocked steps still block (2026-10-27): a step
  // the reply does not need is skipped, listed in processAll.skipped.
  const processAll = processAllPlan({ actions: suggestion?.proposedActions ?? [], stepStates, checkStates, actionInputs, checked: checkedSteps, reply: draft, signature: signatureSeed(), notNeeded: notNeededSteps, replyCarrierIndex })
  // Every step whose Send block is lifted for this reply: { index, reason }.
  const liftedSteps = [
    ...(taskChoiceBlock && !taskChoiceBlock.applies ? [{ index: taskChoiceBlock.index, reason: taskChoiceBlock.reason }] : []),
    ...(processAll.skipped ?? []),
  ]
  // The steps blocking Send for this reply (the ones that get the "My reply
  // doesn't need this" link), and why a step's block is lifted. A Process
  // all step counts only where Process all is the button (the agent draft
  // panel) or is offered; elsewhere it never blocked Send.
  const processAllShown = () => agentLayout || showProcessAll
  const isBlockingStep = (i) => (taskChoiceBlock?.applies && taskChoiceBlock.index === i) || (processAllShown() && processAll.blocked.some((b) => b.index === i))
  const liftedStepReason = (i) => {
    if (taskChoiceBlock && !taskChoiceBlock.applies && taskChoiceBlock.index === i) return taskChoiceBlock.reason
    return processAllShown() ? (processAll.skipped ?? []).find((x) => x.index === i)?.reason ?? null : null
  }
  // The label link slot (2026-10-26): a reply that keeps INSERTLABELLINK for
  // a "recover and send" step still to run. Process all fills it before the
  // send, so its placeholder checks skip it, but only while that step is
  // checked and in the plan (an unchecked step never fills it, so Process all
  // is refused like Send); Send alone stays blocked with the reason.
  const labelSlotPending = hasPendingLabelLinkSlot(draft, suggestion?.proposedActions ?? [], stepStates)
  const labelSlotFilledHere = labelSlotFilledByProcessAll(draft, suggestion?.proposedActions ?? [], stepStates, processAll)
  const processCheckDraft = labelSlotFilledHere ? replyForProcessChecks(draft, suggestion?.proposedActions ?? [], stepStates, processAll) : draft
  // The RMA number's token (2026-10-27, rmaReference.js): Send fills it from
  // the processed return step; before the return ran, Send is blocked, and
  // Process all only when the return step is not in its plan.
  const rmaSendWarning = rmaReferenceSendWarning(draft, suggestion?.proposedActions ?? [], stepStates)
  const rmaProcessAllWarning = rmaReferenceProcessAllWarning(draft, suggestion?.proposedActions ?? [], stepStates, processAll)
  // A Website scrap refund drafted up front (2026-10-29, houseTemplateReply.js):
  // the amount, dates and RTN number its return step fills in this pass do
  // not hold Process all; Send still refuses any left after Process.
  const passFillTokens = tokensFilledByPass(suggestion?.proposedActions ?? [], processAll.indexes, actionInputs)
  const processPlaceholderWarning = (labelSlotFilledHere || passFillTokens.length ? unfilledPlaceholderWarning(withoutRmaReferenceToken(replyForProcessAllGate(processCheckDraft, passFillTokens))) : draftPlaceholderWarning) ?? rmaProcessAllWarning
  // The placeholder stop (2026-10-30: the RMA reference is a warning now,
  // below; the label link slot is an unfilled INSERTLABELLINK, so a stop).
  // The Signifyd mention is a Send warning (2026-10-30), so Send's stop reads
  // the placeholders alone.
  const sendPlaceholderWarning = labelSlotPending && !placeholderOnlyWarning(withoutRmaReferenceToken(replyForProcessChecks(draft, suggestion?.proposedActions ?? [], stepStates))) ? LABEL_LINK_SLOT_WARNING : placeholderOnlyWarning(withoutRmaReferenceToken(draft))
  // What stops Send and Retry Send (2026-10-30, sendWarnings.js): only an
  // unfilled placeholder, a Walmart link, an empty reply, or no address to
  // send to (plus the invoice attachment still loading, a moment). Every
  // other check is a warning in the Send warnings dialog. The regenerated
  // compare still asking (2026-10-28) is a stop too (Jenn, 2026-10-30): it is
  // which suggestion is current, not a check of the reply; Send says so
  // first.
  const replyIsEmpty = isBlankReply(draft) || isSignatureOnlyReply(draft ?? '', signatureSeed())
  const sendStop = (regeneratedBlock ? REGENERATED_SEND_STOP : null) ?? sendStopReason({
    placeholder: sendPlaceholderWarning,
    walmartLink: walmartLinkReason,
    empty: nothingToSendOrProcess || (!fromEbay && replyIsEmpty),
    noAddress: noticeToReason,
  }) ?? (invoiceClaimReason && invoicesLoading ? invoiceClaimReason : null)
  // nothingToSendOrProcess keeps its own words.
  const sendStopText = nothingToSendOrProcess && !regeneratedBlock ? 'Nothing to send or process — use Close or Escalate instead' : sendStop
  // Every Send warning for a reply (2026-10-30), one list for the dialog.
  // processedNow: steps a Process all just ran; markedNotNeeded: steps the
  // dialog marked; retry: Retry Send (no task choice, no double-reply guard:
  // the decision is already recorded).
  function sendWarningsFor(text, { processedNow = [], markedNotNeeded = [], retry = false } = {}) {
    const actions = suggestion?.proposedActions ?? []
    const notNeeded = [...new Set([...notNeededSteps, ...markedNotNeeded])]
    const rmaIdx = rmaReferenceStepIndex(actions)
    const rmaWaiting = Boolean(rmaReferenceSendWarning(text, actions, stepStates)) && !(processedNow ?? []).includes(rmaIdx)
    const recent = retry ? null : recentRelatedReply(relatedContacts)
    return panelSendWarnings({
      promise: panelPromiseWarnings({ text, suggestion, stepStates, processedNow, uncheckedSteps, notNeededSteps: notNeeded, refundDocuments: templateRefundDocs.suggestionId === suggestion?.id ? templateRefundDocs.docs : [] }),
      taskChoice: !retry && taskChoiceBlock?.applies && !notNeeded.includes(taskChoiceBlock.index)
        ? { index: taskChoiceBlock.index, message: taskChoiceSaveFailed ? taskChoiceError.message : (taskChoiceStep.params?.missingReason ?? 'Choose whether the package has moved first.') }
        : null,
      invoiceClaim: invoiceClaimWarningFor(text),
      taskSubjectMissing: Boolean(taskSubjectMissingReason),
      rmaReference: rmaWaiting ? { index: rmaIdx } : null,
      recentReply: recent ? recentReplyMessage(recent) : null,
      text,
      // The agent's own steps' warnings (2026-10-30, agentReplyFollowsSteps.js):
      // an amount on no step ("Use the step's amount"), "no return" on an RMA,
      // return instructions on a scrap step, items the step's are not. In the
      // same dialog, never a second prompt; the panel's Alerts above the
      // buttons still show them as the reply is written.
      extra: ownStepsShown && !retry ? sendWarnings(text, liveRefundList, { actions: suggestion?.proposedActions ?? [], inputs: actionInputs, unchecked: uncheckedSteps }).map((w) => ({
        code: w.code,
        text: w.message,
        ...(Number.isInteger(w.index) ? { index: w.index } : {}),
        fixes: w.fix ? [{ kind: SEND_FIX.useStepAmount, label: USE_STEP_AMOUNT_LABEL, amount: w.fix.amount, stepAmount: w.fix.stepAmount }] : [],
      })) : [],
    })
  }
  function openSendWarnings(warnings, proceed) {
    setSendWarningsAsk({ warnings, proceed, markedNotNeeded: [] })
  }
  // A warning's fix (2026-10-30). Mark this step not needed and Check the
  // step settle it here (the dialog drops its warnings); the others close
  // the dialog and take the CSR to the fix.
  function onSendWarningFix(fix) {
    const ask = sendWarningsAsk
    if (!ask) return
    if (fix.kind === SEND_FIX.markNotNeeded && Number.isInteger(fix.index)) {
      markTouched()
      setNotNeededSteps((prev) => (prev.includes(fix.index) ? prev : [...prev, fix.index]))
      setSendWarningsAsk({ ...ask, warnings: withoutStepWarnings(ask.warnings, fix.index), markedNotNeeded: [...ask.markedNotNeeded, fix.index] })
      return
    }
    if (fix.kind === SEND_FIX.checkStep && Number.isInteger(fix.index)) {
      onToggleStep(fix.index, true)
      setSendWarningsAsk({ ...ask, warnings: withoutStepWarnings(ask.warnings, fix.index) })
      return
    }
    setSendWarningsAsk(null)
    // "Use the step's amount" changes the reply, so the CSR sees it and
    // presses Send again (the warnings are read from the new reply).
    if (fix.kind === SEND_FIX.useStepAmount) {
      const next = withStepAmount(liveDraftRef.current ?? draft, fix.amount, fix.stepAmount)
      setDraft(next)
      liveDraftRef.current = next
      return
    }
    if (fix.kind === SEND_FIX.processStep && Number.isInteger(fix.index)) {
      handleProcessStep(fix.index)
    } else if (fix.kind === SEND_FIX.choosePath && Number.isInteger(fix.index)) {
      showTaskChoiceError(fix.index, taskChoiceBlockMessage(suggestion?.proposedActions?.[fix.index], fix.index))
    }
  }
  function onSendWarningsAnyway() {
    const ask = sendWarningsAsk
    setSendWarningsAsk(null)
    ask?.proceed?.(warningCodes(ask.warnings), ask.markedNotNeeded ?? [])
  }
  const showProcessAll = Boolean(suggestion) && !isTask && !fromEbay && Boolean(draft?.trim()) && conversationStatus !== 'closed' && offersProcessAll(suggestion?.proposedActions ?? [], processAll, draft, checkedSteps)
  // The steps the panel shows, numbered as shown (select_reason_code, a
  // manual-panel step, a hidden task path and an unneeded replacement label
  // are not shown): array index -> number.
  const shownStepNumbers = (() => {
    const map = new Map()
    let n = 0
    ;(suggestion?.proposedActions ?? []).forEach((a, i) => {
      if (a.source === 'manual_panel' || a.type === 'select_reason_code' || isTaskPathHidden(a, taskPathKey) || isEmptyPathReply(a) || isResolutionHiddenStep(a)) return
      if (a.type === 'create_return_label_for_replacement') {
        const sib = replacementLabelSiblingIndex(a, suggestion.proposedActions)
        const code = actionInputs[sib]?.reasonCode
        if (!suggestion.proposedActions[sib]?.inputOptions?.find((opt) => opt.value === code)?.requiresZeroDollarRma) return
        // The $0 RMA box checked: the label comes from the $0 RMA (2026-10-29).
        if (replacementLabelHeldForZeroDollar(a, suggestion.proposedActions, actionInputs)) return
      }
      n += 1
      map.set(i, n)
    })
    return map
  })()
  // The Send guard for the agent's own steps (2026-10-30): warnings, never a block.
  const replyStepWarns = ownStepsShown && !decided ? sendWarnings(draft, liveRefundList, { actions: suggestion?.proposedActions ?? [], inputs: actionInputs, unchecked: uncheckedSteps }) : []
  const agentPlaceholderFields = agentLayout ? placeholderFieldNames(processCheckDraft) : []
  const agentActionState = agentLayout ? primaryActionState({
    // The steps it runs, with the ones still waiting on the person (so the
    // label stays "Process all steps and send reply" while they block it).
    steps: [...processAll.indexes, ...processAll.blocked.map((b) => b.index)].sort((x, y) => x - y).map((i) => ({ number: shownStepNumbers.get(i) ?? i + 1, label: suggestion.proposedActions[i]?.label ?? null, type: suggestion.proposedActions[i]?.type })),
    fields: agentPlaceholderFields,
    blocked: processAll.blocked.map((b) => b.reason),
    // Every other reason the button is refused today, in its own words. As
    // Process all its own checks stay; with no step to process it is the
    // Send, and only Send's stops disable it (2026-10-30): the rest are the
    // Send warnings dialog's.
    otherReason: (!agentPlaceholderFields.length ? ((processAll.indexes.length || processAll.blocked.length) ? processPlaceholderWarning : sendPlaceholderWarning) : null) ?? walmartLinkReason ?? noticeToReason ?? (processAll.indexes.length || processAll.blocked.length ? (invoiceClaimReason ?? taskChoiceMissingReason ?? taskSubjectMissingReason) : ((regeneratedBlock ? REGENERATED_SEND_STOP : null) ?? (agentHasReply ? null : EMPTY_REPLY_REASON) ?? (invoiceClaimReason && invoicesLoading ? invoiceClaimReason : null))) ?? null,
    // No reply (2026-10-27): the eBay case waits for the buyer; the button
    // processes the steps only ("Process 1 step").
    reply: !agentNoReply,
    caseLabel: postsToCase(replyDest) ? caseName(replyDest) : null,
  }) : null
  const agentRun = suggestion?.modelMeta?.agentRun ?? null
  // Where the button area shows (a pending suggestion's decision): there the
  // panel's error shows above the button, not at the top.
  const showAgentActions = agentLayout && !loading && !decided && !staleDecidedSuggestion && !canRetrySend && !composingClosedReply
  // The reply mode toggle in the agent draft panel's Reply header (the same
  // control as the decision row's, below).
  // "Start a new contact" (2026-10-27), under either reply mode toggle.
  const startNewContactEl = replyMode === 'new' && channel === 'm365_email' && !isEbayClientEmail ? (
    <FormControlLabel
      sx={{ mr: 0, '& .MuiFormControlLabel-label': { fontSize: '0.75rem', textTransform: 'none', letterSpacing: 0, fontWeight: 400 } }}
      control={<Checkbox size="small" checked={startNewContact} onChange={(e) => setStartNewContact(e.target.checked)} disabled={busy} inputProps={{ 'data-testid': 'start-new-contact' }} />}
      label={startNewContact ? 'Start a new contact (a new topic)' : 'Start a new contact (otherwise kept on this contact)'}
    />
  ) : null
  const replyModeToggleEl = channel === 'm365_email' && !isEbayClientEmail && replyModes.length > 1 ? (
    <Stack alignItems="flex-end" spacing={0.25}>
      <ToggleButtonGroup value={replyMode} exclusive onChange={(_e, newValue) => handleReplyModeChange(newValue)} size="small" aria-label="Reply mode"
        disabled={busy || (decided && !canRetrySend && !composingClosedReply)}>
        <ToggleButton value="reply" sx={{ textTransform: 'none', px: 1.25, py: 0.25, fontSize: '0.75rem', letterSpacing: 0, '&.Mui-selected': { bgcolor: 'warning.main', color: 'warning.contrastText', '&:hover': { bgcolor: 'warning.dark' } } }}>
          Reply to Email
        </ToggleButton>
        <ToggleButton value="new" disabled={newOutboundState.disabled} sx={{ textTransform: 'none', px: 1.25, py: 0.25, fontSize: '0.75rem', letterSpacing: 0, '&.Mui-selected': { bgcolor: 'warning.main', color: 'warning.contrastText', '&:hover': { bgcolor: 'warning.dark' } } }}>
          Send New Outbound Email
        </ToggleButton>
      </ToggleButtonGroup>
      {newOutboundState.disabled && (
        <Typography variant="caption" color="text.secondary" data-testid="new-outbound-unavailable" sx={{ textTransform: 'none', letterSpacing: 0, fontWeight: 400 }}>{newOutboundState.reason}</Typography>
      )}
      {startNewContactEl}
    </Stack>
  ) : null

  // What Send Feedback sends besides the text (2026-10-26): the browser's
  // half of the snapshot, read at Submit. The reasons are the ones the
  // buttons show today, in their own words.
  function feedbackUiStateNow() {
    const hasBox = Boolean(suggestion) && !noDraftBoxFn({ fromEbay, intent: suggestion.intent, isEbayClientEmail })
    const sendDisabled = hasBox && Boolean(sendStopText)
    const processAllDisabled = showProcessAll && Boolean(regeneratedBlock || processAll.blocked.length > 0 || !processAll.indexes.length || processPlaceholderWarning || walmartLinkReason || noticeToReason || invoiceClaimReason)
    return buildFeedbackUiState({
      openedAt: feedbackOpenedAtRef.current,
      draftReply: suggestion?.draftReply ?? null,
      replyText: hasBox ? (draft ?? null) : null,
      lastAttempt: lastAttemptRef.current,
      shownErrors: [error, replySendError, ...(executionErrors ?? []).map((x) => (typeof x === 'string' ? x : x?.error ?? null))].map((m) => (typeof m === 'string' ? m : null)),
      disabled: [
        { button: 'Send', disabled: sendDisabled, reason: sendStopText ?? null },
        { button: 'Process all steps and send reply', disabled: processAllDisabled, reason: regeneratedBlock ?? (processAll.blocked.length ? processAll.blocked.map((b) => b.reason).join(' ') : (processPlaceholderWarning ?? walmartLinkReason ?? noticeToReason ?? invoiceClaimReason ?? null)) },
        { button: agentActionState?.label ?? 'Process all steps and send reply', disabled: Boolean(agentLayout && agentActionState?.disabled && agentActionState?.warn), reason: agentActionState?.line ?? null },
        { button: 'Send New Outbound Email', disabled: channel === 'm365_email' && Boolean(newOutboundState?.disabled), reason: newOutboundState?.reason ?? null },
      ],
      stepStates,
      checkStates,
      // The steps shown as lifted (liftedStepReason's rule): a Process all
      // step only where Process all is shown.
      skippedSteps: liftedSteps.filter((x) => processAllShown() || x.index === taskChoiceStepIndex),
    })
  }

  // The full screen state Send Feedback sends (2026-10-29,
  // feedbackScreenState.js): the panel's own per-step state, never the DOM.
  // Stored unredacted, admin-only, apart from the snapshot.
  function feedbackScreenStateNow() {
    const hasBox = Boolean(suggestion) && !noDraftBoxFn({ fromEbay, intent: suggestion.intent, isEbayClientEmail })
    return buildFeedbackScreenState({
      suggestion,
      context: {
        channel, client, fromEbay, isEbayClientEmail, isInternalEmail, conversationStatus,
        templateAccount, templateTrqClientCode, templateTeam, agentLayout, isAdmin,
        mailbox, outboundFrom, subject,
      },
      actionInputs,
      appliedInputs: appliedActionInputsRef.current,
      stepStates,
      checkStates,
      taskChoice,
      taskChoiceDate,
      notNeededSteps,
      uncheckedSteps,
      skippedSteps: liftedSteps.filter((x) => processAllShown() || x.index === taskChoiceStepIndex),
      isShown: isStepShown,
      draft,
      hasBox,
      insertedTemplate: draftInsertedTemplate,
      insertedTemplateId: draftInsertedTemplateIdRef.current,
      replyMode,
      to: channel === 'm365_email' ? draftTo : null,
      subject: channel === 'm365_email' ? draftSubject : null,
      cc: channel === 'm365_email' ? ccText : null,
      partLinks,
    })
  }

  // Whether a step shows as its own card (the Proposed Steps list and the
  // Manual Panel's window alike).
  const isStepShown = (a, i) => {
    // The read-only screen view's "Changed only" (2026-10-29).
    if (screenMode && screenView.changedOnly && !screenView.changedOnly.has(i)) return false
    // select_reason_code always immediately precedes the
    // action it supplies a reason code for (cancel_order_trq —
    // see actions.js) and action-executor.js already reads its
    // input by its own array index regardless of where
    // cancel_order_trq ends up, so its editable field renders
    // INSIDE the next card instead of as its own step (below).
    if (a.type === 'select_reason_code') return false
    // A task step on a path not chosen (2026-10-15): hidden, so
    // nothing below the choice can be Processed until then.
    if (isTaskPathHidden(a, taskPathKey)) return false
    // The Fix the address path's empty reply (2026-10-27): it
    // only empties the reply box when chosen.
    if (isEmptyPathReply(a)) return false
    // The resolution choice and its paths' replies (2026-10-27): the
    // choice is drawn on the head step, the reply loads into the box.
    if (isResolutionHiddenStep(a)) return false
    // create_return_label_for_replacement is always proposed
    // alongside process_replacement (see actions.js's
    // buildReplacementLabelSiblingAction()), but should only be
    // shown at all once the sibling's currently-selected reason
    // code actually requires a zero-dollar RMA — every other
    // reason code never needs this step.
    if (a.type === 'create_return_label_for_replacement') {
      const siblingIndex = replacementLabelSiblingIndex(a, suggestion.proposedActions)
      const siblingReasonCode = actionInputs[siblingIndex]?.reasonCode
      const siblingRequiresZeroDollarRma = suggestion.proposedActions[siblingIndex]?.inputOptions?.find((opt) => opt.value === siblingReasonCode)?.requiresZeroDollarRma
      if (!siblingRequiresZeroDollarRma) return false
      // The $0 RMA box checked: the label comes from the $0 RMA (2026-10-29).
      if (replacementLabelHeldForZeroDollar(a, suggestion.proposedActions, actionInputs)) return false
    }
    return true
  }

  // A step's card: the Proposed Steps' one step component (2026-10-27: also
  // the Manual Panel's, through stepSlots.js). stepNumber: its number in the
  // list (null in the Manual Panel's window).
  const renderProposedStep = (a, i, stepNumber) => {
    // The paired select_reason_code step, if this action is the
    // one it supplies a reason code for — its own editable
    // input renders at the top of THIS card instead of its own.
    // Bound to actionInputs[pairedReasonCodeIndex] (the field's
    // own original array index) — never shifted/renamed, since
    // action-executor.js and the retry/execute path both read
    // it by that same index regardless of this display change.
    const priorAction = suggestion.proposedActions[i - 1]
    // A step in an Other Actions window (2026-10-29): its own Check /
    // Process on either layout, and no unchecked-step rule there.
    const stepInWindow = Boolean(suggestion?.id && stepSlotFor(conversationId, suggestion.id, i))
    const stepUnchecked = !stepInWindow && isStepUnchecked(i)
    const ownProcess = stepOwnProcessShown({ agentLayout, inWindow: stepInWindow })
    const pairedReasonCode = priorAction?.type === 'select_reason_code' ? priorAction : null
    const pairedReasonCodeIndex = pairedReasonCode ? i - 1 : null
    // The step's own call as View calls shows it (cancel_order_trq's
    // body follows the current reason code and note).
    const stepApiCallNow = () => {
      if (!a.apiCall) return null
      // cancel_order_trq's own apiCall.body is frozen on the
      // AI-inferred reason at proposal time — patch in the
      // CSR's CURRENT selection (2026-09-28) so the preview
      // never shows a stale/overridden reason code.
      // The body has no reasonDescription and its note is
      // "notes" (2026-10-27), as the executor sends it; the
      // notes box's edit shows in it.
      if (a.type === 'cancel_order_trq' && pairedReasonCode) {
        const selectedCode = actionInputs[pairedReasonCodeIndex]
        const effectiveOptions = pairedReasonCode.inputOptions?.length ? pairedReasonCode.inputOptions : (fallbackCancelReasonOptions ?? [])
        const selectedOption = effectiveOptions.find((opt) => opt.value === selectedCode)
        if (selectedCode && selectedOption) {
          const editedNote = actionInputs[i]?.editedNote
          const notes = typeof editedNote === 'string' && editedNote.trim() ? `${editedNote} Processed by {agent name or automation}` : a.apiCall.body?.notes
          return { ...a.apiCall, body: { ...a.apiCall.body, returnReasonCode: selectedCode, notes } }
        }
      }
      return a.apiCall
    }
    // The step's title row (2026-10-26): first on the agent draft
    // panel, above its full-width fields; in place otherwise.
    const titleRow = (
          <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap" useFlexGap data-testid={agentLayout ? 'agent-draft-step-title-row' : undefined}>
            {a.targetSystem && !agentLayout && <Chip size="small" color="primary" variant="outlined" label={a.targetSystem} />}
            {/* The step's checkbox (2026-10-26), in place of its number:
                every step starts checked; an unchecked step is not
                processed. A processed step stays checked. */}
            {agentLayout && !stepInWindow && (
              <StepCheck number={stepNumber} checked={!stepUnchecked}
                onChange={busy || decided || conversationStatus === 'closed' || stepProcessGate(a, stepStates[i]) === 'done' ? null : (v) => onToggleStep(i, v)}
                note={stepDependencyNote(suggestion.proposedActions, i, (k) => shownStepNumbers.get(k) ?? k + 1)} />
            )}
            {/* sales_hold_phone_call_safe_to_call: label is a plain-English
                restatement of the condition box just above (Billing State/
                Zip/local time/Safe-to-Call) — skip it here so that box's
                content isn't duplicated underneath it. */}
            {a.type !== 'sales_hold_phone_call_safe_to_call' && (
              <Typography variant="body2" data-testid={agentLayout ? 'agent-draft-step-title' : undefined} sx={agentLayout ? { fontSize: 13, fontWeight: 600, color: A2.text, ...(stepUnchecked ? { opacity: 0.5 } : {}) } : { flex: 1 }}>{a.label}</Typography>
            )}
            {agentLayout && <SystemChip system={a.targetSystem} testId="agent-draft-step-system" />}
            {/* A pipeline step kept beside the agent's own (2026-10-30,
                agentReplyFollowsSteps.js): no agent equivalent, and it
                never contradicts the agent's reply or steps. */}
            {a.fromPipeline === true && <Chip size="small" variant="outlined" label={FROM_PIPELINE_CHIP} data-testid="step-from-pipeline" sx={{ height: 20, fontSize: 11 }} />}
            {agentLayout && <Box sx={{ flex: 1 }} />}
            {/* The customer's own return label (2026-10-23): the Support
                step is never processed here; its button opens Transfer
                to Support with the step's text as the note. */}
            {supportTransferNote(a) && canTransferToSupport && !decided && (
              <UncheckedGate unchecked={stepUnchecked}>
                <Button size="small" variant="outlined" color="primary" data-testid="support-deduction-transfer"
                  onClick={withAutomationTakeoverGuard(() => { setTransferNoteDraft(supportTransferNote(a)); setTransferModalOpen(true) })}
                  disabled={busy || stepUnchecked} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>
                  Transfer to Support
                </Button>
              </UncheckedGate>
            )}
            {/* A task flow's note with links (2026-10-14; task-flows.js): each
                tracking link with its own copy button. */}
            {a.type === 'task_note' && a.params?.links?.length > 0 && (
              <Stack spacing={0.25} sx={{ flexBasis: '100%' }} data-testid="task-note-links">
                {a.params.links.map((l) => (
                  <Stack key={l.label} direction="row" spacing={0.5} alignItems="center" sx={{ pl: 2, minWidth: 0 }}>
                    <Typography variant="caption" sx={{ fontFamily: 'monospace', flexShrink: 0 }}>{l.label}</Typography>
                    <Link href={l.url} target="_blank" rel="noopener noreferrer" variant="caption" sx={{ fontFamily: 'monospace', wordBreak: 'break-all', minWidth: 0, flex: 1 }}>{l.url}</Link>
                    <CopyButton value={l.url} />
                  </Stack>
                ))}
              </Stack>
            )}
            {/* A task's moved / not-moved choice (2026-10-15): required
                before any step below shows or anything is Sent. */}
            {a.type === 'task_path_choice' && (() => {
              const recorded = taskPathChoiceFrom(suggestion.modelMeta?.apiCalls)
              const refused = taskChoiceError?.index === i && taskChoiceError.kind === 'refused'
              // The controls are TaskPathChoiceControls.jsx's (2026-10-29),
              // shared with the admin agent draft column's stage choice.
              return (
                <TaskPathChoiceControls boxRef={taskChoiceBoxRef} highlighted={refused} outlined={refused && !decided}
                  options={a.params?.options ?? []} value={taskChoice} onChange={(v) => handleTaskPathChoice(i, v)}
                  disabled={busy || decided || conversationStatus === 'closed'}
                  preselected={a.params?.preselected ?? null} showPreselected={!recorded}
                  date={taskChoiceDate} onDateChange={(v) => handleTaskChoiceDate(i, v)} showDate={!decided}
                  dateDisabled={busy || conversationStatus === 'closed'}
                  chosenBy={recorded?.by ?? null}
                  error={!decided && taskChoiceError?.index === i ? taskChoiceError.message : null}
                  sources={a.params?.sources ?? []} />
              )
            })()}
            {/* A task's email response (2026-10-14): loads the template
                into the reply box (with both tracking paths, each its own). */}
            {a.type === 'task_reply_template' && !decided && (
              <Button size="small" variant="outlined" sx={{ fontSize: '0.7rem', py: 0.25, px: 1, flexShrink: 0 }}
                data-testid="task-use-reply" onClick={() => setDraft(draftBoxText(a.params?.text ?? ''))}>
                Use this reply
              </Button>
            )}
            {/* The link to the correct part (2026-10-27): pre-filled when
                find_part found it; the SKU comes from the link (or the SKU
                field), and its warranty fills the reply. */}
            {a.type === PART_LINK_STEP_TYPE && !decided && conversationStatus !== 'closed' && (() => {
              const pl = partLinks[i] ?? {}
              const link = pl.link ?? a.params?.link ?? ''
              const warranty = pl.warranty ?? (pl.filledLink ? null : a.params?.warranty) ?? null
              const commit = (force = false) => {
                const v = String(link ?? '').trim()
                if (!v) return
                if (!force && v === (pl.filledLink ?? a.params?.link ?? '')) return
                // A new link is read on its own; the SKU field's value
                // goes with it only when the person confirms the SKU.
                applyPartLink(i, a, { link: v, sku: force ? (pl.sku ?? '') : '' })
              }
              return (
                <Box sx={{ flexBasis: '100%' }} data-testid="part-link">
                  <Stack direction="row" spacing={1} alignItems="center">
                    <TextField size="small" label={PART_LINK_LABEL} value={link} disabled={busy || pl.busy}
                      onChange={(e) => setPartLinks((p) => ({ ...p, [i]: { ...(p[i] ?? {}), link: e.target.value } }))}
                      onBlur={() => commit()} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); commit() } }}
                      inputProps={{ 'data-testid': 'part-link-input' }} sx={{ flex: 1, minWidth: 0 }} />
                    {pl.needsSku && (
                      <TextField size="small" label="SKU" value={pl.sku ?? ''} disabled={busy || pl.busy}
                        onChange={(e) => setPartLinks((p) => ({ ...p, [i]: { ...(p[i] ?? {}), sku: e.target.value.toUpperCase() } }))}
                        onBlur={() => { if (pl.sku) commit(true) }} onKeyDown={(e) => { if (e.key === 'Enter' && pl.sku) { e.preventDefault(); commit(true) } }}
                        inputProps={{ 'data-testid': 'part-link-sku' }} sx={{ width: 150 }} />
                    )}
                  </Stack>
                  {pl.needsSku && <Typography variant="caption" display="block" color="warning.dark">No SKU in this link: enter the SKU.</Typography>}
                  {warranty && <Typography variant="caption" display="block" color="text.secondary" data-testid="part-link-warranty">Warranty: {warranty}</Typography>}
                </Box>
              )
            })()}
            {/* Park saves the work (2026-10-27): a fact under this
                step changed since the park while the CSR had
                changed its inputs; or the step was processed
                before the park, or left out by their choice. */}
            {/* The step's message signs as someone else (2026-10-30). */}
            {!decided && typeof actionInputs[i]?.editedMessage === 'string' && signatureNameMismatch(actionInputs[i].editedMessage, signatureInfo, agentFirstName) && (
              <Alert severity="warning" sx={{ flexBasis: '100%', py: 0 }} data-testid="step-signature-name-warning"
                action={<Button color="inherit" size="small" onClick={() => fixStepSignature(i)} data-testid="fix-step-signature-name">Fix signature</Button>}>
                {signatureMismatchText(signatureNameMismatch(actionInputs[i].editedMessage, signatureInfo, agentFirstName))}
              </Alert>
            )}
            {!decided && parkStepWarnings[i] && (
              <Typography variant="caption" color="warning.dark" data-testid="park-step-warning" sx={{ flexBasis: '100%', fontWeight: 600 }}>
                {parkStepWarnings[i]}
              </Typography>
            )}
            {/* The regenerated compare asks first (2026-10-28): Process
                waits for its Done. */}
            {!decided && regeneratedBlock && isProcessableStep(a) && stepStates[i]?.status !== 'success' && (
              <Typography variant="caption" color="warning.dark" data-testid="step-regenerated-wait" sx={{ flexBasis: '100%', fontWeight: 600 }}>
                {regeneratedBlock}
              </Typography>
            )}
            {!decided && parkStepNotes[i] && (
              <Typography variant="caption" color="text.secondary" data-testid="park-step-note" sx={{ flexBasis: '100%', fontStyle: 'italic' }}>
                {parkStepNotes[i]}
              </Typography>
            )}
            {/* Send blocks follow the reply (2026-10-27): a step whose
                block the reply lifted says so (its controls stay
                usable); a blocking step offers the manual escape. */}
            {!decided && conversationStatus !== 'closed' && liftedStepReason(i) && (
              <Typography variant="caption" color="text.secondary" data-testid="step-not-needed" sx={{ flexBasis: '100%', fontStyle: 'italic' }}>
                {STEP_NOT_NEEDED_NOTE}
                {liftedStepReason(i) === SKIP_CSR_MARKED_NOT_NEEDED && (
                  <Link component="button" type="button" variant="caption" data-testid="step-not-needed-undo" sx={{ ml: 0.75, verticalAlign: 'baseline' }}
                    onClick={() => { markTouched(); setNotNeededSteps((prev) => prev.filter((k) => k !== i)) }}>Undo</Link>
                )}
              </Typography>
            )}
            {!decided && conversationStatus !== 'closed' && isBlockingStep(i) && (
              <Link component="button" type="button" variant="caption" data-testid="step-mark-not-needed" disabled={busy}
                sx={{ flexBasis: '100%', textAlign: 'left' }}
                onClick={() => { markTouched(); setNotNeededSteps((prev) => (prev.includes(i) ? prev : [...prev, i])) }}>
                {STEP_MARK_NOT_NEEDED_LABEL}
              </Link>
            )}
            {!UI_ONLY_TYPES.has(a.type) && Boolean(a.targetSystem) && (() => {
              const ss = stepStates[i] ?? { status: 'idle' }
              const gate = stepProcessGate(a, ss)
              if (gate === 'done') {
                return <Box sx={{ color: 'success.main', fontWeight: 700, fontSize: '1.1rem', lineHeight: 1, flexShrink: 0 }}>✓</Box>
              }
              if (gate === 'failed') {
                return <Box sx={{ color: 'error.main', fontWeight: 700, fontSize: '1.1rem', lineHeight: 1, flexShrink: 0 }}>✗</Box>
              }
              // A closed conversation must never offer a live Process/Check/
              // Send button for a step that hasn't actually run yet — only the
              // ✓/✗ badges above (real history) still render.
              if (conversationStatus === 'closed') return null
              // The agent draft panel (2026-10-23): the one button
              // processes the steps; a step keeps only its check. A step in
              // an Other Actions window keeps its own Process (2026-10-29).
              if (!ownProcess && a.type !== 'process_return_refund') return null
              // An unchecked step's own control (2026-10-26): shown,
              // disabled, with why.
              if (agentLayout && stepUnchecked) {
                const cs = checkStates[i] ?? { status: 'idle' }
                const label = cs.status !== 'checked' ? 'Check' : (checkIsStale(cs.result?.checkedItems ? cs.result : null, actionInputs[i]) ? 'Check again' : (cs.result?.rateQuotes && actionInputs[i]?.estimateStale ? 'Re-estimate' : null))
                if (!label) return null
                return (
                  <UncheckedGate unchecked>
                    <Button size="small" variant="contained" color="secondary" disabled sx={{ flexShrink: 0 }}>{label}</Button>
                  </UncheckedGate>
                )
              }

              if (a.type === 'process_return_refund') {
                const cs = checkStates[i] ?? { status: 'idle' }
                if (cs.status !== 'checked') {
                  return (
                    <Button
                      size="small" variant="contained" color="secondary" flexshrink={0}
                      disabled={cs.status === 'checking' || !isActionInputSatisfied(a, actionInputs[i])}
                      onClick={() => handleCheckStep(i)}
                      startIcon={cs.status === 'checking' ? <CircularProgress size={14} color="inherit" /> : null}
                      sx={{ flexShrink: 0 }}
                    >
                      {cs.status === 'checking' ? 'Checking…' : 'Check'}
                    </Button>
                  )
                }
                // Items or the reason code edited since the check
                // (2026-10-27): the disposition is stale, and Process
                // waits for Check again.
                if (checkIsStale(cs.result?.checkedItems ? cs.result : null, actionInputs[i])) {
                  return (
                    <Button
                      size="small" variant="contained" color="warning" flexshrink={0}
                      disabled={!isActionInputSatisfied(a, actionInputs[i])}
                      onClick={() => handleCheckStep(i)}
                      sx={{ flexShrink: 0 }}
                      data-testid="return-step-check-again"
                    >
                      Check again
                    </Button>
                  )
                }
                // A package weight edit / add / remove since the
                // last (re-)estimate invalidates it — Process is
                // disabled, not merely warned, until a fresh
                // Check re-quotes the current package set.
                // Only applies when a rate-quote flow exists at
                // all (cs.result.rateQuotes) — the company-pays
                // path has no estimate to go stale.
                if (cs.result?.rateQuotes && actionInputs[i]?.estimateStale) {
                  return (
                    <Button
                      size="small" variant="contained" color="warning" flexshrink={0}
                      disabled={cs.status === 'checking'}
                      onClick={() => handleCheckStep(i)}
                      startIcon={cs.status === 'checking' ? <CircularProgress size={14} color="inherit" /> : null}
                      sx={{ flexShrink: 0 }}
                    >
                      {cs.status === 'checking' ? 'Re-estimating…' : 'Re-estimate'}
                    </Button>
                  )
                }
                // Whether this Process click will actually create a return
                // shipping label (feature/website-rma-label-email-step1) —
                // mirrors action-executor.js's own shipsOwnLabel condition
                // exactly, so Process is only gated on a "Send label to"
                // address when the server will actually use one.
                const hasExistingReturn = a.params?.hasExistingReturn
                const isEbayDisposition = isEbayChannel || isEbayClientEmail
                const isWebsiteRmaRoute = !hasExistingReturn && cs.result?.disposition && !isEbayDisposition
                const shipsOwnLabel = Boolean(cs.result?.rateQuotes) && (actionInputs[i]?.shippingPaymentOption ?? 'customerCost') === 'customerShipsOwn'
                const willCreateLabel = isWebsiteRmaRoute && !shipsOwnLabel
                const emailValid = !willCreateLabel || isSingleValidEmail(actionInputs[i]?.email ?? a.params?.shipTo?.emailAddress)
                if (!ownProcess) return null
                return (
                  <Button
                    size="small" variant="contained" flexshrink={0}
                    disabled={ss.status === 'processing' || Boolean(regeneratedBlock) || !emailValid}
                    onClick={withAutomationTakeoverGuard(() => handleProcessStep(i))}
                    startIcon={ss.status === 'processing' ? <CircularProgress size={14} color="inherit" /> : null}
                    sx={{ flexShrink: 0 }}
                  >
                    {ss.status === 'processing' ? 'Processing…' : 'Process'}
                  </Button>
                )
              }

              if (a.type === 'create_return_label_for_replacement') {
                // Needs only the replacement id, so it is ready as
                // soon as the replacement exists, with or without
                // its ERP order number.
                const siblingIndex = replacementLabelSiblingIndex(a, suggestion.proposedActions)
                const siblingSucceeded = replacementLabelSiblingReady(stepStates, siblingIndex)
                return (
                  <Button
                    size="small" variant="contained" flexshrink={0}
                    disabled={ss.status === 'processing' || Boolean(regeneratedBlock) || !siblingSucceeded || replacementLabelNotRequested(a, i, suggestion.proposedActions, actionInputs)}
                    onClick={withAutomationTakeoverGuard(() => handleProcessStep(i))}
                    startIcon={ss.status === 'processing' ? <CircularProgress size={14} color="inherit" /> : null}
                    sx={{ flexShrink: 0 }}
                  >
                    {ss.status === 'processing' ? 'Processing…' : 'Process'}
                  </Button>
                )
              }

              if (a.type === 'resend_return_label_send_message' && resendLabelCreateSiblingIndex(a, suggestion.proposedActions) !== null) {
                // eBay B-create: the label (and its link) only
                // exists once the sibling create step succeeds.
                const siblingIndex = resendLabelCreateSiblingIndex(a, suggestion.proposedActions)
                const siblingSucceeded = stepStates[siblingIndex]?.status === 'success'
                return (
                  <Button
                    size="small" variant="contained" flexshrink={0}
                    disabled={ss.status === 'processing' || Boolean(regeneratedBlock) || !siblingSucceeded}
                    onClick={withAutomationTakeoverGuard(() => handleProcessStep(i))}
                    startIcon={ss.status === 'processing' ? <CircularProgress size={14} color="inherit" /> : null}
                    title={!siblingSucceeded ? 'Create the return shipping label first' : undefined}
                    sx={{ flexShrink: 0 }}
                  >
                    {ss.status === 'processing' ? 'Processing…' : 'Process'}
                  </Button>
                )
              }

              if (a.type === 'automated_return_notice_send_message') {
                // Gated only when the sibling label step is
                // actually CREATING a brand-new label (no
                // known trackingNumber at proposal time) — see
                // suggestionActionInputs.js's
                // automatedReturnNoticeLabelSiblingIndex(). The
                // "resend an existing label" case has no
                // sibling dependency (siblingIndex is null) and
                // falls through to the ungated default below.
                const siblingIndex = automatedReturnNoticeLabelSiblingIndex(a, suggestion.proposedActions)
                const siblingSucceeded = siblingIndex === null || stepStates[siblingIndex]?.status === 'success'
                return (
                  <Button
                    size="small" variant="contained" flexshrink={0}
                    disabled={ss.status === 'processing' || Boolean(regeneratedBlock) || !siblingSucceeded}
                    onClick={withAutomationTakeoverGuard(() => handleProcessStep(i))}
                    startIcon={ss.status === 'processing' ? <CircularProgress size={14} color="inherit" /> : null}
                    title={!siblingSucceeded ? 'Create the return shipping label first' : undefined}
                    sx={{ flexShrink: 0 }}
                  >
                    {ss.status === 'processing' ? 'Processing…' : 'Process'}
                  </Button>
                )
              }

              if (waitsOnOverdueRefund(a)) {
                // Return Status's overdue refund (2026-10-29): the email to
                // Support and the note wait on the refund step.
                const refundIdx = overdueRefundStepIndex(suggestion.proposedActions)
                const refundDone = refundIdx >= 0 && stepStates[refundIdx]?.status === 'success'
                return (
                  <Button
                    size="small" variant="contained" flexshrink={0}
                    disabled={ss.status === 'processing' || Boolean(regeneratedBlock) || !refundDone}
                    onClick={withAutomationTakeoverGuard(() => handleProcessStep(i))}
                    startIcon={ss.status === 'processing' ? <CircularProgress size={14} color="inherit" /> : null}
                    title={!refundDone ? 'Process the refund first' : undefined}
                    data-testid={a.type === OVERDUE_EMAIL_STEP ? 'overdue-email-process' : undefined}
                    sx={{ flexShrink: 0 }}
                  >
                    {ss.status === 'processing' ? 'Processing…' : (gate === 'retry' ? 'Send again' : 'Process')}
                  </Button>
                )
              }

              if (a.type === 'issue_ebay_return_refund_add_note') {
                // Gated on the sibling issue_ebay_return_refund
                // step actually succeeding — its own outcome
                // (full/partial, amount) is what this note
                // describes, and doesn't exist until then. See
                // suggestionActionInputs.js's
                // issueEbayReturnRefundNoteSiblingIndex().
                const siblingIndex = issueEbayReturnRefundNoteSiblingIndex(a, suggestion.proposedActions)
                const siblingSucceeded = siblingIndex === null || stepStates[siblingIndex]?.status === 'success'
                return (
                  <Button
                    size="small" variant="contained" flexshrink={0}
                    disabled={ss.status === 'processing' || Boolean(regeneratedBlock) || !siblingSucceeded}
                    onClick={withAutomationTakeoverGuard(() => handleProcessStep(i))}
                    startIcon={ss.status === 'processing' ? <CircularProgress size={14} color="inherit" /> : null}
                    title={!siblingSucceeded ? 'Issue the refund first' : undefined}
                    sx={{ flexShrink: 0 }}
                  >
                    {ss.status === 'processing' ? 'Processing…' : 'Process'}
                  </Button>
                )
              }

              if (a.type === 'offer_partial_refund_ebay') {
                return (
                  <Button
                    size="small" variant="contained" flexshrink={0}
                    disabled={ss.status === 'processing' || Boolean(regeneratedBlock) || !isActionInputSatisfied(a, actionInputs[i])}
                    onClick={withAutomationTakeoverGuard(() => handleProcessStep(i))}
                    startIcon={ss.status === 'processing' ? <CircularProgress size={14} color="inherit" /> : null}
                    sx={{ flexShrink: 0 }}
                  >
                    {ss.status === 'processing' ? 'Submitting…' : 'Submit Refund Offer'}
                  </Button>
                )
              }

              return (
                <Button
                  size="small" variant="contained" flexshrink={0}
                  disabled={ss.status === 'processing' || Boolean(regeneratedBlock) || !isActionInputSatisfied(a, actionInputs[i])}
                  onClick={withAutomationTakeoverGuard(() => handleProcessStep(i))}
                  startIcon={ss.status === 'processing' ? <CircularProgress size={14} color="inherit" /> : null}
                  sx={{ flexShrink: 0 }}
                >
                  {ss.status === 'processing' ? 'Processing…' : 'Process'}
                </Button>
              )
            })()}
            {/* View calls (2026-10-27): one small link at the end of the
                title row, "View call" or "View calls (N)", in both
                layouts; its modal lists the step's own call, its
                branches and its planned steps. Admin only, as before. */}
            {isAdmin && (
              <ViewCalls title={a.label} testId={agentLayout ? 'agent-draft-step-view-call' : 'step-view-call'} calls={[
                ...(a.apiCall ? [{ label: (a.branches?.length || a.plannedSteps?.length) ? (a.apiCall.label ?? a.label ?? 'step') : null, call: stepApiCallNow() }] : []),
                ...(a.branches ?? []).map((br) => ({ label: br.pathLabel ?? 'branch', call: br.apiCall })),
                ...(a.plannedSteps ?? []).map((st) => ({ label: st.pathLabel ?? 'step', call: st.apiCall })),
              ]} />
            )}
          </Stack>
    )
    return (
    <Box key={i}>
      <Paper variant="outlined" data-testid={agentLayout ? 'agent-draft-step' : undefined} sx={agentLayout
        // The A2 step row (2026-10-23): no card. Since 2026-10-26
        // the title row (checkbox, number, title, system chip,
        // View call) comes first and the fields take the card's
        // full width under it.
        ? { border: 0, bgcolor: 'transparent', p: 0, display: 'flex', flexDirection: 'column', fontSize: 13 }
        : { px: 0.75, py: 0.5, display: 'flex', gap: 0.5, alignItems: 'flex-start', ...(a.requiresInput ? { borderColor: 'warning.main', borderWidth: 2 } : {}) }}>
        {!agentLayout && <Box sx={{
          minWidth: 22, height: 22, borderRadius: '50%',
          bgcolor: a.requiresInput ? 'warning.main' : 'primary.main',
          color: a.requiresInput ? 'warning.contrastText' : 'primary.contrastText',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '0.7rem', fontWeight: 700, flexShrink: 0, mt: 0.1,
        }}>
          {stepNumber}
        </Box>}
        <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
          {/* Replacement or refund on the step (2026-10-27): the
              out-of-stock warning and the switch, at the top of the path's
              first step. */}
          {/* The delivery estimate's no-date text joins the out-of-stock
              warning (2026-11-02, replacementEdd.js): one warning. */}
          {agentLayout && resView && resView.headIndex === i && (
            <ResolutionBar view={{ ...resView, stockLines: stockLinesWithEdd(resView.stockLines, eddStepView(a, eddStates[i])).lines }} onChoose={handleResolutionChoice} disabled={resolutionDisabled} />
          )}
          {agentLayout && !resView && stockWarningLines(a).length > 0 && (
            <ResolutionBar view={{ path: 'replacement', headPath: 'replacement', options: [], toggle: false, stockLines: stockLinesWithEdd(stockWarningLines(a), eddStepView(a, eddStates[i])).lines, note: a.params?.resolutionNote ?? null }} />
          )}
          {agentLayout && titleRow}
          <StepFieldsWrap on={agentLayout} unchecked={stepUnchecked}>
          {pairedReasonCode && !decided && !pairedReasonCode.itemSelection && getEditableMessageDefault(pairedReasonCode) === null && (
            <TextField
              select
              size="small"
              label={pairedReasonCode.inputLabel ?? 'Required input'}
              value={actionInputs[pairedReasonCodeIndex] ?? ''}
              onChange={(ev) => setActionInputs((prev) => ({ ...prev, [pairedReasonCodeIndex]: ev.target.value }))}
              required
              error={!actionInputs[pairedReasonCodeIndex]}
              helperText={!actionInputs[pairedReasonCodeIndex] ? 'Required before approving' : ''}
              sx={{ minWidth: 240 }}
            >
              {/* pairedReasonCode.inputOptions is empty for a suggestion
                  persisted before the live cancel-reason catalog shipped
                  (2026-09-28) — fallbackCancelReasonOptions fills in from
                  a live client-side fetch in that case (see this
                  component's own useEffect). */}
              {(pairedReasonCode.inputOptions?.length ? pairedReasonCode.inputOptions : (fallbackCancelReasonOptions ?? [])).map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
              ))}
            </TextField>
          )}
          {a.type === 'address_confirmation_remove_hold' && a.params?.holdReason && (
            <Typography variant="body2" sx={{ fontWeight: 700, bgcolor: 'action.hover', px: 1, py: 0.5, borderRadius: 1 }}>
              Hold reason: {a.params.holdReason}
            </Typography>
          )}
          {a.type === 'sales_hold_phone_call_safe_to_call' && (
            <Stack spacing={0.25} sx={{ bgcolor: 'action.hover', px: 1, py: 0.5, borderRadius: 1 }}>
              <Typography variant="body2">Billing State: {a.params?.billingRegion ?? 'unknown'} &nbsp;·&nbsp; Billing Zip: {a.params?.billingPostalCode ?? 'unknown'}</Typography>
              {a.params?.timezone && (
                <Typography variant="body2">Customer local time: {a.params.localTime} {a.params.dayOfWeek} ({a.params.timezone})</Typography>
              )}
              <Typography variant="body2" data-testid="call-time-status" data-status={callTimeDisplay(a.params).status} sx={{ fontWeight: 700, color: callTimeDisplay(a.params).color }}>
                {callTimeDisplay(a.params).text}
              </Typography>
            </Stack>
          )}
          {!agentLayout && titleRow}
          {/* sales_hold_phone_call_safe_to_call: rationale is also a
              restatement of the same condition box (see the label skip
              above) — the box already conveys everything needed. */}
          {a.type !== 'sales_hold_phone_call_safe_to_call' && <RationaleText rationale={a.rationale} />}
          {/* A $0 RMA replacement's own label step is optional (2026-10-30):
              unchecked until a person checks it. */}
          {replacementLabelStepOptional(a, suggestion.proposedActions, actionInputs) && (
            <ReplacementLabelOptional
              checked={actionInputs[i]?.replacementLabel === true}
              readOnly={stepStates[i]?.status === 'success' || stepStates[i]?.status === 'processing'}
              onChange={(checked) => setActionInputs((prev) => ({ ...prev, [i]: withReplacementLabelChoice(prev[i], checked, { by: viewerUsername ?? null }) }))}
            />
          )}
          {/* The eBay return's state before Process (2026-10-29): what eBay
              shows and what Process will do (approve, or skip the approve
              eBay already made, or stop). Hidden once the step ran. */}
          {ebayReturnStateLine(a) && (stepStates[i]?.status ?? 'idle') !== 'success' && (
            <Typography variant="body2" data-testid="ebay-return-state-line" sx={{ fontWeight: 600 }}>{ebayReturnStateLine(a)}</Typography>
          )}
          {/* A shipped order's eBay cancel reject sends eBay the order's
              tracking number and ship date (2026-10-28,
              docs/decisions/2026-10-28-ebay-cancel-reject-reason.md): its
              own line, so it reads as a step of what Process does. */}
          {a.type === 'reject_ebay_cancellation' && ebayCancelRejectTrackingLine(a.params ?? {}) && (
            <Typography variant="body2" data-testid="reject-then-line" sx={{ fontWeight: 600 }}>{ebayCancelRejectTrackingLine(a.params ?? {})}</Typography>
          )}
          {a.branches?.length > 0 && (
            <Stack spacing={0.25} sx={{ mt: 0.25 }}>
              {a.branches.map((br, bi) => (
                <Stack key={bi} direction="row" spacing={0.75} alignItems="center">
                  <Typography variant="caption" color="text.secondary" sx={{ flex: 1 }}>{br.pathLabel}</Typography>
                </Stack>
              ))}
            </Stack>
          )}
          {/* Unlike a.branches (mutually-exclusive alternatives), plannedSteps is
              a sequence — every entry runs, in order, when this action is processed. */}
          {a.plannedSteps?.length > 0 && (
            <Stack spacing={0.25} sx={{ mt: 0.25 }}>
              {a.plannedSteps.map((step, si) => (
                <Stack key={si} spacing={0.25}>
                  <Stack direction="row" spacing={0.75} alignItems="center">
                    <Typography variant="caption" color="text.secondary" sx={{ flex: 1 }}>{si + 1}. {step.pathLabel}</Typography>
                  </Stack>
                  {/* Surfaced directly on the step (not just inside the draft
                      reply text) so a CSR can still copy the label URL even if
                      they accidentally delete it while editing the draft. */}
                  {step.url && (
                    <Stack direction="row" spacing={0.25} alignItems="center" sx={{ pl: 2, minWidth: 0 }}>
                      <Link href={step.url} target="_blank" rel="noopener noreferrer" variant="caption" sx={{ fontFamily: 'monospace', wordBreak: 'break-all', minWidth: 0, flex: 1 }}>
                        {step.url}
                      </Link>
                      <CopyButton value={step.url} />
                    </Stack>
                  )}
                </Stack>
              ))}
            </Stack>
          )}
          {/* Gated on the STEP TYPE itself (getEditableMessageDefault(a) !== null),
              not the conversation's channel/fromEbay — every type it recognizes
              (send_ebay_member_message, automated_return_notice_send_message,
              resend_return_label_send_message, sales_hold_send_ebay_message,
              inr_send_message, inr_issue_refund, inr_provide_shipment_info) is
              structurally reachable only on a genuine eBay order/message to begin
              with (2026-09-28) — a buyer-initiated eBay thread (fromEbay false,
              channel 'ebay') proposing inr_send_message/inr_issue_refund/
              inr_provide_shipment_info used to render no box at all under the old
              channel-based gate. */}
          {!decided && (
            getEditableMessageDefault(a) !== null
          ) && (() => {
            // Sent directly to the eBay case/inquiry (Post-Order's
            // send_message), not the standard buyer-seller Message API reply
            // box — labeled distinctly so it never reads as an ordinary
            // buyer message, even though it's the same editable-message
            // pattern as every other case here.
            const isManualInrReply = a.type === 'inr_request_id_process' && !a.params?.disposition
            // eBay-only — see draftRestrictedWarning's own comment above.
            const restrictedWarning = isEbayChannel ? restrictedInfoWarning(actionInputs[i]?.editedMessage) : null
            const placeholderWarning = unfilledPlaceholderWarning(actionInputs[i]?.editedMessage)
            return (
              <>
                <Stack direction="row" spacing={0.5} alignItems="flex-start" sx={{ mt: 0.5 }}>
                  <ExpandableTextField
                    isCustomerReply
                    size="small"
                    label={isManualInrReply ? 'Reply to eBay case — sent directly to the case, not the standard buyer message' : 'Message to buyer (editable)'}
                    color={isManualInrReply ? 'warning' : undefined}
                    value={actionInputs[i]?.editedMessage ?? ''}
                    {...cursorTrackingProps(i)}
                    onChange={(ev) => setActionInputs((prev) => ({ ...prev, [i]: withEbayRefundNote(a, prev[i] ?? {}, { editedMessage: ev.target.value }) }))}
                    disabled={stepStates[i]?.status === 'processing'}
                    multiline
                    minRows={4}
                    fullWidth
                    sx={isManualInrReply ? {
                      '& .MuiInputLabel-root': { color: 'warning.main' },
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: 'warning.main' },
                    } : undefined}
                  />
                  <Button size="small" variant="outlined" color="secondary"
                    onClick={() => openTemplateDialog(i)}
                    disabled={stepStates[i]?.status === 'processing'}
                    sx={{ flexShrink: 0, mt: 0.5 }}>
                    Templates
                  </Button>
                </Stack>
                {restrictedWarning && (
                  <Alert severity="error" sx={{ mt: 1 }}>{restrictedWarning}</Alert>
                )}
                {placeholderWarning && (
                  <Alert severity="warning" sx={{ mt: 1 }}>{placeholderWarning}</Alert>
                )}
              </>
            )
          })()}
          {(() => {
            // process_return_refund has no single default note at
            // proposal time (it depends on the live disposition
            // check) — only show the box once "Check if scrap"
            // has succeeded and the result actually carries a
            // note-bearing planned step (the Gen Instructions
            // path makes no TRQ write at all, so it never gets one).
            // Reads off the last-known result rather than
            // status === 'checked' alone, so a re-check (a
            // plain one, or the disposition-override toggle)
            // doesn't make the box flicker out and back in for
            // the "checking" window — handleCheckStep keeps
            // the previous result in place until the new one
            // lands.
            const noteDefault = a.type === 'process_return_refund'
              ? (checkStates[i]?.result ? noteFromPlannedSteps(checkStates[i].result.plannedSteps) : null)
              : getEditableNoteDefault(a)
            if (noteDefault === null || decided) return null
            return (
              <ExpandableTextField
                size="small"
                label="Order note (editable)"
                value={actionInputs[i]?.editedNote ?? ''}
                onChange={(ev) => setActionInputs((prev) => ({ ...prev, [i]: { ...(prev[i] ?? {}), editedNote: ev.target.value } }))}
                disabled={stepStates[i]?.status === 'processing'}
                multiline
                minRows={3}
                fullWidth
                containerSx={{ mt: 0.5 }}
                inputProps={{ style: { resize: 'vertical', overflow: 'auto', fontSize: '0.875rem' } }}
              />
            )
          })()}
          {(() => {
            // Address-carrying "update shipping address" proposed steps —
            // see suggestionActionInputs.js's getEditableAddressDefault()
            // for the three field-shape families these six action types
            // fall into. Hidden once decided, same as the note box above.
            const addressDefault = getEditableAddressDefault(a)
            if (addressDefault === null || decided) return null
            const fields = a.type === 'sales_hold_address_too_long'
              ? [['newAddress1', 'Address 1'], ['newAddress2', 'Address 2']]
              : a.type === 'sales_hold_need_physical_address_apply'
                ? [['physicalAddress1', 'Address 1'], ['physicalAddress2', 'Address 2']]
                : a.type === 'address_confirmation_update_address'
                  ? [['shippingName', 'Name'], ['shippingAddress1', 'Address 1'], ['shippingAddress2', 'Address 2'], ['shippingCity', 'City'], ['shippingRegion', 'State'], ['shippingPostalCode', 'ZIP']]
                  : [['shippingAddress1', 'Address 1'], ['shippingAddress2', 'Address 2'], ['shippingCity', 'City'], ['shippingRegion', 'State'], ['shippingPostalCode', 'ZIP']]
            const current = actionInputs[i]?.editedAddress ?? addressDefault
            // An ambiguous address (2026-10-27): pick one of
            // Smarty's candidates or the address on file;
            // nothing is filled in until a pick.
            const candidates = a.params?.candidates ?? []
            return (
              <>
              {candidates.length > 0 && (
                <Box sx={{ flexBasis: '100%', mt: 0.5 }} data-testid="address-candidate-picker">
                  <Typography variant="caption" color="text.secondary" display="block">Which address does the customer mean? Pick one; nothing is filled in until you do.</Typography>
                  <RadioGroup value={actionInputs[i]?.candidateIndex != null ? String(actionInputs[i].candidateIndex) : ''}
                    onChange={(e) => setActionInputs((prev) => applyAddressCandidatePick(suggestion.proposedActions, prev, i, Number(e.target.value)))}>
                    {candidates.map((c, k) => (
                      <FormControlLabel key={k} value={String(k)} disabled={stepStates[i]?.status === 'processing'}
                        control={<Radio size="small" inputProps={{ 'data-testid': `address-candidate-${k}` }} />}
                        label={<Typography variant="body2">{addressCandidateLabel(c)}</Typography>} />
                    ))}
                  </RadioGroup>
                </Box>
              )}
              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 0.5 }}>
                {fields.map(([field, label]) => (
                  <TextField
                    key={field}
                    size="small"
                    label={label}
                    value={current[field] ?? ''}
                    onChange={(ev) => setActionInputs((prev) => ({
                      ...prev,
                      [i]: { ...(prev[i] ?? {}), editedAddress: { ...(prev[i]?.editedAddress ?? addressDefault), [field]: ev.target.value } },
                    }))}
                    disabled={stepStates[i]?.status === 'processing'}
                    InputLabelProps={{ sx: { fontSize: 13 }, shrink: true }}
                    inputProps={{ style: { fontSize: 13 } }}
                    sx={{ flex: 1, minWidth: 140, '& .MuiOutlinedInput-input': { py: 0.25, px: 0.5 } }}
                  />
                ))}
              </Stack>
              </>
            )
          })()}
          {a.requiresInput && !decided && a.type === 'send_return_label_email' && (
            // LEGACY (feature/website-rma-label-email-step1) —
            // only reachable for a suggestion that already had
            // this step appended before that feature shipped;
            // process_return_refund's own Website RMA route now
            // shows these same fields itself (below, in its own
            // blue Disposition section). Same bespoke-field
            // convention as editedAddress/editedNote above
            // rather than the generic single-value requiresInput
            // mechanism, which doesn't fit a field that needs
            // its own default.
            <LabelEmailFields
              i={i}
              actionInputs={actionInputs}
              setActionInputs={setActionInputs}
              defaultEmail={a.params?.defaultEmail}
              ccCompany={a.params?.company}
              disabled={stepStates[i]?.status === 'processing'}
            />
          )}
          {a.requiresInput && !decided && a.type === 'resend_return_label' && (
            // Website B-recover (resend the existing label) and
            // B-create (create a new one) both need the "Send
            // label to"/cc fields — the SAME shared
            // LabelEmailFields component the Website RMA path's
            // own Step 1 uses (feature/website-rma-label-email-
            // step1), reused here rather than duplicated
            // (feature/website-resend-label-decision). Only
            // B-create additionally needs weight/packages — no
            // rate quotes/who-pays here at all, this only
            // creates a label, never an RMA with a refund.
            <>
              <LabelEmailFields
                i={i}
                actionInputs={actionInputs}
                setActionInputs={setActionInputs}
                defaultEmail={labelSendToDefault(a)}
                ccCompany={a.params?.company}
                disabled={stepStates[i]?.status === 'processing'}
              />
              {a.params?.sendToWarning && !(actionInputs[i]?.email ?? '').trim() && (
                <Typography variant="caption" color="warning.main" display="block" sx={{ mt: 0.5 }}>{a.params.sendToWarning}</Typography>
              )}
              {a.params?.sendToNote && (
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }} data-testid="label-send-to-note">{a.params.sendToNote}</Typography>
              )}
              {a.params?.flow === 'B-create' && (
                <Box sx={{ mt: 1 }}>
                  <Typography variant="caption" fontWeight={600} display="block" sx={{ mb: 0.5 }}>Packages</Typography>
                  <PackagesEditor
                    packages={actionInputs[i]?.packages ?? (a.params?.labelCreateData?.packages?.length ? defaultLabelPackages(a) : (a.params?.packages ?? defaultLabelPackages(a)))}
                    onChange={(next) => setActionInputs((prev) => ({ ...prev, [i]: { ...(prev[i] ?? {}), packages: next } }))}
                    disabled={stepStates[i]?.status === 'processing'}
                  />
                  {a.params?.weightNote && (
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }} data-testid="label-weight-note">{a.params.weightNote}</Typography>
                  )}
                </Box>
              )}
            </>
          )}
          {!decided && showsLabelPackagesEditor(a) && (
            // One label per box (2026-10-27): a row per box,
            // preselected from the boxes the items went out in;
            // Process creates exactly these packages.
            <Box sx={{ mt: 1 }}>
              <Typography variant="caption" fontWeight={600} display="block" sx={{ mb: 0.5 }}>Packages (one label per box)</Typography>
              <PackagesEditor
                packages={actionInputs[i]?.packages ?? defaultLabelPackages(a)}
                onChange={(next) => setActionInputs((prev) => ({ ...prev, [i]: { ...(prev[i] ?? {}), packages: next } }))}
                disabled={stepStates[i]?.status === 'processing'}
              />
              {a.params?.weightNote && (
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>{a.params.weightNote}</Typography>
              )}
            </Box>
          )}
          {a.params?.escalationWarning && !decided && (
            // A return eBay escalated to a case (2026-10-28,
            // step-builders.js's escalatedReturnWarning()): still refunded
            // on the return; if eBay refuses it, refund it on the case in
            // Seller Hub.
            <Alert severity="warning" sx={{ mt: 0.5 }} data-testid="refund-escalation-warning">
              <LinkedCaseText text={a.params.escalationWarning} caseId={a.params.escalatedCaseId} kind="escalated_return" testId="refund-escalation-case-link" />
            </Alert>
          )}
          {a.params?.ebayRefundRoute && !decided && (
            // The eBay refund route (2026-10-29, step-builders.js's
            // ebayRefundRouteNote()): which way this refund goes, before
            // Process, the id linked like the contact card's.
            <EbayRefundRouteNote route={a.params.ebayRefundRoute} />
          )}
          {isOverdueRefundStep(a) && !decided && (
            // Return Status's overdue refund (2026-10-29, overdueRefund.js):
            // why the step is there, and its amount (editable).
            <OverdueRefundInfo step={a} input={actionInputs[i]} live={overdueLive} disabled={stepStates[i]?.status === 'success' || stepStates[i]?.status === 'processing'}
              onAmount={(v) => setActionInputs((prev) => ({ ...prev, [i]: { ...(prev[i] ?? {}), refundAmount: v } }))} />
          )}
          {a.type === OVERDUE_EMAIL_STEP && (
            // The email to Support to zero out the RMA (2026-10-29): the
            // email it will send, editable until it is sent.
            <OverdueSupportEmail step={a} input={actionInputs[i]} live={overdueLive} disabled={decided || stepStates[i]?.status === 'success' || stepStates[i]?.status === 'processing'}
              onChange={(patch) => setActionInputs((prev) => ({ ...prev, [i]: { ...(prev[i] ?? {}), ...patch } }))} />
          )}
          {isOverdueNoteStep(a) && !decided && stepStates[i]?.status !== 'success' && (
            <Typography variant="caption" color="text.secondary" display="block" data-testid="overdue-note-hint">{OVERDUE_TOKENS_HINT} The Support sentence follows whether the email was sent.</Typography>
          )}
          {a.type === 'advise_manual_review' && a.params?.caseId && a.params?.caseRefundNote && !a.params?.ebayRefundRoute && (
            // The open-case advice step (2026-10-28): the case number links
            // to the case on eBay, where the refund is made.
            <Typography variant="caption" display="block" sx={{ mt: 0.5 }} data-testid="refund-case-advice-link">
              eBay case: <EbayCaseLink caseId={a.params.caseId} kind={a.params.caseKind ?? 'casemanagement'} testId="refund-case-link" />
            </Typography>
          )}
          {(a.requiresInput || takesEbayRefundDefaultNote(a)) && !decided && (a.type === 'issue_ebay_return_refund' || a.type === 'create_ebay_refund') && (
            // The numbered-Proposed-Step counterpart of
            // RefundModal.jsx's own Full/Partial refund modal —
            // same fields (Full/Partial toggle, an editable
            // comment defaulting per refundType, and a $-clamped
            // amount field for Partial only), just inline in the
            // Proposed Steps list instead of a separate modal.
            // See actions.js's automatedReturnNoticeRefundOnlyActions().
            (() => {
              const value = actionInputs[i] ?? {}
              const orderTotal = a.params?.orderTotal ?? 0
              // The order note in this step follows the refund (2026-10-29,
              // withEbayRefundNote()): a typed note is kept.
              const setValue = (patch) => setActionInputs((prev) => ({ ...prev, [i]: withEbayRefundNote(a, prev[i] ?? {}, patch) }))
              return (
                <Stack spacing={1} sx={{ mt: 0.5 }}>
                  <ToggleButtonGroup
                    value={value.refundType ?? null}
                    exclusive
                    size="small"
                    onChange={(_ev, v) => {
                      if (!v) return
                      setValue({
                        refundType: v,
                        comment: v === 'full' ? FULL_REFUND_COMMENT : PARTIAL_REFUND_COMMENT,
                        ...(v !== 'partial' ? { amount: '' } : {}),
                      })
                    }}
                    disabled={stepStates[i]?.status === 'processing'}
                  >
                    <ToggleButton value="full">Full Refund</ToggleButton>
                    <ToggleButton value="partial">Partial Refund</ToggleButton>
                  </ToggleButtonGroup>
                  {value.refundType && (
                    <ExpandableTextField
                      size="small" label="Refund Comment" multiline minRows={2} fullWidth
                      value={value.comment ?? ''}
                      onChange={(ev) => setValue({ comment: ev.target.value })}
                      disabled={stepStates[i]?.status === 'processing'}
                    />
                  )}
                  {value.refundType === 'partial' && (
                    <TextField
                      size="small" label="Refund Amount" type="number" value={value.amount ?? ''}
                      onChange={(ev) => setValue({ amount: String(Math.max(0, Math.min(orderTotal, Number(ev.target.value) || 0))) })}
                      disabled={stepStates[i]?.status === 'processing'}
                      InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                    />
                  )}
                </Stack>
              )
            })()
          )}
          {a.requiresInput && !decided && a.itemSelection && (
            <Stack spacing={1} sx={{ mt: 0.5 }}>
              {!a.hideReasonCode && (
                <FormControl size="small" fullWidth error={!actionInputs[i]?.reasonCode}>
                  <Select
                    SelectDisplayProps={{ 'aria-label': a.inputLabel ?? 'Return reason code' }}
                    displayEmpty
                    value={actionInputs[i]?.reasonCode ?? ''}
                    sx={{ fontSize: 13, color: 'text.secondary', '& .MuiSelect-select': { py: 0.5 } }}
                    onChange={(ev) => {
                      // A new code clears the optional $0 RMA label step
                      // (off again, 2026-10-30), and a label sentence it
                      // had put in the reply comes out.
                      const wasOn = Boolean(zeroDollarOption(a.inputOptions, actionInputs[i]?.reasonCode)) && zeroDollarLabelChecked(actionInputs[i])
                      setActionInputs((prev) => ({ ...prev, [i]: { ...withoutZeroDollarChoice(prev[i] ?? { items: [] }), reasonCode: ev.target.value } }))
                      if (wasOn) setDraft((prev) => draftWithZeroDollarChoice(prev, { zeroDollar: false, checked: false, channelKind: labelChannelKind }))
                      setCheckStates((prev) => keepCheckWhenStale(a, prev, i))
                    }}
                  >
                    {(a.inputOptions ?? []).map((opt) => (
                      <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              {/* The $0 RMA (2026-10-29): the banner and the optional
                  label step (unchecked by default, 2026-10-30), from the
                  catalog's flag. */}
              {zeroDollarOption(a.inputOptions, actionInputs[i]?.reasonCode) && (
                <ZeroDollarRmaBanner
                  code={actionInputs[i]?.reasonCode}
                  what={a.type === 'process_replacement' ? 'replacement' : 'refund'}
                  typical={zeroDollarTypical}
                  checked={zeroDollarLabelChecked(actionInputs[i])}
                  readOnly={stepStates[i]?.status === 'success' || stepStates[i]?.status === 'processing'}
                  onChange={(checked) => {
                    setActionInputs((prev) => ({ ...prev, [i]: withZeroDollarLabelChoice(prev[i], checked, { by: viewerUsername ?? null }) }))
                    setDraft((prev) => draftWithZeroDollarChoice(prev, { zeroDollar: true, checked, channelKind: labelChannelKind }))
                  }}
                />
              )}
              <TableContainer sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}>
                <Table size="small" sx={{ '& .MuiTableCell-root': { px: 0.5, py: 0.25 } }}>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox" />
                      <TableCell sx={{ fontSize: '0.75rem', fontWeight: 700 }}>SKU</TableCell>
                      <TableCell sx={{ fontSize: '0.75rem', fontWeight: 700 }}>Description</TableCell>
                      <TableCell sx={{ fontSize: '0.75rem', fontWeight: 700 }}>Brand</TableCell>
                      {a.type === 'offer_partial_refund_ebay' && <TableCell align="right" sx={{ fontSize: '0.75rem', fontWeight: 700 }}>Price</TableCell>}
                      <TableCell align="right" sx={{ fontSize: '0.75rem', fontWeight: 700 }}>Qty</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groupItemsForTable(a.itemSelection.allItems).map((it, ri) => {
                      const selection = actionInputs[i]?.items ?? []
                      const entry = selection.find((x) => x.sku === it.sku)
                      const checked = Boolean(entry)
                      const description = it.description ?? '—'
                      const truncatedDescription = description.length > 30 ? `${description.slice(0, 30)}…` : description
                      return (
                        <TableRow
                          key={it.sku ?? `${it.description}-${ri}`}
                          sx={it.itemType !== 'component' ? { bgcolor: 'action.hover' } : {}}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              size="small"
                              checked={checked}
                              disabled={!it.sku || isComponentBlockedByKit(it, a.itemSelection.allItems, selection)}
                              onChange={(ev) => {
                                const isChecked = ev.target.checked
                                setActionInputs((prev) => {
                                  const cur = prev[i] ?? { reasonCode: '', items: [] }
                                  const items = toggleKitAwareSelection(cur, it, a.itemSelection.allItems, isChecked)
                                  return { ...prev, [i]: { ...cur, items } }
                                })
                                setCheckStates((prev) => keepCheckWhenStale(a, prev, i))
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ '&.MuiTableCell-root': { pl: it.itemType === 'component' ? 3 : 1 }, fontSize: 13, color: 'text.secondary' }}>
                            {it.itemType === 'component' ? '↳ ' : ''}{it.sku ?? '—'}
                          </TableCell>
                          <TableCell sx={{ fontSize: 13, color: 'text.secondary' }}>
                            <Tooltip title={description}>
                              <span>{truncatedDescription}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell sx={{ fontSize: 13, color: 'text.secondary' }}>{it.brandId ?? '—'}</TableCell>
                          {a.type === 'offer_partial_refund_ebay' && (
                            <TableCell align="right">{it.extendedPrice != null ? `$${Number(it.extendedPrice).toFixed(2)}` : '—'}</TableCell>
                          )}
                          <TableCell align="right">
                            <TextField
                              size="small"
                              type="number"
                              value={entry?.quantity ?? it.quantity ?? 1}
                              disabled={!checked}
                              sx={{ '& .MuiOutlinedInput-input': { py: 0.25, px: 0.5 } }}
                              inputProps={{ min: 1, max: it.quantity ?? 1, style: { width: 30, textAlign: 'right', fontSize: 13 } }}
                              onChange={(ev) => {
                                const qty = Math.max(1, Math.min(it.quantity ?? 1, Number(ev.target.value) || 1))
                                setActionInputs((prev) => {
                                  const cur = prev[i] ?? { reasonCode: '', items: [] }
                                  const items = cur.items.map((x) => x.sku === it.sku ? { ...x, quantity: qty } : x)
                                  return { ...prev, [i]: { ...cur, items } }
                                })
                                setCheckStates((prev) => keepCheckWhenStale(a, prev, i))
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              {alreadyReturnedSelection(a, actionInputs[i]).length > 0 && (
                // An item already on an RTN (2026-10-27): no Process for it.
                <Typography variant="body2" color="error" data-testid="already-returned">
                  {alreadyReturnedSelection(a, actionInputs[i]).join(' ')} {ALREADY_RETURNED_HINT}
                </Typography>
              )}
              {a.type === 'offer_partial_refund_ebay' && (
                <Typography variant="body2" fontWeight={700}>
                  Refund Offer: ${(actionInputs[i]?.items ?? []).reduce((sum, si) => {
                    const master = (a.itemSelection.allItems ?? []).find((ai) => ai.sku === si.sku)
                    return sum + (master?.unitPrice ?? 0) * (Number(si.quantity) || 0)
                  }, 0).toFixed(2)}
                </Typography>
              )}
            </Stack>
          )}
          {a.shippingSelection && !decided && (
            <Stack spacing={1} sx={{ mt: 0.5 }}>
              <FormControl size="small" fullWidth>
                <InputLabel sx={{ fontSize: 13 }}>Shipping method</InputLabel>
                <Select
                  label="Shipping method"
                  value={actionInputs[i]?.shippingMethod ?? ''}
                  sx={{ fontSize: 13, color: 'text.secondary', '& .MuiSelect-select': { py: 0.5 } }}
                  onChange={(ev) => setActionInputs((prev) => ({ ...prev, [i]: { ...(prev[i] ?? {}), shippingMethod: ev.target.value } }))}
                >
                  {a.shippingSelection.methodOptions.map((m) => (
                    <MenuItem key={m} value={m}>{m}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                {[
                  ['shippingName', 'Name'], ['shippingAddress1', 'Address 1'], ['shippingAddress2', 'Address 2'],
                  ['shippingCity', 'City'], ['shippingRegion', 'State'], ['shippingPostalCode', 'ZIP'],
                ].map(([field, label]) => (
                  <TextField
                    key={field}
                    size="small"
                    label={label}
                    value={actionInputs[i]?.address?.[field] ?? ''}
                    onChange={(ev) => setActionInputs((prev) => ({
                      ...prev,
                      [i]: { ...(prev[i] ?? {}), address: { ...(prev[i]?.address ?? {}), [field]: ev.target.value } },
                    }))}
                    InputLabelProps={{ sx: { fontSize: 13 } }}
                    inputProps={{ style: { fontSize: 13 } }}
                    sx={{ flex: 1, minWidth: 140, '& .MuiOutlinedInput-input': { py: 0.25, px: 0.5 } }}
                  />
                ))}
              </Stack>
            </Stack>
          )}
          {a.type === 'process_replacement' && (() => {
            // The replacement's delivery date (2026-11-02,
            // replacementEdd.js): "Estimated delivery 11/06/2026 (Standard,
            // storefront estimate at 10:42 AM ET)", or why there is none.
            const view = eddStepView(a, eddStates[i])
            if (!view) return null
            const stockShown = agentLayout && ((resView && resView.headIndex === i && resView.stockLines.length > 0) || (!resView && stockWarningLines(a).length > 0))
            const notes = view.notes.filter((n) => !(stockShown && n.tone === 'warning'))
            // The date stands out (2026-11-03): bold green with a date, bold
            // red without one (a storefront message, a missing option, an
            // error), with room above the address fields.
            const red = { fontSize: 13, fontWeight: 700, color: (theme) => eddToneColor(theme, 'error') }
            return (
              <Box sx={{ mt: 1.5 }} data-testid="replacement-edd" data-tone={eddTone(view) ?? ''}>
                {view.loading && <Typography variant="caption" color="text.secondary" display="block" data-testid="replacement-edd-loading">Estimating delivery…</Typography>}
                {!view.loading && view.label && (
                  <Typography variant="body2" sx={{ fontSize: 14, fontWeight: 700, color: (theme) => eddToneColor(theme, 'success') }} data-testid="replacement-edd-date">{view.label}</Typography>
                )}
                {!view.loading && view.sentence && <Typography variant="body2" sx={red} data-testid="replacement-edd-sentence">{view.sentence}</Typography>}
                {!view.loading && notes.map((n) => (
                  <Typography key={n.text} variant="body2" sx={n.tone === 'warning' ? red : { fontSize: 13, color: 'text.secondary' }} data-testid="replacement-edd-step-note">{n.text}</Typography>
                ))}
                {!view.loading && view.warning && !stockShown && (
                  <Typography variant="body2" sx={red} data-testid="replacement-edd-warning">{view.warning}</Typography>
                )}
                {!view.loading && view.note && <Typography variant="caption" color="text.secondary" display="block" data-testid="replacement-edd-reply-note">{view.note}</Typography>}
              </Box>
            )
          })()}
          {a.type === 'process_return_refund' && !decided && checkStates[i]?.status !== 'checked' && (
            // No check yet (2026-10-27): the Disposition is blank,
            // with no "Not checked" choice, until Check runs.
            <Box sx={{ mt: 0.5 }} data-testid="return-step-disposition">
              <FormControl size="small" fullWidth disabled>
                <InputLabel id={`disposition-label-${i}`} shrink>{DISPOSITION_LABEL}</InputLabel>
                <Select labelId={`disposition-label-${i}`} label={DISPOSITION_LABEL} notched value="" displayEmpty SelectDisplayProps={{ 'aria-label': 'Disposition' }}>
                  {DISPOSITION_OPTIONS.map((o) => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
                </Select>
              </FormControl>
              <Typography variant="caption" color="text.secondary" display="block" data-testid="return-step-disposition-helper">{DISPOSITION_HELPER}</Typography>
            </Box>
          )}
          {checkStates[i]?.status === 'checked' && (() => {
            const r = checkStates[i].result
            const hasExistingReturn = a.params?.hasExistingReturn
            // The two hasExistingReturn outcomes are already eBay-only
            // (an eBay Gen return can't exist off eBay) and unreachable
            // off eBay — their wording stays as-is regardless of channel.
            // isEbayClientEmail alongside isEbayChannel: a genuine
            // eBay order reached via the m365 shared mailbox
            // still runs the eBay disposition path server-side
            // (action-executor.js's process_return_refund), so
            // it must show the eBay wording too, not the
            // Website wording isEbayChannel alone would select.
            const isEbayDisposition = isEbayChannel || isEbayClientEmail
            const pathLabel = hasExistingReturn && r.disposition
              ? 'Not scrap, a prepaid return label will be created and the eBay return approved with an RMA number.'
              : hasExistingReturn && !r.disposition
                ? 'Scrap, the existing eBay return will be approved without requiring the item back.'
                : !hasExistingReturn && r.disposition
                  ? (isEbayDisposition
                    ? 'Not scrap, customer must open an eBay Generated Return.'
                    : 'Not scrap — an RMA and return shipping label will be created via the console.')
                  : (isEbayDisposition
                    ? 'Scrap, eBay refund will be issued directly, and an RTN will be logged in the console.'
                    : 'Scrap — a return will be documented in the console; no item needs to come back.')
            return (
              <Box sx={{ mt: 0.5, p: 1, borderRadius: 1, bgcolor: (theme) => alpha(theme.palette.info.light, 0.18) }}>
                <Typography variant="caption" fontWeight={600} display="block" sx={{ mb: 0.25 }}>Disposition check result</Typography>
                {!isAdmin && !hasExistingReturn && r.disposition && isEbayDisposition ? (
                  <Typography variant="caption" display="block">
                    The item(s) should be returned to us - customer must open an eBay Generated Return.
                  </Typography>
                ) : (
                  <Typography variant="caption" display="block">
                    {pathLabel}
                  </Typography>
                )}
                {/* The disposition (2026-10-27): the check's result
                    selected, Return or Scrap only; another choice is
                    an override, shown as such and recorded with the
                    decision (checkedDisposition). Older answers with
                    no naturalDisposition read their disposition. */}
                {(() => {
                  const natural = typeof r.naturalDisposition === 'boolean' ? r.naturalDisposition : Boolean(r.disposition)
                  const chosen = dispositionWord(Boolean(r.disposition))
                  // Already shipped back (2026-10-28): the step's own
                  // override says why.
                  const over = overriddenText(chosen, dispositionWord(natural), r.alreadyShippedBack?.overriddenFrom && chosen === 'return' ? r.alreadyShippedBack.reason : null)
                  const stale = checkIsStale(r.checkedItems ? r : null, actionInputs[i])
                  return (
                    <Box sx={{ mt: 0.5 }} data-testid="return-step-disposition">
                      <FormControl size="small" fullWidth disabled={decided || checkStates[i]?.status === 'checking'}>
                        <InputLabel id={`disposition-label-${i}`}>{DISPOSITION_LABEL}</InputLabel>
                        <Select
                          labelId={`disposition-label-${i}`}
                          label={DISPOSITION_LABEL}
                          value={chosen}
                          SelectDisplayProps={{ 'aria-label': 'Disposition', 'data-testid': 'return-step-disposition-select' }}
                          onChange={(ev) => handleDispositionOverrideChange(i, r.alreadyShippedBack ? ev.target.value === 'return' : overrideForChoice(ev.target.value, natural))}
                        >
                          {DISPOSITION_OPTIONS.map((o) => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
                        </Select>
                      </FormControl>
                      {over && <Typography variant="caption" color="warning.main" display="block" data-testid="return-step-overridden">{over}</Typography>}
                      {/* The customer's own return tracking (2026-10-28,
                          already shipped back), linked to the carrier. */}
                      {r.disposition && (r.alreadyShippedBack?.tracking ?? []).map((t) => (
                        <Typography key={t.number} variant="caption" display="block" data-testid="return-step-customer-tracking">
                          {t.url ? <Link href={t.url} target="_blank" rel="noopener noreferrer">{customerReturnTrackingLine(t)}</Link> : customerReturnTrackingLine(t)}
                        </Typography>
                      ))}
                      {stale && <Typography variant="caption" color="warning.main" display="block" data-testid="return-step-stale">{CHECK_STALE_TEXT}</Typography>}
                    </Box>
                  )
                })()}
                {r.plannedSteps?.length > 0 && (
                  <Stack spacing={0.25} sx={{ mt: 0.5 }}>
                    <Stack direction="row" spacing={0.75} alignItems="center">
                      <Typography variant="caption" fontWeight={600} display="block" sx={{ flex: 1 }}>Select the Process button to complete these steps:</Typography>
                      {/* View calls (2026-10-27): one link for the checked steps' calls. */}
                      {isAdmin && (
                        <ViewCalls testId="check-result-view-call" calls={r.plannedSteps.map((step, si) => ({ label: `${si + 1}. ${step.pathLabel ?? 'step'}`, call: step.apiCall }))} />
                      )}
                    </Stack>
                    {r.plannedSteps.map((step, si) => (
                      <Stack key={si} direction="row" spacing={0.75} alignItems="center">
                        <Typography variant="caption" color="text.secondary" sx={{ flex: 1 }}>{si + 1}. {step.pathLabel}</Typography>
                      </Stack>
                    ))}
                  </Stack>
                )}
                {r.rateQuotes && (() => {
                  const rq = combineRateQuotes(r.rateQuotes)
                  const value = actionInputs[i] ?? {}
                  const packages = value.packages ?? r.packages ?? [{ weight: 0 }]
                  const paymentOption = value.shippingPaymentOption ?? 'customerCost'
                  const deduction = value.shippingDeductionEdited ? value.shippingDeduction : shippingRateDefaultDeduction(paymentOption, rq)
                  const allItems = fillMissingUnitCost(a.itemSelection?.allItems ?? [], orderSummaryItemDetails)
                  const selectedItems = value.items ?? []
                  const lineTaxes = computeLineTax(allItems, { orderTax: orderSummaryOrderTax, shippingCost: orderSummaryShippingCost, orderTotal: orderSummaryOrderTotal })
                  const { itemsTotal, deductionAmount, estimatedRefund, unresolvedSkus } = estimatedRefundBreakdown({
                    allItems, selectedItems, lineTaxes,
                    deduction: paymentOption === 'customerShipsOwn' ? 0 : deduction,
                  })
                  const pct = shippingHighCostPct(rq, itemsTotal)

                  // itemsTotal/lineTaxes (above) depend only on allItems/selectedItems —
                  // neither of which this handler ever touches (item selection is wired
                  // up separately) — so they're reused as-is rather than recomputed;
                  // only the option/deduction-dependent pieces (deductionAmount/
                  // estimatedRefund/pct/the note block) need recalculating here.
                  function applyShippingChange(patch) {
                    setActionInputs((prev) => {
                      const cur = prev[i] ?? {}
                      const option = patch.shippingPaymentOption ?? cur.shippingPaymentOption ?? 'customerCost'
                      const newDeduction = 'shippingDeduction' in patch ? patch.shippingDeduction : shippingRateDefaultDeduction(option, rq)
                      const newBreakdown = estimatedRefundBreakdown({
                        allItems, selectedItems, lineTaxes,
                        deduction: option === 'customerShipsOwn' ? 0 : newDeduction,
                      })
                      const newPct = shippingHighCostPct(rq, newBreakdown.itemsTotal)
                      const newBlock = r.alreadyShippedBack ? null : shippingNoteBlock({
                        paymentOption: option, itemsTotal: newBreakdown.itemsTotal, deductionAmount: newBreakdown.deductionAmount,
                        estimatedRefund: newBreakdown.estimatedRefund, pct: newPct, deduction: newDeduction, rateQuote: rq,
                      })
                      // Already shipped back (2026-10-28): the note's one
                      // amounts line, in the RMA note's own words.
                      const note = r.alreadyShippedBack
                        ? withRefundAmountsNoteLine(cur.editedNote, { original: newBreakdown.itemsTotal, deduction: newBreakdown.deductionAmount, final: newBreakdown.estimatedRefund })
                        : withShippingNoteLine(cur.editedNote, cur.shippingNoteLine ?? null, newBlock)
                      return { ...prev, [i]: { ...cur, ...patch, shippingPaymentOption: option, shippingDeduction: newDeduction, editedNote: note, shippingNoteLine: newBlock, itemsTotal: newBreakdown.itemsTotal } }
                    })
                  }

                  return (
                    <Box sx={{ mt: 0.75, pt: 0.75, borderTop: 1, borderColor: 'divider' }}>
                      {/* The label section (2026-10-27,
                          ReturnLabelFields.jsx, shared with the agent's
                          return step): the packages, each with its
                          quote, and, when a label is emailed, the
                          send-to and the copy. */}
                      {!(r.alreadyShippedBack && paymentOption === 'customerShipsOwn') && <ReturnLabelFields
                        value={value}
                        onChange={(patch) => setActionInputs((prev) => ({ ...prev, [i]: { ...(prev[i] ?? {}), ...patch } }))}
                        packages={packages}
                        onPackagesChange={(next) => handlePackagesChange(i, next)}
                        defaultEmail={a.params?.shipTo?.emailAddress}
                        ccCompany={a.params?.company}
                        showEmail={paymentOption !== 'customerShipsOwn' && !isEbayDisposition && !decided}
                        showErrors
                        disabled={stepStates[i]?.status === 'processing'}
                        renderPackageExtra={(pkgIndex) => {
                          const q = r.rateQuotes[pkgIndex]
                          if (!q) return null
                          // Inline, beside the weight field (PackagesEditor.jsx's own row
                          // Stack) rather than on a wrapping line below it.
                          return (
                            <Typography variant="caption" color="text.secondary">
                              Customer Cost: ${Number(q.totalEstimated ?? 0).toFixed(2)} · Our Cost: ${Number(q.totalNegotiated ?? 0).toFixed(2)}
                            </Typography>
                          )
                        }}
                      />}
                      <Typography variant="caption" fontWeight={600} display="block" sx={{ mt: 0.75, mb: 0.5 }}>Return shipping — who pays?</Typography>
                      {/* Each option its own separated button (a gap between them,
                          its own rounded border on every side) rather than MUI's
                          default merged-segment look — easier to tell the three
                          options apart at a glance. */}
                      <ToggleButtonGroup
                        size="small" exclusive value={paymentOption}
                        onChange={(ev, val) => { if (val) applyShippingChange({ shippingPaymentOption: val, shippingDeductionEdited: false }) }}
                        sx={{
                          gap: 0.75, flexWrap: 'wrap',
                          '& .MuiToggleButtonGroup-grouped': {
                            border: 1, borderColor: 'divider', borderRadius: '4px !important', ml: '0 !important',
                          },
                        }}
                      >
                        <ToggleButton value="customerCost" sx={{ fontWeight: paymentOption === 'customerCost' ? 700 : 400 }}>
                          Customer Cost (${Number(rq.totalEstimated ?? 0).toFixed(2)})
                        </ToggleButton>
                        <ToggleButton value="ourCost">Our Cost (${Number(rq.totalNegotiated ?? 0).toFixed(2)})</ToggleButton>
                        <ToggleButton value="customerShipsOwn">Customer pays for their own shipping</ToggleButton>
                      </ToggleButtonGroup>
                      {pct >= 0.3 && (
                        <Typography variant="caption" color="error.main" display="block" sx={{ mt: 0.5 }}>
                          {shippingHighCostMessage(pct)}
                        </Typography>
                      )}
                      {paymentOption !== 'customerShipsOwn' && (
                        <TextField
                          size="small" type="number" label="Label deduction"
                          value={deduction ?? ''}
                          onChange={(ev) => applyShippingChange({ shippingDeduction: ev.target.value === '' ? null : Number(ev.target.value), shippingDeductionEdited: true })}
                          sx={{ mt: 0.75, mb: 0.25, display: 'block', maxWidth: 120, ...compactFieldSx }}
                          InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                        />
                      )}
                      {/* The send-to and copy fields are in the label
                          section above (ReturnLabelFields), shown when a
                          label is emailed: not for "customer pays for their
                          own shipping" (action-executor.js's shipsOwnLabel),
                          never on an eBay-disposition conversation. */}
                      <Stack spacing={0.25} sx={{ mt: 0.75 }}>
                        <Typography variant="body2" color="text.secondary">
                          Refund for selected item(s) (items + tax): ${itemsTotal.toFixed(2)}
                        </Typography>
                        {(paymentOption !== 'customerShipsOwn' || r.alreadyShippedBack) && (
                          <Typography variant="body2" color="text.secondary">
                            Less return label deduction: -${deductionAmount.toFixed(2)}
                          </Typography>
                        )}
                        <Typography variant="body2" fontWeight={700}>
                          Refund total: ${estimatedRefund.toFixed(2)}
                        </Typography>
                      </Stack>
                      {unresolvedSkus.length > 0 && (
                        <Typography variant="caption" color="warning.main" display="block" sx={{ mt: 0.5 }}>
                          Refund amount could not be calculated for: {unresolvedSkus.join(', ')} — excluded from the total above.
                        </Typography>
                      )}
                    </Box>
                  )
                })()}
                {!r.rateQuotes && !hasExistingReturn && r.disposition && !isEbayDisposition && !decided && !r.alreadyShippedBack && (
                  // Company pays for return shipping (no rate quote):
                  // a label is always made, so the label section shows
                  // unconditionally (2026-10-27: with its packages, one
                  // per box, the same ReturnLabelFields as the agent's
                  // return step).
                  <ReturnLabelFields
                    value={actionInputs[i] ?? {}}
                    onChange={(patch) => setActionInputs((prev) => ({ ...prev, [i]: { ...(prev[i] ?? {}), ...patch } }))}
                    packages={actionInputs[i]?.packages ?? r.labelPackages ?? [{ weight: '' }]}
                    onPackagesChange={(next) => setActionInputs((prev) => ({ ...prev, [i]: { ...(prev[i] ?? {}), packages: next } }))}
                    defaultEmail={a.params?.shipTo?.emailAddress}
                    ccCompany={a.params?.company}
                    showErrors
                    disabled={stepStates[i]?.status === 'processing'}
                  />
                )}
                {!hasExistingReturn && r.disposition === false && !isEbayDisposition && (() => {
                  const value = actionInputs[i] ?? {}
                  const allItems = fillMissingUnitCost(a.itemSelection?.allItems ?? [], orderSummaryItemDetails)
                  const selectedItems = value.items ?? []
                  const lineTaxes = computeLineTax(allItems, { orderTax: orderSummaryOrderTax, shippingCost: orderSummaryShippingCost, orderTotal: orderSummaryOrderTotal })
                  const { itemsTotal, unresolvedSkus } = estimatedRefundBreakdown({ allItems, selectedItems, lineTaxes, deduction: 0 })
                  return (
                    <>
                      <Typography variant="body2" fontWeight={700} display="block" sx={{ mt: 1 }}>
                        Total Refund: ${itemsTotal.toFixed(2)}
                      </Typography>
                      {unresolvedSkus.length > 0 && (
                        <Typography variant="caption" color="warning.main" display="block">
                          Refund amount could not be calculated for: {unresolvedSkus.join(', ')} — excluded from the total above.
                        </Typography>
                      )}
                    </>
                  )
                })()}
              </Box>
            )
          })()}
          {checkStates[i]?.status === 'failed' && (
            <Box sx={{ mt: 0.5, p: 1, borderRadius: 1, bgcolor: (theme) => alpha(theme.palette.error.light, 0.18) }}>
              <Typography variant="caption" color="error.dark" fontWeight={600} display="block" sx={{ mb: 0.25 }}>Check failed</Typography>
              <Typography variant="caption">{checkStates[i].error}</Typography>
            </Box>
          )}
          {a.requiresInput && !decided && !a.itemSelection && getEditableMessageDefault(a) === null && !hasBespokeRequiresInputUi(a.type) && (
            <TextField
              size="small"
              type={a.inputType ?? 'text'}
              label={a.inputLabel ?? 'Required input'}
              value={actionInputs[i] ?? ''}
              onChange={(ev) => setActionInputs((prev) => ({ ...prev, [i]: ev.target.value }))}
              required
              error={!actionInputs[i]}
              helperText={!actionInputs[i] ? 'Required before approving' : ''}
              sx={{ maxWidth: 240, mt: 0.5 }}
            />
          )}
          </StepFieldsWrap>
        </Stack>
      </Paper>
      {/* Step result / error bar */}
      {(() => {
        const ss = stepStates[i]
        // Waiting on the OMS API (2026-10-29): the checklist, its chip and
        // Check now, never "processed".
        const pendingRow = pendingStepFor(returnLabels.data, suggestion?.id, i) ?? pendingFromResult(ss?.result)
        if (pendingRow && ss?.status !== 'processing') return <PendingStepChecklist row={pendingRow} onCheckNow={returnLabels.checkNow} onRecordAgain={returnLabels.recordAgain} onOpenConversation={onOpenRelatedConversation ?? null} />
        if (ss?.status === 'processing' && waitsForRmaNumber(a)) return <RmaNumberWaitCaption />
        if (!ss) return null
        if (ss.status === 'success' && ss.result && Object.keys(ss.result).length > 0) {
          return (
            <Box sx={{ mt: 0.5, p: 1, borderRadius: 1, bgcolor: (theme) => alpha(theme.palette.success.light, 0.18) }}>
              {isAdmin ? (
                <>
                  <Typography variant="caption" color="success.dark" fontWeight={600} display="block" sx={{ mb: 0.25 }}>Step result</Typography>
                  <Typography variant="caption" component="pre" sx={{ fontFamily: 'monospace', m: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                    {JSON.stringify(ss.result, null, 2)}
                  </Typography>
                </>
              ) : (
                <Typography variant="caption" color="success.dark" fontWeight={600} display="block">Successfully processed</Typography>
              )}
              {/* The replacement's ERP order number (process_replacement
                  when the inline lookup found it, get_erp_replacement_id
                  otherwise), or a note that it isn't available yet. */}
              {ss.result.erpReplacementId && (
                <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.5, minWidth: 0 }}>
                  <Typography variant="caption">Replacement order number:</Typography>
                  <Typography variant="caption" fontWeight={700} sx={{ fontFamily: 'monospace' }} data-testid="erp-replacement-id">{ss.result.erpReplacementId}</Typography>
                  <CopyButton value={ss.result.erpReplacementId} />
                </Stack>
              )}
              {/* A task's console refund (task_create_refund, 2026-10-14):
                  the new return document's number. */}
              {ss.result.erpReturnId && (
                <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.5, minWidth: 0 }}>
                  <Typography variant="caption">Return document:</Typography>
                  <Typography variant="caption" fontWeight={700} sx={{ fontFamily: 'monospace' }} data-testid="erp-return-id">{ss.result.erpReturnId}</Typography>
                  <CopyButton value={ss.result.erpReturnId} />
                </Stack>
              )}
              {ss.result.erpReplacementPending && (
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
                  Replacement created. Order number not available yet. Use the step below to fetch it.
                </Typography>
              )}
              {/* Multi-package result (feature/return-label-multi-package,
                  process_return_refund's Website RMA branch and the manual
                  create_return_shipping_label) — every package's own link,
                  labelled, or its own error if that package's label failed to
                  create. Falls back to the plain single-labelUrl rendering
                  below for every OTHER flow that still returns just result.labelUrl
                  (resend_return_label, automated_return_notice_resend_label, etc.). */}
              {Array.isArray(ss.result.labels) ? (
                <Stack spacing={0.5} sx={{ mt: isAdmin ? 0.5 : 0 }}>
                  {ss.result.labels.map((l) => (
                    <Box key={l.package}>
                      <Typography variant="caption" fontWeight={600} display="block">
                        Package {l.package}{l.error ? ' — failed' : ''}
                      </Typography>
                      {l.error ? (
                        <Typography variant="caption" color="error.dark">{l.error}</Typography>
                      ) : (
                        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ minWidth: 0 }}>
                          <Link href={l.labelUrl} target="_blank" rel="noopener noreferrer" variant="caption" sx={{ fontFamily: 'monospace', wordBreak: 'break-all', minWidth: 0, flex: 1 }}>
                            {l.labelUrl}
                          </Link>
                          <CopyButton value={l.labelUrl} />
                        </Stack>
                      )}
                    </Box>
                  ))}
                </Stack>
              ) : ss.result.labelUrl && (
                <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: isAdmin ? 0.5 : 0, minWidth: 0 }}>
                  <Link href={ss.result.labelUrl} target="_blank" rel="noopener noreferrer" variant="caption" sx={{ fontFamily: 'monospace', wordBreak: 'break-all', minWidth: 0, flex: 1 }}>
                    {ss.result.labelUrl}
                  </Link>
                  <CopyButton value={ss.result.labelUrl} />
                </Stack>
              )}
              {/* The agent's new label (2026-11-02): its reply has no place
                  for the link, so nothing was added to it; the person copies
                  the link above into the reply if the customer needs it. */}
              {labelLinkNotInReply(a, ss.result) && (
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }} data-testid="label-link-not-in-reply">
                  {LABEL_LINK_NOT_IN_REPLY}
                </Typography>
              )}
            </Box>
          )
        }
        if (isDailyLimitStepState(ss)) {
          // eBay's daily message limit on every route (2026-10-29): send it in
          // Seller Hub, then click Sent response through eBay Portal (our own record; closes the contact
          // as the send would have).
          const boxText = actionInputs[i]?.editedMessage ?? getEditableMessageDefault(a) ?? ''
          const firstName = agentFirstName
          const copyText = firstName ? boxText.replaceAll('[AGENT_FIRST_NAME]', firstName) : boxText
          return (
            <EbayDailyLimitNotice text={ss.error} messageText={copyText} action={a} disabled={busy}
              onMarkSent={async () => {
                const res = await markEbayStepSentInSellerHub(suggestion.id, i, copyText)
                setStepStates((prev) => ({ ...prev, [i]: { status: 'success', error: null, result: res?.result ?? { sentInSellerHub: true } } }))
                if (res?.result?.conversationClosed) {
                  onDecided?.('closed')
                  releaseAssignment(conversationId)
                }
              }} />
          )
        }
        if (ss.status === 'failed') {
          // A refund stopped by an open eBay return or INR inquiry
          // (2026-10-29, the executor's pre-check or eBay's 34916): rebuild
          // the step on that route. Nothing was refunded.
          const rerouteLabel = decided ? null : ebayRerouteButtonLabel(ss)
          return (
            <Box sx={{ mt: 0.5, p: 1, borderRadius: 1, bgcolor: (theme) => alpha(theme.palette.error.light, 0.18) }}>
              {ss.partlyDone && <PendingStepChecklist row={{ status: 'partly_done', checklist: ss.checklist }} compact />}
              <Typography variant="caption" color="error.dark" fontWeight={600} display="block" sx={{ mb: 0.25 }}>Error</Typography>
              <Typography variant="caption" component="pre" sx={{ fontFamily: 'monospace', m: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                {ss.error}
              </Typography>
              {rerouteLabel && (
                <Box sx={{ mt: 0.75 }}>
                  <Button size="small" variant="outlined" disabled={busy || ss.rerouting} onClick={() => handleEbayRefundReroute(i)} data-testid="ebay-refund-reroute">
                    {ss.rerouting ? 'Rebuilding…' : rerouteLabel}
                  </Button>
                  {ss.rerouteError && <Typography variant="caption" color="error" display="block" sx={{ mt: 0.5 }} data-testid="ebay-refund-reroute-error">{ss.rerouteError}</Typography>}
                </Box>
              )}
            </Box>
          )
        }
        return null
      })()}
      {/* A step started from Other Actions (2026-10-27): once processed, its
          reply template is offered here (its name and a preview, 2026-10-30),
          never put in the reply by itself. The paste asks first over a reply
          in the box (pasteManualReply()). */}
      {a.source === 'manual_panel' && (
        <ManualStepReply check={checkStates[i]?.result ?? a.params?.checkResult ?? null} stepState={stepStates[i]} inputs={actionInputs[i]}
          index={i}
          disabled={busy || conversationStatus === 'closed'}
          readWarranty={(link) => fetchPartLink(suggestion.id, { link, sku: '' })}
          previewText={(text) => { const box = draftBoxText(text); return isEbayChannel ? box : htmlToPlainText(box) }}
          pastedAt={manualPasted[i] ?? null}
          onUse={(text, option) => pasteManualReply(i, text, option?.template ?? null)} />
      )}
    </Box>
    )
  }

  // A step the Manual Panel's window holds a slot for renders there.
  const inStepSlot = (i, card) => {
    const slot = card && suggestion?.id ? stepSlotFor(conversationId, suggestion.id, i) : null
    return slot ? createPortal(card, slot, `step-slot-${i}`) : card
  }
  return (
    <Box sx={{ display: 'flex', alignItems: 'stretch', minHeight: '100%', bgcolor: agentLayout ? A2.panel : 'background.default' }}>
    <Box sx={{ p: 2, flex: 1, minWidth: 0 }} data-agent-layout={agentLayout ? '1' : undefined}
      onInputCapture={onPanelInput} onChangeCapture={onPanelInput} onPasteCapture={onPanelInput} onCutCapture={onPanelInput}
      onKeyDownCapture={onPanelKeyDown} onClickCapture={onPanelClick}
      // The read-only screen view (2026-10-29): inert, so no control in it
      // takes a click, a key or the focus.
      {...(screenMode ? { inert: '', 'data-screen-view': '1' } : {})}>
      {confirmDialog}
      {newerSuggestion && (
        <Alert severity="info" sx={{ mb: 1 }} data-testid="new-draft-notice"
          action={<Button color="inherit" size="small" onClick={loadNewerDraft} data-testid="load-new-draft">Load new draft</Button>}>
          {newerSuggestion.id === regeneratedNoticeId ? REGENERATED_NOTICE_TEXT : newDraftNoticeText(suggestion, newerSuggestion)}
        </Alert>
      )}
      {quietUpdatedId && suggestion?.id === quietUpdatedId && !decided && (
        <Typography variant="caption" color="text.secondary" component="div" sx={{ mb: 0.5 }} data-testid="quiet-refresh-updated">
          {QUIET_UPDATED_TEXT}
        </Typography>
      )}
      {/* Park saves the work (2026-10-27): the restored line, the result of
          unpark's check, and the "Since you parked this" panel, at the top
          of the suggestion on either layout. */}
      {parkChecking && (
        <Typography variant="caption" color="text.secondary" component="div" sx={{ mb: 0.5 }} data-testid="park-checking">
          Checking for changes since this was parked…
        </Typography>
      )}
      {(restoredLine || parkCheckLine) && !parkCompare && !parkStripHidden && !decided && (
        <ParkInfoStrip restoredLine={restoredLine} checkLine={parkCheckLine} changes={parkChangeLines} onClose={() => setParkStripHidden(true)}
          startFromDraftLabel={restoredFromOther && restoredLine ? START_FROM_AI_DRAFT_LABEL : null} onStartFromDraft={startFromAiDraft} />
      )}
      {parkCompare && !decided && (
        <ParkComparePanel
          restoredLine={parkCompare.source === 'regenerated' ? null : restoredLine}
          // A contact regenerated under a stale tab (2026-10-28): the same
          // panel, its own title.
          title={parkCompare.source === 'regenerated' ? REGENERATED_COMPARE_TITLE : null}
          processedText={parkCompare.source === 'regenerated' ? 'Already processed on the earlier suggestion, not offered again' : undefined}
          compare={parkCompare.compare}
          choices={parkChoices}
          busy={parkBusy || busy}
          error={parkError}
          // A card's or a step's pick (or its Undo, value null), and the
          // bottom row's picks for everything; Done applies them and closes
          // the panel (2026-10-28), so every pick can be undone until then.
          onChoose={(items, value) => setParkChoices((prev) => chooseItems(prev, items, value))}
          onKeepAll={() => setParkChoices(chooseAll(parkCompare.compare, PARK_KEEP))}
          onUseNewAll={() => setParkChoices(chooseAll(parkCompare.compare, PARK_NEW))}
          onDone={() => applyParkChoices(null)}
        />
      )}
      {/* Related contacts (2026-10-20): duplicates, the same request already
          answered, the customer's other open contacts. */}
      <RelatedContactsBanners
        related={relatedContacts}
        conversationId={conversationId}
        onOpenConversation={onOpenRelatedConversation}
        onCloseNoReply={suggestion && !decided && !taskContact?.isTask ? (answeredId) => onDecide('dismissed', undefined, answeredId ? { closeAnsweredGroup: { answeredId } } : {}) : null}
        closeNoReplyDisabled={decideBusy}
        closeNoReplyWaiting={quietChecking}
        onChanged={onRelatedChanged}
      />
      {/* When the draft on screen was written (2026-10-26): one small line
          above the header. A newer draft waiting does not change it. */}
      {agentLayout && <GeneratedAtLine at={suggestion?.createdAt} sx={{ bgcolor: A2.section, px: '20px', pt: '8px' }} />}
      <Stack direction="row" alignItems="center" justifyContent="space-between" data-a2-section={agentLayout ? 'header' : undefined}
        sx={agentLayout ? { mb: 1, bgcolor: A2.section, px: '20px', pt: '6px', pb: '14px', borderBottom: 1, borderColor: A2.rule } : { mb: 0.75 }}>
        <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap" useFlexGap>
          <Typography fontWeight={700} sx={agentLayout ? { fontSize: 15 } : undefined}>AI Suggestion</Typography>
          {/* "Live" (2026-10-26; was "Current"): this is the suggestion the
              CSR sees, shown only while the comparison panel is on screen,
              and never beside "Agent draft". */}
          {showLiveChip(shadowMode, suggestion?.modelMeta?.draftSource) && (
            <Tooltip title={LIVE_CHIP_TOOLTIP}>
              <Chip size="small" label={LIVE_CHIP_LABEL} variant="outlined" data-testid="shadow-compare-current" sx={{ height: 20, fontSize: '0.7rem' }} />
            </Tooltip>
          )}
          {/* No main AI draft (2026-10-20): a rule-based path handled the
              contact; only the agent draft has a reply. Admin-only, with the
              agent draft. */}
          {shadowMode && noAiDraftLabel(suggestion) && (
            <Typography data-testid="no-ai-draft-label" fontSize="0.75rem" color="text.secondary" sx={{ overflowWrap: 'anywhere' }}>{noAiDraftLabel(suggestion)}</Typography>
          )}
          {/* The agent's draft is this suggestion's (2026-10-21, a primary
              intent; docs/agent-draft-shadow.md). */}
          {suggestion?.modelMeta?.draftSource === 'agent' && (
            <Tooltip title={agentDraftChipTooltip(suggestion.modelMeta?.agentConfidence?.level)}>
              <Chip size="small" label="Agent draft" variant="outlined" color="info" data-testid="agent-draft-source" sx={{ height: 20, fontSize: '0.7rem' }} />
            </Tooltip>
          )}
          {/* No run status chip here (2026-10-26): the agent's draft is the
              main one only when its run finished ok, so "ok" said nothing. */}
          {agentAutomationHold(suggestion) && (
            <Chip size="small" label={agentAutomationHold(suggestion)} variant="outlined" color="warning" data-testid="agent-draft-automation-hold" sx={{ height: 20, fontSize: '0.7rem' }} />
          )}
        </Stack>
        {suggestion && (
          <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap" useFlexGap>
            {suggestion.intent === 'spam' && suggestion.modelMeta?.spamRule ? (
              <Tooltip title={suggestion.modelMeta.spamRule.shortId ?? ''}>
                <Chip
                  size="small" variant="outlined" color="error"
                  label={suggestion.modelMeta.spamRule.name ?? suggestion.modelMeta.spamRule.shortId ?? 'spam rule'}
                  sx={{ height: 20, fontSize: '0.75rem', '& .MuiChip-label': { px: 0.75 } }}
                />
              </Tooltip>
            ) : suggestion.intent === 'spam' && suggestion.decidedBy && (
              // Manually marked as spam (the agent's own Spam button) rather
              // than matched by an automatic rule — mutually exclusive with
              // the rule chip above, since a suggestion is either rule-
              // matched or manually marked, never both.
              <Chip
                size="small" variant="outlined" color="error"
                label={`Marked as spam by ${suggestion.decidedBy}`}
                sx={{ height: 20, fontSize: '0.75rem', '& .MuiChip-label': { px: 0.75 } }}
              />
            )}
            {qa && (
              <Tooltip title={qa.overall?.summary ?? ''}>
                <Chip size="small" color={QA_COLOR[qa.overall?.recommendation] ?? 'default'}
                  label={`QA: ${qa.overall?.recommendation} (${qa.overall?.score}/5)`}
                  sx={{ height: 20, fontSize: '0.75rem', '& .MuiChip-label': { px: 0.75 } }} />
              </Tooltip>
            )}
            <Button size="small" onClick={onGenerate} disabled={busy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}
              startIcon={busy ? <CircularProgress size={14} color="inherit" /> : null}>
              {busy ? 'Regenerating…' : 'Regenerate'}
            </Button>
          </Stack>
        )}
      </Stack>

      {/* The agent's What's next (2026-10-21): with the agent's draft as this
          suggestion's, its steps show here, where the agent column shows
          them, for every agent (not only admins). */}
      {/* Since 2026-10-23 also the own-label check's lines (which RMA the
          customer's return tracking is for; returnTrackingSteps.js). */}
      {!agentLayout && whatsNextSteps(correctPartSteps(agentNextStepsFor(suggestion)), suggestion).length > 0 && (
        <Box data-testid="agent-next-steps" sx={{ mb: 1, p: 1, borderLeft: 3, borderColor: 'warning.main', bgcolor: 'action.hover', borderRadius: 1 }}>
          <Typography fontSize="0.75rem" fontWeight={600} color="text.secondary">What's next</Typography>
          <Box component="ol" sx={{ m: 0, pl: 2.5, fontSize: '0.85rem', overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
            {whatsNextSteps(correctPartSteps(agentNextStepsFor(suggestion)), suggestion).map((step, i) => <li key={i}><NextStepText text={step} links={suggestion.modelMeta?.nextStepTrackingLinks ?? null} /></li>)}
          </Box>
        </Box>
      )}
      {!agentLayout && showCorrectPartBox && <CorrectPartBox suggestionId={suggestion.id} onUse={applyCorrectPart} />}

      {error && !showAgentActions && <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>}
      {closedNotice &&<Alert severity="info" sx={{ mb: 1 }}>{closedNotice}</Alert>}
      {noMessages && (
        <Alert
          severity="warning"
          sx={{ mb: 1 }}
          data-testid="no-messages-notice"
          action={(
            <Button color="inherit" size="small" disabled={closingEmpty} onClick={handleCloseEmpty}>
              {closingEmpty ? 'Closing…' : 'Close contact'}
            </Button>
          )}
        >
          This contact has no messages to answer. Check the conversation on its channel; close the contact if there is nothing to do.
        </Alert>
      )}
      {(() => {
        // Waiting on a TRQ retry (2026-10-14): after a deferred Regenerate, and
        // whenever the contact is open while waiting for it.
        const text = trqRetryNotice({
          deferral: retryDeferral,
          conversation: { status: conversationStatus, waitingReason: conversationWaitingReason, dueAt: conversationRetryDueAt, attempt: conversationRetryAttempts, maxAttempts: conversationRetryMaxAttempts },
        })
        return text ? <Alert severity="info" sx={{ mb: 1 }} data-testid="trq-retry-notice">{text}</Alert> : null
      })()}
      {/* This order's return label waiting on the OMS API on another
          contact, and this contact's timed-out waits (2026-10-29). */}
      <ReturnLabelBanners banners={orderWaitingBanners(returnLabels.data)} nextSteps={timedOutNextSteps(returnLabels.data)} />

      {/* Flows automation failure banner — read-only here; resolving is only
          done from the admin Failures page (ui/src/admin/pages/FailuresPage.jsx). */}
      {automationFailures?.length > 0 && (
        <Alert severity="error" sx={{ mb: 1 }}>
          <Typography variant="body2" fontWeight={700} sx={{ mb: 0.5 }}>
            {automationFailures.length === 1 ? 'Automated processing failed' : `${automationFailures.length} automated processing attempts failed`} — this needs manual handling:
          </Typography>
          <Stack spacing={0.5}>
            {automationFailures.map((f) => (
              <Typography key={f.id} variant="caption" display="block">
                <b>{f.flowKey}</b>: {f.failureMessage}
              </Typography>
            ))}
          </Stack>
        </Alert>
      )}

      {loading ? (
        <Box sx={{ py: 2, textAlign: 'center' }}><CircularProgress size={22} /></Box>
      ) : !suggestion && isInternalEmail ? (
        // An internal email between CXHub mailboxes (2026-10-12): no AI runs,
        // so there is never a suggestion to load. The agent writes the reply
        // here, threaded back to the other mailbox.
        <Stack spacing={0.75} data-testid="internal-email-composer">
          <Typography color="text.secondary" variant="body2">Internal email: no AI suggestion. Write your reply.</Typography>
          <TextField label="To" value={draftTo} onChange={(e) => setDraftTo(e.target.value)} size="small" fullWidth disabled={busy}
            sx={{ '& .MuiInputBase-input': { py: '6px', fontSize: '0.8rem' }, '& .MuiInputLabel-root': { fontSize: '0.8rem' } }} />
          <TextField label="Subject" value={draftSubject} onChange={(e) => setDraftSubject(e.target.value)} size="small" fullWidth disabled={busy}
            sx={{ '& .MuiInputBase-input': { py: '6px', fontSize: '0.8rem' }, '& .MuiInputLabel-root': { fontSize: '0.8rem' } }} />
          <RichReplyEditor isCustomerReply ref={draftEditorRef} label="Reply" value={draft} minRows={3}
            onChange={setDraft} disabled={busy} onOpenTemplates={() => openTemplateDialog()} />
          {error && <Alert severity="error">{error}</Alert>}
          {replySendError && <Alert severity="error">{replySendError}</Alert>}
          <Box>
            <Button variant="contained" color="success" onClick={onSendClosedM365Reply}
              disabled={busy || !String(draftTo ?? '').trim() || isSignatureOnlyReply(draft, signatureSeed())}
              sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>
              Send
            </Button>
          </Box>
        </Stack>
      ) : !suggestion ? (
        <Stack spacing={1} alignItems="flex-start">
          <Typography color="text.secondary" variant="body2">No suggestion generated yet.</Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Button variant="contained" onClick={onGenerate} disabled={busy}
              startIcon={busy ? <CircularProgress size={16} color="inherit" /> : null}>
              {busy ? 'Generating…' : 'Generate AI suggestion'}
            </Button>
            {conversationStatus === 'pending' && (
              <Tooltip title="Close this conversation directly — for cases where the reply/resolution happened outside the normal decision flow.">
                <span>
                  <Button
                    size="small"
                    variant="outlined"
                    color="inherit"
                    onClick={async () => { if (await remindUntoldCustomer('close')) onCloseConversation?.() }}
                    disabled={closingConversation}
                    startIcon={closingConversation ? <CircularProgress size={14} color="inherit" /> : null}
                  >
                    {closingConversation ? 'Closing…' : 'Close Conversation'}
                  </Button>
                </span>
              </Tooltip>
            )}
          </Stack>
        </Stack>
      ) : (
        <Stack spacing={agentLayout ? 1 : 1.5}>
          {/* The agent draft panel's Summary and What's next (2026-10-23):
              the agent's summary in the soft blue block, and What's next
              condensed, one item per thing to do (agentDraftLayout.js). */}
          {agentLayout && (suggestion.modelMeta?.agentSummary || suggestion.modelMeta?.agentConfidence) && (
            <SummaryBlock summary={suggestion.modelMeta?.agentSummary ?? null} testId="agent-draft-summary"
              right={<ConfidenceLabel confidence={confidenceView(correctPartUsed ? confidenceAfterCorrectPart(suggestion.modelMeta?.agentConfidence) : suggestion.modelMeta?.agentConfidence)} testId="agent-draft-confidence" part="chip" />}>
              <ConfidenceLabel confidence={confidenceView(correctPartUsed ? confidenceAfterCorrectPart(suggestion.modelMeta?.agentConfidence) : suggestion.modelMeta?.agentConfidence)} testId="agent-draft-confidence" part="reasons" />
            </SummaryBlock>
          )}
          {/* Since 2026-10-23 also the own-label check's lines, as written
              (they name the tracking number; returnTrackingSteps.js). */}
          {agentLayout && <NextStepsSection steps={correctPartSteps(suggestion.modelMeta?.agentNextSteps ?? [])} extra={[...customerTrackingNextSteps(suggestion), ...supportRefundNextSteps(suggestion)]} trackingLinks={suggestion.modelMeta?.nextStepTrackingLinks ?? null} testId="agent-next-steps" />}
          {agentLayout && showCorrectPartBox && <CorrectPartBox suggestionId={suggestion.id} onUse={applyCorrectPart} />}
          {suggestion.intent === 'spam' && (
            <Stack direction="row" spacing={0.5} alignItems="center">
              {canManageReviewedByMgmt ? (
                <Checkbox
                  size="small"
                  checked={reviewedByMgmt}
                  onChange={(e) => onReviewedByMgmtChange(e.target.checked)}
                  disabled={reviewedByMgmtBusy}
                  sx={{ p: 0.5 }}
                />
              ) : (
                <Tooltip title="Only admin or Support Permissions may change this">
                  <span>
                    <Checkbox size="small" checked={reviewedByMgmt} disabled sx={{ p: 0.5 }} />
                  </span>
                </Tooltip>
              )}
              <Typography variant="body2">
                Reviewed by Mgmt{reviewedByMgmt && reviewedByMgmtUser ? ` — reviewed by ${reviewedByMgmtUser}` : ''}
              </Typography>
            </Stack>
          )}

          {/* eBay INR case history — only present for INR conversations (either
              the request-ID/disposition path or the case-decision path) */}
          {(suggestion.modelMeta?.inrHistory?.length > 0 || suggestion.modelMeta?.inrBuyerRequested) && (
            <Box>
              {suggestion.modelMeta?.inrBuyerRequested && (
                <Stack direction="row" spacing={1} alignItems="baseline" sx={{ mb: 0.5 }}>
                  <Typography variant="caption" color="text.secondary" fontWeight={600}>
                    Buyer Requested:
                  </Typography>
                  <Typography variant="body2">
                    {suggestion.modelMeta.inrBuyerRequested}
                  </Typography>
                </Stack>
              )}
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="subtitle2" fontWeight={700}>
                  History
                </Typography>
                <Link component="button" variant="caption" onClick={() => setHistoryExpanded((v) => !v)}>
                  {historyExpanded ? 'Collapse' : 'Expand'}
                </Link>
              </Stack>
              {historyExpanded && (
                <Stack spacing={0.5} sx={{ mt: 0.75 }}>
                  {(suggestion.modelMeta.inrHistory ?? []).map((h, i) => (
                    <Paper key={i} variant="outlined" sx={{ px: 1.5, py: 0.75 }}>
                      <Stack direction="row" spacing={1} alignItems="baseline" flexWrap="wrap">
                        <Typography variant="caption" color="text.secondary">
                          {formatEST(h.date)}
                        </Typography>
                        <Typography variant="caption" fontWeight={700}>
                          {INR_ACTOR_LABELS[h.actor] ?? h.actor ?? 'Unknown'}
                        </Typography>
                      </Stack>
                      {h.description && (
                        <Typography variant="body2" sx={{ mt: 0.25 }}>
                          {h.description}
                        </Typography>
                      )}
                      {caseHistorySentLabel(h) && (
                        <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.25 }} data-testid="case-history-sent-from-cxhub">
                          {caseHistorySentLabel(h)}
                        </Typography>
                      )}
                      {showTranslation && alignedHistoryTranslation(suggestion.modelMeta.inrHistory, historyTranslation)?.[i] && (
                        <Box sx={{ mt: 0.5, p: 1, bgcolor: 'action.hover', borderRadius: 1 }}>
                          <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" sx={{ mb: 0.25 }}>
                            English
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-wrap' }}>
                            {historyTranslation[i]}
                          </Typography>
                        </Box>
                      )}
                    </Paper>
                  ))}
                </Stack>
              )}
            </Box>
          )}

          {/* orderSwitching: an order-correction override (App.jsx's header
              dropdown) is in flight — the whole lookup + suggestion
              regeneration runs synchronously inside that one request, so
              there's no progress to react to sooner than this. Dims (never
              hides) the steps below rather than blocking on them, same
              "signal more is coming without discarding what's on screen"
              posture as the header widget's own full-clear treatment for
              this same state — reusing the existing stale-regeneration
              Alert pattern (below) rather than introducing a third loading
              style. */}
          {orderSwitching && (
            <Alert severity="info" icon={<CircularProgress size={16} />}>
              Regenerating for the newly selected order…
            </Alert>
          )}

          {/* Queued-for-automation banner (migration 0087) — 'waiting' is
              already admin-only visible, so this never renders for a plain
              csr regardless of isAdmin. */}
          {isQueuedForAutomation && isAdmin && (
            <Alert severity="info" sx={{ mb: 1 }}
              action={
                <Button color="inherit" size="small" onClick={() => setAutomationTakeoverConfirm({ pendingAction: null })}>
                  Take over
                </Button>
              }>
              Queued for automation, due {conversationAutomationDueAt ? new Date(conversationAutomationDueAt).toLocaleString() : 'soon'}
            </Alert>
          )}

          {/* Proposed actions */}
          {(suggestion.proposedActions?.some((a) => screenMode || a.source !== 'manual_panel') || inboundWarnings(suggestion).length > 0) && (
            <StepsWrap agentLayout={agentLayout} count={shownStepNumbers.size} sx={orderSwitching ? { opacity: 0.5, pointerEvents: 'none', transition: 'opacity 0.15s' } : undefined}>
              {/* A ship-to address or expedited request the customer made anywhere
                  in the thread (2026-10-02) — above every step. */}
              <ReplacementShippingRequestBanners suggestion={suggestion} />
              <Stack spacing={0.25} sx={{ mt: 0.5 }}>
                {(() => {
                  // Numbers only the cards that actually render below — a
                  // running counter across the loop, since select_reason_code
                  // and the other skipped cases below would otherwise leave a
                  // gap in the numbering (e.g. 1, 3, 4 instead of 1, 2, 3).
                  let visibleStep = 0
                  return suggestion.proposedActions.map((a, i) => {
                  // A step started from Other Actions (source 'manual_panel')
                  // shows in the Manual Panel's window, with this same step
                  // component (2026-10-27, stepSlots.js; rendered below the
                  // list, into the window's slot), never twice here. A
                  // proposed step the window reuses moves into it while the
                  // window is open.
                  // The read-only screen view lists them here too, its
                  // own change marks under each card (2026-10-29).
                  if (a.source === 'manual_panel' && !screenMode) return null
                  if (!isStepShown(a, i)) return null
                  visibleStep += 1
                  const stepNumber = visibleStep
                  if (screenMode) {
                    return (
                      <Box key={`screen-step-${i}`} data-testid="screen-step" data-step-index={i}>
                        {renderProposedStep(a, i, stepNumber)}
                        {screenView.renderStepMarks?.(i)}
                      </Box>
                    )
                  }
                  return inStepSlot(i, renderProposedStep(a, i, stepNumber))
                  })
                })()}
              </Stack>
            </StepsWrap>
          )}
          {/* The steps started from Other Actions (2026-10-27): each into its
              Manual Panel window's slot (stepSlots.js), with the same step
              component as the list above. */}
          {(suggestion.proposedActions ?? []).map((a, i) => (!screenMode && a?.source === 'manual_panel' && isStepShown(a, i) && stepSlotFor(conversationId, suggestion.id, i)
            ? inStepSlot(i, renderProposedStep(a, i, null))
            : null))}

          {/* Human review flag — shown when the AI flagged uncertainty in the
              draft. Also shown for FROM_EBAY (no !fromEbay gate) — a FROM_EBAY
              cancellation notification can itself be flagged (see pipeline.js's
              FROM_MEMBERS pre-check), and the CSR needs to see that reason even
              though FROM_EBAY has no drafted reply of its own. whiteSpace:
              pre-wrap preserves line breaks between quoted buyer messages,
              which Alert/Typography otherwise collapse by default. */}
          {/* A declined Website order (2026-10-19; server/src/ai/declined-order.js):
              internal only, red, with the "is it theirs?" warnings. The same
              internal wording as the header; never the fraud screen's name
              (2026-10-22). */}
          {suggestion.modelMeta?.declinedOrder?.poNumber && (
            <Alert severity="error" data-testid="declined-order-banner" sx={{ whiteSpace: 'pre-wrap' }}>
              {`Order ${suggestion.modelMeta.declinedOrder.poNumber}: payment could not be processed (internal). It was never placed. Never tell the customer why it was declined.`}
              {(suggestion.modelMeta.declinedOrder.warnings ?? []).map((w) => (
                <Box key={w} component="span" sx={{ display: 'block', mt: 0.5, fontWeight: 600 }}>{w}</Box>
              ))}
            </Alert>
          )}
          {/* The agent draft panel (2026-10-23): the reason's "fill in the
              placeholder" sentences are said once, by the line under the
              reply (agentDraftLayout.js's withoutPlaceholderReasons()). */}
          {suggestion.needsHumanReview && (agentLayout ? withoutPlaceholderReasons(suggestion.humanReviewReason) : suggestion.humanReviewReason) && (
            <Alert severity="warning" sx={{ whiteSpace: 'pre-wrap' }} data-testid="human-review-reason">{agentLayout ? withoutPlaceholderReasons(suggestion.humanReviewReason) : suggestion.humanReviewReason}</Alert>
          )}
          {/* A failed generation, or a stage that failed and was skipped
              (2026-10-26, generation-error.js): admins only, the stage on
              one line and the message and stack frames behind Details. */}
          {isAdmin && <GenerationFailureDetails modelMeta={suggestion.modelMeta} />}
          {/* A VIN or part numbers read from the customer's photo (2026-10-19,
              docs/image-label-read.md), with the photo it came from. */}
          {suggestion.modelMeta?.imageLabelRead && (
            <PhotoLabelLine read={suggestion.modelMeta.imageLabelRead} conversationId={conversationId} messages={conversationMessages} />
          )}

          {/* The agent draft panel's Reply section (2026-10-23): the reply
              controls as before, the reply mode toggle in its header, one
              placeholder line under the editor, and nothing after it. */}
          {/* eBay's daily message limit (2026-10-29): for an hour after the
              last refusal on this contact's account, until a send succeeds. */}
          {conversationStatus !== 'closed' && <EbayDailyLimitBanner channel={channel} company={templateAccount} actions={suggestion?.proposedActions ?? []} />}
          <ReplyWrap on={agentLayout} right={agentLayout ? replyModeToggleEl : null}
            footer={agentLayout ? <PlaceholderLine text={placeholderLine(processCheckDraft)} /> : null}>
          {/* From/To/Subject — email conversations only. To/Subject are
              genuinely wired into the send (see send-approved-reply.js's own
              emailTo/emailSubject handling); From stays display-only —
              m365OutboundAddress() always sends as the account's one
              configured mailbox, not a CSR-typed value (see
              channels/m365/client.js's sendReply()). It shows the server's
              resolved outboundFrom — the mailbox's own address, or the brand
              send identity (service@) for a no-reply internal mailbox —
              falling back to the receiving address when the server hasn't
              resolved one. Hidden for isEbayClientEmail — this conversation
              has no real "Email" field at all; the eBay message
              maybeAddEbayMessageStep() proposes (actions.js) is the only
              reply path, so this box must not be offered alongside it. */}
          {/* The reply's destination (2026-10-27): under the To line, or
              first on an eBay reply ("Sends to eBay inquiry <id>"). */}
          {agentLayout && replyDestLine && (
            <Typography data-testid="agent-reply-destination" data-kind={replyDest?.kind ?? ''} sx={{ fontSize: 12, color: A2.label }}>{replyDestLine}</Typography>
          )}
          {channel === 'm365_email' && !isEbayClientEmail && (
            <Stack spacing={0.5}>
              <TextField label="From" value={draftFrom} onChange={(e) => setDraftFrom(e.target.value)} size="small" fullWidth disabled
                sx={{ '& .MuiInputBase-input': { py: '6px', fontSize: '0.8rem' }, '& .MuiInputLabel-root': { fontSize: '0.8rem' } }} />
              <TextField label="To" value={draftTo} onChange={(e) => setDraftTo(e.target.value)} size="small" fullWidth disabled={busy || (decided && !canRetrySend && !composingClosedReply)}
                sx={{ '& .MuiInputBase-input': { py: '6px', fontSize: '0.8rem' }, '& .MuiInputLabel-root': { fontSize: '0.8rem' } }} />
              {/* A likely misspelled customer email (related contacts,
                  2026-10-20). The To field changes only on this click, for the
                  agent to review before sending; orders found with the
                  corrected address are candidates to confirm, never chosen. */}
              {relatedContacts?.emailTypo && (
                <Alert severity="warning" data-testid="email-typo-banner" sx={{ py: 0.25 }}
                  action={<Button size="small" color="inherit" data-testid="use-corrected-address" disabled={busy}
                    onClick={() => setDraftTo((prev) => withCorrectedAddress(prev, relatedContacts.emailTypo))}>Use Corrected Address</Button>}>
                  {emailTypoText(relatedContacts.emailTypo)}
                  {suggestion?.modelMeta?.correctedEmailLookup && (
                    <Box data-testid="corrected-email-orders" sx={{ mt: 0.25 }}>
                      {(suggestion.modelMeta.correctedEmailLookup.orders ?? []).length
                        ? `Found via the corrected address (confirm before using): ${suggestion.modelMeta.correctedEmailLookup.orders.map((o) => o.erpOrderId ?? o.poNumber).filter(Boolean).join(', ')}`
                        : 'No orders found with the corrected address.'}
                    </Box>
                  )}
                </Alert>
              )}
              {/* CC (2026-10-08): Reply to Email only, comma-separated, the
                  Reply-All default above. The server re-checks every address. */}
              {ccField.visible && (
                <TextField label="CC" value={ccField.disabled ? '' : ccText} onChange={(e) => setCcEdited(e.target.value)} size="small" fullWidth
                  disabled={ccField.disabled || busy || (decided && !canRetrySend && !composingClosedReply)}
                  error={ccInvalid.length > 0}
                  helperText={ccField.note ?? (ccInvalid.length ? `Not an email address: ${ccInvalid.join(', ')}` : null)}
                  inputProps={{ 'data-testid': 'reply-cc-input' }}
                  sx={{ '& .MuiInputBase-input': { py: '6px', fontSize: '0.8rem' }, '& .MuiInputLabel-root': { fontSize: '0.8rem' }, '& .MuiFormHelperText-root': { fontSize: '0.7rem', mx: 0 } }} />
              )}
              <TextField label="Subject" value={draftSubject} onChange={(e) => setDraftSubject(e.target.value)} size="small" fullWidth disabled={busy || (decided && !canRetrySend && !composingClosedReply)}
                sx={{ '& .MuiInputBase-input': { py: '6px', fontSize: '0.8rem' }, '& .MuiInputLabel-root': { fontSize: '0.8rem' } }} />
            </Stack>
          )}

          {/* File attachments — RichReplyEditor.jsx no longer offers a way to
              insert an inline image at all (see that file's own comment on
              why removing its Image extension doesn't regress anything: a
              past draft/reply's own embedded data: URI image was already
              silently dropped on reload before this change too). Browser-
              memory only until Send/Retry Send — see this state's own
              comment above. Hidden for isEbayClientEmail — same reasoning as
              the From/To/Subject block above. */}
          {channel === 'm365_email' && !isEbayClientEmail && (
            <Stack spacing={0.5}>
              <input ref={attachmentInputRef} type="file" hidden aria-label="Add attachment" onChange={handleAttachmentFileSelected} />
              {attachmentError && <Alert severity="error" onClose={() => setAttachmentError(null)}>{attachmentError}</Alert>}
              <EmailAttachmentList attachments={attachments} onRemove={removeAttachment} disabled={busy || (decided && !canRetrySend)} />
            </Stack>
          )}

          {/* Drafted reply — hidden for FROM_EBAY (no reply is ever sent),
              for automated_return_notice_default (no draftReply/email box at
              all for this intent — pipeline.js sets needsDraft: false; the
              AI-drafted text lives inside its own Proposed Step instead —
              see actions.js's automatedReturnNoticeDefaultActions()), and for
              isEbayClientEmail — same reasoning as the From/To/Subject block
              above: this conversation's only reply path is the eBay-message
              Proposed Step maybeAddEbayMessageStep() built, not this box.
              hasNoDraftBoxOfItsOwn() is the single shared source of truth for
              these three cases — onDecide() below gates humanReply on the
              exact same check, so the two can never drift apart again. */}
          {!noDraftBoxFn({ fromEbay, intent: suggestion.intent, isEbayClientEmail }) && (
            <>
              {refreshingDraft && (
                <Stack direction="row" spacing={1} alignItems="center">
                  <CircularProgress size={14} />
                  <Typography variant="caption" color="text.secondary">Refreshing draft…</Typography>
                </Stack>
              )}
              {isEbayChannel ? (
                <ExpandableTextField isCustomerReply label="Drafted reply (editable)" value={draft} multiline minRows={4}
                  {...cursorTrackingProps('main')}
                  onChange={(e) => setDraft(e.target.value)} disabled={busy || (decided && !canRetrySend) || refreshingDraft} fullWidth size="small" />
              ) : (
                <RichReplyEditor isCustomerReply ref={draftEditorRef} label="Drafted reply (editable)" value={draft} minRows={3}
                  onChange={setDraft} disabled={busy || (decided && !canRetrySend && !composingClosedReply) || refreshingDraft}
                  onAddAttachment={channel === 'm365_email' ? () => attachmentInputRef.current?.click() : undefined}
                  onOpenTemplates={(!decided || composingClosedReply) ? () => openTemplateDialog() : undefined} />
              )}
              {/* eBay's ExpandableTextField has no toolbar to merge a Templates
                  button into (unlike RichReplyEditor, above) — left exactly as
                  it was, standalone, for that channel only. */}
              {isEbayChannel && !decided && (
                <Button size="small" variant="outlined" color="secondary" onClick={() => openTemplateDialog()} sx={{ alignSelf: 'flex-start' }}>
                  Templates
                </Button>
              )}
              {replyReplaced && (
                <Typography variant="caption" color="text.secondary" data-testid="reply-replaced-note" role="status">{replyReplaced}</Typography>
              )}
            </>
          )}
          </ReplyWrap>
          {/* The agent's shadow draft, stacked here on a narrow viewport
              (2026-10-16; side by side on a wide one, below). Nothing when
              this suggestion has none, or for a CSR / View as Agent. */}
          {(shadowMode === 'stacked' || shadowMode === 'stacked-collapsed') && (
            <ShadowCompareStacked draft={compareDraft} collapsed={shadowMode === 'stacked-collapsed'} onToggle={toggleShadowCompare} showTranslation={showTranslation} translation={shadowTr.translation} translationStatus={shadowTr.status} signature={compareSignature} replyHeaders={shadowReplyHeaders} replyDestination={channel === 'ebay' ? (suggestion?.modelMeta?.replyDestination ?? null) : null} trackingLinks={suggestion?.modelMeta?.nextStepTrackingLinks ?? null} />
          )}
          {(liveEnglish?.english || (showTranslation && draftTranslation)) && (() => {
            // Every channel (2026-10-30; it was email only): the live view
            // of the box as edited when there is one, else the stored
            // draft's translation. An email draft is HTML (rendered as its
            // formatting, App.jsx's sanitizeHtmlBody); an eBay draft is plain
            // text (its line breaks kept).
            const english = liveEnglish?.english ?? draftTranslation
            const caption = sendingCaption(liveEnglish?.language ?? null)
            const html = /<[a-z][^>]*>/i.test(english)
            return (
              <Box data-testid="draft-english-view" sx={{ p: 1.25, bgcolor: 'action.hover', borderRadius: 1 }}>
                <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" sx={{ mb: 0.25 }}>
                  English (AI draft)
                </Typography>
                {caption && (
                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }} data-testid="draft-english-caption">
                    {caption}
                  </Typography>
                )}
                {html ? (
                  <Box
                    sx={{ fontSize: '0.875rem', color: 'text.secondary', '& p': { margin: '0 0 0.5em' }, '& p:last-child': { marginBottom: 0 } }}
                    dangerouslySetInnerHTML={{ __html: sanitizeHtmlBody(resolveAgentFirstNamePlaceholder(english, templateAccount)) }}
                  />
                ) : (
                  <Box sx={{ fontSize: '0.875rem', color: 'text.secondary', whiteSpace: 'pre-wrap' }}>
                    {resolveAgentFirstNamePlaceholder(english, templateAccount)}
                  </Box>
                )}
              </Box>
            )
          })()}

          {/* QA dimensions — only relevant when a draft reply was generated.
               Note shown on click, not hover, so a CSR can tap through several
               chips without the note flashing on every mouse pass. */}
          {!fromEbay && qa && (
            <ClickAwayListener onClickAway={() => setOpenQaKey(null)}>
              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                {DIMENSIONS.map(([key, label]) => {
                  const score = qa[key]?.score
                  const color = score >= 4 ? 'success' : score === 3 ? 'warning' : 'error'
                  return (
                    <Tooltip
                      key={key}
                      title={qa[key]?.notes ?? ''}
                      open={openQaKey === key}
                      onClose={() => setOpenQaKey(null)}
                      disableHoverListener
                      disableFocusListener
                      disableTouchListener
                    >
                      <Chip
                        size="small"
                        variant="outlined"
                        color={color}
                        label={`${label}: ${score}/5`}
                        onClick={() => setOpenQaKey((prev) => (prev === key ? null : key))}
                      />
                    </Tooltip>
                  )
                })}
              </Stack>
            </ClickAwayListener>
          )}

          {/* Execution failure banner — shown above decision buttons when one or more
               API calls failed after the CSR clicked Approve. Includes endpoint,
               body sent, and the exact response so the CSR knows what to escalate. */}
          {executionErrors?.length > 0 && (
            <Alert severity="error" sx={{ mt: 1 }}>
              <Typography variant="body2" fontWeight={700} sx={{ mb: 0.5 }}>
                {executionErrors.length === 1 ? '1 action failed' : `${executionErrors.length} actions failed`} — decision was recorded but the following call{executionErrors.length > 1 ? 's' : ''} did not complete:
              </Typography>
              {executionErrors.map((e, i) => (
                <Box key={i} sx={{ mb: i < executionErrors.length - 1 ? 1.5 : 0 }}>
                  <Typography variant="caption" fontWeight={700}>{e.actionLabel}</Typography>
                  {e.endpoint && <Typography variant="caption" display="block" sx={{ fontFamily: 'monospace' }}>Endpoint: {e.endpoint}</Typography>}
                  {e.body && <Typography variant="caption" display="block" sx={{ fontFamily: 'monospace' }}>Body: {JSON.stringify(e.body)}</Typography>}
                  <Typography variant="caption" display="block" color="error.dark">Error: {e.error}</Typography>
                  {e.response && <Typography variant="caption" display="block" sx={{ fontFamily: 'monospace' }}>Response: {JSON.stringify(e.response)}</Typography>}
                </Box>
              ))}
            </Alert>
          )}

          {/* Reply-send failure banner — the decision was recorded, but the outbound
               send failed (e.g. writes disabled, or an eBay/Graph API error). Channel-
               agnostic text since this fires for both eBay and m365_email sends. */}
          {replySendError && isDailyLimitText(replySendError) && suggestion?.id && (
            <EbayDailyLimitNotice text={replySendError} messageText={draft} disabled={busy}
              onMarkSent={async () => {
                await markEbayReplySentInSellerHub(suggestion.id, draft)
                setReplySendError(null)
                onDecided?.('closed')
                releaseAssignment(conversationId)
              }} />
          )}
          {replySendError && !isDailyLimitText(replySendError) && (
            <Alert severity="error" sx={{ mt: 1 }}>
              <Typography variant="body2" fontWeight={700} sx={{ mb: 0.5 }}>
                Decision was recorded, but sending the reply failed:
              </Typography>
              <Typography variant="caption" display="block" color="error.dark">{replySendError}</Typography>
            </Alert>
          )}

          {/* Transfer to Support and escalation notes (2026-10-09): the
              CONTACT's newest events (contactNotes.js), so a regenerated or
              newer suggestion still shows why the contact was transferred or
              escalated. Transfer while the team is Support, escalation while
              the status is escalated; each once. An escalation from before
              migration 0051 has no note, just the heading. */}
          {contactNoteBlocks({ latestTransfer, latestEscalation, team: templateTeam, conversationStatus, suggestion }).map((b) => (
            <Alert key={b.kind} severity="info" sx={{ mb: 1 }} data-testid={b.kind === 'transfer' ? 'transfer-note' : 'escalation-note'}>
              {contactNoteHeading(b)}
              {b.note && (
                <Typography variant="body2" sx={{ mt: 0.25 }}>{b.note}</Typography>
              )}
            </Alert>
          ))}

          {/* Decision */}
          {staleDecidedSuggestion ? (
            autoRetryingStale ? (
              // In place of the (misleading) decided view while the
              // background refresh is in flight — busy is already true
              // here (onGenerate sets it), so every decided-gated field
              // below is already disabled for the duration.
              <Alert severity="info" icon={<CircularProgress size={16} />}>
                A new message arrived after this suggestion was decided — refreshing…
              </Alert>
            ) : (
              // The auto-retry already ran once (staleAutoRetriedRef) and
              // this suggestion is STILL stale — either the retry itself
              // failed, or it came back stale/errored again. Never leave
              // the stale decided view up with no indication anything is
              // wrong; offer a manual way out instead of retrying forever.
              <Alert severity="warning" action={
                <Button size="small" color="inherit" onClick={onGenerate} disabled={busy}>Regenerate</Button>
              }>
                This suggestion is out of date — a new message arrived after it was decided, and the automatic refresh didn't complete.
              </Alert>
            )
          ) : (
            <>
              {decided && (
                <Alert severity={suggestion.status === 'approved' || suggestion.status === 'edited' ? 'success' : 'info'}>
                  {suggestion.status}{suggestion.decidedBy ? ` by ${suggestion.decidedBy}` : ''}
                </Alert>
              )}
              {(!decided || canRetrySend || composingClosedReply) && (
                <>
                  {!fromEbay && draftRestrictedWarning && (
                    <Alert severity="error" sx={{ mt: 1 }}>{draftRestrictedWarning}</Alert>
                  )}
                  {!fromEbay && sendPlaceholderWarning && !agentLayout && (
                    <Alert severity="warning" sx={{ mt: 1 }}>{sendPlaceholderWarning}</Alert>
                  )}
                  {!fromEbay && !agentLayout && rmaSendWarning && (
                    <Alert severity="info" sx={{ mt: 1 }} data-testid="rma-reference-warning">{rmaSendWarning} Send anyway puts the order's number in its place.</Alert>
                  )}
                  {!fromEbay && mentionsSignifyd(draft ?? '') && (
                    <Alert severity="warning" sx={{ mt: 1 }} data-testid="signifyd-warning">{SIGNIFYD_SEND_WARNING}</Alert>
                  )}
                  {walmartLinkReason && (
                    <Alert severity="warning" sx={{ mt: 1 }} data-testid="walmart-link-warning">{walmartLinkReason}</Alert>
                  )}
                  {!fromEbay && !decided && draftSignatureMismatch && (
                    <Alert severity="warning" sx={{ mt: 1 }} data-testid="signature-name-warning"
                      action={<Button color="inherit" size="small" onClick={fixDraftSignature} data-testid="fix-signature-name">Fix signature</Button>}>
                      {signatureMismatchText(draftSignatureMismatch)}
                    </Alert>
                  )}
                  {addressMismatchReason && (
                    <Alert severity="warning" sx={{ mt: 1 }} data-testid="address-reply-mismatch">{addressMismatchReason}</Alert>
                  )}
                  {noticeToReason && (
                    <Alert severity="warning" sx={{ mt: 1 }} data-testid="notice-no-order-email">{noticeToReason}</Alert>
                  )}
                  {invoiceClaimReason && (
                    <Alert severity="warning" sx={{ mt: 1 }} data-testid="invoice-claim-warning">{invoiceClaimReason}</Alert>
                  )}
                  {/* Reply mode — m365_email only (hidden for isEbayClientEmail,
                      same gate as the From/To/Subject box above: an eBay-client
                      conversation has no real "Email" field, so neither
                      threading mode applies). Filled/bold ("pop") styling on
                      the selected option, matching the QA chip's own "warning"
                      color rather than inventing a new 3-way scheme for a
                      control that isn't itself graded. */}
                  {!agentLayout && channel === 'm365_email' && !isEbayClientEmail && replyModes.length > 1 && (
                    <ToggleButtonGroup
                      value={replyMode}
                      exclusive
                      onChange={(_e, newValue) => handleReplyModeChange(newValue)}
                      size="small"
                      aria-label="Reply mode"
                      disabled={busy || (decided && !canRetrySend && !composingClosedReply)}
                      sx={{ mb: 0.75 }}
                    >
                      <ToggleButton value="reply" sx={{ textTransform: 'none', px: 1.5, py: 0.25, fontSize: '0.75rem', '&.Mui-selected': { bgcolor: 'warning.main', color: 'warning.contrastText', '&:hover': { bgcolor: 'warning.dark' } } }}>
                        Reply to Email
                      </ToggleButton>
                      <ToggleButton value="new" disabled={newOutboundState.disabled} sx={{ textTransform: 'none', px: 1.5, py: 0.25, fontSize: '0.75rem', '&.Mui-selected': { bgcolor: 'warning.main', color: 'warning.contrastText', '&:hover': { bgcolor: 'warning.dark' } } }}>
                        Send New Outbound Email
                      </ToggleButton>
                    </ToggleButtonGroup>
                  )}
                  {!agentLayout && startNewContactEl && <Box sx={{ mb: 0.75 }}>{startNewContactEl}</Box>}
                  {!agentLayout && channel === 'm365_email' && !isEbayClientEmail && newOutboundState.disabled && (
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: -0.5, mb: 0.75 }} data-testid="new-outbound-unavailable">
                      {newOutboundState.reason}
                    </Typography>
                  )}
                  {/* The Send guard for the agent's own steps (2026-10-30,
                      agentReplyFollowsSteps.js): an amount that is no step's,
                      "no return" on an RMA or the reverse. A warning with
                      its fix; Send is not blocked. */}
                  {replyStepWarns.map((w, k) => (
                    <Alert key={`${w.code}-${k}`} severity="warning" sx={{ mb: 0.75 }} data-testid="reply-step-warning"
                      action={w.fix ? <Button color="inherit" size="small" data-testid="use-step-amount" onClick={() => { const next = withStepAmount(liveDraftRef.current ?? draft, w.fix.amount, w.fix.stepAmount); setDraft(next); liveDraftRef.current = next }}>{USE_STEP_AMOUNT_LABEL}</Button> : null}>
                      {w.message}
                    </Alert>
                  ))}
                  {houseReplyNote && <Alert severity="info" data-testid="house-reply-note" sx={{ mb: 0.75 }}>{houseReplyNote}</Alert>}
                  {showAgentActions ? (
                    // The agent draft panel's one button (2026-10-23): runs
                    // the steps in order through the same Process all pass
                    // (processAll.js, POST .../process-steps), stops at a
                    // failed step and names it, and only then sends the reply
                    // through the normal Send (onDecide), with every send
                    // gate. With no steps it is the Send. No confirmation:
                    // the label and the line under it say what it does.
                    <>
                      {error && <Alert severity="error" data-testid="agent-draft-action-error" sx={{ whiteSpace: 'pre-wrap' }}>{error}</Alert>}
                      <PrimaryActionArea state={agentActionState} busy={busy} waiting={quietChecking}
                        onClick={processAll.indexes.length
                          ? withAutomationTakeoverGuard(() => onProcessAllAndSend(processAll.indexes))
                          : () => onDecide('approved')}>
                        <DecisionButtonRow>
                        <QuietCheckGate waiting={quietChecking}><Button variant="outlined" color="error" onClick={withAutomationTakeoverGuard(() => { setEscalateNoteDraft(''); setEscalateModalOpen(true) })} disabled={decideBusy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>Escalate</Button></QuietCheckGate>
                        {canTransferToSupport && (
                          <QuietCheckGate waiting={quietChecking}><Button variant="outlined" color="primary" onClick={withAutomationTakeoverGuard(() => { setTransferNoteDraft(''); setTransferModalOpen(true) })} disabled={decideBusy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>Transfer to Support</Button></QuietCheckGate>
                        )}
                        <QuietCheckGate waiting={quietChecking}><Button variant="outlined" color="inherit" onClick={withAutomationTakeoverGuard(() => onDecide('dismissed'))} disabled={decideBusy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>Close - No Reply Needed</Button></QuietCheckGate>
                        <QuietCheckGate waiting={quietChecking}><Button variant="outlined" color="secondary" onClick={withAutomationTakeoverGuard(onSpam)} disabled={decideBusy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>Spam</Button></QuietCheckGate>
                        </DecisionButtonRow>
                      </PrimaryActionArea>
                    </>
                  ) : (
                  <DecisionButtonRow>
                  {canRetrySend ? (
                    // A fresh decision on a pending suggestion this is not —
                    // Escalate/Close/Spam don't apply to a retry, only Close
                    // Conversation (below, already unconditional on
                    // conversationStatus === 'pending') covers "give up instead."
                    <QuietCheckGate waiting={quietChecking}>
                    <Button variant="contained" color="success" onClick={() => onRetrySend()} disabled={decideBusy || Boolean(sendStop)} title={sendStop ?? undefined} data-testid="retry-send" sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>
                      Retry Send
                    </Button>
                    </QuietCheckGate>
                  ) : composingClosedReply ? (
                    // A closed conversation with no pending suggestion to
                    // Approve/Escalate/Dismiss/Spam against — those decision
                    // verbs don't apply here, only a fresh Send does (see
                    // onSendClosedM365Reply's own comment).
                    <Button variant="contained" color="success" onClick={onSendClosedM365Reply}
                      disabled={busy || isSignatureOnlyReply(draft, signatureSeed()) || Boolean(walmartLinkReason)}
                      startIcon={busy ? <CircularProgress size={14} color="inherit" /> : null}
                      sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>
                      {busy ? 'Sending…' : 'Send'}
                    </Button>
                  ) : (
                    <>
                      {/* Send is hidden whenever there's no drafted-reply box
                          of this suggestion's own to send — the SAME shared
                          predicate the box itself renders on just above,
                          not the narrower eBay-client-email-only check this
                          used to be (2026-09-25): a fromEbay or
                          automated_return_notice_default suggestion with a
                          processable step used to still show a clickable
                          Send that submitted an empty humanReply, reading as
                          "this sends the reply" when it provably didn't —
                          the actual customer-facing send for these flows
                          goes out via a Proposed Step's Process button
                          instead (see docs/decisions.md, 2026-09-25). */}
                      {!noDraftBoxFn({ fromEbay, intent: suggestion.intent, isEbayClientEmail }) && (
                        <QuietCheckGate waiting={quietChecking}>
                        <Button variant="contained" color="success" onClick={() => onDecide('approved')} data-testid="send-reply" disabled={decideBusy || Boolean(sendStopText)}
                          title={sendStopText ?? undefined} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>
                          Send
                        </Button>
                        </QuietCheckGate>
                      )}
                      {showProcessAll && !noDraftBoxFn({ fromEbay, intent: suggestion.intent, isEbayClientEmail }) && (
                        <QuietCheckGate waiting={quietChecking}>
                        <Button variant="contained" color="success" data-testid="process-all-and-send"
                          onClick={withAutomationTakeoverGuard(() => setProcessAllConfirm({ indexes: processAll.indexes }))}
                          disabled={decideBusy || Boolean(regeneratedBlock) || processAll.blocked.length > 0 || !processAll.indexes.length || Boolean(processPlaceholderWarning) || Boolean(walmartLinkReason) || Boolean(noticeToReason) || Boolean(invoiceClaimReason)}
                          title={regeneratedBlock ?? (processAll.blocked.length ? processAll.blocked.map((b) => b.reason).join(' ') : null) ?? (processPlaceholderWarning ?? walmartLinkReason ?? noticeToReason ?? invoiceClaimReason ?? undefined)}
                          sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>
                          Process all steps and send reply
                        </Button>
                        </QuietCheckGate>
                      )}
                      {!isTask && <QuietCheckGate waiting={quietChecking}><Button variant="outlined" color="error" onClick={withAutomationTakeoverGuard(() => { setEscalateNoteDraft(''); setEscalateModalOpen(true) })} disabled={decideBusy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>Escalate</Button></QuietCheckGate>}
                      {canTransferToSupport && (
                        <QuietCheckGate waiting={quietChecking}><Button variant="outlined" color="primary" onClick={withAutomationTakeoverGuard(() => { setTransferNoteDraft(''); setTransferModalOpen(true) })} disabled={decideBusy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>Transfer to Support</Button></QuietCheckGate>
                      )}
                      <QuietCheckGate waiting={quietChecking}><Button variant="outlined" color="inherit" onClick={withAutomationTakeoverGuard(() => (taskContact?.isTask ? setCloseNoteOpen(true) : onDecide('dismissed')))} disabled={decideBusy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>Close - No Reply Needed</Button></QuietCheckGate>
                      {!isTask && <QuietCheckGate waiting={quietChecking}><Button variant="outlined" color="secondary" onClick={withAutomationTakeoverGuard(onSpam)} disabled={decideBusy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>Spam</Button></QuietCheckGate>}
                    </>
                  )}
                  </DecisionButtonRow>
                  )}
                </>
              )}
            </>
          )}

          {/* "Responded via Process" (migration 0083, see directSendAttributionState's
              own comment above): the customer already got their reply through a
              Proposed Step's Process button, so Send has nothing left to do and
              stays hidden — but Escalate/Close/Spam are real, still-available next
              steps (hand it off, close it out, or mark it spam), so they render
              here on their own rather than inside the block above, which also
              carries reply-composition UI (the reply-mode toggle, draft
              warnings) that doesn't apply here — nothing is being composed. */}
          {directSendAttributionState && (
            <DecisionButtonRow sx={{ mt: 1 }}>
              {!isTask && <QuietCheckGate waiting={quietChecking}><Button variant="outlined" color="error" onClick={withAutomationTakeoverGuard(() => { setEscalateNoteDraft(''); setEscalateModalOpen(true) })} disabled={decideBusy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>Escalate</Button></QuietCheckGate>}
                      {canTransferToSupport && (
                        <QuietCheckGate waiting={quietChecking}><Button variant="outlined" color="primary" onClick={withAutomationTakeoverGuard(() => { setTransferNoteDraft(''); setTransferModalOpen(true) })} disabled={decideBusy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>Transfer to Support</Button></QuietCheckGate>
                      )}
              <QuietCheckGate waiting={quietChecking}><Button variant="outlined" color="inherit" onClick={withAutomationTakeoverGuard(() => (taskContact?.isTask ? setCloseNoteOpen(true) : onDecide('dismissed')))} disabled={decideBusy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>Close - No Reply Needed</Button></QuietCheckGate>
              {!isTask && <QuietCheckGate waiting={quietChecking}><Button variant="outlined" color="secondary" onClick={withAutomationTakeoverGuard(onSpam)} disabled={decideBusy} sx={{ fontSize: '0.75rem', py: 0.25, px: 1 }}>Spam</Button></QuietCheckGate>}
            </DecisionButtonRow>
          )}

          {/* Manual close escape hatch — available whenever the conversation is
              still 'pending', regardless of whether THIS suggestion has already
              been decided (e.g. the decision's reply went out via a proposed-
              action Process step rather than the standard send, or the
              resolution otherwise happened outside the normal decision flow).
              Previously nested inside the `!decided` branch above, which meant
              a decided-but-still-pending conversation had no way to close at
              all — the exact gap this fixes. */}
          {conversationStatus === 'pending' && (
            <Box>
              <Tooltip title="Close this conversation directly — for cases where the reply/resolution happened outside the normal decision flow.">
                <span>
                  <Button
                    size="small"
                    variant="outlined"
                    color="inherit"
                    onClick={async () => { if (await remindUntoldCustomer('close')) onCloseConversation?.() }}
                    disabled={closingConversation}
                    startIcon={closingConversation ? <CircularProgress size={14} color="inherit" /> : null}
                  >
                    {closingConversation ? 'Closing…' : 'Close Conversation'}
                  </Button>
                </span>
              </Tooltip>
            </Box>
          )}

          {/* Send Feedback — always available when a suggestion exists.
              Starts a silent screenshot of what is on screen and opens the
              dialog at once; the capture skips every dialog, so the modal is
              never in the image. Nothing about this is shown to the agent
              (see feedbackScreenshot.js's own comment). */}
          <Stack direction="row" spacing={1} alignItems="center">
            <Button variant="text" color="inherit" size="small"
              onClick={() => {
                setFeedbackError(null)
                // The whole panel, steps below the fold included (2026-10-29).
                feedbackScreenshotRef.current = startFeedbackCapture({ root: document.getElementById('root'), panel: document.querySelector(PANEL_SELECTOR) })
                setFeedbackOpen(true)
              }}>
              Send Feedback
            </Button>
          </Stack>

          {feedbackSuccess && (
            <Alert severity="success" onClose={() => setFeedbackSuccess(false)}>Feedback submitted — thank you!</Alert>
          )}
          {/* The agent run's details (2026-10-23), collapsed behind one line. */}
          {agentLayout && (
            <DetailsFooter testId="agent-draft-details"
              runLine={runDetailsLine(agentRun)}
              sources={agentRun ? shadowSourcesLine({ agentOrder: agentRun.order, sources: agentRun.sources }) : null}
              toolLines={toolCallLines(agentRun?.toolCalls)}
              footer={pipelineOnDemand ? pipelineCompareLink : null} />
          )}
          {/* No A2 layout (a FROM_EBAY or task contact): the link alone. */}
          {!agentLayout && pipelineOnDemand && <Box sx={{ px: '20px' }}>{pipelineCompareLink}</Box>}
        </Stack>
      )}

      {closeError && <Alert severity="error" onClose={onDismissCloseError} sx={{ mt: 1 }}>{closeError}</Alert>}

      {/* Reopen a closed conversation that was closed by mistake, back into
          the queue — admin only (reopening un-does a resolution that
          may already be reflected in reporting counts). An alternative to
          composing a reply below, not part of that flow: a plain status
          flip, with whatever suggestion history the conversation already
          has, for a human to look at. */}
      {conversationStatus === 'closed' && isAdmin && (
        <Box sx={{ mt: 2 }}>
          <Tooltip title="Reopen this conversation and put it back in the queue — for a contact closed by mistake.">
            <span>
              <Button
                size="small"
                variant="outlined"
                color="inherit"
                onClick={onReopenConversation}
                disabled={reopeningConversation}
                startIcon={reopeningConversation ? <CircularProgress size={14} color="inherit" /> : null}
              >
                {reopeningConversation ? 'Reopening…' : 'Reopen Conversation'}
              </Button>
            </span>
          </Tooltip>
        </Box>
      )}
      {reopenError && <Alert severity="error" onClose={onDismissReopenError} sx={{ mt: 1 }}>{reopenError}</Alert>}

      {/* Ad-hoc reply on an already-closed FROM_MEMBERS eBay conversation —
          the buyer wrote back after the last suggestion was decided, and
          there's no pending suggestion left to Approve/Edit. Additive to
          (not a replacement for) the decided-suggestion history above;
          never shown for FROM_EBAY (no reply is ever sent there) or while
          still pending (the normal decision flow above already covers
          that). m365_email is handled above instead, via composingClosedReply —
          it needs a real To/Subject/Templates surface an eBay message has
          no concept of at all, which is why this box never needed them. */}
      {conversationStatus === 'closed' && !fromEbay && channel !== 'm365_email' && (
        <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
          <Typography fontWeight={700} sx={{ mb: 1 }}>New reply</Typography>
          <Stack spacing={1} alignItems="flex-start">
            <ExpandableTextField
              isCustomerReply
              label="New reply (editable)"
              value={closedReplyDraft}
              {...cursorTrackingProps('closed-reply')}
              onChange={(e) => setClosedReplyDraft(e.target.value)}
              multiline minRows={4} fullWidth size="small"
              disabled={closedReplyBusy}
            />
            {closedReplyRestrictedWarning && (
              <Alert severity="error" sx={{ mt: 1 }}>{closedReplyRestrictedWarning}</Alert>
            )}
            {closedReplyPlaceholderWarning && (
              <Alert severity="warning" sx={{ mt: 1 }}>{closedReplyPlaceholderWarning}</Alert>
            )}
            <Stack direction="row" spacing={1}>
              <Button size="small" variant="outlined" color="secondary"
                onClick={() => openTemplateDialog('closed-reply')} disabled={closedReplyBusy}>
                Templates
              </Button>
              <Button
                variant="contained" color="success" size="small"
                onClick={onSendManualReply}
                disabled={closedReplyBusy || isSignatureOnlyReply(closedReplyDraft, signatureSeed())}
                startIcon={closedReplyBusy ? <CircularProgress size={14} color="inherit" /> : null}
              >
                {closedReplyBusy ? 'Sending…' : 'Send'}
              </Button>
            </Stack>
            {closedReplyError && (
              <Alert severity="error" sx={{ mt: 1 }} onClose={() => setClosedReplyError(null)}>{closedReplyError}</Alert>
            )}
          </Stack>
        </Box>
      )}

      {/* Template selector dialog (TemplatePickerDialog.jsx, shared with the New view) */}
      <TemplatePickerDialog
        open={templateDialogOpen}
        onClose={() => setTemplateDialogOpen(false)}
        onUse={applyTemplate}
        scope={{ account: templateAccount, trqClientCode: templateTrqClientCode, team: templateTeam }}
        intent={suggestion?.intent ?? null}
        disableRestoreFocus={Boolean(pendingTemplateFocusRef.current)}
      />

      {/* Send Feedback dialog */}
      <Dialog open={feedbackOpen} onClose={() => { if (!feedbackBusy) { feedbackScreenshotRef.current = null; setFeedbackOpen(false) } }} maxWidth="sm" fullWidth>
        <DialogTitle>Send Feedback</DialogTitle>
        <DialogContent>
          {feedbackError && <Alert severity="error" sx={{ mb: 1.5 }}>{feedbackError}</Alert>}
          <ExpandableTextField
            label="What should the AI have done differently?"
            multiline
            minRows={4}
            fullWidth
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            disabled={feedbackBusy}
            autoFocus
            sx={{ mt: 0.5 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { feedbackScreenshotRef.current = null; setFeedbackOpen(false) }} disabled={feedbackBusy}>Cancel</Button>
          <Button
            variant="contained"
            disabled={feedbackBusy || !feedbackText.trim()}
            startIcon={feedbackBusy ? <CircularProgress size={14} color="inherit" /> : null}
            onClick={async () => {
              setFeedbackBusy(true); setFeedbackError(null)
              try {
                // Wait for the background capture, up to its cap, then send
                // with or without it, and say why when there is none.
                setFeedbackAttaching(true)
                const result = await finishFeedbackCapture(feedbackScreenshotRef.current)
                setFeedbackAttaching(false)
                const { screenshot, screenshotStatus } = await feedbackScreenshotPayload(result)
                await submitFeedback(conversationId, {
                  suggestionId: suggestion?.id ?? undefined,
                  intent: suggestion?.intent ?? undefined,
                  message: feedbackText.trim(),
                  screenshot,
                  screenshotStatus,
                  // The snapshot's browser half (2026-10-26,
                  // feedbackUiState.js). Nothing new is shown to the CSR.
                  uiState: feedbackUiStateNow(),
                  // "As the CSR saw it" (2026-10-29): the full screen state,
                  // admin-only. A capture that throws never blocks the report.
                  screenState: (() => { try { return feedbackScreenStateNow() } catch { return undefined } })(),
                })
                feedbackScreenshotRef.current = null
                setFeedbackOpen(false)
                setFeedbackText('')
                setFeedbackSuccess(true)
              } catch (e) {
                setFeedbackError(e.message)
              } finally {
                setFeedbackAttaching(false)
                setFeedbackBusy(false)
              }
            }}
          >
            {feedbackAttaching ? 'Attaching screenshot…' : feedbackBusy ? 'Submitting…' : 'Submit'}
          </Button>
        </DialogActions>
      </Dialog>

      <SpamRuleDialog
        open={spamDialogOpen}
        onClose={() => { setSpamDialogOpen(false); onDecided?.(pendingSpamStatus); setPendingSpamStatus(null) }}
        onSaved={() => { setSpamDialogOpen(false); onDecided?.(pendingSpamStatus); setPendingSpamStatus(null) }}
        initialValues={{
          name: spamContext?.fromIdentifier ? `Spam from ${spamContext.fromIdentifier}` : '',
          channel: spamContext?.channel ? [spamContext.channel] : [],
          client: spamContext?.client ? [spamContext.client] : [],
          company: spamContext?.company ? [spamContext.company] : [],
          fromPatterns: spamContext?.fromIdentifier ? [spamContext.fromIdentifier] : [],
          bodyPattern: spamContext?.subject ?? '',
        }}
      />

      <DraggableModal
        open={escalateModalOpen}
        onClose={() => setEscalateModalOpen(false)}
        title="Escalate"
        centered
        width={480}
        height={320}
        actions={
          <Button
            variant="contained"
            color="error"
            disabled={busy || !escalateNoteDraft.trim()}
            onClick={() => { setEscalateModalOpen(false); onDecide('escalated', escalateNoteDraft.trim()) }}
          >
            Escalate
          </Button>
        }
      >
        <ExpandableTextField
          size="small"
          label="Reason for escalation"
          multiline
          minRows={4}
          fullWidth
          autoFocus
          value={escalateNoteDraft}
          onChange={(e) => setEscalateNoteDraft(e.target.value)}
        />
      </DraggableModal>

      <DraggableModal
        open={transferModalOpen}
        onClose={() => setTransferModalOpen(false)}
        title="Transfer to Support"
        centered
        width={480}
        height={320}
        actions={
          <Button
            variant="contained"
            color="primary"
            disabled={busy || !transferNoteDraft.trim()}
            onClick={() => { setTransferModalOpen(false); onDecide('transferred', transferNoteDraft.trim()) }}
          >
            Transfer to Support
          </Button>
        }
      >
        <ExpandableTextField
          size="small"
          label="Reason for transfer"
          multiline
          minRows={4}
          fullWidth
          autoFocus
          value={transferNoteDraft}
          onChange={(e) => setTransferNoteDraft(e.target.value)}
        />
      </DraggableModal>

      <DraggableModal
        open={closeNoteOpen}
        onClose={() => setCloseNoteOpen(false)}
        title="Close task - No Reply Needed"
        centered
        width={480}
        height={320}
        actions={
          <Button
            variant="contained"
            color="primary"
            disabled={busy || !closeNoteDraft.trim()}
            data-testid="task-close-note-confirm"
            onClick={() => { setCloseNoteOpen(false); onDecide('dismissed', closeNoteDraft.trim()) }}
          >
            Close task
          </Button>
        }
      >
        <ExpandableTextField
          size="small"
          label="Why no reply is needed (the task's close note)"
          multiline
          minRows={4}
          fullWidth
          autoFocus
          value={closeNoteDraft}
          onChange={(e) => setCloseNoteDraft(e.target.value)}
          inputProps={{ 'data-testid': 'task-close-note' }}
        />
      </DraggableModal>

      {/* The Send warnings (2026-10-30, SendWarningsDialog.jsx): every one
          that applies, each with its fix; Send anyway sends as written. */}
      <SendWarningsDialog
        open={Boolean(sendWarningsAsk)}
        warnings={sendWarningsAsk?.warnings ?? []}
        onCancel={() => setSendWarningsAsk(null)}
        onFix={onSendWarningFix}
        onSendAnyway={onSendWarningsAnyway}
      />

      {/* The double-reply guard (related contacts, 2026-10-20). */}
      <DraggableModal
        open={Boolean(recentReplyConfirm)}
        onClose={() => setRecentReplyConfirm(null)}
        title={recentReplyConfirm?.title ?? 'Reply already sent'}
        centered
        width={440}
        height={200}
        actions={
          <>
            <Button variant="outlined" color="inherit" onClick={() => setRecentReplyConfirm(null)}>Cancel</Button>
            <Button variant="contained" color="warning" data-testid="recent-reply-send-anyway"
              onClick={() => { const proceed = recentReplyConfirm?.proceed; setRecentReplyConfirm(null); proceed?.() }}>
              {recentReplyConfirm?.confirmLabel ?? 'Send anyway'}
            </Button>
          </>
        }
      >
        <Typography variant="body2" data-testid="recent-reply-message">{recentReplyConfirm?.message}</Typography>
      </DraggableModal>

      {/* "Process all steps and send reply" (2026-10-23): what will run. */}
      <DraggableModal
        open={Boolean(processAllConfirm)}
        onClose={() => setProcessAllConfirm(null)}
        title="Process all steps and send reply"
        centered
        width={480}
        height={260}
        actions={
          <>
            <Button variant="outlined" color="inherit" onClick={() => setProcessAllConfirm(null)}>Cancel</Button>
            <Button variant="contained" color="success" data-testid="process-all-confirm"
              onClick={() => { const indexes = processAllConfirm?.indexes ?? []; setProcessAllConfirm(null); onProcessAllAndSend(indexes) }}>
              Process and send
            </Button>
          </>
        }
      >
        <Typography variant="body2" sx={{ mb: 1 }}>These steps run first, in order. If one fails, the reply is not sent.</Typography>
        {processAllStepList(suggestion?.proposedActions ?? [], processAllConfirm?.indexes ?? [], checkedSteps).map((line) => (
          <Typography key={line} variant="body2" data-testid="process-all-step">{line}</Typography>
        ))}
        {/* The steps the reply does not need (2026-10-27): not run. */}
        {processAllSkippedList(suggestion?.proposedActions ?? [], liftedSteps.filter((x) => x.index !== taskChoiceStepIndex)).map((line) => (
          <Typography key={line} variant="body2" color="text.secondary" data-testid="process-all-skipped">{line}</Typography>
        ))}
        {processAllManualNote(suggestion?.proposedActions ?? [], processAll.manual) && (
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }} data-testid="process-all-manual">
            {processAllManualNote(suggestion?.proposedActions ?? [], processAll.manual)}
          </Typography>
        )}
      </DraggableModal>

      {/* Admin takeover of a contact queued for Flows automation (migration
          0087) — opened either by the banner's own "Take over" button
          (pendingAction: null — just take over, no follow-up action) or by
          withAutomationTakeoverGuard()/handleProcessStep's stale-page catch
          (pendingAction: the action the admin actually clicked, run once
          takeover succeeds). */}
      <DraggableModal
        open={Boolean(automationTakeoverConfirm)}
        onClose={() => { setAutomationTakeoverConfirm(null); setTakeoverError(null) }}
        title="Take over from automation"
        centered
        width={440}
        height={220}
        actions={
          <>
            <Button variant="outlined" color="inherit" disabled={takeoverBusy} onClick={() => { setAutomationTakeoverConfirm(null); setTakeoverError(null) }}>
              Cancel
            </Button>
            <Button variant="contained" color="warning" disabled={takeoverBusy} onClick={confirmAutomationTakeover}>
              {takeoverBusy ? 'Taking over…' : 'Take over'}
            </Button>
          </>
        }
      >
        <Typography variant="body2">
          This contact is queued for automation. Take it over? Automation won't run on this suggestion.
        </Typography>
        {takeoverError && <Alert severity="error" sx={{ mt: 1 }}>{takeoverError}</Alert>}
      </DraggableModal>

      {/* Dev-only: API call preview modal */}
    </Box>
    {shadowMode === 'side' && onShadowColumnDrag && (
      <ResizeHandle onMouseDown={onShadowColumnDrag} label="Resize agent draft" />
    )}
    {shadowMode === 'side' && (
      <Box data-testid="shadow-compare-column" sx={{ width: shadowColumnWidth, flexShrink: 0, minWidth: 0 }}>
        <ShadowCompareColumn draft={compareDraft} onCollapse={toggleShadowCompare} showTranslation={showTranslation} translation={shadowTr.translation} translationStatus={shadowTr.status} signature={compareSignature} replyHeaders={shadowReplyHeaders} replyDestination={channel === 'ebay' ? (suggestion?.modelMeta?.replyDestination ?? null) : null} trackingLinks={suggestion?.modelMeta?.nextStepTrackingLinks ?? null} />
      </Box>
    )}
    {shadowMode === 'rail' && <ShadowCompareRail onExpand={toggleShadowCompare} title={comparisonTitle(compareDraft)} />}
    </Box>
  )
}

// localStorage, or null when even reading it throws (blocked site data).
// The reply controls: as before, or (the agent draft panel, 2026-10-23)
// inside the A2 Reply section with the footer line last.
function ReplyWrap({ on, right, footer, children }) {
  if (!on) return children
  return (
    <A2ReplySection testId="agent-draft-reply" right={right}>
      {children}
      {footer}
    </A2ReplySection>
  )
}

// The Proposed Steps block: as before, or (the agent draft panel,
// 2026-10-23) the A2 "Steps · N" section.
function StepsWrap({ agentLayout, count, sx, children }) {
  if (agentLayout) {
    return (
      <Box sx={sx}>
        <StepsSection count={count} testId="agent-draft-steps">{children}</StepsSection>
      </Box>
    )
  }
  return (
    <Box sx={sx}>
      <Typography variant="subtitle2" fontWeight={700}>
        Proposed Steps
      </Typography>
      {children}
    </Box>
  )
}

// A step's fields (2026-10-26): on the agent draft panel, the card's full
// width under the title row, dimmed and read only while the step is
// unchecked (AgentDraftLayout.jsx's StepFields); as before otherwise.
function StepFieldsWrap({ on, unchecked, children }) {
  if (!on) return <>{children}</>
  return <StepFields unchecked={unchecked}>{children}</StepFields>
}

function shadowCompareStorage() {
  try {
    return window.localStorage
  } catch {
    return null
  }
}
